import { useState, useEffect, useRef } from "react";
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

// ─── i18n ────────────────────────────────────────────────────────────────────
const STRINGS = {
  en: {
    appName:"RepairOS",appSub:"Shop Manager",
    dashboard:"Dashboard",repairs:"Repairs",warranty:"Warranty",parts:"Inventory",
    customers:"Customers",finance:"Finance",analytics:"Analytics",report:"Monthly Report",
    settings:"Settings",customParts:"Parts Catalog",
    newRepair:"New Repair",save:"Save",cancel:"Cancel",delete:"Delete",edit:"Edit",
    add:"Add",search:"Search",done:"Done",close:"Close",
    active:"Active",history:"History",
    pending:"Pending",inProgress:"In Progress",delivered:"Delivered",cancelled:"Cancelled",
    name:"Name",device:"Device",type:"Type",status:"Status",price:"Price",date:"Date",
    phone:"Phone",notes:"Notes",deposit:"Deposit",warranty2:"Warranty",priority:"Priority",
    normal:"Normal",high:"High",urgent:"Urgent",
    none:"None",month:"month",months:"months",
    revenue:"Revenue",netProfit:"Net Profit",losses:"Loss Drag",completion:"Completion",
    yourCut:"Your Cut",storeCut:"Store Cut",withdrawn:"Withdrawn",balance:"Balance",
    withdraw:"Withdraw",withdrawal:"Withdrawal",amount:"Amount",
    lowStock:"Low Stock",inProgress2:"In Progress",
    language:"Language",currency:"Currency",splitPct:"Profit Split (%)",shopName:"Shop Name",
    technicians:"Technicians",addTech:"Add Technician",
    msgTemplates:"Message Templates",dataSection:"Data & Backup",
    exportBackup:"Export Backup",restoreBackup:"Restore Backup",clearData:"Clear Data",
    restoreConfirm:"This will replace ALL current data. Are you sure?",
    selectFile:"Select backup file…",
    telegram:"Telegram Bot Token",waAuto:"Auto-open WhatsApp when Done",
    saveAll:"Save All",allRepairs:"All Repairs",
    repairsHistory:"Repair History",totalSpent:"Total Spent",
    deviceCatalog:"Device Catalog",addDevice:"Add Device",
    partName:"Part Name",partType:"Type / Variant",partPrice:"Price",
    addPart:"Add Part",addType:"Add Type",
    imei:"IMEI / Serial",deposit2:"Deposit Paid",
    partsUsed:"Parts Used",fromInventory:"From Inventory",ordered:"Ordered / Custom",
    projProfit:"Projected profit",partsCost:"Parts cost",
    warrantyTracker:"Warranty Tracker",active2:"Active",expiringSoon:"Expiring Soon",expired:"Expired",
    daysLeft:"days left",expiredAgo:"Expired",expiresToday:"Expires today!",
    profitSplit:"Profit Split",splitConfig:"Profit Split Configuration",
    lossJobs:"Loss Jobs",noLossJobs:"No loss jobs — great work!",
    withdrawHistory:"Withdrawal History",recordWithdrawal:"Record Withdrawal",
    availableWithdraw:"Available to withdraw",monthlyReport:"Monthly Report",
    summary:"Summary",dailyVolume:"Daily Volume",peakHours:"Peak Hours",
    busiestDays:"Busiest Days",byType:"By Type",mostUsedParts:"Most Used Parts",
    notifications:"Notifications",markAllRead:"Mark all read",
    myBalance:"MY BALANCE",afterWithdrawals:"After withdrawals",
    missing:"Missing",required:"Name and device required",
    added:"Added",updated:"Updated",deleted:"Deleted",removed:"Removed",saved:"Saved",
    statusUpdated:"Status Updated",customerNotified:"Customer Notified",
    telegramFailed:"Telegram Failed",checkToken:"Check token in Settings",
    testSent:"Test Sent",failed:"Failed",
    noRepairs:"No repairs yet",noHistory:"No history",noCustomers:"No customers",
    noNotifs:"All clear!",noWithdrawals:"No withdrawals yet",noParts:"No parts",
    allClear:"All clear!",noData:"No data",
    warrantyExpiring:"Warranty Expiring",lossRepairs:"Loss Repairs",
    devicesUnderWarranty:"devices under warranty coverage",
    repaired:"Repaired",warrantyUntil:"Warranty until",
    allTimePerformance:"All-time performance",last6Months:"Revenue vs Losses — 6 Months",
    byRepairType:"By Type",statusBreakdown:"Status Breakdown",topRepairTypes:"Top Repair Types",
    backupRestored:"Backup Restored",invalidBackup:"Invalid backup file",
    rtlLayout:"Right-to-Left Layout",newDeviceAdded:"New device added to catalog",costPrice:"Cost Price",margin:"Margin",autofilled:"Auto-filled from customer",
    topDevices:"Top Requested Devices",topParts:"Most Requested Parts",insideDevice:"Inside",
    dbManager:"Database Manager",activeDb:"Active Database",noDbActive:"No database active (using browser storage)",createDb:"Create New DB",switchDb:"Switch",deleteDb:"Delete",testDb:"Test DB",testDbHint:"Mark as test environment",dbFolder:"DB Folder",selectFolder:"Select Folder",dbCreated:"Database Created",dbSwitched:"Database Switched",dbDeleted:"Database Deleted",dbFolderRequired:"Please select a folder first",fsNotSupported:"File System Access API not supported in this browser. Use Chrome or Edge.",sevenDays:"7 Days",thirtyDays:"30 Days",thisMonth:"This Month",ninetyDays:"90 Days",allTime:"All Time",customerDevices:"Customer Devices",addDevice2:"Add Device",deviceModel:"Device Model",noDevices:"No devices yet",removeDevice:"Remove",
  },
  ar: {
    appName:"ريبير أو إس",appSub:"إدارة الورشة",
    dashboard:"الرئيسية",repairs:"الإصلاحات",warranty:"الضمان",parts:"المخزون",
    customers:"العملاء",finance:"المالية",analytics:"التحليلات",report:"التقرير الشهري",
    settings:"الإعدادات",customParts:"كتالوج القطع",
    newRepair:"إصلاح جديد",save:"حفظ",cancel:"إلغاء",delete:"حذف",edit:"تعديل",
    add:"إضافة",search:"بحث",done:"تم",close:"إغلاق",
    active:"النشطة",history:"الأرشيف",
    pending:"قيد الانتظار",inProgress:"جارٍ الإصلاح",delivered:"تم التسليم",cancelled:"ملغي",
    name:"الاسم",device:"الجهاز",type:"النوع",status:"الحالة",price:"السعر",date:"التاريخ",
    phone:"الهاتف",notes:"ملاحظات",deposit:"العربون",warranty2:"الضمان",priority:"الأولوية",
    normal:"عادي",high:"عالٍ",urgent:"عاجل",
    none:"لا شيء",month:"شهر",months:"أشهر",
    revenue:"الإيرادات",netProfit:"صافي الربح",losses:"خسائر",completion:"معدل الإنجاز",
    yourCut:"حصتك",storeCut:"حصة المحل",withdrawn:"المسحوب",balance:"الرصيد",
    withdraw:"سحب",withdrawal:"سحب",amount:"المبلغ",
    lowStock:"مخزون منخفض",inProgress2:"جارٍ",
    language:"اللغة",currency:"العملة",splitPct:"نسبة توزيع الأرباح (%)",shopName:"اسم الورشة",
    technicians:"الفنيون",addTech:"إضافة فني",
    msgTemplates:"قوالب الرسائل",dataSection:"البيانات والنسخ الاحتياطي",
    exportBackup:"تصدير نسخة احتياطية",restoreBackup:"استعادة نسخة احتياطية",clearData:"مسح البيانات",
    restoreConfirm:"سيؤدي هذا إلى استبدال جميع البيانات الحالية. هل أنت متأكد؟",
    selectFile:"اختر ملف النسخة الاحتياطية…",
    telegram:"رمز بوت تيليجرام",waAuto:"فتح واتساب تلقائياً عند الانتهاء",
    saveAll:"حفظ الكل",allRepairs:"جميع الإصلاحات",
    repairsHistory:"سجل الإصلاحات",totalSpent:"إجمالي الإنفاق",
    deviceCatalog:"كتالوج الأجهزة",addDevice:"إضافة جهاز",
    partName:"اسم القطعة",partType:"النوع / الصنف",partPrice:"السعر",
    addPart:"إضافة قطعة",addType:"إضافة نوع",
    imei:"الرقم التسلسلي / IMEI",deposit2:"العربون المدفوع",
    partsUsed:"القطع المستخدمة",fromInventory:"من المخزون",ordered:"مطلوبة / مخصصة",
    projProfit:"الربح المتوقع",partsCost:"تكلفة القطع",
    warrantyTracker:"متتبع الضمان",active2:"فعّال",expiringSoon:"ينتهي قريباً",expired:"منتهي",
    daysLeft:"أيام متبقية",expiredAgo:"انتهى",expiresToday:"ينتهي اليوم!",
    profitSplit:"توزيع الأرباح",splitConfig:"إعداد توزيع الأرباح",
    lossJobs:"إصلاحات خاسرة",noLossJobs:"لا توجد إصلاحات خاسرة — عمل رائع!",
    withdrawHistory:"سجل السحوبات",recordWithdrawal:"تسجيل سحب",
    availableWithdraw:"المتاح للسحب",monthlyReport:"التقرير الشهري",
    summary:"الملخص",dailyVolume:"الحجم اليومي",peakHours:"ساعات الذروة",
    busiestDays:"أكثر الأيام ازدحاماً",byType:"حسب النوع",mostUsedParts:"القطع الأكثر استخداماً",
    notifications:"الإشعارات",markAllRead:"تحديد الكل كمقروء",
    myBalance:"رصيدي",afterWithdrawals:"بعد السحوبات",
    missing:"ناقص",required:"الاسم والجهاز مطلوبان",
    added:"تمت الإضافة",updated:"تم التحديث",deleted:"تم الحذف",removed:"تمت الإزالة",saved:"تم الحفظ",
    statusUpdated:"تم تحديث الحالة",customerNotified:"تم إشعار العميل",
    telegramFailed:"فشل تيليجرام",checkToken:"تحقق من الرمز في الإعدادات",
    testSent:"تم إرسال الاختبار",failed:"فشل",
    noRepairs:"لا توجد إصلاحات بعد",noHistory:"لا يوجد أرشيف",noCustomers:"لا يوجد عملاء",
    noNotifs:"لا توجد إشعارات!",noWithdrawals:"لا توجد سحوبات بعد",noParts:"لا توجد قطع",
    allClear:"كل شيء على ما يرام!",noData:"لا توجد بيانات",
    warrantyExpiring:"الضمان على وشك الانتهاء",lossRepairs:"إصلاحات خاسرة",
    devicesUnderWarranty:"أجهزة تحت الضمان",
    repaired:"تاريخ الإصلاح",warrantyUntil:"الضمان حتى",
    allTimePerformance:"الأداء الكلي",last6Months:"الإيرادات والخسائر — 6 أشهر",
    byRepairType:"حسب نوع الإصلاح",statusBreakdown:"توزيع الحالات",topRepairTypes:"أكثر أنواع الإصلاح",
    backupRestored:"تمت استعادة النسخة الاحتياطية",invalidBackup:"ملف النسخة الاحتياطية غير صالح",
    rtlLayout:"تخطيط من اليمين إلى اليسار",newDeviceAdded:"تمت إضافة جهاز جديد إلى الكتالوج",costPrice:"سعر التكلفة",margin:"الهامش",autofilled:"تم الملء تلقائياً من العميل",
    topDevices:"الأجهزة الأكثر طلباً",topParts:"القطع الأكثر طلباً",insideDevice:"داخل",
    dbManager:"مدير قواعد البيانات",activeDb:"قاعدة البيانات النشطة",noDbActive:"لا توجد قاعدة بيانات (يستخدم تخزين المتصفح)",createDb:"إنشاء قاعدة بيانات",switchDb:"تبديل",deleteDb:"حذف",testDb:"قاعدة اختبار",testDbHint:"وضع الاختبار",dbFolder:"مجلد قواعد البيانات",selectFolder:"اختر المجلد",dbCreated:"تم إنشاء قاعدة البيانات",dbSwitched:"تم التبديل",dbDeleted:"تم الحذف",dbFolderRequired:"الرجاء اختيار مجلد أولاً",fsNotSupported:"File System Access API غير مدعوم. استخدم Chrome أو Edge.",sevenDays:"7 أيام",thirtyDays:"30 يوم",thisMonth:"هذا الشهر",ninetyDays:"90 يوم",allTime:"الكل",customerDevices:"أجهزة العميل",addDevice2:"إضافة جهاز",deviceModel:"طراز الجهاز",noDevices:"لا توجد أجهزة",removeDevice:"حذف",
  }
};

// ─── Currency ─────────────────────────────────────────────────────────────────
const CURRENCIES = {
  USD: { symbol:"$",  pos:"before", sep:",", dec:".", decimals:0 },
  IQD: { symbol:"IQD",pos:"after",  sep:",", dec:".", decimals:0 },
  EUR: { symbol:"€",  pos:"before", sep:",", dec:".", decimals:0 },
  GBP: { symbol:"£",  pos:"before", sep:",", dec:".", decimals:0 },
  SAR: { symbol:"SAR",pos:"after",  sep:",", dec:".", decimals:0 },
};
function fmtMoney(val, currencyCode) {
  const c = CURRENCIES[currencyCode] || CURRENCIES.USD;
  const n = Math.round(parseFloat(val)||0).toLocaleString();
  return c.pos==="before" ? `${c.symbol}${n}` : `${n} ${c.symbol}`;
}

// ─── DB ───────────────────────────────────────────────────────────────────────
const DB = {
  get: (k) => { try { return JSON.parse(localStorage.getItem(k) ?? "null"); } catch { return null; } },
  set: (k, v) => localStorage.setItem(k, JSON.stringify(v)),
  init() {
    const def = {
      repairs:[], parts:INITIAL_PARTS, customers:[], notifications:[],
      technicians:[], withdrawals:[], customPartsCatalog:[],
      tg_token:"", wa_number:"", shop_name:"RepairOS",
      split_pct:50, language:"en", currency:"USD", wa_auto:false, rtl_layout:false,
      shop_phone:"",shop_email:"",shop_address:"",shop_tagline:"",shop_hours:"",shop_website:"",receipt_footer:"",receipt_show_logo:true,receipt_show_address:true,country_code:"",
      msg_new_repair:"🔧 <b>New Repair</b>\nCustomer: {name}\nDevice: {device}\nType: {type}\nJob: #{id}\nPriority: {priority}",
      msg_done:"✅ Hi {name}! Your <b>{device}</b> is ready! 🎉\nThank you for choosing <b>{shop}</b>!",
      msg_done_wa:"✅ Hi {name}! Your *{device}* is ready! 🎉\nThank you for choosing *{shop}*!",
      msg_repair_delivered:"📦 <b>Device Collected</b>\nCustomer: {name}\nDevice: {device}\nJob: #{id}",
      msg_warranty_expiring:"🛡️ <b>Warranty Expiring</b>\nCustomer: {name}\nDevice: {device}\nExpires: {date}",
      msg_low_stock:"⚠️ <b>Low Stock Alert</b>\n{part} ({brand})\nOnly <b>{qty}</b> units left!\nShop: {shop}",
      msg_withdrawal:"💸 <b>Withdrawal: {amount}</b>\nNote: {note}",
      next_id:1,
    };
    Object.entries(def).forEach(([k,v]) => { if (DB.get(k) === null) DB.set(k, v); });
  },
  nextId() { const id = DB.get("next_id")||1; DB.set("next_id", id+1); return id; }
};


// ─── File-based DB (File System Access API) ───────────────────────────────────
// ─── Server DB ────────────────────────────────────────────────────────────────
// Talks to the Express API at /api/* (proxied by CRA dev server to port 3001).
// Falls back to localStorage (via SDB) when server is not running.
const ServerDB = {
  _active: null,
  _cache:  null,
  _serverAvailable: false,

  async _ping(){
    try{
      const r=await fetch('/api/ping',{cache:'no-store',signal:AbortSignal.timeout(2000)});
      return r.ok;
    }catch{ return false; }
  },

  async init(){
    this._serverAvailable = await this._ping();
    if(!this._serverAvailable) return;
    // 1. Try to restore the active session DB
    const sessionDb = sessionStorage.getItem('repairosActiveDb');
    if(sessionDb){
      const ok=await this.switchDb(sessionDb);
      if(ok) return;
      sessionStorage.removeItem('repairosActiveDb');
    }
    // 2. Fall back to this device's default DB (persisted in localStorage)
    const defaultDb = localStorage.getItem('repairosDefaultDb');
    if(defaultDb){
      await this.switchDb(defaultDb);
    }
  },

  isActive(){ return this._serverAvailable && !!this._active && !!this._cache; },

  async listDbs(){
    try{ const r=await fetch('/api/dbs',{cache:'no-store'}); return r.ok?await r.json():[]; }
    catch{ return []; }
  },

  // Helper: strip .json for URL (no dots in params = no Express routing issues)
  _url(fname){ return '/api/dbs/'+encodeURIComponent(fname.replace(/\.json$/,'')); },

  async createDb(name,isTest=false){
    const fname=(name.replace(/[^a-zA-Z0-9_-]/g,'_')||'db')+(isTest?'_TEST':'')+'.json';
    try{
      const r=await fetch(this._url(fname),{
        method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({isTest,shopName:name}),
      });
      if(!r.ok) return false;
      await this.switchDb(fname);
      return fname;
    }catch{ return false; }
  },

  async switchDb(fname){
    try{
      const r=await fetch(this._url(fname),{cache:'no-store'});
      if(!r.ok) return false;
      this._cache=await r.json();
      this._active=fname;
      sessionStorage.setItem('repairosActiveDb',fname);
      return true;
    }catch{ return false; }
  },

  async switchToNone(){
    this._active=null; this._cache=null;
    sessionStorage.removeItem('repairosActiveDb');
  },

  setDeviceDefault(fname){
    if(fname) localStorage.setItem('repairosDefaultDb',fname);
    else localStorage.removeItem('repairosDefaultDb');
  },
  getDeviceDefault(){ return localStorage.getItem('repairosDefaultDb')||null; },

  async deleteDb(fname){
    try{
      await fetch(this._url(fname),{method:'DELETE'});
      if(this._active===fname) await this.switchToNone();
      // Clear default if it was this DB
      if(this.getDeviceDefault()===fname) this.setDeviceDefault(null);
      return true;
    }catch{ return false; }
  },

  async reload(){
    if(!this.isActive()) return;
    try{
      const r=await fetch(this._url(this._active),{cache:'no-store'});
      if(r.ok) this._cache=await r.json();
    }catch{}
  },

  _flushTimer:null,
  _flush(){
    if(!this.isActive()) return;
    clearTimeout(this._flushTimer);
    this._flushTimer=setTimeout(async()=>{
      try{
        await fetch(this._url(this._active),{
          method:'PUT',headers:{'Content-Type':'application/json'},
          body:JSON.stringify(this._cache),
        });
      }catch(e){ console.error('ServerDB flush error',e); }
    },300);
  },

  get(k){ if(!this.isActive()) return null; return this._cache[k]??null; },
  set(k,v){ if(!this.isActive()) return; this._cache[k]=v; this._flush(); },
  getActiveInfo(){
    if(!this._active) return null;
    return {name:this._active,isTest:this._cache?.isTest||false,shopName:this._cache?.shop_name||''};
  },
};

// ─── Smart DB proxy — ServerDB if active, else localStorage ──────────────────
const SDB = {
  get(k){ return ServerDB.isActive() ? ServerDB.get(k) : DB.get(k); },
  set(k,v){ if(ServerDB.isActive()) ServerDB.set(k,v); else DB.set(k,v); },
  nextId(){ const id=(this.get('next_id')||1); this.set('next_id',id+1); return id; },
};


// ─── Auth & Permission System ─────────────────────────────────────────────────
// Passwords hashed with PBKDF2-SHA256 via Web Crypto API.
// Sessions stored as HMAC-signed tokens in sessionStorage only.
// Nothing sensitive is logged or exposed to DevTools storage.

const AUTH_STORE_KEY  = 'ros_users';
const SESSION_KEY     = 'ros_sess';
const HMAC_KEY_KEY    = 'ros_hk';       // sessionStorage — per-tab signing key
const HMAC_REM_KEY    = 'ros_hk_rem';  // localStorage — persists for remember-me
const REMEMBER_KEY    = 'ros_remember';   // localStorage — persists across browser restarts
const REMEMBER_USER_KEY = 'ros_rem_user'; // stores username only (not password)

// Permission sections and levels
const PERM_SECTIONS = ['dashboard','repairs','warranty','customParts','parts','customers','finance','analytics','report','settings'];
const PERM_LEVELS   = ['none','read','write'];

// Granular settings sub-sections for admin access control
const SETTINGS_SECTIONS = [
  {id:'shop',       label:'Shop & Identity',     icon:'🏪', desc:'Shop name, logo, profit split, app version'},
  {id:'appearance', label:'Appearance',           icon:'🎨', desc:'Themes, fonts, layout, language & region'},
  {id:'printing',   label:'Printing & Receipts',  icon:'🖨️', desc:'Receipt design, paper size, printable reports'},
  {id:'telegram',   label:'Telegram & Alerts',    icon:'📨', desc:'Bot token, WhatsApp, technicians'},
  {id:'templates',  label:'Message Templates',    icon:'✉️',  desc:'Customise notification messages with live preview'},
  {id:'assets',     label:'Assets & Brands',      icon:'🖼️', desc:'Upload images, edit brand icons'},
  {id:'data',       label:'Data & Databases',     icon:'💾', desc:'Export, restore, clear data and manage server databases'},
  {id:'users',      label:'User Management',      icon:'👑', desc:'Create and manage user accounts (admin only)'},
];

// Roles
const ROLES = {
  admin:      {label:'👑 Admin',       description:'Full access, manage users & settings', canManageUsers:true,  isAdmin:true},
  manager:    {label:'🏢 Manager',     description:'Access to all data, no user management', canManageUsers:false, isAdmin:false},
  technician: {label:'🔧 Technician',  description:'Repairs, inventory & catalog only',      canManageUsers:false, isAdmin:false},
  receptionist:{label:'📋 Receptionist',description:'Customers, repairs & dashboard only',   canManageUsers:false, isAdmin:false},
  viewer:     {label:'👁️ Viewer',      description:'Read-only access to reports & analytics',canManageUsers:false, isAdmin:false},
  custom:     {label:'⚙️ Custom',       description:'Manually configured permissions',        canManageUsers:false, isAdmin:false},
};

// Role preset permissions
const ROLE_PRESETS = {
  admin:        Object.fromEntries(['dashboard','repairs','warranty','customParts','parts','customers','finance','analytics','report','settings'].map(s=>[s,'write'])),
  manager:      Object.fromEntries(['dashboard','repairs','warranty','customParts','parts','customers','finance','analytics','report','settings'].map(s=>[s,'write'])),
  technician:   {dashboard:'read',repairs:'write',warranty:'read',customParts:'read',parts:'write',customers:'read',finance:'none',analytics:'none',report:'none',settings:'none'},
  receptionist: {dashboard:'read',repairs:'write',warranty:'read',customParts:'read',parts:'read',customers:'write',finance:'none',analytics:'none',report:'none',settings:'none'},
  viewer:       Object.fromEntries(['dashboard','repairs','warranty','customParts','parts','customers','finance','analytics','report','settings'].map(s=>[s,'read'])),
  custom:       Object.fromEntries(['dashboard','repairs','warranty','customParts','parts','customers','finance','analytics','report','settings'].map(s=>[s,'none'])),
};

const ALL_WRITE = Object.fromEntries(PERM_SECTIONS.map(s=>[s,'write']));
const ALL_READ  = Object.fromEntries(PERM_SECTIONS.map(s=>[s,'read']));
const ALL_NONE  = Object.fromEntries(PERM_SECTIONS.map(s=>[s,'none']));

// Default settings section access per role (admin can customise, stored in SDB)
const DEFAULT_SETTINGS_ACCESS = {
  admin:       {shop:true,appearance:true,telegram:true,templates:true,assets:true,data:true,users:true},
  manager:     {shop:true,appearance:true,telegram:true,templates:true,assets:true,data:true,users:false},
  technician:  {shop:false,appearance:true,telegram:false,templates:false,assets:false,data:false,users:false},
  receptionist:{shop:false,appearance:true,telegram:false,templates:false,assets:false,data:false,users:false},
  viewer:      {shop:false,appearance:true,telegram:false,templates:false,assets:false,data:false,users:false},
  custom:      {shop:false,appearance:false,telegram:false,templates:false,assets:false,data:false,users:false},
};
function getSettingsAccess(role){
  const saved = SDB.get('settings_access')||{};
  const defaults = DEFAULT_SETTINGS_ACCESS[role]||DEFAULT_SETTINGS_ACCESS.custom;
  return {...defaults,...(saved[role]||{})};
}
function canSeeSettingsSection(user, sectionId){
  if(!user) return false;
  if(user.role==='admin') return true;
  return !!getSettingsAccess(user.role)[sectionId];
}

// In-memory rate limiter (never persisted)
const _loginAttempts = {};
function _checkRateLimit(username){
  const now = Date.now();
  const key = username.toLowerCase();
  const a = _loginAttempts[key] || {count:0,until:0};
  if(a.until > now) return {locked:true, secsLeft:Math.ceil((a.until-now)/1000)};
  return {locked:false};
}
function _recordFailure(username){
  const key = username.toLowerCase();
  const a = _loginAttempts[key] || {count:0,until:0};
  a.count++;
  if(a.count >= 5) { a.until = Date.now() + 30000; a.count = 0; }
  _loginAttempts[key] = a;
}
function _clearFailures(username){ delete _loginAttempts[username.toLowerCase()]; }

// Crypto helpers
async function _pbkdf2(password, salt){
  const enc = new TextEncoder();
  const keyMat = await crypto.subtle.importKey('raw', enc.encode(password), 'PBKDF2', false, ['deriveBits']);
  const bits = await crypto.subtle.deriveBits(
    {name:'PBKDF2', salt:enc.encode(salt), iterations:200000, hash:'SHA-256'},
    keyMat, 256
  );
  return Array.from(new Uint8Array(bits)).map(b=>b.toString(16).padStart(2,'0')).join('');
}

async function _getHmacKey(persist=false){
  // For remember-me sessions: use localStorage key so it survives page restarts
  let raw = sessionStorage.getItem(HMAC_KEY_KEY) || localStorage.getItem(HMAC_REM_KEY);
  if(!raw){
    const bytes = new Uint8Array(32);
    crypto.getRandomValues(bytes);
    raw = Array.from(bytes).map(b=>b.toString(16).padStart(2,'0')).join('');
    sessionStorage.setItem(HMAC_KEY_KEY, raw);
  } else {
    // Sync to session for this tab
    sessionStorage.setItem(HMAC_KEY_KEY, raw);
  }
  if(persist) localStorage.setItem(HMAC_REM_KEY, raw);
  const keyBytes = new Uint8Array(raw.match(/.{2}/g).map(h=>parseInt(h,16)));
  return crypto.subtle.importKey('raw', keyBytes, {name:'HMAC',hash:'SHA-256'}, false, ['sign','verify']);
}

async function _signToken(payload, persist=false){
  const key = await _getHmacKey(persist);
  const enc = new TextEncoder();
  const sig = await crypto.subtle.sign('HMAC', key, enc.encode(payload));
  const sigHex = Array.from(new Uint8Array(sig)).map(b=>b.toString(16).padStart(2,'0')).join('');
  return btoa(payload) + '.' + sigHex;
}

async function _verifyToken(token){
  try {
    const [b64, sigHex] = token.split('.');
    if(!b64 || !sigHex) return null;
    const payload = atob(b64);
    const key = await _getHmacKey();
    const enc = new TextEncoder();
    const sig = new Uint8Array(sigHex.match(/.{2}/g).map(h=>parseInt(h,16)));
    const ok = await crypto.subtle.verify('HMAC', key, sig, enc.encode(payload));
    if(!ok) return null;
    const obj = JSON.parse(payload);
    // Expiry is encoded in token (exp field), fall back to 8h for old tokens
    const expiry = obj.exp || (obj.ts + 8*3600*1000);
    if(Date.now() > expiry) return null;
    return obj;
  } catch { return null; }
}

// User storage (passwords hashed, never stored plain)
function _loadUsers(){ return SDB.get(AUTH_STORE_KEY) || []; }
function _saveUsers(users){ SDB.set(AUTH_STORE_KEY, users); }

async function authCreateAdmin(){
  const users = _loadUsers();
  if(users.find(u=>u.role==='admin')) return; // admin already exists
  const salt = crypto.randomUUID();
  const hash = await _pbkdf2('admin123', salt);
  _saveUsers([{
    id: 'admin', username:'admin', displayName:'Admin',
    passwordHash: hash, salt,
    role:'admin', permissions: ALL_WRITE, createdAt: new Date().toISOString()
  }]);
}

async function authLogin(username, password, remember=false){
  const rl = _checkRateLimit(username);
  if(rl.locked) return {ok:false, error:`Too many attempts. Try again in ${rl.secsLeft}s.`};
  const users = _loadUsers();
  const user = users.find(u=>u.username.toLowerCase()===username.toLowerCase());
  if(!user){
    _recordFailure(username);
    return {ok:false, error:'Invalid username or password.'};
  }
  const hash = await _pbkdf2(password, user.salt);
  if(hash !== user.passwordHash){
    _recordFailure(username);
    return {ok:false, error:'Invalid username or password.'};
  }
  _clearFailures(username);
  // Build session token — never includes password or hash
  // Remember me: token valid 30 days; otherwise 8 hours
  const expiresIn = remember ? 30*24*3600*1000 : 8*3600*1000;
  const payload = JSON.stringify({id:user.id, username:user.username, role:user.role, ts:Date.now(), exp:Date.now()+expiresIn});
  const token = await _signToken(payload, remember); // persist=true stores HMAC key in localStorage
  sessionStorage.setItem(SESSION_KEY, token);
  if(remember){
    localStorage.setItem(REMEMBER_KEY, token);
    localStorage.setItem(REMEMBER_USER_KEY, username.trim());
  } else {
    localStorage.removeItem(REMEMBER_KEY);
    localStorage.removeItem(REMEMBER_USER_KEY);
  }
  return {ok:true, user: _sanitizeUser(user)};
}

function _sanitizeUser(u){
  // Strip sensitive fields before putting in state
  const {passwordHash, salt, ...safe} = u;
  return safe;
}

async function authRestore(){
  try {
    // 1. Try session token first
    let token = sessionStorage.getItem(SESSION_KEY);
    // 2. Fall back to remember-me token from localStorage
    if(!token) token = localStorage.getItem(REMEMBER_KEY);
    if(!token) return null;
    const obj = await _verifyToken(token);
    if(!obj) {
      sessionStorage.removeItem(SESSION_KEY);
      localStorage.removeItem(REMEMBER_KEY);
      return null;
    }
    const users = _loadUsers();
    const user = users.find(u=>u.id===obj.id);
    if(!user) {
      sessionStorage.removeItem(SESSION_KEY);
      localStorage.removeItem(REMEMBER_KEY);
      return null;
    }
    // Copy to session so future checks are fast
    sessionStorage.setItem(SESSION_KEY, token);
    return _sanitizeUser(user);
  } catch { return null; }
}

function authLogout(){
  sessionStorage.removeItem(SESSION_KEY);
  sessionStorage.removeItem(HMAC_KEY_KEY);
  localStorage.removeItem(REMEMBER_KEY);
  localStorage.removeItem(REMEMBER_USER_KEY);
  localStorage.removeItem(HMAC_REM_KEY); // clear persisted signing key on logout
}

// Permission helpers
function canAccess(user, section){
  if(!user) return 'none';
  if(user.role==='admin'||user.role==='manager') return 'write';
  return (user.permissions||{})[section] || 'none';
}
function canRead(user, section){ const l=canAccess(user,section); return l==='read'||l==='write'; }
function canWrite(user, section){ return canAccess(user,section)==='write'; }

// User management (admin only)
async function authCreateUser(adminUser, newUser){
  if(adminUser.role !== 'admin') return {ok:false,error:'Not authorized'};
  const users = _loadUsers();
  if(users.find(u=>u.username.toLowerCase()===newUser.username.toLowerCase()))
    return {ok:false, error:'Username already exists'};
  const salt = crypto.randomUUID();
  const hash = await _pbkdf2(newUser.password, salt);
  const user = {
    id: crypto.randomUUID(), username: newUser.username.trim(),
    displayName: newUser.displayName||newUser.username,
    passwordHash: hash, salt,
    role: newUser.role || 'technician',
    permissions: newUser.permissions || ROLE_PRESETS[newUser.role||'technician'] || ALL_NONE,
    photoUrl: newUser.photoUrl||'',
    createdAt: new Date().toISOString()
  };
  _saveUsers([...users, user]);
  return {ok:true, user:_sanitizeUser(user)};
}

async function authUpdateUser(adminUser, userId, updates){
  if(adminUser.role !== 'admin') return {ok:false,error:'Not authorized'};
  const users = _loadUsers();
  let updated = null;
  const newUsers = await Promise.all(users.map(async u=>{
    if(u.id !== userId) return u;
    let patch = {displayName: updates.displayName||u.displayName, role: updates.role||u.role, permissions: updates.permissions||u.permissions, photoUrl: updates.photoUrl!==undefined?updates.photoUrl:u.photoUrl};
    if(updates.password){
      const salt = crypto.randomUUID();
      const hash = await _pbkdf2(updates.password, salt);
      patch = {...patch, passwordHash:hash, salt};
    }
    updated = {...u, ...patch};
    return updated;
  }));
  _saveUsers(newUsers);
  return {ok:true, user: updated?_sanitizeUser(updated):null};
}

function authDeleteUser(adminUser, userId){
  if(adminUser.role !== 'admin') return {ok:false,error:'Not authorized'};
  const users = _loadUsers();
  if(users.find(u=>u.id===userId)?.role==='admin') return {ok:false,error:'Cannot delete admin'};
  _saveUsers(users.filter(u=>u.id!==userId));
  return {ok:true};
}

function authListUsers(adminUser){
  if(adminUser.role !== 'admin' && adminUser.role !== 'manager') return [];
  return _loadUsers().map(_sanitizeUser);
}
function canManageUsers(user){
  return user?.role === 'admin';
}

// ─── Initial Parts ────────────────────────────────────────────────────────────
const INITIAL_PARTS = [
  {id:1,name:"iPhone Screen (OLED)",  brand:"Apple",    stock:12,cost:45, price:120,category:"Display"},
  {id:2,name:"Samsung Galaxy Battery",brand:"Samsung",  stock:8, cost:12, price:35, category:"Battery"},
  {id:3,name:"iPhone Battery",        brand:"Apple",    stock:15,cost:18, price:45, category:"Battery"},
  {id:4,name:"Charging Port USB-C",   brand:"Universal",stock:20,cost:5,  price:25, category:"Charging"},
  {id:5,name:"Back Glass iPhone",     brand:"Apple",    stock:6, cost:30, price:80, category:"Display"},
  {id:6,name:"Front Camera Module",   brand:"Universal",stock:4, cost:22, price:60, category:"Camera"},
  {id:7,name:"Speaker Module",        brand:"Universal",stock:9, cost:8,  price:30, category:"Audio"},
  {id:8,name:"Digitizer Touch",       brand:"Samsung",  stock:5, cost:35, price:90, category:"Display"},
];
const DEFAULT_REPAIR_TYPES=[
  {name:"Screen Replacement", icon:"🖥️"},
  {name:"Battery Replacement", icon:"🔋"},
  {name:"Charging Port Fix",   icon:"⚡"},
  {name:"Water Damage",        icon:"💧"},
  {name:"Camera Repair",       icon:"📷"},
  {name:"Speaker Fix",         icon:"🔊"},
  {name:"Microphone Fix",      icon:"🎤"},
  {name:"Software Issue",      icon:"💻"},
  {name:"Back Glass Repair",   icon:"🪟"},
  {name:"Button Repair",       icon:"🔘"},
  {name:"Data Recovery",       icon:"💾"},
  {name:"Other",               icon:"🔧"},
];
const DEFAULT_WARRANTY_OPTIONS=[
  {label:"None",    value:"0"},
  {label:"1 week",  value:"0.25"},
  {label:"2 weeks", value:"0.5"},
  {label:"1 month", value:"1"},
  {label:"3 months",value:"3"},
  {label:"6 months",value:"6"},
  {label:"1 year",  value:"12"},
  {label:"2 years", value:"24"},
];
// Live lists — read from SDB if customised, else defaults
// ─── Quick Repair Presets helpers ────────────────────────────────────────────
// Spinner step for money fields: whole thousands for IQD, 1 for other currencies
function priceStep(){ return (SDB.get("currency")||DB.get("currency")||"USD")==="IQD"?1000:1; }
function getRepairPresets(){
  return SDB.get("repair_presets")||[];
}
function saveRepairPresets(arr){
  SDB.set("repair_presets",arr);
}

function getRepairTypes(){return SDB.get("repair_types")||DEFAULT_REPAIR_TYPES;}
function getWarrantyOptions(){return SDB.get("warranty_options")||DEFAULT_WARRANTY_OPTIONS;}
// Legacy compat
const REPAIR_TYPES=DEFAULT_REPAIR_TYPES.map(t=>t.name);
const REPAIR_TYPE_ICONS=Object.fromEntries(DEFAULT_REPAIR_TYPES.map(t=>[t.name,t.icon]));
function getTypeIcon(type){const rt=getRepairTypes().find(r=>r.name===type);return rt?rt.icon:REPAIR_TYPE_ICONS[type]||"🔧";}
function getRepairTypesDisplay(r){if(r.types&&r.types.length)return r.types.join(", ");return r.type||"";}
function getRepairTypesIcons(r){const types=r.types&&r.types.length?r.types:[r.type||""];return types.map(t=>getTypeIcon(t)).join(" ");}
// Get icon for a catalog part based on its repairTypeLink or name keywords
function getPartIcon(part){
  if(!part) return "🔩";
  if(part.repairTypeLink&&REPAIR_TYPE_ICONS[part.repairTypeLink]) return REPAIR_TYPE_ICONS[part.repairTypeLink];
  const n=(part.name||"").toLowerCase();
  if(n.includes("screen")||n.includes("lcd")||n.includes("display")||n.includes("glass")) return "🖥️";
  if(n.includes("batt")) return "🔋";
  if(n.includes("charg")||n.includes("port")||n.includes("usb")) return "⚡";
  if(n.includes("camera")||n.includes("cam")) return "📷";
  if(n.includes("speaker")||n.includes("audio")||n.includes("sound")) return "🔊";
  if(n.includes("mic")) return "🎤";
  if(n.includes("button")||n.includes("power")||n.includes("volume")) return "🔘";
  if(n.includes("back")||n.includes("housing")||n.includes("frame")) return "🪟";
  if(n.includes("water")||n.includes("liquid")) return "💧";
  if(n.includes("data")||n.includes("software")||n.includes("flash")) return "💾";
  return "🔩";
}
const STATUS_CFG={"Pending":{color:"#FF9F0A",bg:"rgba(255,159,10,0.15)",icon:"⏳"},"In Progress":{color:"#0A84FF",bg:"rgba(10,132,255,0.15)",icon:"🔧"},"Done":{color:"#30D158",bg:"rgba(48,209,88,0.15)",icon:"✅"},"Delivered":{color:"#636366",bg:"rgba(99,99,102,0.15)",icon:"📦"},"Cancelled":{color:"#FF453A",bg:"rgba(255,69,58,0.15)",icon:"❌"},"Awaiting Customer":{color:"#BF5AF2",bg:"rgba(191,90,242,0.15)",icon:"🕐"}};
const ACTIVE_S=["Pending","In Progress","Done"];
const WAITING_S=["Awaiting Customer"];
const HISTORY_S=["Delivered","Cancelled"];
const PIE_COLS=["#0A84FF","#30D158","#FF9F0A","#BF5AF2","#5AC8FA","#FF453A","#FF6B35","#00D2D3"];
const MONTHS_EN=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const MONTHS_AR=["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"];
const NOTIF_CATS=[{id:"new_repair",label:"New Repair Received",labelAr:"استلام إصلاح جديد",icon:"📱"},{id:"repair_done",label:"Repair Marked Done",labelAr:"إصلاح مكتمل",icon:"✅"},{id:"repair_delivered",label:"Repair Delivered",labelAr:"إصلاح مُسلَّم",icon:"📦"},{id:"warranty_expiring",label:"Warranty Expiring",labelAr:"ضمان ينتهي قريباً",icon:"🛡️"},{id:"low_stock",label:"Low Stock Alert",labelAr:"تنبيه مخزون منخفض",icon:"⚠️"},{id:"withdrawal",label:"Withdrawal Recorded",labelAr:"تسجيل سحب",icon:"💸"}];

// ─── Telegram ─────────────────────────────────────────────────────────────────
async function sendTelegram(token, chatId, msg) {
  if (!token||!chatId) return false;
  const params=new URLSearchParams({chat_id:String(chatId).trim(),text:msg,parse_mode:"HTML"});
  const url=`https://api.telegram.org/bot${token.trim()}/sendMessage?${params.toString()}`;
  try {
    const r=await fetch(url,{method:"GET"});
    if (r.ok){const j=await r.json().catch(()=>({}));return j.ok===true;}
    return false;
  } catch {
    return await new Promise(res=>{
      const img=new Image();
      img.onload=()=>res(true);img.onerror=()=>res(false);
      img.src=url;setTimeout(()=>res(false),5000);
    });
  }
}
async function notifyTechnicians(eventId, vars={}) {
  const token=SDB.get("tg_token");if(!token)return;
  const techs=SDB.get("technicians")||[];
  for(const tech of techs){
    if(!tech.telegramId)continue;
    if(!(tech.notifCats||[]).includes(eventId))continue;
    let tpl=SDB.get(`msg_${eventId}`)||`Event: ${eventId}`;
    Object.entries(vars).forEach(([k,v])=>{tpl=tpl.replaceAll(`{${k}}`,v||"");});
    await sendTelegram(token,tech.telegramId,tpl);
  }
}

// ─── Finance helpers ──────────────────────────────────────────────────────────
function calcRepairProfit(r){
  const rev=parseFloat(r.price)||0;
  const cost=(r.partsUsed||[]).reduce((s,p)=>s+(parseFloat(p.cost)||0)*(p.qty||1),0);
  return rev-cost;
}

// ─── Repair date system ───────────────────────────────────────────────────────
// createdAt   = date the phone was received (existing field, unchanged)
// doneAt      = when the repair was marked Done
// deliveredAt = when the customer collected the phone
// paidAt      = when the customer paid
// All three new fields are OPTIONAL. Repairs saved before this system existed
// simply don't have them and keep working exactly as before (see helpers).
const DATE_FIELDS=["doneAt","deliveredAt","paidAt"];

// Fields to merge into a repair when its status changes. `stamp` is the value
// to write (ISO string normally; the edit form passes a local datetime string).
function statusDatePatch(r,newStatus,stamp){
  const now=stamp||new Date().toISOString();
  const p={};
  // A repair that was NOT already Done and has no done date skipped the Done
  // step. Older Done repairs (no recorded date) are left alone — nothing was skipped.
  const skippedDone=!r.doneAt&&r.status!=="Done";
  if(newStatus==="Done"){
    if(!r.doneAt) p.doneAt=now;
    if(r.deliveredAt) p.deliveredAt=null;          // moved back from Delivered
  } else if(newStatus==="Delivered"){
    if(!r.deliveredAt) p.deliveredAt=now;
    if(skippedDone) p.doneAt=now;                  // skipped Done → same moment as delivery
  } else if(newStatus==="Awaiting Customer"){
    if(skippedDone) p.doneAt=now;                  // finished and waiting for the customer to collect
  } else if(newStatus==="Pending"||newStatus==="In Progress"){
    if(r.doneAt) p.doneAt=null;                    // work reopened
    if(r.deliveredAt) p.deliveredAt=null;
  }
  return p;
}
// Fields to merge when a repair is marked paid / unpaid.
function paidDatePatch(r,paid,stamp){
  if(paid) return {paid:true,paidAt:r.paidAt||stamp||new Date().toISOString()};
  return {paid:false,paidAt:null};
}
// Convert the date inputs coming from the edit form (local strings) to ISO.
// Keys that aren't present at all (older repairs) are left untouched.
function normalizeDateFields(data){
  const out={...data};
  DATE_FIELDS.forEach(k=>{
    if(!(k in out)) return;
    const v=out[k];
    if(!v){ out[k]=null; return; }
    const d=new Date(v);
    out[k]=isNaN(d.getTime())?null:d.toISOString();
  });
  return out;
}
// The date a repair's money counts toward in reports. Repairs paid before the
// payment-date system existed have no paidAt, so they keep using the received
// date — their old month totals do not move.
function getFinanceDate(r){ return new Date(r.paidAt||r.createdAt); }
function isInMonth(d,m,y){ return d.getMonth()===m&&d.getFullYear()===y; }
function isPaidRealised(r){ return (r.status==="Done"||r.status==="Delivered")&&!!r.paid; }
function daysBetween(a,b){ return Math.max(0,Math.floor((new Date(b)-new Date(a))/864e5)); }
// Days a finished phone has been waiting for pickup (null if unknown/not waiting).
// Only repairs with a recorded doneAt can answer this; older ones return null.
function daysWaitingPickup(r){
  if((r.status!=="Done"&&r.status!=="Awaiting Customer")||!r.doneAt||r.deliveredAt) return null;
  return daysBetween(r.doneAt,new Date());
}
// One place that applies a status change (with its dates) to a repair.
// opts.paid also marks it paid at the same moment ("Delivered & Paid").
function applyStatusChange(r,newStatus,opts){
  const stamp=new Date().toISOString();
  let out={...r,...statusDatePatch(r,newStatus,stamp),status:newStatus,updatedAt:stamp};
  if(opts&&opts.paid) out={...out,...paidDatePatch(out,true,stamp)};
  return out;
}
// Where you were in the Repairs list (tab, filters, search, scroll). Saved when
// you open a repair and restored when you come back, so you land exactly there.
let REPAIRS_VIEW=null;
function saveRepairsView(v){REPAIRS_VIEW={...(REPAIRS_VIEW||{}),...v};}
function clearRepairsView(){REPAIRS_VIEW=null;}
let NAV_COUNT=0; // in-app navigations so far; > 0 means "Back" has somewhere in the app to go

// ─── Scroll memory ───────────────────────────────────────────────────────────
// The page scrolls inside the .main element. New pages / views start at the top;
// going BACK to a page or list you left puts you exactly where you were.
const SCROLL_MEM={};        // sub-views inside a page (e.g. customers list, catalog brand list)
const PAGE_SCROLL={};       // whole pages, saved when you navigate away from them
const PAGE_RESTORE={v:null};// set by Back/Forward so the next page change restores instead of resetting
function mainEl(){return document.querySelector(".main");}
function scrollMainTo(v){
  [0,60,200].forEach(ms=>setTimeout(()=>requestAnimationFrame(()=>{const m=mainEl();if(m) m.scrollTop=v;}),ms));
}
function rememberScroll(key){const m=mainEl();if(m) SCROLL_MEM[key]=m.scrollTop;}
// Call with an id for the view being shown (e.g. "customers:list" / "customers:detail").
// When it changes: a view you earlier left from (remembered) restores its position,
// anything else starts at the top.
function useViewScroll(viewKey){
  const first=useRef(true);
  useEffect(()=>{
    if(first.current){first.current=false;return;}
    if(SCROLL_MEM[viewKey]!==undefined){const v=SCROLL_MEM[viewKey];delete SCROLL_MEM[viewKey];scrollMainTo(v);}
    else scrollMainTo(0);
  },[viewKey]);
}
// Shared contact link builders (customer page + repair page)
function contactNumber(phone){
  const cc=SDB.get("country_code")||"";
  const d=String(phone||"").replace(/\D/g,"");
  return cc&&d.startsWith("0")?cc+d.slice(1):d.replace(/^\+/,"");
}
// ─── PRINTING & RECEIPTS ENGINE ──────────────────────────────────────────────
const RECEIPT_PRESETS = [
  {id:'thermal58', label:'58mm Thermal Printer', widthMm:58, fontPx:11, isReceipt:true},
  {id:'thermal80', label:'80mm Thermal Printer', widthMm:80, fontPx:12, isReceipt:true},
  {id:'a5',        label:'A5 Half Page',         widthMm:148,fontPx:13, isReceipt:false},
  {id:'a4',        label:'A4 Full Page',         widthMm:210,fontPx:13, isReceipt:false},
];
function getReceiptPreset(id){ return RECEIPT_PRESETS.find(p=>p.id===id)||RECEIPT_PRESETS[1]; }
// Default label sets per language. Users can override any individual label
// in Settings → Printing & Receipts → Language, without touching this file.
const RECEIPT_I18N_DEFAULTS = {
  en: {
    receiptLabel:'Receipt', date:'Date', status:'Status', customer:'Customer', name:'Name', phone:'Phone',
    device:'Device', model:'Model', service:'Service', imei:'IMEI/SN', partsLabor:'Parts & Labor',
    subtotal:'Subtotal', depositPaid:'Deposit Paid', paidInFull:'✓ Paid in Full', balanceDue:'Balance Due',
    warrantyUntil:'Warranty until', notes:'Notes',
  },
  ar: {
    receiptLabel:'إيصال', date:'التاريخ', status:'الحالة', customer:'الزبون', name:'الاسم', phone:'الهاتف',
    device:'الجهاز', model:'الموديل', service:'الخدمة', imei:'IMEI / الرقم التسلسلي', partsLabor:'القطع والأجور',
    subtotal:'المجموع', depositPaid:'الدفعة المقدمة', paidInFull:'✓ مدفوع بالكامل', balanceDue:'المبلغ المتبقي',
    warrantyUntil:'الضمان حتى', notes:'ملاحظات',
  },
};
function getReceiptI18n(lang,settings){
  settings=settings||getReceiptSettings();
  const base=RECEIPT_I18N_DEFAULTS[lang]||RECEIPT_I18N_DEFAULTS.en;
  const overrides=(settings.translations&&settings.translations[lang])||{};
  return {...base,...overrides};
}
function getReceiptSettings(){
  const saved=SDB.get('receipt_settings')||{};
  return {
    paper:'thermal80', showLogo:true, showAddress:true, showPhone:true, showEmail:false,
    showWebsite:false, showNotes:true, showWarranty:true, showDeposit:true,
    footerText:'Thank you for your business!',
    accentColor:'#0A84FF', fontFamily:'system', headerStyle:'banner',
    receiptLang:'en',
    ...saved,
    translations:{en:{...((saved.translations||{}).en||{})},ar:{...((saved.translations||{}).ar||{})}},
  };
}
function saveReceiptSettings(obj){ SDB.set('receipt_settings',obj); }

// Default label sets for the printed Monthly Report, per language.
// Users can override any of these individually in Settings without touching this file.
const REPORT_I18N_DEFAULTS = {
  en: {
    reportTitle:'Monthly Report', repairsWord:'repairs', generatedWord:'Generated',
    colId:'#', colCustomer:'Customer', colDevice:'Device', colType:'Type', colStatus:'Status',
    colPrice:'Price', colCost:'Cost', colProfit:'Profit', colPaid:'Paid', colPaidDate:'Paid On', colDate:'Received',
    statusPaid:'✓ Paid', statusUnpaid:'Unpaid', statusNA:'—',
    sumTotalJobs:'Total Jobs', sumPaidJobs:'Paid Jobs', sumUnpaidJobs:'Unpaid Jobs', sumRevenue:'Revenue (paid)',
    sumPartsCost:'Parts Cost', sumNetProfit:'Net Profit', sumPendingProfit:'Pending Profit',
    sumLosses:'Losses', sumLossCount:'Loss Jobs', sumDeposits:'Deposits Held', sumOutstanding:'Outstanding',
    sumAvgValue:'Avg. Repair Value', sumCompletionRate:'Completion Rate',
    statusPending:'Pending', statusInProgress:'In Progress', statusDone:'Done',
    statusDelivered:'Delivered', statusCancelled:'Cancelled', statusAwaitingCustomer:'Awaiting Customer',
  },
  ar: {
    reportTitle:'التقرير الشهري', repairsWord:'إصلاحات', generatedWord:'تم الإنشاء بتاريخ',
    colId:'#', colCustomer:'الزبون', colDevice:'الجهاز', colType:'النوع', colStatus:'الحالة',
    colPrice:'السعر', colCost:'التكلفة', colProfit:'الربح', colPaid:'الدفع', colPaidDate:'تاريخ الدفع', colDate:'تاريخ الاستلام',
    statusPaid:'✓ مدفوع', statusUnpaid:'غير مدفوع', statusNA:'—',
    sumTotalJobs:'إجمالي الأعمال', sumPaidJobs:'الأعمال المدفوعة', sumUnpaidJobs:'الأعمال غير المدفوعة', sumRevenue:'الإيرادات (مدفوعة)',
    sumPartsCost:'تكلفة القطع', sumNetProfit:'صافي الربح', sumPendingProfit:'الربح المعلق',
    sumLosses:'الخسائر', sumLossCount:'أعمال خاسرة', sumDeposits:'الدفعات المقدمة', sumOutstanding:'المبلغ المتبقي',
    sumAvgValue:'متوسط قيمة الإصلاح', sumCompletionRate:'نسبة الإنجاز',
    statusPending:'قيد الانتظار', statusInProgress:'قيد التنفيذ', statusDone:'مكتمل',
    statusDelivered:'تم التسليم', statusCancelled:'ملغى', statusAwaitingCustomer:'بانتظار الزبون',
  },
};
function getReportI18n(lang,settings){
  settings=settings||getReportSettings();
  const base=REPORT_I18N_DEFAULTS[lang]||REPORT_I18N_DEFAULTS.en;
  const overrides=(settings.translations&&settings.translations[lang])||{};
  return {...base,...overrides};
}
// Built-in Arabic translations for the default repair type list, used as a
// fallback so Arabic reports look right out of the box. User overrides
// (typed in Settings) always take priority over these.
const DEFAULT_TYPE_TRANSLATIONS_AR={
  'Screen Replacement':'استبدال الشاشة',
  'Battery Replacement':'استبدال البطارية',
  'Charging Port Fix':'إصلاح منفذ الشحن',
  'Water Damage':'ضرر المياه',
  'Camera Repair':'إصلاح الكاميرا',
  'Speaker Fix':'إصلاح السماعة',
  'Microphone Fix':'إصلاح المايكروفون',
  'Software Issue':'مشكلة برمجية',
  'Back Glass Repair':'إصلاح الزجاج الخلفي',
  'Button Repair':'إصلاح الأزرار',
  'Data Recovery':'استعادة البيانات',
  'Other':'أخرى',
};
// Repair type names are otherwise freeform/user-defined, so translation
// falls back to a lookup table the user fills in themselves for custom types.
function translateRepairType(typeName,lang,settings){
  if(lang!=='ar'||!typeName) return typeName;
  settings=settings||getReportSettings();
  const userMap=(settings.typeTranslations&&settings.typeTranslations.ar)||{};
  return userMap[typeName]||DEFAULT_TYPE_TRANSLATIONS_AR[typeName]||typeName;
}
function translateStatus(status,lang,L){
  if(lang!=='ar') return status;
  const map={Pending:L.statusPending,'In Progress':L.statusInProgress,Done:L.statusDone,
    Delivered:L.statusDelivered,Cancelled:L.statusCancelled,'Awaiting Customer':L.statusAwaitingCustomer};
  return map[status]||status;
}
// Builds the summary card array shared by both the real printed report and
// the settings live preview, so toggling a card or translating its label
// behaves identically in both places. `values` holds pre-formatted display
// strings keyed by card id (see summaryCards in getReportSettings).
function buildReportSummary(values,lang,settings){
  const L=getReportI18n(lang,settings);
  const sc=(settings&&settings.summaryCards)||{};
  const CARD_DEFS=[
    ['totalJobs',L.sumTotalJobs,'#1a1a1a'],
    ['paidJobs',L.sumPaidJobs,'#0A63C2'],
    ['unpaidJobs',L.sumUnpaidJobs,'#B25E09'],
    ['revenue',L.sumRevenue,'#0A9E4C'],
    ['partsCost',L.sumPartsCost,'#B25E09'],
    ['netProfit',L.sumNetProfit,values.netProfitColor||'#0A63C2'],
    ['pendingProfit',L.sumPendingProfit,'#B25E09'],
    ['losses',L.sumLosses,'#D92D20'],
    ['lossCount',L.sumLossCount,'#D92D20'],
    ['deposits',L.sumDeposits,'#0A9E4C'],
    ['outstanding',L.sumOutstanding,'#B25E09'],
    ['avgValue',L.sumAvgValue,'#0A63C2'],
    ['completionRate',L.sumCompletionRate,'#8E44AD'],
  ];
  return CARD_DEFS.filter(([key])=>sc[key]!==false&&values[key]!==undefined)
    .map(([key,label,color])=>({label,value:values[key],color}));
}
function getReportSettings(){
  const saved=SDB.get('report_settings')||{};
  return {
    columns:{ id:true, customer:true, device:true, type:true, status:true, price:true, cost:true, profit:true, paid:true, paidDate:true, date:true, ...(saved.columns||{}) },
    lang:'en',
    header:{ showLogo:true, showName:true, showAddress:true, showPhone:true, showEmail:true, position:'top', ...(saved.header||{}) },
    // Which summary cards appear above the table, and in what order.
    summaryCards:{
      totalJobs:true, paidJobs:true, unpaidJobs:false, revenue:true, partsCost:true,
      netProfit:true, pendingProfit:true, losses:true, lossCount:false, deposits:false,
      outstanding:false, avgValue:false, completionRate:false,
      ...(saved.summaryCards||{}),
    },
    ...saved,
    translations:{ en:{...((saved.translations||{}).en||{})}, ar:{...((saved.translations||{}).ar||{})} },
    typeTranslations:{ ar:{...((saved.typeTranslations||{}).ar||{})} },
  };
}
function saveReportSettings(obj){ SDB.set('report_settings',obj); }
function getShopInfo(){
  return {
    name:SDB.get('shop_name')||'RepairOS',
    logo:SDB.get('shop_logo')||'',
    tagline:SDB.get('shop_tagline')||'',
    address:SDB.get('shop_address')||'',
    phone:SDB.get('shop_phone')||'',
    email:SDB.get('shop_email')||'',
    website:SDB.get('shop_website')||'',
  };
}
// Escape helper for safe HTML injection
function escHtml(s){ return String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }

// Build a self-contained printable HTML document for a single repair receipt
function generateReceiptHTML(repair,fmt){
  const settings=getReceiptSettings();
  const preset=getReceiptPreset(settings.paper);
  const shop=getShopInfo();
  const r=repair;
  const lang=settings.receiptLang||'en';
  const isRtl=lang==='ar';
  const L=getReceiptI18n(lang,settings);
  const allTypes=r.types&&r.types.length?r.types:(r.type?[r.type]:[]);
  const priceNum=parseFloat(r.price)||0;
  const depositNum=parseFloat(r.deposit)||0;
  const balanceDue=priceNum-depositNum;
  const dateStr=new Date(r.createdAt||Date.now()).toLocaleString(isRtl?'ar-IQ':'en-US');
  const wUntil=r.warrantyUntil?new Date(r.warrantyUntil).toLocaleDateString(isRtl?'ar-IQ':'en-US'):null;
  const accent=settings.accentColor||'#0A84FF';
  const fontStacks={
    system:isRtl?"'Segoe UI',Tahoma,Arial,-apple-system,sans-serif":"-apple-system,'Segoe UI',Roboto,Arial,sans-serif",
    serif:isRtl?"'Times New Roman',Tahoma,serif":"Georgia,'Times New Roman',serif",
    mono:isRtl?"Tahoma,'SF Mono',monospace":"'SF Mono','Courier New',monospace",
  };
  const fontFamily=fontStacks[settings.fontFamily]||fontStacks.system;
  const isReceiptSize=preset.isReceipt;

  const partsRows=(r.partsUsed||[]).map(p=>`
    <tr>
      <td style="text-align:${isRtl?'right':'left'};padding:5px 0;word-break:break-word;">${escHtml(p.name)}${p.qty>1?` <span style="color:#999;">× ${p.qty}</span>`:''}</td>
      <td style="text-align:${isRtl?'left':'right'};padding:5px 0;font-weight:600;white-space:nowrap;">${escHtml(fmt((p.price||0)*(p.qty||1)))}</td>
    </tr>`).join('');

  // Page + body sizing — real padding baked into body so the on-screen preview
  // AND the physical print both show breathing room around the content.
  // @page margin is invisible in on-screen preview (browsers only apply it
  // during real printing), so ALL whitespace lives in body padding instead.
  // This keeps the preview and the physical printout pixel-identical.
  const pageCss=isReceiptSize
    ? `@page{size:${preset.widthMm}mm auto;margin:0;}
       body{width:${preset.widthMm}mm;margin:0 auto;padding:${preset.widthMm===58?'14px 12px 18px':'16px 15px 20px'};}`
    : `@page{size:${preset.widthMm===148?'A5':'A4'};margin:0;}
       body{max-width:${preset.widthMm}mm;margin:0 auto;padding:16mm 15mm 18mm;}`;

  const headerHtml=settings.headerStyle==='banner'
    ? `<div style="background:linear-gradient(135deg,${accent}14,${accent}05);border-radius:${isReceiptSize?'10px':'14px'};padding:${isReceiptSize?'14px 10px':'20px 18px'};margin-bottom:${isReceiptSize?'12px':'18px'};text-align:center;border:1px solid ${accent}22;">
        ${settings.showLogo&&shop.logo?`<img class="logo" src="${shop.logo}"/>`:''}
        <div class="shop-name" style="color:${accent};">${escHtml(shop.name)}</div>
        ${shop.tagline?`<div class="shop-tagline">${escHtml(shop.tagline)}</div>`:''}
        <div class="shop-meta">
          ${settings.showAddress&&shop.address?escHtml(shop.address)+'<br/>':''}
          ${settings.showPhone&&shop.phone?'📞 '+escHtml(shop.phone)+'&nbsp;&nbsp;':''}
          ${settings.showEmail&&shop.email?'✉️ '+escHtml(shop.email):''}
          ${settings.showWebsite&&shop.website?'<br/>🌐 '+escHtml(shop.website):''}
        </div>
      </div>`
    : `<div class="center" style="margin-bottom:${isReceiptSize?'12px':'18px'};">
        ${settings.showLogo&&shop.logo?`<img class="logo" src="${shop.logo}"/>`:''}
        <div class="shop-name">${escHtml(shop.name)}</div>
        ${shop.tagline?`<div class="shop-tagline">${escHtml(shop.tagline)}</div>`:''}
        <div class="shop-meta">
          ${settings.showAddress&&shop.address?escHtml(shop.address)+'<br/>':''}
          ${settings.showPhone&&shop.phone?'📞 '+escHtml(shop.phone)+'&nbsp;&nbsp;':''}
          ${settings.showEmail&&shop.email?'✉️ '+escHtml(shop.email):''}
          ${settings.showWebsite&&shop.website?'<br/>🌐 '+escHtml(shop.website):''}
        </div>
        <div style="height:3px;width:44px;background:${accent};border-radius:3px;margin:10px auto 0;"></div>
      </div>`;

  return `<!DOCTYPE html><html dir="${isRtl?'rtl':'ltr'}" lang="${lang}"><head><meta charset="utf-8"><title>${L.receiptLabel} #${r.id}</title>
  <style>
    ${pageCss}
    *{box-sizing:border-box;}
    html,body{background:#fff;}
    body{font-family:${fontFamily};font-size:${preset.fontPx}px;color:#1a1a1a;line-height:1.5;-webkit-font-smoothing:antialiased;direction:${isRtl?'rtl':'ltr'};overflow-wrap:break-word;}
    .center{text-align:center;}
    .logo{max-width:${isReceiptSize?'52px':'72px'};max-height:${isReceiptSize?'52px':'72px'};margin:0 auto 8px;display:block;object-fit:contain;}
    .shop-name{font-size:${preset.fontPx+6}px;font-weight:800;margin-bottom:2px;letter-spacing:-.01em;overflow-wrap:break-word;}
    .shop-tagline{font-size:${preset.fontPx-1}px;color:#777;margin-bottom:6px;font-style:${isRtl?'normal':'italic'};}
    .shop-meta{font-size:${preset.fontPx-2}px;color:#555;line-height:1.6;overflow-wrap:break-word;}
    .divider{border-top:1px dashed #ccc;margin:12px 0;}
    .divider-solid{border-top:2px solid #1a1a1a;margin:14px 0;}
    .section-label{font-size:${preset.fontPx-2}px;font-weight:800;color:${accent};text-transform:${isRtl?'none':'uppercase'};letter-spacing:.06em;margin:14px 0 8px;}
    .row{display:flex;flex-wrap:wrap;justify-content:space-between;gap:3px 10px;margin-bottom:6px;font-size:${preset.fontPx}px;}
    .row .l{color:#666;flex-shrink:0;}
    .row .v{font-weight:600;text-align:${isRtl?'left':'right'};color:#111;overflow-wrap:break-word;min-width:0;flex:1 1 auto;max-width:70%;}
    table{width:100%;border-collapse:collapse;margin:2px 0;table-layout:fixed;}
    table td{font-size:${preset.fontPx}px;border-bottom:1px solid #f0f0f0;}
    table tr:last-child td{border-bottom:none;}
    .total-box{background:${accent}0d;border:1.5px solid ${accent}33;border-radius:${isReceiptSize?'8px':'10px'};padding:${isReceiptSize?'10px 12px':'14px 16px'};margin-top:10px;}
    .total-row{display:flex;${isReceiptSize?'flex-direction:column;align-items:center;gap:4px;text-align:center;':'flex-wrap:wrap;justify-content:space-between;align-items:baseline;gap:4px 10px;'}font-size:${isReceiptSize?preset.fontPx+3:preset.fontPx+5}px;font-weight:800;color:${accent};}
    .total-row .lbl{font-size:${preset.fontPx-1}px;font-weight:700;color:#444;text-transform:${isRtl?'none':'uppercase'};letter-spacing:.04em;}
    .footer{text-align:center;margin-top:${isReceiptSize?'16px':'22px'};font-size:${preset.fontPx-1}px;color:#888;overflow-wrap:break-word;}
    .badge{display:inline-block;font-size:${preset.fontPx-2}px;font-weight:700;padding:4px 11px;border-radius:20px;background:${accent}12;color:${accent};border:1px solid ${accent}30;margin-top:8px;}
    .id-tag{display:inline-block;font-size:${preset.fontPx-1}px;font-weight:700;color:#999;letter-spacing:.02em;}
    @media print{ body{-webkit-print-color-adjust:exact;print-color-adjust:exact;} }
  </style></head>
  <body>
    ${headerHtml}
    <div class="row"><span class="l">${L.receiptLabel}</span><span class="id-tag">#${r.id}</span></div>
    <div class="row"><span class="l">${L.date}</span><span class="v">${dateStr}</span></div>
    <div class="row"><span class="l">${L.status}</span><span class="v">${escHtml(r.status)}</span></div>
    <div class="divider"></div>
    <div class="section-label">${L.customer}</div>
    <div class="row"><span class="l">${L.name}</span><span class="v">${escHtml(r.customerName||'No name')}</span></div>
    ${r.phone?`<div class="row"><span class="l">${L.phone}</span><span class="v">${escHtml(r.phone)}</span></div>`:''}
    <div class="section-label">${L.device}</div>
    <div class="row"><span class="l">${L.model}</span><span class="v">${escHtml(r.device||'')}</span></div>
    ${allTypes.length?`<div class="row"><span class="l">${L.service}</span><span class="v">${escHtml(allTypes.join(', '))}</span></div>`:''}
    ${r.imei?`<div class="row"><span class="l">${L.imei}</span><span class="v" style="font-family:${fontStacks.mono};font-size:${preset.fontPx-2}px;direction:ltr;">${escHtml(r.imei)}</span></div>`:''}
    ${partsRows?`<div class="section-label">${L.partsLabor}</div><table>${partsRows}</table>`:''}
    <div class="total-box">
      <div class="row" style="margin-bottom:4px;"><span class="l">${L.subtotal}</span><span class="v">${escHtml(fmt(priceNum))}</span></div>
      ${settings.showDeposit&&depositNum>0?`<div class="row" style="margin-bottom:4px;"><span class="l">${L.depositPaid}</span><span class="v">-${escHtml(fmt(depositNum))}</span></div>`:''}
      <div class="divider" style="margin:8px 0;"></div>
      <div class="total-row"><span class="lbl">${r.paid?L.paidInFull:L.balanceDue}</span><span>${r.paid?escHtml(fmt(priceNum)):escHtml(fmt(balanceDue))}</span></div>
    </div>
    ${settings.showWarranty&&wUntil?`<div class="center"><span class="badge">🛡️ ${L.warrantyUntil} ${wUntil}</span></div>`:''}
    ${settings.showNotes&&r.notes?`<div class="section-label">${L.notes}</div><div style="font-size:${preset.fontPx-1}px;color:#444;line-height:1.6;overflow-wrap:break-word;">${escHtml(r.notes)}</div>`:''}
    <div class="divider-solid"></div>
    <div class="footer">${escHtml(settings.footerText)}</div>
  </body></html>`;
}

// Open a new window, write HTML, trigger print
function printHTML(html){
  const w=window.open('','_blank','width=440,height=680');
  if(!w){ toast('⚠️','Popup blocked','Allow popups for this site to print'); return; }
  w.document.open(); w.document.write(html); w.document.close();
  const doPrint=()=>{ try{ w.focus(); w.print(); }catch(e){} };
  w.onload=doPrint;
  setTimeout(doPrint,350);
}
function printReceipt(repair,fmt){ printHTML(generateReceiptHTML(repair,fmt)); }

// Build a printable A4 report — used for monthly summary / device lists
function generateReportHTML({title,subtitle,columns,rows,summary,lang,headerConfig}){
  const shop=getShopInfo();
  const receiptSettings=getReceiptSettings();
  const accent=receiptSettings.accentColor||'#0A84FF';
  const isRtl=lang==='ar';
  const hc={showLogo:true,showName:true,showAddress:true,showPhone:true,showEmail:true,position:'top',...(headerConfig||{})};
  const fontFamily=isRtl?"'Segoe UI',Tahoma,Arial,-apple-system,sans-serif":"-apple-system,'Segoe UI',Roboto,Arial,sans-serif";

  const headCells=columns.map(c=>`<th style="text-align:${c.align||'left'};">${escHtml(c.label)}</th>`).join('');
  const bodyRows=rows.map(row=>`<tr>${columns.map(c=>`<td style="text-align:${c.align||'left'};">${escHtml(row[c.key]??'')}</td>`).join('')}</tr>`).join('');
  const summaryHtml=(summary||[]).map(s=>`
    <div style="display:inline-block;text-align:center;padding:12px 20px;background:${accent}0c;border:1px solid ${accent}22;border-radius:10px;margin:0 8px 10px 0;">
      <div style="font-size:19px;font-weight:800;color:${s.color||'#111'};">${escHtml(s.value)}</div>
      <div style="font-size:10.5px;color:#666;margin-top:3px;font-weight:600;text-transform:${isRtl?'none':'uppercase'};letter-spacing:.03em;">${escHtml(s.label)}</div>
    </div>`).join('');

  const showHeaderBlock=hc.showLogo||hc.showName||hc.showAddress||hc.showPhone||hc.showEmail;
  const headerBlock=showHeaderBlock?`
    <div class="header">
      ${hc.showLogo&&shop.logo?`<img src="${shop.logo}"/>`:''}
      <div>
        ${hc.showName?`<div class="shop-name">${escHtml(shop.name)}</div>`:''}
        <div class="shop-meta">${[hc.showAddress&&shop.address,hc.showPhone&&shop.phone,hc.showEmail&&shop.email].filter(Boolean).map(escHtml).join(' · ')}</div>
      </div>
    </div>`:'';

  return `<!DOCTYPE html><html dir="${isRtl?'rtl':'ltr'}" lang="${lang||'en'}"><head><meta charset="utf-8"><title>${escHtml(title)}</title>
  <style>
    @page{size:A4;margin:0;}
    *{box-sizing:border-box;}
    html,body{background:#fff;}
    body{font-family:${fontFamily};font-size:12px;color:#1a1a1a;padding:14mm 13mm 16mm;-webkit-font-smoothing:antialiased;direction:${isRtl?'rtl':'ltr'};}
    .header{display:flex;align-items:center;gap:14px;margin-bottom:18px;padding-bottom:16px;border-bottom:3px solid ${accent};}
    .header img{width:52px;height:52px;object-fit:contain;border-radius:8px;}
    .shop-name{font-size:19px;font-weight:800;letter-spacing:-.01em;}
    .shop-meta{font-size:10.5px;color:#666;margin-top:3px;}
    h1{font-size:17px;margin:0 0 3px;font-weight:800;color:${accent};}
    .subtitle{font-size:11px;color:#777;margin-bottom:16px;}
    table{width:100%;border-collapse:collapse;margin-top:10px;border-radius:8px;overflow:hidden;}
    th{background:${accent}0f;padding:9px 10px;font-size:10.5px;font-weight:800;text-transform:${isRtl?'none':'uppercase'};letter-spacing:.04em;color:${accent};border-bottom:2px solid ${accent}30;}
    td{padding:8px 10px;font-size:11px;border-bottom:1px solid #f0f0f0;}
    tr:nth-child(even) td{background:#fafafa;}
    .gen-date{text-align:${isRtl?'left':'right'};font-size:9.5px;color:#aaa;margin-top:24px;padding-top:10px;border-top:1px solid #eee;}
    @media print{ body{-webkit-print-color-adjust:exact;print-color-adjust:exact;} }
  </style></head>
  <body>
    ${hc.position==='top'?headerBlock:''}
    <h1>${escHtml(title)}</h1>
    ${subtitle?`<div class="subtitle">${escHtml(subtitle)}</div>`:''}
    ${summaryHtml?`<div>${summaryHtml}</div>`:''}
    <table><thead><tr>${headCells}</tr></thead><tbody>${bodyRows}</tbody></table>
    ${hc.position==='bottom'?headerBlock:''}
    <div class="gen-date">${new Date().toLocaleString(isRtl?'ar-IQ':'en-US')}</div>
  </body></html>`;
}
function printReport(opts){ printHTML(generateReportHTML(opts)); }

function calcFinancials(repairs,withdrawals,splitPct){
  // Only PAID repairs count toward real profit/splits. Done-but-unpaid work
  // is tracked separately as "pending" — it doesn't touch the real numbers
  // until the customer actually pays.
  const paidRepairs=repairs.filter(r=>(r.status==="Done"||r.status==="Delivered")&&r.paid);
  const unpaidRepairs=repairs.filter(r=>(r.status==="Done"||r.status==="Delivered")&&!r.paid);

  const totalRevenue=paidRepairs.reduce((s,r)=>s+(parseFloat(r.price)||0),0);
  const totalPartsCost=paidRepairs.reduce((s,r)=>s+(r.partsUsed||[]).reduce((x,p)=>x+(parseFloat(p.cost)||0)*(p.qty||1),0),0);
  const netProfit=totalRevenue-totalPartsCost;
  const lossJobs=paidRepairs.filter(r=>calcRepairProfit(r)<0);
  const lossTotal=lossJobs.reduce((s,r)=>s+calcRepairProfit(r),0);
  // ownerOnly → 100% to owner; storeOnly → 100% to store; normal → splitPct
  const ownerCut=paidRepairs.reduce((s,r)=>{
    const profit=calcRepairProfit(r);
    if(r.ownerOnly) return s+profit;
    if(r.storeOnly) return s;
    return s+profit*(splitPct/100);
  },0);
  const storeCut=paidRepairs.reduce((s,r)=>{
    const profit=calcRepairProfit(r);
    if(r.ownerOnly) return s;
    if(r.storeOnly) return s+profit;
    return s+profit*((100-splitPct)/100);
  },0);
  const totalWithdrawn=(withdrawals||[]).reduce((s,w)=>s+(parseFloat(w.amount)||0),0);
  const ownerBalance=ownerCut-totalWithdrawn;

  // Pending (unpaid) numbers — informational only, never added to real totals/splits
  const unpaidRevenue=unpaidRepairs.reduce((s,r)=>s+(parseFloat(r.price)||0),0);
  const unpaidPartsCost=unpaidRepairs.reduce((s,r)=>s+(r.partsUsed||[]).reduce((x,p)=>x+(parseFloat(p.cost)||0)*(p.qty||1),0),0);
  const unpaidProfit=unpaidRevenue-unpaidPartsCost;
  const unpaidCount=unpaidRepairs.length;

  return {totalRevenue,totalPartsCost,netProfit,ownerCut,storeCut,totalWithdrawn,ownerBalance,lossTotal,lossJobCount:lossJobs.length,
    unpaidRevenue,unpaidPartsCost,unpaidProfit,unpaidCount};
}

// ─── Toast ────────────────────────────────────────────────────────────────────
let _toastFn=null;
const toast=(icon,title,body)=>{if(_toastFn)_toastFn({icon,title,body,id:Date.now()});};

// ─── Icons ────────────────────────────────────────────────────────────────────
const PATHS={
  dashboard:"M3 3h7v7H3zm11 0h7v7h-7zM3 14h7v7H3zm11 0h7v7h-7z",
  repairs:"M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z",
  parts:"M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z",
  customers:"M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zm5 2a4 4 0 013 3.87M16 3.13a4 4 0 010 7.75",
  analytics:"M18 20V10M12 20V4M6 20v-6",
  report:"M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6M16 13H8M16 17H8M10 9H8",
  finance:"M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6",
  warranty:"M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  catalog:"M4 19.5A2.5 2.5 0 016.5 17H20M4 19.5A2.5 2.5 0 014 17V5a2 2 0 012-2h14a2 2 0 012 2v12M4 19.5V20a2 2 0 002 2h12a2 2 0 002-2v-.5",
  settings:"M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z",
  plus:"M12 5v14M5 12h14",bell:"M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0",
  close:"M18 6L6 18M6 6l12 12",search:"M21 21l-4.35-4.35M17 11A6 6 0 115 11a6 6 0 0112 0z",
  edit:"M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z",
  trash:"M3 6h18M8 6V4a1 1 0 011-1h6a1 1 0 011 1v2M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6M10 11v6M14 11v6",
  send:"M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z",
  withdraw:"M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z",
  check:"M20 6L9 17l-5-5",chevron:"M9 18l6-6-6-6",back:"M19 12H5M12 5l-7 7 7 7",
  upload:"M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12",
  menu:"M3 12h18M3 6h18M3 18h18",
};
const I=({n,s=17,c="currentColor"})=>(
  <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d={PATHS[n]||""}/>
  </svg>
);
const TgIcon=({s=17})=>(<svg width={s} height={s} viewBox="0 0 24 24" fill="#29B6F6"><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12L7.119 13.92l-2.96-.924c-.643-.204-.657-.643.136-.953l11.57-4.461c.537-.194 1.006.131.83.64z"/></svg>);
const WaIcon=({s=17})=>(<svg width={s} height={s} viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>);


// ─── Theme System ─────────────────────────────────────────────────────────────
const THEMES = {
  obsidian: {
    name:"Obsidian",icon:"🖤",
    bg:"#000",bg2:"#0a0a0a",
    gl:"rgba(255,255,255,0.04)",glb:"rgba(255,255,255,0.08)",glh:"rgba(255,255,255,0.08)",
    tx:"#fff",t2:"rgba(255,255,255,0.6)",t3:"rgba(255,255,255,0.35)",
    blue:"#0A84FF",green:"#30D158",orange:"#FF9F0A",red:"#FF453A",purple:"#BF5AF2",teal:"#5AC8FA",
    r:"16px",rs:"10px",
    sbBg:"rgba(7,7,7,0.97)",cardBg:"rgba(255,255,255,0.03)",
  },
  midnight: {
    name:"Midnight Blue",icon:"🌌",
    bg:"#060818",bg2:"#0a0f1e",
    gl:"rgba(100,140,255,0.06)",glb:"rgba(100,140,255,0.12)",glh:"rgba(100,140,255,0.1)",
    tx:"#e8eeff",t2:"rgba(200,215,255,0.65)",t3:"rgba(160,185,255,0.4)",
    blue:"#4F8EF7",green:"#2DD87A",orange:"#FF9F45",red:"#FF5C57",purple:"#B98CFF",teal:"#4ECFFF",
    r:"16px",rs:"10px",
    sbBg:"rgba(4,6,18,0.97)",cardBg:"rgba(100,140,255,0.04)",
  },
  forest: {
    name:"Forest",icon:"🌲",
    bg:"#050f08",bg2:"#080f0b",
    gl:"rgba(80,220,120,0.05)",glb:"rgba(80,220,120,0.1)",glh:"rgba(80,220,120,0.09)",
    tx:"#d8f0e0",t2:"rgba(180,240,200,0.6)",t3:"rgba(140,200,160,0.4)",
    blue:"#2FC972",green:"#5DE89B",orange:"#F5A623",red:"#FF5F5F",purple:"#A78BFA",teal:"#34D1BF",
    r:"16px",rs:"10px",
    sbBg:"rgba(3,9,5,0.97)",cardBg:"rgba(80,220,120,0.04)",
  },
  crimson: {
    name:"Crimson",icon:"🔴",
    bg:"#0f0508",bg2:"#150a0d",
    gl:"rgba(255,60,100,0.05)",glb:"rgba(255,60,100,0.1)",glh:"rgba(255,60,100,0.09)",
    tx:"#ffe8ee",t2:"rgba(255,200,215,0.65)",t3:"rgba(255,160,180,0.4)",
    blue:"#FF3C64",green:"#3FE08B",orange:"#FF8C42",red:"#FF4545",purple:"#C77DFF",teal:"#38C9E0",
    r:"16px",rs:"10px",
    sbBg:"rgba(10,3,7,0.97)",cardBg:"rgba(255,60,100,0.04)",
  },
  arctic: {
    name:"Arctic",icon:"🧊",
    bg:"#06090f",bg2:"#0b1018",
    gl:"rgba(140,200,255,0.05)",glb:"rgba(140,200,255,0.1)",glh:"rgba(140,200,255,0.09)",
    tx:"#e8f4ff",t2:"rgba(180,220,255,0.65)",t3:"rgba(140,190,240,0.4)",
    blue:"#38B6FF",green:"#3DEBA0",orange:"#FFB347",red:"#FF5C7A",purple:"#A78AFF",teal:"#00E5CC",
    r:"16px",rs:"10px",
    sbBg:"rgba(4,7,14,0.97)",cardBg:"rgba(140,200,255,0.04)",
  },
  sunset: {
    name:"Sunset",icon:"🌅",
    bg:"#0f0800",bg2:"#150d04",
    gl:"rgba(255,140,60,0.05)",glb:"rgba(255,140,60,0.1)",glh:"rgba(255,140,60,0.09)",
    tx:"#fff0e0",t2:"rgba(255,220,180,0.65)",t3:"rgba(255,190,140,0.4)",
    blue:"#FF7C2A",green:"#3DE88A",orange:"#FFB240",red:"#FF4545",purple:"#C77DFF",teal:"#29D6C4",
    r:"16px",rs:"10px",
    sbBg:"rgba(10,5,0,0.97)",cardBg:"rgba(255,140,60,0.04)",
  },
  light: {
    name:"Light",icon:"☀️",
    bg:"#f5f5f7",bg2:"#ffffff",
    gl:"rgba(0,0,0,0.04)",glb:"rgba(0,0,0,0.1)",glh:"rgba(0,0,0,0.07)",
    tx:"#1d1d1f",t2:"rgba(0,0,0,0.55)",t3:"rgba(0,0,0,0.35)",
    blue:"#0071E3",green:"#28C840",orange:"#FF9500",red:"#FF3B30",purple:"#9B59F5",teal:"#32ADE6",
    r:"16px",rs:"10px",
    sbBg:"rgba(248,248,250,0.97)",cardBg:"rgba(0,0,0,0.03)",
  },
  slate: {
    name:"Slate",icon:"🌫️",
    bg:"#1a1a2e",bg2:"#16213e",
    gl:"rgba(150,170,255,0.05)",glb:"rgba(150,170,255,0.1)",glh:"rgba(150,170,255,0.09)",
    tx:"#e8e8f0",t2:"rgba(200,200,230,0.65)",t3:"rgba(160,160,200,0.4)",
    blue:"#7C83FD",green:"#3CE09A",orange:"#FFA844",red:"#FF5C7A",purple:"#BD93F9",teal:"#8BE9FD",
    r:"16px",rs:"10px",
    sbBg:"rgba(14,14,28,0.97)",cardBg:"rgba(100,110,200,0.05)",
  },
};

const FONTS = {
  system:  {name:"System Default", value:"-apple-system,BlinkMacSystemFont,'SF Pro Display',Tahoma,sans-serif"},
  inter:   {name:"Inter",          value:"'Inter','Segoe UI',system-ui,sans-serif"},
  mono:    {name:"Monospace",      value:"'SF Mono','Fira Code','Cascadia Code',monospace"},
  rounded: {name:"Rounded",        value:"'Nunito','Quicksand','Varela Round',system-ui,sans-serif"},
  serif:   {name:"Serif",          value:"'Georgia','Cambria','Times New Roman',serif"},
  arabic:  {name:"Arabic Optimized",value:"'Noto Sans Arabic','Amiri',system-ui,sans-serif"},
};

const RADIUS_PRESETS = {
  sharp:  {name:"Sharp",  r:"6px",  rs:"4px"},
  normal: {name:"Normal", r:"16px", rs:"10px"},
  round:  {name:"Round",  r:"22px", rs:"14px"},
  pill:   {name:"Pill",   r:"30px", rs:"18px"},
};

const DENSITY_PRESETS = {
  compact:  {name:"Compact",  pageP:"14px 18px", cardP:"11px 14px"},
  normal:   {name:"Normal",   pageP:"26px 28px", cardP:"14px 16px"},
  spacious: {name:"Spacious", pageP:"36px 38px", cardP:"20px 24px"},
};

function buildThemeCSS(themeKey, fontKey, radiusKey, densityKey, accentColor){
  const th = THEMES[themeKey]   || THEMES.obsidian;
  const fn = FONTS[fontKey]     || FONTS.system;
  const rd = RADIUS_PRESETS[radiusKey] || RADIUS_PRESETS.normal;
  const dn = DENSITY_PRESETS[densityKey] || DENSITY_PRESETS.normal;
  const acc = accentColor || th.blue;
  return `
:root{
  --bg:${th.bg};--bg2:${th.bg2};
  --gl:${th.gl};--glb:${th.glb};--glh:${th.glh};
  --tx:${th.tx};--t2:${th.t2};--t3:${th.t3};
  --blue:${acc};--green:${th.green};--orange:${th.orange};--red:${th.red};--purple:${th.purple};--teal:${th.teal};
  --r:${rd.r};--rs:${rd.rs};--sw:228px;
  --sb-bg:${th.sbBg};--card-bg:${th.cardBg};
  --font:${fn.value};
  --page-p:${dn.pageP};--card-p:${dn.cardP};
}
body{font-family:var(--font);background:var(--bg);color:var(--tx);height:100vh;overflow:hidden;}
`;
}

function loadAppearance(){
  try{
    return JSON.parse(localStorage.getItem('ros_appearance')||'{}');
  }catch{return{};}
}
function saveAppearance(obj){
  localStorage.setItem('ros_appearance',JSON.stringify(obj));
}

// ─── CSS ──────────────────────────────────────────────────────────────────────
const CSS=`
*{margin:0;padding:0;box-sizing:border-box;}
/* Default dark :root — overridden by ros-theme-vars style tag */
:root{
  --bg:#000;--bg2:#0a0a0a;
  --gl:rgba(255,255,255,0.04);--glb:rgba(255,255,255,0.08);--glh:rgba(255,255,255,0.08);
  --tx:#fff;--t2:rgba(255,255,255,0.6);--t3:rgba(255,255,255,0.35);
  --blue:#0A84FF;--green:#30D158;--orange:#FF9F0A;--red:#FF453A;--purple:#BF5AF2;--teal:#5AC8FA;
  --r:16px;--rs:10px;--sw:228px;
  --sb-bg:rgba(7,7,7,0.97);--card-bg:rgba(255,255,255,0.03);
  --font:-apple-system,BlinkMacSystemFont,'SF Pro Display',Tahoma,sans-serif;
  --page-p:26px 28px;--card-p:14px 16px;
}
body{font-family:var(--font);background:var(--bg);color:var(--tx);height:100vh;overflow:hidden;}
.app{display:flex;height:100vh;overflow:hidden;}

/* RTL = only text direction, NOT layout flip */
[dir=rtl] .inp{text-align:right;direction:rtl;}
[dir=rtl] .fl{text-align:right;}
[dir=rtl] .stitle{text-align:right;}
[dir=rtl] .pt,.ps{text-align:right;}
[dir=rtl] .sl,.sv,.sc2{text-align:right;}
[dir=rtl] .et,.es{text-align:right;}
[dir=rtl] .mrow span:first-child{text-align:right;}
[dir=rtl] tbody td{text-align:right;}
[dir=rtl] thead th{text-align:right;}
[dir=rtl] .ltx,.lsb{text-align:right;}
[dir=rtl] .ss{text-align:right;}

/* SIDEBAR */
.sb{width:var(--sw);background:var(--sb-bg,rgba(7,7,7,0.97));border-right:1px solid var(--glb);display:flex;flex-direction:column;padding:18px 10px;gap:2px;flex-shrink:0;overflow-y:auto;transition:transform .28s ease;}
.sb::-webkit-scrollbar{width:2px;}
[dir=rtl] .sb{border-right:none;border-left:1px solid var(--glb);}
.sb-logo{display:flex;align-items:center;gap:10px;padding:6px 10px 18px;border-bottom:1px solid var(--glb);margin-bottom:6px;}
.lic{width:36px;height:36px;background:linear-gradient(135deg,#0A84FF,#5AC8FA);border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:18px;box-shadow:0 4px 14px rgba(10,132,255,0.45);flex-shrink:0;}
.ltx{font-size:15px;font-weight:700;letter-spacing:-.3px;color:var(--tx);}
.lsb{font-size:10px;color:var(--t3);margin-top:1px;}
.ss{font-size:10px;font-weight:600;color:var(--t3);letter-spacing:.8px;text-transform:uppercase;padding:12px 10px 4px;}
.nv{display:flex;align-items:center;gap:9px;padding:9px 12px;border-radius:var(--rs);cursor:pointer;color:var(--t2);font-size:12.5px;font-weight:500;transition:all .17s;border:1px solid transparent;}
.nv:hover{background:var(--glh);color:var(--tx);}
.nv.on{background:rgba(10,132,255,0.14);color:var(--blue);border-color:rgba(10,132,255,0.18);}
.nbg{margin-left:auto;background:var(--red);color:#fff;font-size:10px;font-weight:700;min-width:18px;height:18px;border-radius:9px;display:flex;align-items:center;justify-content:center;padding:0 4px;}
[dir=rtl] .nbg{margin-left:0;margin-right:auto;}

/* MAIN */
.main{flex:1;overflow-y:auto;overflow-x:hidden;background:var(--bg2);}
.main::-webkit-scrollbar{width:3px;}
.main::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.08);border-radius:2px;}
.page{padding:var(--page-p,26px 28px);min-height:100vh;animation:fu .27s ease;}
@keyframes fu{from{opacity:0;transform:translateY(9px)}to{opacity:1;transform:translateY(0)}}
@media(prefers-reduced-motion:reduce){.page,.md,.toast{animation:none!important;}}

.topbar{position:sticky;top:0;z-index:40;background:var(--sb-bg,rgba(10,10,10,0.88));backdrop-filter:blur(24px);border-bottom:1px solid var(--glb);padding:10px 20px;display:flex;align-items:center;gap:10px;}
.nbtn{position:relative;background:var(--gl);border:1px solid var(--glb);border-radius:9px;width:36px;height:36px;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:all .17s;}
.nbtn:hover{background:var(--glh);}
.ndot{position:absolute;top:5px;right:5px;width:8px;height:8px;background:var(--red);border-radius:50%;border:2px solid var(--bg2);}

/* PAGE HEADER */
.ph{display:flex;align-items:center;justify-content:space-between;margin-bottom:22px;}
.pt{font-size:24px;font-weight:700;letter-spacing:-.5px;color:var(--tx);}
.ps{font-size:12px;color:var(--t3);margin-top:3px;}

/* CARDS */
.card{background:var(--card-bg,var(--gl));border:1px solid var(--glb);border-radius:var(--r);padding:18px;transition:border-color .2s;}
.card:hover{border-color:rgba(255,255,255,0.11);}
.sg4{display:grid;grid-template-columns:repeat(4,1fr);gap:12px;margin-bottom:16px;}
.sg3{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:16px;}
.sg5{display:grid;grid-template-columns:repeat(5,1fr);gap:12px;margin-bottom:16px;}
.sg2{display:grid;grid-template-columns:repeat(2,1fr);gap:12px;margin-bottom:16px;}
.sc{background:var(--gl);border:1px solid var(--glb);border-radius:var(--r);padding:17px;overflow:hidden;transition:all .24s ease;}
.sc.cl{cursor:pointer;}
.sc.cl:hover{transform:translateY(-3px);border-color:rgba(255,255,255,0.14);box-shadow:0 8px 26px rgba(0,0,0,0.38);}
.si{width:34px;height:34px;border-radius:9px;display:flex;align-items:center;justify-content:center;font-size:16px;margin-bottom:10px;}
.sv{font-size:23px;font-weight:700;letter-spacing:-1px;color:var(--tx);}
.sl{font-size:11px;color:var(--t3);margin-top:2px;font-weight:500;}
.sc2{font-size:10px;color:var(--t3);margin-top:4px;}
.g2{display:grid;grid-template-columns:1fr 1fr;gap:13px;}
.g3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:13px;}
.mb14{margin-bottom:14px;}

/* TABLE */
.tw{overflow-x:auto;}
table{width:100%;border-collapse:collapse;}
thead tr{border-bottom:1px solid var(--glb);}
thead th{padding:8px 12px;text-align:left;font-size:10px;font-weight:600;color:var(--t3);letter-spacing:.5px;text-transform:uppercase;}
tbody tr{border-bottom:1px solid rgba(255,255,255,0.04);transition:background .12s;}
tbody tr:hover{background:var(--gl);}
tbody td{padding:10px 12px;font-size:12.5px;color:var(--tx);}

/* BADGE/BUTTON/INPUT */
.sbadge{display:inline-flex;align-items:center;gap:4px;padding:3px 9px;border-radius:20px;font-size:10.5px;font-weight:600;}
.btn{display:inline-flex;align-items:center;gap:6px;padding:8px 15px;border-radius:var(--rs);border:none;cursor:pointer;font-size:12.5px;font-weight:600;transition:all .17s;font-family:inherit;-webkit-tap-highlight-color:transparent;touch-action:manipulation;}
.bp{background:var(--blue);color:#fff;}
.bp:hover{background:#006EDF;transform:translateY(-1px);box-shadow:0 5px 16px rgba(10,132,255,0.4);}
.bg2{background:var(--gl);color:var(--t2);border:1px solid var(--glb);}
.bg2:hover{background:var(--glh);color:var(--tx);}
.bd{background:rgba(255,69,58,0.12);color:var(--red);border:1px solid rgba(255,69,58,0.18);}
.bd:hover{background:rgba(255,69,58,0.22);}.btn:active{transform:scale(.96);opacity:.85;}
.bsm{padding:5px 10px;font-size:11px;border-radius:7px;}
.bgreen{background:rgba(48,209,88,0.13);color:var(--green);border:1px solid rgba(48,209,88,0.18);}
.inp{width:100%;background:rgba(255,255,255,0.06);border:1px solid var(--glb);border-radius:var(--rs);padding:8px 12px;color:var(--tx);font-size:12.5px;font-family:inherit;outline:none;transition:all .17s;}
.inp:focus{border-color:var(--blue);background:rgba(10,132,255,0.08);}
.inp::placeholder{color:var(--t3);}
select.inp option{background:var(--bg2);color:var(--tx);}
.fg{display:flex;flex-direction:column;gap:5px;}
.fl{font-size:10.5px;font-weight:600;color:var(--t3);letter-spacing:.3px;}
.fg2{display:grid;grid-template-columns:1fr 1fr;gap:11px;}
.fg3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:11px;}

/* MODAL */
.mo{position:fixed;inset:0;background:rgba(0,0,0,0.72);backdrop-filter:blur(12px);z-index:100;display:flex;align-items:center;justify-content:center;padding:20px;animation:fu .18s ease;}
.md{background:var(--bg2);border:1px solid var(--glb);border-radius:20px;padding:24px;width:100%;max-width:600px;max-height:88vh;overflow-y:auto;animation:su .27s cubic-bezier(.34,1.56,.64,1);}
.md-w{max-width:720px;}
@keyframes su{from{opacity:0;transform:translateY(26px) scale(.96)}to{opacity:1;transform:translateY(0) scale(1)}}
.mh{display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;}
.mt2{font-size:16px;font-weight:700;color:var(--tx);}
.ma{display:flex;gap:8px;justify-content:flex-end;margin-top:20px;}

/* TOAST */
.tc{position:fixed;top:16px;right:16px;z-index:200;display:flex;flex-direction:column;gap:7px;}
.toast{background:var(--bg2);border:1px solid var(--glb);border-radius:var(--r);padding:12px 15px;min-width:260px;max-width:330px;display:flex;align-items:flex-start;gap:10px;animation:si .34s cubic-bezier(.34,1.56,.64,1);box-shadow:0 10px 32px rgba(0,0,0,0.55);}
@keyframes si{from{opacity:0;transform:translateX(52px)}to{opacity:1;transform:translateX(0)}}
.ti{font-size:18px;flex-shrink:0;}.tt{font-size:12.5px;font-weight:600;color:var(--tx);}.tb{font-size:11px;color:var(--t2);margin-top:1px;}

/* MISC */
.sbar{display:flex;align-items:center;gap:8px;background:var(--gl);border:1px solid var(--glb);border-radius:var(--rs);padding:7px 12px;}
.sbar input{background:none;border:none;outline:none;color:var(--tx);font-size:12.5px;font-family:inherit;width:100%;}
.sbar input::placeholder{color:var(--t3);}
.chip{display:inline-flex;align-items:center;padding:3px 9px;border-radius:20px;font-size:10.5px;font-weight:600;background:var(--gl);border:1px solid var(--glb);color:var(--t2);cursor:pointer;transition:all .13s;white-space:nowrap;}
.chip.on{background:rgba(10,132,255,0.17);border-color:rgba(10,132,255,0.35);color:var(--blue);}
.hr{height:1px;background:var(--glb);margin:13px 0;}
.empty{text-align:center;padding:50px 20px;color:var(--t3);}
.ei{font-size:42px;margin-bottom:9px;}.et{font-size:14px;font-weight:500;color:var(--tx);}.es{font-size:12px;margin-top:3px;}
/* ── Repair Card ── */
.rrow{position:relative;background:var(--gl);border:1px solid var(--glb);border-radius:16px;overflow:hidden;display:flex;flex-direction:column;color:var(--tx);cursor:pointer;-webkit-tap-highlight-color:transparent;touch-action:manipulation;}


/* Left accent bar */
.rrow-accent{position:absolute;left:0;top:0;bottom:0;width:4px;border-radius:0;z-index:1;}
/* Main card body */
.rrow-body{display:flex;gap:12px;padding:14px 14px 14px 20px;align-items:flex-start;}
/* Icon badge */
.rav{width:42px;height:42px;border-radius:13px;display:flex;align-items:center;justify-content:center;font-size:19px;flex-shrink:0;margin-top:1px;}
/* Card content */
.rrow-content{flex:1;min-width:0;}
.rrow-top{display:flex;align-items:flex-start;justify-content:space-between;gap:8px;margin-bottom:5px;}
.rrow-name{font-size:14.5px;font-weight:700;letter-spacing:-.01em;line-height:1.2;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:200px;}
.rrow-price{font-size:18px;font-weight:800;letter-spacing:-.02em;flex-shrink:0;line-height:1;}
.rrow-meta{display:flex;align-items:center;gap:6px;flex-wrap:wrap;margin-bottom:6px;}
.rrow-device{font-size:12px;color:var(--t2);font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:180px;}
.rrow-badges{display:flex;align-items:center;gap:5px;flex-wrap:wrap;margin-bottom:8px;}
/* Footer strip */
.rrow-footer{display:flex;align-items:center;justify-content:space-between;gap:6px;padding:7px 10px 7px 20px;border-top:1px solid rgba(255,255,255,0.05);background:rgba(0,0,0,0.15);overflow:visible;}
.rrow-date{font-size:10px;color:var(--t3);font-weight:500;}
.rrow-actions{display:flex;align-items:center;gap:4px;}
/* Unified action button */
.ract-btn{display:inline-flex;align-items:center;justify-content:center;gap:4px;height:28px;padding:0 10px;border-radius:8px;font-size:11px;font-weight:700;cursor:pointer;transition:background .13s,opacity .13s;border:1px solid transparent;user-select:none;white-space:nowrap;}
.ract-btn:active{opacity:.7;}
.ract-btn-ghost{background:rgba(255,255,255,0.06);border-color:rgba(255,255,255,0.08);color:var(--t2);}
.ract-btn-ghost:hover{background:rgba(255,255,255,0.1);border-color:rgba(255,255,255,0.14);}
.ract-btn-del{background:rgba(255,69,58,0.1);border-color:rgba(255,69,58,0.18);color:var(--red);}
.ract-btn-del:hover{background:rgba(255,69,58,0.18);}
.ract-btn-pay-yes{background:rgba(48,209,88,0.12);border-color:rgba(48,209,88,0.25);color:var(--green);}
.ract-btn-pay-yes:hover{background:rgba(48,209,88,0.2);}
.ract-btn-pay-no{background:rgba(255,159,10,0.12);border-color:rgba(255,159,10,0.25);color:var(--orange);}
.ract-btn-pay-no:hover{background:rgba(255,159,10,0.2);}
/* Status pill */
.rpill{display:inline-flex;align-items:center;gap:4px;height:28px;padding:0 10px 0 8px;border-radius:8px;font-size:11px;font-weight:700;cursor:pointer;transition:all .13s;white-space:nowrap;user-select:none;}
.rpill:hover{opacity:.8;}
/* Status dropdown */
.rdd{position:fixed;background:var(--bg2);border:1px solid var(--glb);border-radius:14px;overflow:hidden;z-index:9999;min-width:160px;box-shadow:0 16px 40px rgba(0,0,0,0.8);animation:fadeInScale .15s ease;}
.rdd-item{display:flex;align-items:center;gap:9px;padding:9px 14px;font-size:12.5px;cursor:pointer;transition:background .15s;}
.rdd-item:hover{background:rgba(255,255,255,0.09);}
.rdd-item.active{background:rgba(255,255,255,0.06);}
.rdd-item.active:hover{background:rgba(255,255,255,0.12);}
/* Priority badge */
.pri-badge{display:inline-flex;align-items:center;gap:3px;font-size:10px;font-weight:800;padding:2px 7px;border-radius:10px;text-transform:uppercase;letter-spacing:.04em;}
/* Inline badge */
.ibadge{display:inline-flex;align-items:center;gap:3px;font-size:10px;font-weight:700;padding:2px 7px;border-radius:10px;}
/* Tabs — pill style */
.tabs{display:flex;gap:0;margin-bottom:18px;border-bottom:1px solid var(--glb);overflow-x:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none;padding-bottom:0;}
.tabs::-webkit-scrollbar{display:none;}
.tab{padding:10px 18px;font-size:13px;font-weight:600;cursor:pointer;color:var(--t3);transition:all .17s;white-space:nowrap;border-bottom:2px solid transparent;margin-bottom:-1px;position:relative;}
.tab.on{color:var(--blue);border-bottom-color:var(--blue);}
.tab:hover:not(.on){color:var(--t2);}
.tab-badge{display:inline-flex;align-items:center;justify-content:center;min-width:17px;height:17px;border-radius:9px;font-size:10px;font-weight:800;padding:0 4px;margin-left:5px;line-height:1;}
.type-icon-btn{display:inline-flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:8px;background:rgba(255,255,255,0.07);border:1px solid rgba(255,255,255,0.1);cursor:default;font-size:14px;position:relative;flex-shrink:0;transition:background .15s;z-index:1;}
.type-icon-btn:hover{background:rgba(255,255,255,0.13);}
.type-tooltip{position:absolute;bottom:calc(100% + 6px);left:50%;transform:translateX(-50%);background:var(--bg2);border:1px solid var(--glb);border-radius:10px;padding:6px 10px;box-shadow:0 8px 28px rgba(0,0,0,0.7);pointer-events:none;white-space:nowrap;z-index:200;opacity:0;visibility:hidden;transition:opacity .15s,visibility .15s;}
.type-icon-btn:hover .type-tooltip{opacity:1;visibility:visible;}
.type-tooltip-name{font-size:12px;font-weight:700;color:var(--tx);}
.ccard{position:relative;background:var(--gl);border:1px solid var(--glb);border-radius:18px;overflow:hidden;cursor:pointer;transition:border-color .18s,box-shadow .18s;}
.ccard:hover{border-color:rgba(255,255,255,0.13);box-shadow:0 6px 24px rgba(0,0,0,0.35);}
.ccard-banner{height:56px;position:relative;flex-shrink:0;}
.ccard-avatar{width:48px;height:48px;border-radius:15px;border:2.5px solid var(--bg);display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:800;color:#fff;overflow:hidden;box-shadow:0 4px 14px rgba(0,0,0,0.4);flex-shrink:0;margin-top:-24px;margin-left:14px;}
.ccard-body{padding:8px 14px 14px;}
.ccard-name{font-size:14px;font-weight:700;letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-bottom:2px;}
.ccard-sub{font-size:11px;color:var(--t3);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-bottom:10px;}
.ccard-divider{height:1px;background:var(--glb);margin:0 0 10px;}
.ccard-stats{display:flex;align-items:center;justify-content:space-between;}
.ccard-stat-label{font-size:10.5px;color:var(--t3);font-weight:500;}
.ccard-stat-value{font-size:13px;font-weight:800;margin-top:1px;}
.ccard-badges{display:flex;gap:5px;margin-top:8px;flex-wrap:wrap;}
.ccard-badge{display:inline-flex;align-items:center;gap:3px;font-size:9.5px;font-weight:700;padding:2px 7px;border-radius:8px;text-transform:uppercase;letter-spacing:.03em;}
.clist-row{display:flex;align-items:center;gap:11px;padding:11px 14px;border-radius:13px;cursor:pointer;transition:background .12s;position:relative;overflow:hidden;border:1px solid transparent;}
.clist-row:hover{background:rgba(255,255,255,0.04);border-color:rgba(255,255,255,0.07);}
.prow{display:flex;align-items:center;gap:8px;padding:8px 11px;background:rgba(255,255,255,0.04);border:1px solid var(--glb);border-radius:9px;}
.cat-pill{padding:2px 8px;border-radius:20px;font-size:10px;font-weight:600;}
.tog{position:relative;display:inline-block;width:40px;height:22px;}
.tog input{display:none;}
.ts{position:absolute;inset:0;background:rgba(255,255,255,0.13);border-radius:11px;cursor:pointer;transition:.27s;}
.ts:before{content:'';position:absolute;height:16px;width:16px;left:3px;top:3px;background:#fff;border-radius:50%;transition:.27s;box-shadow:0 2px 5px rgba(0,0,0,0.3);}
.tog input:checked+.ts{background:var(--green);}
.tog input:checked+.ts:before{transform:translateX(18px);}
.prog{height:4px;background:rgba(255,255,255,0.07);border-radius:2px;overflow:hidden;}
.progf{height:100%;border-radius:2px;transition:width .7s cubic-bezier(.4,0,.2,1);}
.stitle{font-size:13px;font-weight:600;margin-bottom:11px;}
.mrow{display:flex;align-items:center;justify-content:space-between;padding:9px 0;border-bottom:1px solid rgba(255,255,255,0.04);}
.mrow:last-child{border-bottom:none;}
.dot{width:7px;height:7px;border-radius:50%;display:inline-block;flex-shrink:0;}
.imei-tag{font-family:monospace;font-size:10px;background:rgba(90,200,250,0.1);color:var(--teal);padding:1px 6px;border-radius:5px;border:1px solid rgba(90,200,250,0.2);}
.wb{display:inline-flex;align-items:center;gap:3px;font-size:10px;font-weight:600;padding:2px 7px;border-radius:11px;}
.npanel{position:fixed;top:52px;right:14px;width:300px;background:var(--bg2);border:1px solid var(--glb);border-radius:16px;z-index:90;overflow:hidden;box-shadow:0 16px 46px rgba(0,0,0,0.6);animation:su .2s ease;}
.slabel{font-weight:600;font-size:10.5px;color:var(--blue);letter-spacing:.5px;text-transform:uppercase;margin-bottom:-4px;}
.loss-badge{background:rgba(255,69,58,0.12);color:var(--red);border:1px solid rgba(255,69,58,0.2);font-size:10.5px;font-weight:700;padding:2px 7px;border-radius:10px;}
.wdraw-row{display:flex;align-items:center;gap:10px;padding:10px 14px;background:var(--gl);border:1px solid var(--glb);border-radius:var(--rs);}
.warr-card{background:var(--gl);border:1px solid var(--glb);border-radius:var(--r);padding:14px 16px;display:flex;align-items:center;gap:12px;transition:all .18s;}
.warr-card:hover{border-color:rgba(255,255,255,0.12);}
.tech-card{background:var(--gl);border:1px solid var(--glb);border-radius:var(--r);padding:14px 16px;}
.cat-check{display:flex;align-items:center;gap:10px;padding:8px 0;border-bottom:1px solid rgba(255,255,255,0.04);cursor:pointer;}
.cat-check:last-child{border-bottom:none;}
.cb{width:18px;height:18px;border-radius:5px;border:1.5px solid var(--glb);display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:all .15s;}
.cb.on{background:var(--blue);border-color:var(--blue);}

/* MOBILE */
/* Bottom nav — hidden by default, shown on mobile */
.mob-bottom-nav{display:none;position:fixed;bottom:0;left:0;right:0;z-index:70;
  background:rgba(8,8,8,0.96);border-top:1px solid rgba(255,255,255,0.09);
  backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);
  height:calc(56px + env(safe-area-inset-bottom,0px));
  padding-bottom:env(safe-area-inset-bottom,0px);
  align-items:stretch;justify-content:space-around;}
.mob-nav-item{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;
  gap:2px;padding:6px 2px;cursor:pointer;background:transparent;border:none;
  color:rgba(255,255,255,0.35);font-size:9.5px;font-weight:600;letter-spacing:.2px;
  position:relative;-webkit-tap-highlight-color:transparent;touch-action:manipulation;
  transition:color .18s;}
.mob-nav-item.on{color:var(--blue);}
.mob-nav-item .mni{font-size:22px;line-height:1;transition:transform .2s cubic-bezier(.34,1.56,.64,1);}
.mob-nav-item.on .mni{transform:scale(1.18);}
.mob-nav-badge{position:absolute;top:5px;right:calc(50% - 20px);
  background:var(--red);color:#fff;font-size:8.5px;font-weight:700;
  min-width:15px;height:15px;border-radius:8px;display:flex;align-items:center;
  justify-content:center;padding:0 3px;border:1.5px solid rgba(8,8,8,0.96);}
@keyframes slideUp{from{transform:translateY(100%);opacity:.6}to{transform:translateY(0);opacity:1}}
@keyframes fadeInScale{from{opacity:0;transform:scale(.94)}to{opacity:1;transform:scale(1)}}
@media(max-width:768px){
  /* Sidebar hidden behind gesture */
  .sb{position:fixed;left:0;top:0;height:100%;z-index:80;transform:translateX(-110%);
    box-shadow:none;transition:transform .28s cubic-bezier(.4,0,.2,1),box-shadow .28s;}
  [dir=rtl] .sb{left:auto;right:0;transform:translateX(110%);}
  .sb.mob-open{transform:translateX(0)!important;box-shadow:4px 0 40px rgba(0,0,0,0.7);}
  /* Main area fills screen with room for bottom nav */
  .main{width:100%;min-width:0;padding-bottom:calc(56px + env(safe-area-inset-bottom,0px));}
  .page{padding:14px 13px 20px;animation:fadeInScale .22s ease;}
  /* Grid collapsing */
  .sg4,.sg5,.sg3{grid-template-columns:repeat(2,1fr);}
  .g2,.g3,.fg2,.fg3{grid-template-columns:1fr;}
  /* Typography */
  .pt{font-size:19px;}.ps{font-size:12px;}
  /* Touch targets */
  .inp{font-size:16px!important;} /* prevents iOS auto-zoom on focus */
  .login-input{font-size:16px!important;}
  .btn{min-height:38px;}
  .chip{padding:6px 12px!important;font-size:11.5px!important;}
  .nv{padding:11px 13px!important;}
  .tab{padding:8px 14px!important;}
  /* Overlay */
  .mob-over{display:block;}
  /* Modals become bottom sheets */
  .mo{align-items:flex-end!important;padding:0!important;padding-top:60px!important;}
  .md{
    border-radius:22px 22px 0 0!important;
    max-width:100%!important;
    max-height:92dvh!important;
    padding:20px 18px 32px!important;
    animation:slideUp .32s cubic-bezier(.32,1,.5,1)!important;
    /* drag handle */
  }
  .md::before{content:"";display:block;width:36px;height:4px;border-radius:2px;
    background:rgba(255,255,255,0.18);margin:-8px auto 16px;}
  .md-w{max-width:100%!important;}
  /* Topbar compact */
  .topbar{padding:8px 13px;}
  .date-txt{display:none;}
  /* Page header row */
  .ph{flex-wrap:wrap;gap:6px;padding-bottom:12px;}
  /* Table scroll */
  .tw{overflow-x:auto;-webkit-overflow-scrolling:touch;}
  /* Cards */
  .card{border-radius:14px;padding:14px;}
  /* Repair cards on mobile */
  .rrow{border-radius:18px;}
  .rrow-body{padding:14px 12px 13px 18px;}
  .rrow-footer{padding:9px 12px 9px 18px;}
  .rrow-name{max-width:calc(100vw - 170px);}
  .rrow-device{max-width:calc(100vw - 120px);}
  .rrow-price{font-size:16px;}
  .tab{padding:10px 14px;font-size:12.5px;}
  /* Bottom nav visible */
  .mob-bottom-nav{display:flex;}
  /* stat cards smaller text */
  .sc2{font-size:17px!important;}
}
.mob-over{display:none;position:fixed;inset:0;background:rgba(0,0,0,0.6);z-index:75;
  backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);}
/* ── LOGIN ── */
.login-screen{position:fixed;inset:0;background:var(--bg);display:flex;align-items:center;justify-content:center;z-index:9999;padding:16px;overflow:hidden;}
.login-screen *{-webkit-user-select:none;user-select:none;}
.login-screen input{-webkit-user-select:text;user-select:text;}
.login-card{width:100%;max-width:400px;background:rgba(255,255,255,0.03);border:1px solid var(--glb);border-radius:22px;padding:36px 32px;display:flex;flex-direction:column;gap:0;}
.login-logo{width:62px;height:62px;background:linear-gradient(135deg,#0A84FF,#5AC8FA);border-radius:18px;display:flex;align-items:center;justify-content:center;font-size:28px;margin:0 auto 22px;box-shadow:0 6px 24px rgba(10,132,255,0.4);}
.login-title{font-size:24px;font-weight:700;text-align:center;margin-bottom:4px;}
.login-sub{font-size:13px;color:var(--t3);text-align:center;margin-bottom:28px;}
.login-input{width:100%;background:rgba(255,255,255,0.06);border:1.5px solid var(--glb);border-radius:12px;padding:13px 16px;color:var(--tx);font-size:15px;outline:none;transition:border .18s;margin-bottom:12px;}
.login-input:focus{border-color:var(--blue);}
.login-input::placeholder{color:var(--t3);}
.login-btn{width:100%;padding:14px;background:linear-gradient(135deg,#0A84FF,#30A0FF);border:none;border-radius:12px;color:#fff;font-size:15px;font-weight:700;cursor:pointer;transition:opacity .18s;margin-top:4px;}
.login-btn:hover{opacity:.9;}
.login-btn:disabled{opacity:.5;cursor:not-allowed;}
.login-err{font-size:12.5px;color:var(--red);text-align:center;padding:8px 12px;background:rgba(255,69,58,0.08);border:1px solid rgba(255,69,58,0.2);border-radius:9px;margin-bottom:10px;}
.login-ver{font-size:11px;color:var(--t3);text-align:center;margin-top:20px;}
/* ── USER MANAGER ── */
.perm-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:4px;}
.perm-btn{padding:5px 0;border-radius:8px;font-size:11.5px;font-weight:600;cursor:pointer;border:1px solid var(--glb);background:transparent;color:var(--t3);text-align:center;transition:all .15s;}
.perm-btn.active-none{background:rgba(99,99,102,0.2);color:var(--t2);border-color:rgba(99,99,102,0.3);}
.perm-btn.active-read{background:rgba(255,159,10,0.15);color:var(--orange);border-color:rgba(255,159,10,0.3);}
.perm-btn.active-write{background:rgba(48,209,88,0.15);color:var(--green);border-color:rgba(48,209,88,0.3);}

.mob-menu-btn{display:none;}
@media(max-width:768px){.mob-menu-btn{display:flex;}}
.balance-widget{margin-top:auto;padding:8px 4px;}

/* CATALOG */
.dev-card{background:var(--gl);border:1px solid var(--glb);border-radius:var(--r);overflow:hidden;}
/* ── Catalog v19.5 ── */
.cat-dev-row{display:flex;align-items:center;gap:12px;padding:12px 14px;background:var(--gl);border:1px solid var(--glb);border-radius:14px;cursor:pointer;transition:border-color .15s,background .15s;}
.cat-dev-row:hover{border-color:rgba(10,132,255,0.35);background:rgba(10,132,255,0.04);}
.cat-dev-row:active{background:rgba(10,132,255,0.08);}
.cat-brand-card{background:var(--gl);border:1px solid var(--glb);border-radius:18px;overflow:hidden;cursor:pointer;transition:border-color .18s,box-shadow .2s,transform .18s;padding:0;aspect-ratio:1;display:flex;flex-direction:column;}
.cat-brand-card:hover{border-color:rgba(255,255,255,0.14);box-shadow:0 8px 32px rgba(0,0,0,0.5);transform:translateY(-2px);}
.cat-brand-card:active{transform:scale(.97);}
.cat-brand-banner{flex:1;display:flex;align-items:center;justify-content:center;position:relative;overflow:hidden;}
.cat-brand-body{padding:7px 8px 10px;border-top:1px solid rgba(255,255,255,0.05);}
.part-section{background:var(--gl);border:1px solid var(--glb);border-radius:16px;overflow:hidden;margin-bottom:10px;}
.part-section-head{display:flex;align-items:center;justify-content:space-between;padding:13px 14px 11px;border-bottom:1px solid var(--glb);}
.part-section-body{padding:10px 12px 12px;}
.type-pill{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:11px 13px;background:rgba(255,255,255,0.03);border:1px solid var(--glb);border-radius:12px;transition:border-color .12s;}
.type-pill:hover{border-color:rgba(255,255,255,0.1);}
.type-pill-price{font-size:18px;font-weight:800;color:var(--green);white-space:nowrap;letter-spacing:-.02em;}
.type-pill-name{font-size:13px;font-weight:600;color:var(--tx);}
.type-pill-meta{font-size:10.5px;color:var(--t3);}
.type-pill-actions{display:flex;gap:4px;flex-shrink:0;opacity:0;transition:opacity .12s;}
.type-pill:hover .type-pill-actions{opacity:1;}
@media(max-width:768px){
  .type-pill-actions{opacity:1;}
  .type-pill-price{font-size:16px;}
  .type-pill-name{font-size:12.5px;}
}
.dev-head{padding:12px 16px;display:flex;align-items:center;justify-content:space-between;cursor:pointer;background:rgba(255,255,255,0.02);}
.dev-head:hover{background:rgba(255,255,255,0.05);}
.dev-body{padding:0 16px 12px;}
.part-row{display:flex;align-items:center;justify-content:space-between;padding:7px 0;border-bottom:1px solid rgba(255,255,255,0.04);}
.part-row:last-child{border-bottom:none;}
.type-chip{display:inline-flex;align-items:center;gap:6px;padding:4px 10px;background:rgba(10,132,255,0.1);border:1px solid rgba(10,132,255,0.2);border-radius:20px;font-size:11px;color:var(--blue);margin:2px;}
@media(max-width:768px){.sg4{grid-template-columns:1fr 1fr;}.topbar .date-txt{display:none;}.mob-bottom-nav{display:flex;}}
.hide-repair-ids .repair-id{display:none!important;}
.no-sticky-header .topbar{position:relative!important;}
`;



// ─── Sidebar Widgets ──────────────────────────────────────────────────────────
// Available widget definitions
const SIDEBAR_WIDGET_DEFS = {
  balance: {
    id:'balance', label:'My Balance', icon:'💰',
    conditionLabel: null, // always visible
    render({fin,fmt,t,nav}){
      return(
        <div style={{background:"rgba(48,209,88,0.07)",border:"1px solid rgba(48,209,88,0.18)",borderRadius:11,padding:"11px 13px",cursor:"pointer"}} onClick={()=>nav("finance")}>
          <div style={{fontSize:10,color:"var(--green)",fontWeight:700,marginBottom:3}}>💰 {t.myBalance||"My Balance"}</div>
          <div style={{fontSize:19,fontWeight:700,color:fin.ownerBalance>=0?"var(--green)":"var(--red)"}}>{fmt(fin.ownerBalance)}</div>
          <div style={{fontSize:10,color:"var(--t3)",marginTop:2}}>{t.afterWithdrawals||"After withdrawals"}</div>
        </div>
      );
    }
  },
  activeRepairs: {
    id:'activeRepairs', label:'Active Repairs', icon:'🔧',
    conditionLabel: 'Only when there are active repairs',
    condition: ({repairs})=>(repairs||[]).some(r=>r.status==='Pending'||r.status==='In Progress'),
    render({repairs,nav}){
      const active=(repairs||[]).filter(r=>r.status==='Pending'||r.status==='In Progress');
      const pending=active.filter(r=>r.status==='Pending').length;
      const inProg=active.filter(r=>r.status==='In Progress').length;
      return(
        <div style={{background:"rgba(10,132,255,0.07)",border:"1px solid rgba(10,132,255,0.18)",borderRadius:11,padding:"11px 13px",cursor:"pointer"}} onClick={()=>nav("repairs")}>
          <div style={{fontSize:10,color:"var(--blue)",fontWeight:700,marginBottom:4}}>🔧 Active Repairs</div>
          <div style={{fontSize:19,fontWeight:700,color:"var(--blue)"}}>{active.length}</div>
          <div style={{display:"flex",gap:6,marginTop:4}}>
            <span style={{fontSize:10,color:"var(--orange)"}}>⏳ {pending} pending</span>
            <span style={{fontSize:10,color:"var(--blue)"}}>🔧 {inProg} in progress</span>
          </div>
        </div>
      );
    }
  },
  todayDone: {
    id:'todayDone', label:"Today's Done", icon:'✅',
    conditionLabel: 'Only when repairs completed today',
    condition: ({repairs})=>{const t=new Date().toDateString();return (repairs||[]).some(r=>(r.status==='Done'||r.status==='Delivered')&&new Date(r.doneAt||r.updatedAt||r.createdAt).toDateString()===t);},
    render({repairs,fmt,nav}){
      const today=new Date().toDateString();
      const done=(repairs||[]).filter(r=>(r.status==='Done'||r.status==='Delivered')&&new Date(r.doneAt||r.updatedAt||r.createdAt).toDateString()===today);
      const rev=done.reduce((s,r)=>s+(parseFloat(r.price)||0),0);
      return(
        <div style={{background:"rgba(48,209,88,0.07)",border:"1px solid rgba(48,209,88,0.18)",borderRadius:11,padding:"11px 13px",cursor:"pointer"}} onClick={()=>nav("repairs","history")}>
          <div style={{fontSize:10,color:"var(--green)",fontWeight:700,marginBottom:4}}>✅ Done Today</div>
          <div style={{fontSize:19,fontWeight:700,color:"var(--green)"}}>{done.length}</div>
          <div style={{fontSize:10,color:"var(--t3)",marginTop:2}}>{fmt(rev)} earned</div>
        </div>
      );
    }
  },
  lowStock: {
    id:'lowStock', label:'Low Stock Alert', icon:'⚠️',
    conditionLabel: 'Only when stock is low',
    condition: ({parts})=>(parts||[]).some(p=>p.stock<=3&&p.stock>=0),
    render({parts,nav}){
      const low=(parts||[]).filter(p=>p.stock<=3&&p.stock>=0);
      if(!low.length) return(
        <div style={{background:"rgba(48,209,88,0.07)",border:"1px solid rgba(48,209,88,0.18)",borderRadius:11,padding:"11px 13px"}}>
          <div style={{fontSize:10,color:"var(--green)",fontWeight:700,marginBottom:3}}>📦 Stock OK</div>
          <div style={{fontSize:12,color:"var(--t3)"}}>All parts well stocked</div>
        </div>
      );
      return(
        <div style={{background:"rgba(255,159,10,0.07)",border:"1px solid rgba(255,159,10,0.28)",borderRadius:11,padding:"11px 13px",cursor:"pointer"}} onClick={()=>nav("parts")}>
          <div style={{fontSize:10,color:"var(--orange)",fontWeight:700,marginBottom:4}}>⚠️ Low Stock</div>
          <div style={{fontSize:19,fontWeight:700,color:"var(--orange)"}}>{low.length}</div>
          <div style={{fontSize:10,color:"var(--t3)",marginTop:2}}>{low.slice(0,2).map(p=>p.name).join(', ')}{low.length>2?'…':''}</div>
        </div>
      );
    }
  },
  totalRevenue: {
    id:'totalRevenue', label:'Total Revenue', icon:'📈',
    conditionLabel: null,
    render({repairs,fmt,nav}){
      // Money only counts once paid, and lands in the month it was paid
      const paidAll=(repairs||[]).filter(isPaidRealised);
      const rev=paidAll.reduce((s,r)=>s+(parseFloat(r.price)||0),0);
      const nowD=new Date();
      const monthRev=paidAll.filter(r=>isInMonth(getFinanceDate(r),nowD.getMonth(),nowD.getFullYear())).reduce((s,r)=>s+(parseFloat(r.price)||0),0);
      return(
        <div style={{background:"rgba(10,132,255,0.07)",border:"1px solid rgba(10,132,255,0.18)",borderRadius:11,padding:"11px 13px",cursor:"pointer"}} onClick={()=>nav("analytics")}>
          <div style={{fontSize:10,color:"var(--blue)",fontWeight:700,marginBottom:4}}>📈 Revenue</div>
          <div style={{fontSize:18,fontWeight:700,color:"var(--blue)"}}>{fmt(monthRev)}</div>
          <div style={{fontSize:10,color:"var(--t3)",marginTop:2}}>This month · All time: {fmt(rev)}</div>
        </div>
      );
    }
  },
  pendingAmount: {
    id:'pendingAmount', label:'Pending Amount', icon:'💳',
    conditionLabel: 'Only when there is unpaid balance',
    condition: ({repairs})=>(repairs||[]).some(r=>r.status==='Pending'||r.status==='In Progress'),
    render({repairs,fmt,nav}){
      const pending=(repairs||[]).filter(r=>r.status==='Pending'||r.status==='In Progress');
      const amount=pending.reduce((s,r)=>s+(parseFloat(r.price)||0)-(parseFloat(r.deposit)||0),0);
      return(
        <div style={{background:"rgba(191,90,242,0.07)",border:"1px solid rgba(191,90,242,0.2)",borderRadius:11,padding:"11px 13px",cursor:"pointer"}} onClick={()=>nav("repairs")}>
          <div style={{fontSize:10,color:"var(--purple)",fontWeight:700,marginBottom:4}}>💳 Pending Payment</div>
          <div style={{fontSize:18,fontWeight:700,color:"var(--purple)"}}>{fmt(amount)}</div>
          <div style={{fontSize:10,color:"var(--t3)",marginTop:2}}>{pending.length} unpaid repair{pending.length!==1?'s':''}</div>
        </div>
      );
    }
  },
  quickDate: {
    id:'quickDate', label:'Date & Time', icon:'🗓️',
    conditionLabel: null,
    render(){
      const now=new Date();
      const day=now.toLocaleDateString('en-US',{weekday:'long'});
      const date=now.toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});
      const time=now.toLocaleTimeString('en-US',{hour:'2-digit',minute:'2-digit'});
      return(
        <div style={{background:"rgba(90,200,250,0.06)",border:"1px solid rgba(90,200,250,0.15)",borderRadius:11,padding:"11px 13px"}}>
          <div style={{fontSize:10,color:"var(--teal)",fontWeight:700,marginBottom:4}}>🗓️ {day}</div>
          <div style={{fontSize:13,fontWeight:700,color:"var(--tx)"}}>{date}</div>
          <div style={{fontSize:11,color:"var(--t3)",marginTop:2}}>{time}</div>
        </div>
      );
    }
  },
  unpaidRepairs: {
    id:'unpaidRepairs', label:'Unpaid Repairs', icon:'🔴',
    conditionLabel: 'Only when there are unpaid repairs',
    condition: ({repairs})=>(repairs||[]).some(r=>(r.status==='Done'||r.status==='Delivered')&&!r.paid),
    render({repairs,fmt,nav}){
      const unpaid=(repairs||[]).filter(r=>(r.status==='Done'||r.status==='Delivered')&&!r.paid);
      const total=unpaid.reduce((s,r)=>s+(parseFloat(r.price)||0),0);
      return(
        <div style={{background:"rgba(255,69,58,0.07)",border:"1px solid rgba(255,69,58,0.25)",borderRadius:11,padding:"11px 13px",cursor:"pointer"}} onClick={()=>nav("repairs","unpaid")}>
          <div style={{fontSize:10,color:"var(--red)",fontWeight:700,marginBottom:4}}>🔴 Unpaid Repairs</div>
          <div style={{fontSize:19,fontWeight:700,color:"var(--red)"}}>{fmt(total)}</div>
          <div style={{fontSize:10,color:"var(--t3)",marginTop:2}}>{unpaid.length} repair{unpaid.length!==1?'s':''} not yet paid</div>
        </div>
      );
    }
  },
  awaitingCustomer: {
    id:'awaitingCustomer', label:'Awaiting Customer', icon:'🕐',
    conditionLabel: 'Only when customers are being waited on',
    condition: ({repairs})=>(repairs||[]).some(r=>r.status==='Awaiting Customer'),
    render({repairs,fmt,nav}){
      const list=(repairs||[]).filter(r=>r.status==='Awaiting Customer');
      const total=list.reduce((s,r)=>s+(parseFloat(r.price)||0),0);
      const profit=list.reduce((s,r)=>s+calcRepairProfit(r),0);
      return(
        <div style={{background:"rgba(191,90,242,0.07)",border:"1px solid rgba(191,90,242,0.22)",borderRadius:11,padding:"11px 13px",cursor:"pointer"}} onClick={()=>nav("repairs","waiting")}>
          <div style={{fontSize:10,color:"var(--purple)",fontWeight:700,marginBottom:4}}>🕐 Awaiting Customer</div>
          <div style={{fontSize:19,fontWeight:700,color:"var(--purple)"}}>{fmt(total)}</div>
          <div style={{fontSize:10,color:profit>=0?"var(--green)":"var(--red)",marginTop:2,fontWeight:600}}>Profit {fmt(profit)}</div>
          <div style={{fontSize:10,color:"var(--t3)",marginTop:1}}>{list.length} repair{list.length!==1?'s':''} waiting</div>
        </div>
      );
    }
  },
  repairSummary: {
    id:'repairSummary', label:'Repair Summary', icon:'📊',
    conditionLabel: 'Only when there are repairs',
    condition: ({repairs})=>(repairs||[]).length>0,
    render({repairs,nav}){
      const total=(repairs||[]).filter(r=>!WAITING_S.includes(r.status)).length;
      const done=(repairs||[]).filter(r=>r.status==='Done'||r.status==='Delivered').length;
      const pct=total?Math.round(done/total*100):0;
      return(
        <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:11,padding:"11px 13px",cursor:"pointer"}} onClick={()=>nav("repairs")}>
          <div style={{fontSize:10,color:"var(--t3)",fontWeight:700,marginBottom:6}}>📊 All Repairs</div>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:5}}>
            <span style={{fontSize:11,color:"var(--t2)"}}>{total} total</span>
            <span style={{fontSize:11,color:"var(--green)",fontWeight:700}}>{pct}% done</span>
          </div>
          <div className="prog"><div className="progf" style={{width:pct+"%",background:"var(--green)"}}/></div>
        </div>
      );
    }
  },
};

const DEFAULT_WIDGETS = ['balance','activeRepairs'];

function SidebarWidgets({appearance, updateAppearance, currentUser, fin, fmt, repairs, parts, t, nav}){
  const [editing, setEditing] = useState(false);
  const compact = appearance.compactSidebar;
  // sidebarWidgets: array of {id, conditional} where conditional=true means only show when condition passes
  const rawWidgets = appearance.sidebarWidgets || DEFAULT_WIDGETS;
  // Support both old string[] format and new {id,conditional}[] format
  const activeWidgets = rawWidgets.map(w=>typeof w==='string'?{id:w,conditional:false}:w);
  const activeIds = activeWidgets.map(w=>w.id);

  const props = {fin, fmt, repairs, parts, t, nav, currentUser};

  function isEnabled(id){ return activeIds.includes(id); }
  function isConditional(id){ return activeWidgets.find(w=>w.id===id)?.conditional||false; }

  function toggleWidget(id){
    if(isEnabled(id)){
      updateAppearance({sidebarWidgets: activeWidgets.filter(w=>w.id!==id)});
    } else {
      updateAppearance({sidebarWidgets: [...activeWidgets, {id, conditional:false}]});
    }
  }
  function toggleConditional(id){
    updateAppearance({sidebarWidgets: activeWidgets.map(w=>w.id===id?{...w,conditional:!w.conditional}:w)});
  }

  // Determine which widgets to actually render (pass condition check)
  const visibleWidgets = activeWidgets.filter(({id, conditional})=>{
    const def = SIDEBAR_WIDGET_DEFS[id];
    if(!def) return false;
    if(conditional && def.condition && !def.condition(props)) return false;
    return true;
  });

  // In compact mode, just show a tiny avatar with tooltip
  if(compact){
    return(
      <div className="balance-widget" style={{padding:'8px 4px 6px',borderTop:'1px solid var(--glb)',display:'flex',justifyContent:'center'}}>
        <div style={{width:30,height:30,borderRadius:8,overflow:'hidden',background:'rgba(10,132,255,0.15)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:700,color:'var(--blue)',flexShrink:0,cursor:'pointer'}}
          title={currentUser.displayName+' · '+((ROLES[currentUser.role]||ROLES.custom).label)}>
          {currentUser.photoUrl
            ? <img src={currentUser.photoUrl} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
            : currentUser.displayName?.[0]?.toUpperCase()||'U'}
        </div>
      </div>
    );
  }

  return(
    <div className="balance-widget">
      {/* User pill */}
      <div style={{padding:'8px 4px 6px',borderTop:'1px solid var(--glb)',marginBottom:8,display:'flex',alignItems:'center',gap:8}}>
        <div style={{width:30,height:30,borderRadius:8,overflow:'hidden',background:'rgba(10,132,255,0.15)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:700,color:'var(--blue)',flexShrink:0}}>
          {currentUser.photoUrl
            ? <img src={currentUser.photoUrl} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
            : currentUser.displayName?.[0]?.toUpperCase()||'U'}
        </div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:12,fontWeight:600,color:'var(--tx)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{currentUser.displayName}</div>
          <div style={{fontSize:9.5,color:'var(--t3)'}}>{(ROLES[currentUser.role]||ROLES.custom).label}</div>
        </div>
        <button onClick={()=>setEditing(v=>!v)} title="Customize sidebar widgets"
          style={{background:editing?"rgba(10,132,255,0.2)":"transparent",border:"none",cursor:"pointer",color:editing?"var(--blue)":"var(--t3)",fontSize:14,padding:"3px 5px",borderRadius:6,lineHeight:1,flexShrink:0}}>⚙️</button>
      </div>

      {/* Active widgets */}
      {!editing && (
        <div style={{display:"flex",flexDirection:"column",gap:6}}>
          {visibleWidgets.map(({id})=>{
            const def=SIDEBAR_WIDGET_DEFS[id];
            if(!def) return null;
            return <div key={id}>{def.render(props)}</div>;
          })}
        </div>
      )}

      {/* Widget picker */}
      {editing && (
        <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:11,padding:"11px 13px"}}>
          <div style={{fontSize:11,fontWeight:700,color:"var(--blue)",marginBottom:8,letterSpacing:.4}}>⚙️ SIDEBAR WIDGETS</div>
          <div style={{display:"flex",flexDirection:"column",gap:5}}>
            {Object.values(SIDEBAR_WIDGET_DEFS).map(def=>{
              const active=isEnabled(def.id);
              const cond=isConditional(def.id);
              return(
                <div key={def.id} style={{border:`1px solid ${active?"rgba(10,132,255,0.25)":"var(--glb)"}`,borderRadius:9,overflow:'hidden',background:active?"rgba(10,132,255,0.06)":"transparent"}}>
                  <div onClick={()=>toggleWidget(def.id)}
                    style={{display:"flex",alignItems:"center",gap:8,padding:"7px 9px",cursor:"pointer"}}>
                    <span style={{fontSize:14,flexShrink:0}}>{def.icon}</span>
                    <span style={{flex:1,fontSize:11.5,fontWeight:500,color:"var(--tx)"}}>{def.label}</span>
                    <div style={{width:16,height:16,borderRadius:4,border:`1.5px solid ${active?"var(--blue)":"var(--glb)"}`,background:active?"var(--blue)":"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      {active&&<span style={{color:"#fff",fontSize:10,lineHeight:1}}>✓</span>}
                    </div>
                  </div>
                  {/* Conditional toggle — only for widgets that have a condition + are active */}
                  {active && def.conditionLabel && (
                    <div onClick={()=>toggleConditional(def.id)}
                      style={{display:'flex',alignItems:'center',gap:7,padding:'5px 9px 7px',borderTop:'1px solid var(--glb)',cursor:'pointer',background:cond?"rgba(255,159,10,0.07)":"transparent"}}>
                      <span style={{fontSize:11,color:cond?"var(--orange)":"var(--t3)"}}>⚡</span>
                      <span style={{flex:1,fontSize:10.5,color:cond?"var(--orange)":"var(--t3)"}}>{def.conditionLabel}</span>
                      <div style={{width:14,height:14,borderRadius:3,border:`1.5px solid ${cond?"var(--orange)":"var(--glb)"}`,background:cond?"var(--orange)":"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                        {cond&&<span style={{color:"#fff",fontSize:9,lineHeight:1}}>✓</span>}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <button onClick={()=>setEditing(false)} style={{width:"100%",marginTop:8,padding:"6px",background:"var(--blue)",border:"none",borderRadius:8,color:"#fff",fontSize:11.5,fontWeight:600,cursor:"pointer"}}>Done</button>
        </div>
      )}
    </div>
  );
}


// ─── PhotoPicker: upload/clear a profile photo ───────────────────────────────
function PhotoPicker({value, onChange, size=54}){
  const ref = useRef();
  function handleFile(e){
    const file = e.target.files?.[0];
    if(!file) return;
    const reader = new FileReader();
    reader.onload = ev => onChange(ev.target.result);
    reader.readAsDataURL(file);
    e.target.value='';
  }
  return(
    <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:6}}>
      <div onClick={()=>ref.current?.click()}
        style={{width:size,height:size,borderRadius:'50%',background:'rgba(10,132,255,0.15)',border:'2px dashed rgba(10,132,255,0.3)',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',overflow:'hidden',flexShrink:0,position:'relative'}}
        title="Click to upload photo">
        {value
          ? <img src={value} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
          : <span style={{fontSize:size*0.38,color:'var(--blue)'}}>📷</span>}
        {value&&(
          <div style={{position:'absolute',inset:0,background:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',opacity:0,transition:'opacity .15s'}}
            onMouseEnter={e=>e.currentTarget.style.opacity=1}
            onMouseLeave={e=>e.currentTarget.style.opacity=0}>
            <span style={{color:'#fff',fontSize:11,fontWeight:600}}>Change</span>
          </div>
        )}
      </div>
      <div style={{display:'flex',gap:5}}>
        <button type="button" onClick={()=>ref.current?.click()} style={{fontSize:10.5,padding:'3px 8px',background:'rgba(10,132,255,0.1)',border:'1px solid rgba(10,132,255,0.2)',borderRadius:6,color:'var(--blue)',cursor:'pointer',fontWeight:600}}>Upload</button>
        {value&&<button type="button" onClick={()=>onChange('')} style={{fontSize:10.5,padding:'3px 8px',background:'rgba(255,69,58,0.08)',border:'1px solid rgba(255,69,58,0.18)',borderRadius:6,color:'var(--red)',cursor:'pointer',fontWeight:600}}>Remove</button>}
      </div>
      <input ref={ref} type="file" accept="image/*" style={{display:'none'}} onChange={handleFile}/>
    </div>
  );
}

// ─── Read-Only Banner ─────────────────────────────────────────────────────────
function ReadOnlyBanner(){
  return(
    <div style={{display:'flex',alignItems:'center',gap:7,padding:'6px 14px',background:'rgba(255,159,10,0.08)',border:'1px solid rgba(255,159,10,0.2)',borderRadius:10,marginBottom:14}}>
      <span style={{fontSize:14}}>👁️</span>
      <span style={{fontSize:12,color:'var(--orange)',fontWeight:600}}>Read-only — you can view but not make changes</span>
    </div>
  );
}

// ─── Login Screen ─────────────────────────────────────────────────────────────
// ─── WebAuthn / Biometric helpers ────────────────────────────────────────────
const BIOMETRIC_KEY = 'repairosv7_biometric_cred';
const BIOMETRIC_USER_KEY = 'repairosv7_biometric_user';
const BIOMETRIC_REMEMBER_KEY = 'repairosv7_biometric_remember'; // set when user enables "stay signed in" with biometrics
const BIO_LOCK_KEY = 'repairosv7_bio_lock'; // per-device: require biometrics on every launch even when session is valid

function isBiometricAvailable(){
  return !!(window.PublicKeyCredential && navigator.credentials);
}

async function biometricRegister(username){
  if(!isBiometricAvailable()) return {ok:false,error:'WebAuthn not supported on this device'};
  try {
    const challenge = crypto.getRandomValues(new Uint8Array(32));
    const userId = crypto.getRandomValues(new Uint8Array(16));
    const cred = await navigator.credentials.create({publicKey:{
      challenge,
      rp:{name:'RepairOS',id:window.location.hostname},
      user:{id:userId,name:username,displayName:username},
      pubKeyCredParams:[{type:'public-key',alg:-7},{type:'public-key',alg:-257}],
      authenticatorSelection:{authenticatorAttachment:'platform',userVerification:'required'},
      timeout:60000,
      attestation:'none',
    }});
    // Store credential ID and username
    localStorage.setItem(BIOMETRIC_KEY, btoa(String.fromCharCode(...new Uint8Array(cred.rawId))));
    localStorage.setItem(BIOMETRIC_USER_KEY, username);
    return {ok:true};
  } catch(e) {
    return {ok:false,error:e.message||'Biometric setup failed'};
  }
}

async function biometricAuthenticate(){
  if(!isBiometricAvailable()) return {ok:false,error:'WebAuthn not supported'};
  const storedCred = localStorage.getItem(BIOMETRIC_KEY);
  const storedUser = localStorage.getItem(BIOMETRIC_USER_KEY);
  if(!storedCred||!storedUser) return {ok:false,error:'No biometric registered'};
  try {
    const challenge = crypto.getRandomValues(new Uint8Array(32));
    const credId = Uint8Array.from(atob(storedCred), c=>c.charCodeAt(0));
    await navigator.credentials.get({publicKey:{
      challenge,
      rpId:window.location.hostname,
      allowCredentials:[{type:'public-key',id:credId}],
      userVerification:'required',
      timeout:60000,
    }});
    return {ok:true, username:storedUser};
  } catch(e) {
    if(e.name==='NotAllowedError') return {ok:false,error:'Biometric cancelled'};
    return {ok:false,error:e.message||'Biometric failed'};
  }
}

function biometricIsRegistered(){
  return !!(localStorage.getItem(BIOMETRIC_KEY) && localStorage.getItem(BIOMETRIC_USER_KEY));
}
function biometricRegisteredUser(){
  return localStorage.getItem(BIOMETRIC_USER_KEY)||'';
}
function biometricClear(){
  localStorage.removeItem(BIOMETRIC_KEY);
  localStorage.removeItem(BIOMETRIC_USER_KEY);
  localStorage.removeItem(BIOMETRIC_REMEMBER_KEY);
}

// ─── Biometric Prompt Screen (auto-shown on launch when remember-me + bio set) ─
function BiometricPromptScreen({onSuccess, onFallback}){
  const [status,setStatus]=useState('idle'); // idle | loading | error
  const [errMsg,setErrMsg]=useState('');
  const username=biometricRegisteredUser();

  // Auto-trigger on mount
  useEffect(()=>{ handleAuth(); },[]);

  async function handleAuth(){
    setStatus('loading'); setErrMsg('');
    const res=await biometricAuthenticate();
    if(res.ok){
      // Check if a valid session was already restored (bio-lock mode — just gate, don't re-auth)
      const pendingRaw = sessionStorage.getItem('ros_bio_pending_user');
      if(pendingRaw){
        try{
          const pendingUser = JSON.parse(pendingRaw);
          sessionStorage.removeItem('ros_bio_pending_user');
          onSuccess(pendingUser);
          return;
        }catch(e){}
      }
      // No pending user — do full re-authentication
      const users=_loadUsers();
      const user=users.find(u=>u.username.toLowerCase()===res.username.toLowerCase());
      if(user){
        const expiresIn=30*24*3600*1000;
        const payload=JSON.stringify({id:user.id,username:user.username,role:user.role,ts:Date.now(),exp:Date.now()+expiresIn});
        const token=await _signToken(payload,true);
        sessionStorage.setItem(SESSION_KEY,token);
        localStorage.setItem(REMEMBER_KEY,token);
        localStorage.setItem(REMEMBER_USER_KEY,user.username);
        onSuccess(user);
      } else {
        setStatus('error');
        setErrMsg('User not found — please sign in manually.');
      }
    } else {
      if(res.error==='Biometric cancelled'){
        setStatus('idle');
      } else {
        setStatus('error');
        setErrMsg(res.error||'Biometric failed');
      }
    }
  }

  const shopLogo=SDB.get('shop_logo');
  const shopName=SDB.get('shop_name')||'RepairOS';

  return(
    <div className="login-screen">
      <style>{CSS}</style>
      <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:14,width:'100%',maxWidth:380}}>
        <div className="login-card" style={{width:'100%',margin:0,textAlign:'center'}}>
          {shopLogo
            ?<img src={shopLogo} alt="" style={{width:64,height:64,objectFit:'contain',borderRadius:18,display:'block',margin:'0 auto 16px',boxShadow:'0 6px 24px rgba(10,132,255,0.3)'}}/>
            :<div className="login-logo">🔧</div>}
          <div className="login-title">{shopName}</div>
          <div style={{fontSize:13,color:'var(--t3)',marginBottom:24}}>
            Welcome back, <strong style={{color:'var(--tx)'}}>{username}</strong>
          </div>
          {/* Big biometric button */}
          <button onClick={handleAuth} disabled={status==='loading'}
            style={{width:'100%',padding:'18px',borderRadius:16,border:'1px solid rgba(10,132,255,0.35)',
              background:status==='loading'?'rgba(10,132,255,0.08)':'rgba(10,132,255,0.12)',
              color:'var(--blue)',fontSize:32,cursor:'pointer',marginBottom:10,
              display:'flex',flexDirection:'column',alignItems:'center',gap:6,
              transition:'all .18s',boxShadow:status==='loading'?'none':'0 0 0 0 rgba(10,132,255,0)'}}>
            <span style={{fontSize:40}}>{status==='loading'?'⏳':'🔐'}</span>
            <span style={{fontSize:13,fontWeight:700,color:'var(--blue)'}}>
              {status==='loading'?'Verifying…':'Touch ID / Face ID'}
            </span>
          </button>
          {errMsg&&<div className="login-err" style={{marginBottom:10}}>{errMsg}</div>}
          {/* Fallback to password */}
          <button onClick={onFallback}
            style={{width:'100%',padding:'10px',borderRadius:12,border:'none',
              background:'transparent',color:'var(--t3)',fontSize:12.5,cursor:'pointer',
              transition:'color .15s'}}
            onMouseEnter={e=>e.currentTarget.style.color='var(--t2)'}
            onMouseLeave={e=>e.currentTarget.style.color='var(--t3)'}>
            Sign in with password instead
          </button>
        </div>
      </div>
    </div>
  );
}

function LoginScreen({onLogin}){
  const [username,setUsername]=useState(()=>localStorage.getItem(REMEMBER_USER_KEY)||'');
  const [password,setPassword]=useState('');
  const [remember,setRemember]=useState(()=>!!localStorage.getItem(REMEMBER_USER_KEY));
  const [error,setError]=useState('');
  const [loading,setLoading]=useState(false);
  const passRef=useRef();
  const [bioAvail]=useState(()=>isBiometricAvailable());
  const [bioRegistered,setBioRegistered]=useState(()=>biometricIsRegistered());
  const [bioLoading,setBioLoading]=useState(false);
  const [showBioSetup,setShowBioSetup]=useState(false);

  // DB switcher popup state
  const [showDbPopup,setShowDbPopup]=useState(false);
  const [dbs,setDbs]=useState([]);
  const [activeDb,setActiveDb]=useState(ServerDB._active);
  const [dbLoading,setDbLoading]=useState(false);
  const [deviceDefault,setDeviceDefaultState]=useState(()=>ServerDB.getDeviceDefault());
  const [serverReady,setServerReady]=useState(ServerDB._serverAvailable);

  useEffect(()=>{
    if(!ServerDB._serverAvailable) return;
    ServerDB.listDbs().then(list=>{ setDbs(list); setActiveDb(ServerDB._active); setServerReady(true); });
  },[]);

  async function handleSwitchDb(fname){
    setDbLoading(true);
    const ok=await ServerDB.switchDb(fname);
    if(ok){ setActiveDb(fname); }
    else { setError('Could not connect to "'+fname.replace('.json','')+'"'); }
    setDbLoading(false);
  }
  function handleSetDefault(fname){
    ServerDB.setDeviceDefault(fname===deviceDefault?null:fname);
    setDeviceDefaultState(ServerDB.getDeviceDefault());
  }

  async function handleSubmit(){
    if(!username.trim()||!password) return;
    setLoading(true); setError('');
    const result=await authLogin(username.trim(),password,remember);
    setLoading(false);
    if(result.ok){ setPassword(''); onLogin(result.user); }
    else { setError(result.error); setPassword(''); }
  }

  async function handleBiometricLogin(){
    setBioLoading(true); setError('');
    const res = await biometricAuthenticate();
    if(res.ok){
      // Biometric confirmed identity — load users directly (authListUsers requires admin role)
      const users = _loadUsers();
      const user = users.find(u=>u.username.toLowerCase()===res.username.toLowerCase());
      if(user){
        const rememberBio = remember || localStorage.getItem(BIOMETRIC_REMEMBER_KEY)==='1';
        if(rememberBio) localStorage.setItem(BIOMETRIC_REMEMBER_KEY,'1');
        const expiresIn = rememberBio ? 30*24*3600*1000 : 8*3600*1000;
        const payload = JSON.stringify({id:user.id,username:user.username,role:user.role,ts:Date.now(),exp:Date.now()+expiresIn});
        const token = await _signToken(payload, rememberBio);
        sessionStorage.setItem(SESSION_KEY,token);
        if(rememberBio){
          localStorage.setItem(REMEMBER_KEY,token);
          localStorage.setItem(REMEMBER_USER_KEY,user.username);
        }
        setBioLoading(false);
        onLogin(user);
      } else {
        setBioLoading(false);
        setError('Biometric user not found. Please sign in normally.');
      }
    } else {
      setBioLoading(false);
      if(res.error!=='Biometric cancelled') setError(res.error);
    }
  }

  async function handleEnableBiometrics(){
    if(!username.trim()){ setError('Enter your username first'); return; }
    setBioLoading(true); setError('');
    const res = await biometricRegister(username.trim());
    setBioLoading(false);
    if(res.ok){ setBioRegistered(true); setShowBioSetup(false); toast('🔑','Biometrics enabled','Use Face ID or fingerprint next time'); }
    else { setError(res.error); }
  }

  const shopLogo=ServerDB.isActive()?ServerDB.get('shop_logo'):DB.get('shop_logo');
  const shopName=ServerDB.isActive()?ServerDB.get('shop_name'):DB.get('shop_name');
  const appVersion=ServerDB.isActive()?ServerDB.get('app_version'):DB.get('app_version');
  const curDbDisplay=activeDb?activeDb.replace('.json',''):null;

  return(
    <div className="login-screen">
      <style>{CSS}</style>

      {/* ── DB Switcher popup — corner button, only visible when server has DBs ── */}
      {serverReady&&dbs.length>0&&(
        <>
          {/* Corner trigger button */}
          <button onClick={()=>setShowDbPopup(v=>!v)} title="Switch workspace"
            style={{position:'fixed',bottom:16,right:16,display:'flex',alignItems:'center',gap:6,
              padding:'6px 11px',borderRadius:20,border:'1px solid var(--glb)',
              background:'rgba(255,255,255,0.06)',cursor:'pointer',
              color:'var(--t2)',fontSize:11.5,fontWeight:600,zIndex:90,
              backdropFilter:'blur(8px)',transition:'all .15s'}}
            onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.11)'}
            onMouseLeave={e=>e.currentTarget.style.background='rgba(255,255,255,0.06)'}>
            <span>🗄️</span>
            <span style={{maxWidth:110,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
              {curDbDisplay||'No workspace'}
            </span>
            <span style={{opacity:.5,fontSize:10}}>{showDbPopup?'▲':'▼'}</span>
          </button>

          {/* Popup */}
          {showDbPopup&&(
            <>
              <div onClick={()=>setShowDbPopup(false)} style={{position:'fixed',inset:0,zIndex:88}}/>
              <div style={{position:'fixed',bottom:52,right:16,width:290,background:'var(--bg2)',
                border:'1px solid var(--glb)',borderRadius:14,padding:'13px 14px',zIndex:89,
                boxShadow:'0 16px 48px rgba(0,0,0,0.7)',backdropFilter:'blur(12px)'}}>
                <div style={{fontSize:11,fontWeight:700,color:'var(--t3)',letterSpacing:.5,marginBottom:9}}>🗄️ SWITCH WORKSPACE</div>
                <div style={{display:'flex',flexDirection:'column',gap:5}}>
                  {dbs.map(db=>{
                    const isCur=db.name===activeDb;
                    const isDef=db.name===deviceDefault;
                    return(
                      <div key={db.name} style={{display:'flex',alignItems:'center',gap:7,padding:'8px 10px',
                        background:isCur?'rgba(48,209,88,0.1)':'rgba(255,255,255,0.03)',
                        border:`1px solid ${isCur?'rgba(48,209,88,0.3)':'var(--glb)'}`,
                        borderRadius:9,transition:'all .15s'}}>
                        <span style={{fontSize:13,flexShrink:0}}>{db.isTest?'🧪':'🗄️'}</span>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontSize:12,fontWeight:isCur?700:500,
                            color:isCur?'var(--green)':'var(--tx)',
                            overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                            {db.name.replace('.json','')}
                          </div>
                          <div style={{fontSize:9.5,color:'var(--t3)',display:'flex',gap:6}}>
                            {isCur&&<span style={{color:'var(--green)',fontWeight:600}}>● Active</span>}
                            {isDef&&<span style={{color:'var(--blue)',fontWeight:600}}>★ Default</span>}
                            <span>{db.repairCount||0} repairs</span>
                          </div>
                        </div>
                        <div style={{display:'flex',gap:4,flexShrink:0}}>
                          <button title={isDef?'Remove default':'Set as device default'}
                            onClick={()=>handleSetDefault(db.name)}
                            style={{fontSize:12,width:26,height:26,display:'flex',alignItems:'center',justifyContent:'center',
                              background:isDef?'rgba(10,132,255,0.18)':'transparent',
                              border:`1px solid ${isDef?'rgba(10,132,255,0.35)':'var(--glb)'}`,
                              borderRadius:6,cursor:'pointer',color:isDef?'var(--blue)':'var(--t3)'}}>★</button>
                          {!isCur&&(
                            <button onClick={async()=>{await handleSwitchDb(db.name);setShowDbPopup(false);}}
                              disabled={dbLoading}
                              style={{fontSize:11,padding:'3px 9px',background:'rgba(10,132,255,0.12)',
                                border:'1px solid rgba(10,132,255,0.25)',borderRadius:6,
                                color:'var(--blue)',cursor:'pointer',fontWeight:600}}>
                              {dbLoading?'…':'Use'}
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
                {!activeDb&&<div style={{marginTop:8,fontSize:11,color:'var(--orange)',fontWeight:600,textAlign:'center'}}>⚠️ Select a workspace to sign in</div>}
              </div>
            </>
          )}
        </>
      )}

      {/* ── Clean login card ── */}
      <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:14,width:'100%',maxWidth:380}}>
        <div className="login-card" style={{width:'100%',margin:0}}>
          {shopLogo
            ? <img src={shopLogo} alt="" style={{width:64,height:64,objectFit:'contain',borderRadius:18,display:'block',margin:'0 auto 16px',boxShadow:'0 6px 24px rgba(10,132,255,0.3)'}}/>
            : <div className="login-logo">🔧</div>}
          <div className="login-title">{shopName||'RepairOS'}</div>
          <div className="login-sub">
            {curDbDisplay
              ? <span>Workspace: <strong style={{color:'var(--blue)'}}>{curDbDisplay}</strong></span>
              : 'Sign in to your workspace'}
          </div>
          {error&&<div className="login-err">{error}</div>}
          <input className="login-input" placeholder="Username" value={username}
            onChange={e=>setUsername(e.target.value)} autoComplete="username"
            onKeyDown={e=>e.key==='Enter'&&passRef.current?.focus()}/>
          <input className="login-input" type="password" placeholder="Password" value={password}
            ref={passRef}
            onChange={e=>setPassword(e.target.value)} autoComplete="current-password"
            onKeyDown={e=>e.key==='Enter'&&handleSubmit()}/>
          <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',userSelect:'none',margin:'2px 0 8px'}}>
            <div className="tog" style={{transform:'scale(0.85)',transformOrigin:'left center'}}>
              <input type="checkbox" checked={remember} onChange={e=>setRemember(e.target.checked)}/>
              <span className="ts"/>
            </div>
            <span style={{fontSize:12.5,color:'var(--t2)',fontWeight:500}}>Stay signed in</span>
          </label>
          <button className="login-btn" onClick={handleSubmit} disabled={loading||!username||!password}>
            {loading?'Signing in…':'Sign In'}
          </button>
          {/* Biometric login — only shown when WebAuthn is available */}
          {bioAvail&&(
            <div style={{marginTop:6}}>
              {bioRegistered
                ? <button onClick={handleBiometricLogin} disabled={bioLoading}
                    style={{width:'100%',padding:'11px',borderRadius:12,border:'1px solid rgba(10,132,255,0.3)',
                      background:'rgba(10,132,255,0.1)',color:'var(--blue)',fontSize:14,fontWeight:600,
                      cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:8,transition:'all .15s'}}
                    onMouseEnter={e=>e.currentTarget.style.background='rgba(10,132,255,0.18)'}
                    onMouseLeave={e=>e.currentTarget.style.background='rgba(10,132,255,0.1)'}>
                    {bioLoading?'Verifying…':'🔐 Sign in with Biometrics'}
                  </button>
                : (!showBioSetup
                    ? <button onClick={()=>setShowBioSetup(true)}
                        style={{width:'100%',padding:'9px',borderRadius:12,border:'1px solid var(--glb)',
                          background:'transparent',color:'var(--t3)',fontSize:12.5,fontWeight:500,
                          cursor:'pointer',transition:'all .15s'}}
                        onMouseEnter={e=>e.currentTarget.style.color='var(--t2)'}
                        onMouseLeave={e=>e.currentTarget.style.color='var(--t3)'}>
                        Enable Biometric Login
                      </button>
                    : <div style={{display:'flex',flexDirection:'column',gap:7,padding:'10px',background:'rgba(10,132,255,0.07)',borderRadius:12,border:'1px solid rgba(10,132,255,0.2)'}}>
                        <div style={{fontSize:12,color:'var(--t2)',textAlign:'center'}}>Sign in with password first, then enable Face ID / fingerprint for next time.</div>
                        <div style={{display:'flex',gap:7}}>
                          <button onClick={()=>setShowBioSetup(false)} style={{flex:1,padding:'8px',borderRadius:9,border:'1px solid var(--glb)',background:'transparent',color:'var(--t3)',fontSize:12,cursor:'pointer'}}>Cancel</button>
                          <button onClick={handleEnableBiometrics} disabled={bioLoading||!username.trim()}
                            style={{flex:2,padding:'8px',borderRadius:9,border:'1px solid rgba(10,132,255,0.3)',background:'rgba(10,132,255,0.15)',color:'var(--blue)',fontSize:12,fontWeight:700,cursor:'pointer'}}>
                            {bioLoading?'Setting up…':'🔐 Set Up Biometrics'}
                          </button>
                        </div>
                      </div>
                  )
              }
              {bioRegistered&&(
                <button onClick={()=>{biometricClear();setBioRegistered(false);}} style={{width:'100%',marginTop:5,padding:'5px',background:'none',border:'none',color:'var(--t3)',fontSize:11,cursor:'pointer',opacity:.6}}>
                  Remove biometric login
                </button>
              )}
            </div>
          )}
          <div className="login-ver">{shopName||'RepairOS'} {appVersion||'v7'}</div>
        </div>
      </div>
    </div>
  );
}

// ─── User Manager (admin only, inside SettingsPage) ──────────────────────────
function UserManager({currentUser,setCurrentUser,t}){
  const [users,setUsers]=useState([]);
  const [modal,setModal]=useState(null); // null | 'add' | user object
  const [confirmDel,setConfirmDel]=useState(null);

  function reload(){ setUsers(authListUsers(currentUser)); }
  useEffect(()=>{ reload(); },[]);

  const SECTION_LABELS={
    dashboard:'Dashboard', repairs:'Repairs', warranty:'Warranty',
    customParts:'Parts Catalog', parts:'Inventory', customers:'Customers',
    finance:'Finance', analytics:'Analytics', report:'Report', settings:'Settings'
  };

  return(
    <div className="card">
      {confirmDel&&(
        <div className="mo" onClick={()=>setConfirmDel(null)}>
          <div className="md" style={{maxWidth:320,textAlign:'center'}} onClick={e=>e.stopPropagation()}>
            <div style={{fontSize:28,marginBottom:8}}>🗑️</div>
            <div style={{fontWeight:700,fontSize:14,marginBottom:12}}>Delete user "{confirmDel.displayName}"?</div>
            <div style={{display:'flex',gap:8,justifyContent:'center'}}>
              <button className="btn bg2" onClick={()=>setConfirmDel(null)}>Cancel</button>
              <button className="btn bd" onClick={()=>{authDeleteUser(currentUser,confirmDel.id);setConfirmDel(null);reload();toast('🗑️','Deleted',confirmDel.displayName);}}>Delete</button>
            </div>
          </div>
        </div>
      )}
      {modal&&<UserModal user={modal==='add'?null:modal} currentUser={currentUser} sectionLabels={SECTION_LABELS} onClose={()=>setModal(null)} onSave={(updatedUser)=>{setModal(null);reload();if(updatedUser&&setCurrentUser&&updatedUser.id===currentUser.id)setCurrentUser(updatedUser);}} t={t}/>}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:13}}>
        <div className="stitle" style={{marginBottom:0}}>👥 User Management</div>
        <button className="btn bp bsm" onClick={()=>setModal('add')}><I n="plus" s={12} c="#fff"/> Add User</button>
      </div>
      <div style={{display:'flex',flexDirection:'column',gap:8}}>
        {users.map(u=>(
          <div key={u.id} style={{display:'flex',alignItems:'center',gap:10,padding:'10px 12px',background:'rgba(255,255,255,0.03)',border:'1px solid var(--glb)',borderRadius:11}}>
            <div style={{width:36,height:36,borderRadius:10,background:'rgba(10,132,255,0.15)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16,fontWeight:700,color:'var(--blue)',flexShrink:0,overflow:'hidden'}}>{u.photoUrl?<img src={u.photoUrl} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}}/>:u.displayName?.[0]?.toUpperCase()||'U'}</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontWeight:600,fontSize:13}}>{u.displayName}</div>
              <div style={{fontSize:11,color:'var(--t3)',marginTop:1,display:'flex',gap:6,flexWrap:'wrap',alignItems:'center'}}>
                <span>@{u.username}</span>
                <span style={{padding:'1px 7px',borderRadius:20,fontSize:10,fontWeight:700,background:u.role==='admin'?'rgba(10,132,255,0.15)':u.role==='manager'?'rgba(191,90,242,0.15)':u.role==='technician'?'rgba(48,209,88,0.15)':u.role==='receptionist'?'rgba(255,159,10,0.15)':'rgba(100,100,102,0.15)',color:u.role==='admin'?'var(--blue)':u.role==='manager'?'var(--purple)':u.role==='technician'?'var(--green)':u.role==='receptionist'?'var(--orange)':'var(--t2)'}}>
                  {(ROLES[u.role]||ROLES.custom).label}
                </span>
              </div>
            </div>
            <div style={{display:'flex',gap:5}}>
              <button className="btn bg2 bsm" onClick={()=>setModal(u)}><I n="edit" s={11}/></button>
              {u.role!=='admin'&&<button className="btn bd bsm" onClick={()=>setConfirmDel(u)}><I n="trash" s={11}/></button>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function UserModal({user,currentUser,sectionLabels,onClose,onSave,t}){
  const isEdit=!!user;
  const [dName,setDName]=useState(user?.displayName||'');
  const [uName,setUName]=useState(user?.username||'');
  const [pass,setPass]=useState('');
  const [passConfirm,setPassConfirm]=useState('');
  const [photoUrl,setPhotoUrl]=useState(user?.photoUrl||'');
  const [role,setRole]=useState(user?.role||'technician');
  const [perms,setPerms]=useState(user?.permissions||{...ROLE_PRESETS.technician});
  const [err,setErr]=useState('');
  const [loading,setLoading]=useState(false);
  const [makeAdmin,setMakeAdmin]=useState(user?.role==='admin');

  function setAll(level){ setPerms(Object.fromEntries(PERM_SECTIONS.map(s=>[s,level]))); }
  function applyRolePreset(r){
    setRole(r);
    if(r!=='custom') setPerms({...ROLE_PRESETS[r]});
  }

  async function handleSave(){
    if(!dName.trim()) return setErr('Display name required');
    if(!isEdit&&!uName.trim()) return setErr('Username required');
    if(!isEdit&&!pass) return setErr('Password required');
    if(pass&&pass!==passConfirm) return setErr('Passwords do not match');
    if(pass&&pass.length<6) return setErr('Password must be at least 6 characters');
    setLoading(true); setErr('');
    const finalRole = makeAdmin ? 'admin' : role;
    let result;
    if(isEdit){
      result = await authUpdateUser(currentUser, user.id, {displayName:dName.trim(), role:finalRole, permissions:perms, password:pass||undefined, photoUrl});
    } else {
      result = await authCreateUser(currentUser, {username:uName.trim(), displayName:dName.trim(), password:pass, role:finalRole, permissions:perms, photoUrl});
    }
    setLoading(false);
    if(result.ok){ toast('✅','Saved',dName.trim()); onSave(result.user); }
    else setErr(result.error);
  }

  return(
    <div className="mo">
      <div className="md" style={{maxWidth:500}} onClick={e=>e.stopPropagation()}>
        <div className="mh">
          <div className="mt2">{isEdit?`Edit ${user.displayName}`:'Add User'}</div>
          <span style={{cursor:'pointer'}} onClick={onClose}><I n="close" s={15} c="var(--t3)"/></span>
        </div>
        <div style={{display:'flex',flexDirection:'column',gap:12,marginBottom:16}}>
          {err&&<div className="login-err">{err}</div>}
          <div style={{display:'flex',alignItems:'flex-start',gap:14}}>
            <PhotoPicker value={photoUrl} onChange={setPhotoUrl} size={58}/>
            <div style={{flex:1,display:'flex',flexDirection:'column',gap:10}}>
              <div className="fg"><label className="fl">Display Name</label><input className="inp" value={dName} onChange={e=>setDName(e.target.value)} autoFocus placeholder="e.g. Ahmed"/></div>
              <div className="fg"><label className="fl">Username</label><input className="inp" value={uName} onChange={e=>setUName(e.target.value)} disabled={isEdit} placeholder="e.g. ahmed123" style={{opacity:isEdit?.5:1}}/></div>
            </div>
          </div>
          <div className="fg2">
            <div className="fg"><label className="fl">{isEdit?'New Password (leave blank to keep)':'Password'}</label><input className="inp" type="password" value={pass} onChange={e=>setPass(e.target.value)} placeholder={isEdit?'Leave blank to keep current':'Min 6 characters'}/></div>
            <div className="fg"><label className="fl">Confirm Password</label><input className="inp" type="password" value={passConfirm} onChange={e=>setPassConfirm(e.target.value)} placeholder="Repeat password"/></div>
          </div>

          {/* Role selector */}
          {user?.role!=='admin'&&(
            <div style={{background:'rgba(255,255,255,0.02)',border:'1px solid var(--glb)',borderRadius:11,padding:'12px 14px'}}>
              <div style={{fontWeight:600,fontSize:12,color:'var(--t3)',marginBottom:8,letterSpacing:.4}}>ROLE</div>
              <div style={{display:'flex',flexWrap:'wrap',gap:6,marginBottom:10}}>
                {Object.entries(ROLES).filter(([id])=>id!=='admin').map(([id,r])=>(
                  <button key={id} onClick={()=>applyRolePreset(id)}
                    className={`chip ${role===id&&!makeAdmin?'on':''}`}
                    title={r.description}>
                    {r.label}
                  </button>
                ))}
              </div>
              {Object.entries(ROLES).filter(([id])=>id!=='admin').map(([id,r])=>(
                role===id&&!makeAdmin&&<div key={id} style={{fontSize:11,color:'var(--t3)',marginBottom:8}}>ℹ️ {r.description}</div>
              ))}
              <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',padding:'7px 0',borderTop:'1px solid var(--glb)'}}>
                <div className="tog" style={{transform:'scale(0.85)',transformOrigin:'left'}}>
                  <input type="checkbox" checked={makeAdmin} onChange={e=>{setMakeAdmin(e.target.checked);if(e.target.checked)setPerms({...ROLE_PRESETS.admin});}}/>
                  <span className="ts"/>
                </div>
                <div>
                  <div style={{fontSize:12.5,fontWeight:600}}>👑 Grant Admin Access</div>
                  <div style={{fontSize:10.5,color:'var(--t3)'}}>Full access + user management</div>
                </div>
              </label>
            </div>
          )}

          {user?.role!=='admin'&&(
            <div style={{background:'rgba(255,255,255,0.03)',border:'1px solid var(--glb)',borderRadius:11,padding:'13px 14px'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
                <div style={{fontWeight:600,fontSize:12.5,color:'var(--blue)'}}>🔐 Permissions</div>
                <div style={{display:'flex',gap:5}}>
                  <button className="btn bg2 bsm" style={{fontSize:10}} onClick={()=>setAll('write')}>All Write</button>
                  <button className="btn bg2 bsm" style={{fontSize:10}} onClick={()=>setAll('read')}>All Read</button>
                  <button className="btn bg2 bsm" style={{fontSize:10}} onClick={()=>setAll('none')}>All None</button>
                </div>
              </div>
              <div style={{display:'flex',flexDirection:'column',gap:6}}>
                {PERM_SECTIONS.map(sec=>(
                  <div key={sec} style={{display:'flex',alignItems:'center',gap:10}}>
                    <div style={{fontSize:12.5,fontWeight:500,flex:1,minWidth:90}}>{sectionLabels[sec]}</div>
                    <div className="perm-grid" style={{flex:2}}>
                      {PERM_LEVELS.map(lvl=>(
                        <button key={lvl} className={`perm-btn ${perms[sec]===lvl?`active-${lvl}`:''}`}
                          onClick={()=>setPerms(p=>({...p,[sec]:lvl}))}>
                          {lvl==='none'?'🚫 None':lvl==='read'?'👁️ Read':'✏️ Write'}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="ma">
          <button className="btn bg2" onClick={onClose}>Cancel</button>
          <button className="btn bp" onClick={handleSave} disabled={loading}>{loading?'Saving…':'Save'}</button>
        </div>
      </div>
    </div>
  );
}

// ─── ROOT APP ─────────────────────────────────────────────────────────────────
export default function App() {
  const [currentUser,setCurrentUser] = useState(null);
  const [authReady,setAuthReady]     = useState(false);
  const [bioPrompt,setBioPrompt]     = useState(false); // show biometric prompt on launch
  const [page,setPage]           = useState(()=>{
    // Boot to whatever hash is in the URL (supports refresh & direct links)
    const raw=window.location.hash.replace('#','');
    const slashIdx=raw.indexOf('/');
    const h=slashIdx>=0?raw.slice(0,slashIdx):raw;
    const valid=['dashboard','repairs','warranty','customParts','parts','customers','finance','analytics','report','settings','repairDetail'];
    return valid.includes(h)?h:'dashboard';
  });
  // Appearance
  const [appearance,setAppearance] = useState(()=>({
    theme:'obsidian', font:'system', radius:'normal', density:'normal', accent:'', ...loadAppearance()
  }));
  useEffect(()=>{
    const {theme,font,radius,density,accent,compactSidebar,animationsReduced}=appearance;
    const dynCSS = buildThemeCSS(theme,font,radius,density,accent);
    let el = document.getElementById('ros-theme-vars');
    if(!el){el=document.createElement('style');el.id='ros-theme-vars';document.head.prepend(el);}
    el.textContent = dynCSS;
    // Interface options CSS
    let el2 = document.getElementById('ros-interface-vars');
    if(!el2){el2=document.createElement('style');el2.id='ros-interface-vars';document.head.appendChild(el2);}
    el2.textContent = `
      ${compactSidebar ? '.sb{width:62px!important;}.sb-logo .ltx,.sb-logo .lsb,.nv-label,.ss{display:none!important;}.nv{padding:10px!important;justify-content:center!important;gap:0!important;}.sb-logo{justify-content:center!important;padding:6px 0 18px!important;}.sb-logo .lic{flex-shrink:0!important;}' : ''}
      ${animationsReduced ? '*{animation-duration:0.01ms!important;transition-duration:0.01ms!important;}' : ''}
    `;
  },[appearance]);
  function updateAppearance(patch){
    setAppearance(prev=>{const next={...prev,...patch};saveAppearance(next);return next;});
  }
  const pageRef=useRef(null);
  const [param,setParam]         = useState(()=>{
    const raw=window.location.hash.replace('#','');
    const slashIdx=raw.indexOf('/');
    if(slashIdx<0) return null;
    const subPart=raw.slice(slashIdx+1);
    try{ return JSON.parse(decodeURIComponent(subPart)); }catch{ return subPart||null; }
  });
  const [toasts,setToasts]       = useState([]);
  const [repairs,setRepairs]     = useState([]);
  const [parts,setParts]         = useState([]);
  const [customers,setCustomers] = useState([]);
  const [notifs,setNotifs]       = useState([]);
  const [techs,setTechs]         = useState([]);
  const [withdrawals,setWithdrawals] = useState([]);
  const [catalog,setCatalog]     = useState([]);
  const [assets,setAssets]       = useState([]);
  const [brands,setBrands]       = useState([]);
  const [notifOpen,setNotifOpen] = useState(false);
  const [mobOpen,setMobOpen]     = useState(false);
  const [isMobile,setIsMobile]   = useState(()=>typeof window!=='undefined'&&window.innerWidth<=768);
  useEffect(()=>{
    // Responsive breakpoint listener
    const mq=window.matchMedia('(max-width:768px)');
    const onMq=e=>setIsMobile(e.matches);
    mq.addEventListener('change',onMq);
    // Mobile PWA meta & body fixes
    const sm=(n,c)=>{let m=document.querySelector('meta[name="'+n+'"]');if(!m){m=document.createElement('meta');m.name=n;document.head.appendChild(m);}m.content=c;};
    sm('viewport','width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover');
    sm('apple-mobile-web-app-capable','yes');
    sm('apple-mobile-web-app-status-bar-style','black-translucent');
    sm('mobile-web-app-capable','yes');
    sm('theme-color','#000000');
    document.body.style.overscrollBehavior='none';
    document.body.style.webkitOverflowScrolling='touch';
    return()=>mq.removeEventListener('change',onMq);
  },[]);
  const [lang,setLang]           = useState("en");
  const [currency,setCurrency]   = useState("USD");
  const [activeDb,setActiveDb]   = useState(null); // ServerDB info: {name, isTest, shopName}

  useEffect(()=>{
    DB.init();
    ServerDB.init().then(async ()=>{
      // Bootstrap admin on first run
      await authCreateAdmin();
      // Restore session if valid
      const user = await authRestore();
      const bioLockEnabled = localStorage.getItem(BIO_LOCK_KEY)==='1';
      const bioReady = typeof biometricIsRegistered==='function' && biometricIsRegistered() && isBiometricAvailable();
      if(user && bioLockEnabled && bioReady){
        // Valid session exists BUT bio-lock is on — gate with biometrics before entering app
        // Store the already-restored user so BiometricPromptScreen can log them in after auth
        sessionStorage.setItem('ros_bio_pending_user', JSON.stringify(user));
        setBioPrompt(true);
        setAuthReady(true);
      } else if(user){
        setCurrentUser(user); await load();
        setAuthReady(true);
      } else if(bioReady && localStorage.getItem(BIOMETRIC_REMEMBER_KEY)==='1'){
        // No valid session, but bio+remember set — prompt to re-authenticate
        setBioPrompt(true);
        setAuthReady(true);
      } else {
        setAuthReady(true);
      }
    });
    _toastFn=t=>{setToasts(p=>[...p,t]);setTimeout(()=>setToasts(p=>p.filter(x=>x.id!==t.id)),4200);};
  },[]);

  async function load(){
    // If ServerDB is active, reload from server first
    if(ServerDB.isActive()) await ServerDB.reload();
    setRepairs(SDB.get("repairs")||[]);
    setParts(SDB.get("parts")||INITIAL_PARTS);
    setCustomers(SDB.get("customers")||[]);
    setNotifs(SDB.get("notifications")||[]);
    setTechs(SDB.get("technicians")||[]);
    setWithdrawals(SDB.get("withdrawals")||[]);
    setCatalog(SDB.get("customPartsCatalog")||[]);
    setAssets(SDB.get("user_assets")||[]);
    setBrands(SDB.get("custom_brands")||[]);
    const l=SDB.get("language")||DB.get("language")||"en"; setLang(l);
    const c=SDB.get("currency")||DB.get("currency")||"USD"; setCurrency(c);
    // Update ServerDB banner state
    setActiveDb(ServerDB.getActiveInfo());
  }

  const t=STRINGS[lang]||STRINGS.en;
  const [rtlLayout,setRtlLayout]=useState((SDB.get("rtl_layout")||DB.get("rtl_layout"))===true);
  const rtl=rtlLayout;
  const MONTHS=lang==="ar"?MONTHS_AR:MONTHS_EN;
  const fmt=v=>fmtMoney(v,currency);

  const saveRepairs=d=>{SDB.set("repairs",d);setRepairs(d);};
  const saveParts=d=>{SDB.set("parts",d);setParts(d);};
  const saveCustomers=d=>{SDB.set("customers",d);setCustomers(d);};
  const saveTechs=d=>{SDB.set("technicians",d);setTechs(d);};
  const saveWithdrawals=d=>{SDB.set("withdrawals",d);setWithdrawals(d);};
  const saveCatalog=d=>{SDB.set("customPartsCatalog",d);setCatalog(d);};
  const saveAssetsFn=d=>{saveAssets(d);setAssets(d);};
  const saveBrandsFn=d=>{saveActiveBrands(d);setBrands(d);};

  const pushNotif=msg=>{
    const n={id:Date.now(),msg,time:new Date().toISOString(),read:false};
    const l=[n,...(SDB.get("notifications")||[])].slice(0,60);
    SDB.set("notifications",l);setNotifs(l);
  };

  // Push a history entry so back/forward buttons work inside the app
  // pm can be a string (legacy) or an object {tab, sub, id, ...}
  pageRef.current=page;
  const nav=(p,pm=null)=>{
    NAV_COUNT++;
    // Remember where you were on this page so Back can return you there, then
    // make sure the page we're going to starts at the top.
    const m0=mainEl(); if(m0) PAGE_SCROLL[page]=m0.scrollTop;
    PAGE_RESTORE.v=null;
    Object.keys(SCROLL_MEM).forEach(k=>delete SCROLL_MEM[k]);
    // Choosing Repairs from the menu starts fresh; only "Back" (or Edit from a repair's page) restores your place
    if(p==="repairs"){
      const keep=typeof pm==="string"&&pm.startsWith("edit:")&&page==="repairDetail";
      if(!keep) clearRepairsView();
    } else if(p!=="repairDetail"&&REPAIRS_VIEW){ REPAIRS_VIEW.pending=false; }
    const hash='#'+p+(pm?('/'+encodeURIComponent(typeof pm==='object'?JSON.stringify(pm):pm)):'');
    window.history.pushState({page:p,param:pm},'',window.location.pathname+hash);
    setPage(p);setParam(pm);setNotifOpen(false);setMobOpen(false);
  };

  // navSub: push a sub-navigation inside the current page (brand→device, customer detail, etc.)
  // This lets Android back button go back to the previous sub-state within a page.
  const navSub=(subState)=>{
    const hash='#'+page+'/'+encodeURIComponent(JSON.stringify(subState));
    window.history.pushState({page,param:subState},'',window.location.pathname+hash);
    setParam(subState);
  };

  // Listen for back/forward navigation (browser back, Android back button)
  useEffect(()=>{
    // Set initial hash if missing
    if(!window.location.hash&&currentUser) window.history.replaceState({page,param},'','#'+page);
    const VALID_PAGES=['dashboard','repairs','warranty','customParts','parts','customers','finance','analytics','report','settings','repairDetail'];
    const onPop=e=>{
      const raw=window.location.hash.replace('#','');
      const slashIdx=raw.indexOf('/');
      const pagePart=slashIdx>=0?raw.slice(0,slashIdx):raw;
      const subPart=slashIdx>=0?raw.slice(slashIdx+1):'';
      const target=VALID_PAGES.includes(pagePart)?pagePart:'dashboard';
      let pm=e.state?.param||null;
      if(!pm&&subPart){try{pm=JSON.parse(decodeURIComponent(subPart));}catch{pm=subPart;}}
      // Going Back to a different page: return to where you were on it
      if(target!==pageRef.current) PAGE_RESTORE.v=PAGE_SCROLL[target]!==undefined?PAGE_SCROLL[target]:null;
      setPage(target);setParam(pm);setNotifOpen(false);setMobOpen(false);
    };
    window.addEventListener('popstate',onPop);
    return()=>window.removeEventListener('popstate',onPop);
  },[currentUser]);

  // Every page change starts at the top — unless we got here via Back, which restores your place
  useEffect(()=>{
    const v=PAGE_RESTORE.v; PAGE_RESTORE.v=null;
    scrollMainTo(v!=null?v:0);
  },[page]);

  // Scrolling the page with the mouse wheel must never change a number field's
  // value. Browsers do that when a number input is focused and hovered, so we
  // drop focus from it the moment the wheel turns (the page still scrolls).
  useEffect(()=>{
    const onWheel=e=>{
      const el=document.activeElement;
      if(el&&el.tagName==='INPUT'&&el.type==='number'&&(e.target===el||el.contains(e.target))) el.blur();
    };
    document.addEventListener('wheel',onWheel,{passive:true,capture:true});
    return()=>document.removeEventListener('wheel',onWheel,{capture:true});
  },[]);

  const unread=notifs.filter(n=>!n.read).length;
  const pendCount=repairs.filter(r=>r.status==="Pending").length;
  const splitPct=SDB.get("split_pct")??DB.get("split_pct")??50;
  const fin=calcFinancials(repairs,withdrawals,splitPct);

  const ALL_NAV=[
    {id:"dashboard", label:t.dashboard,    icon:"dashboard"},
    {id:"repairs",   label:t.repairs,      icon:"repairs",  badge:pendCount},
    {id:"warranty",  label:t.warranty,     icon:"warranty"},
    {id:"customParts",label:t.customParts, icon:"catalog"},
    {id:"parts",     label:t.parts,        icon:"parts"},
    {id:"customers", label:t.customers,    icon:"customers"},
    {id:"finance",   label:t.finance,      icon:"finance"},
    {id:"analytics", label:t.analytics,    icon:"analytics"},
    {id:"report",    label:t.report,       icon:"report"},
    {id:"settings",  label:t.settings,     icon:"settings"},
  ];
  const NAV=ALL_NAV.filter(n=>canRead(currentUser,n.id));

  function handleLogout(){ authLogout(); setCurrentUser(null); }

  const sharedProps={t,fmt,repairs,parts,customers,techs,withdrawals,catalog,assets,brands,
    saveRepairs,saveParts,saveCustomers,saveTechs,saveWithdrawals,saveCatalog,saveAssetsFn,saveBrandsFn,
    pushNotif,lang,currency,MONTHS,splitPct,fin,nav,navSub,param,rtlLayout,activeDb,currentUser,setCurrentUser,
    canRead:(s)=>canRead(currentUser,s), canWrite:(s)=>canWrite(currentUser,s),
    appearance,updateAppearance,
    confirmDelete:(msg,fn)=>{ if(appearance.confirmDeletes===false){fn();}else{if(window.confirm?window.confirm(msg):true){fn();}} }};

  // Auth gate — show nothing until auth is checked, then login screen or app
  if(!authReady) return(
    <>
      <style>{CSS}</style>
      <div className="login-screen">
        <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:12}}>
          <div className="login-logo" style={{marginBottom:0}}>🔧</div>
          <div style={{color:"var(--t3)",fontSize:13,marginTop:4}}>Loading…</div>
        </div>
      </div>
    </>
  );
  if(!currentUser){
    const handleLoginDone = async user=>{setCurrentUser(user);await load();};
    // Auto-biometric prompt on launch (remember-me + biometrics registered)
    if(bioPrompt){
      return(
        <>
          <style>{CSS}</style>
          <BiometricPromptScreen
            onSuccess={handleLoginDone}
            onFallback={()=>setBioPrompt(false)}
          />
        </>
      );
    }
    return <LoginScreen onLogin={handleLoginDone}/>;
  }

  return(
    <>
      <style>{CSS}</style>
      <div className={`app ${appearance.showRepairId===false?"hide-repair-ids":""} ${appearance.stickyHeader===false?"no-sticky-header":""}`} dir={rtl?"rtl":"ltr"}>
        {/* Mobile overlay */}
        {mobOpen&&<div className="mob-over" onClick={()=>setMobOpen(false)}/>}

        {/* Mobile bottom nav — CSS shows it only on mobile */}
        {(()=>{
          const MOB_NAV=[
            {id:"dashboard",  icon:"🏠", label:"Home"},
            {id:"repairs",    icon:"🔧", label:"Repairs"},
            {id:"customers",  icon:"👤", label:"Clients"},
            {id:"customParts",icon:"📋", label:"Catalog"},
            {id:"settings",   icon:"⚙️", label:"More"},
          ].filter(n=>canRead(currentUser,n.id));
          const pendingCount=repairs.filter(r=>r.status==="Pending"||r.status==="In Progress").length;
          return(
            <nav className="mob-bottom-nav" role="navigation" aria-label="Mobile navigation">
              {MOB_NAV.map(n=>{
                const isOn=page===n.id
                  ||(n.id==="settings"&&["analytics","report","finance","warranty","customParts"].includes(page));
                const badge=n.id==="repairs"?pendingCount:0;
                return(
                  <button key={n.id} className={`mob-nav-item${isOn?" on":""}`}
                    onClick={()=>{nav(n.id);setMobOpen(false);}}
                    aria-label={n.label} aria-current={isOn?"page":undefined}>
                    {badge>0&&<span className="mob-nav-badge">{badge>9?"9+":badge}</span>}
                    <span className="mni">{n.icon}</span>
                    <span>{n.label}</span>
                  </button>
                );
              })}
            </nav>
          );
        })()}

        {/* Sidebar */}
        <div className={`sb ${mobOpen?"mob-open":""} ${appearance.compactSidebar?"sb-compact":""}`}>
          <div className="sb-logo">
            {(()=>{
              const sLogo=SDB.get("shop_logo")||DB.get("shop_logo")||"";
              const sName=SDB.get("shop_name")||DB.get("shop_name")||"";
              return sLogo
                ? <img src={sLogo} alt="" style={{width:32,height:32,objectFit:"contain",borderRadius:8,flexShrink:0,cursor:"pointer"}} onClick={()=>nav("settings","shop")}/>
                : <div className="lic">🔧</div>;
            })()}
            <div><div className="ltx">{SDB.get("shop_name")||DB.get("shop_name")||t.appName}</div><div className="lsb">{SDB.get("shop_tagline")||`${t.appSub} ${SDB.get("app_version")||DB.get("app_version")||"v7"}`}</div></div>
          </div>
          {NAV.map((n,i)=>{
            const secs=[[0,3],[3,6],[6,9],[9,10]];
            const secLabels=[null,t.parts,t.finance,t.settings];
            const secEl=secs.findIndex(([a,b])=>i>=a&&i<b);
            return(
              <div key={n.id}>
                {secEl>0&&i===secs[secEl][0]&&<div className="ss">{secLabels[secEl]}</div>}
                <div className={`nv ${page===n.id?"on":""}`} onClick={()=>nav(n.id)}>
                  <I n={n.icon} s={14}/><span className="nv-label">{n.label}</span>
                  {n.badge>0&&<span className="nbg">{n.badge}</span>}
                </div>
              </div>
            );
          })}
          <SidebarWidgets appearance={appearance} updateAppearance={updateAppearance}
            currentUser={currentUser} fin={fin} fmt={fmt} repairs={repairs} parts={parts} t={t} nav={nav}/>
        </div>

        {/* Main */}
        <div className="main">
          <div className="topbar">
            <div className="nbtn mob-menu-btn" onClick={()=>setMobOpen(v=>!v)}>
              <I n="menu" s={16} c="var(--t2)"/>
            </div>
            <div className="date-txt" style={{color:"var(--t3)",fontSize:12}}>{new Date().toLocaleDateString(lang==="ar"?"ar-IQ":"en-US",{weekday:"long",month:"long",day:"numeric",year:"numeric"})}</div>
            {activeDb&&(
              <div style={{marginLeft:10,padding:"3px 10px",background:activeDb.isTest?"rgba(255,159,10,0.12)":"rgba(48,209,88,0.1)",border:`1px solid ${activeDb.isTest?"rgba(255,159,10,0.3)":"rgba(48,209,88,0.25)"}`,borderRadius:20,fontSize:11,fontWeight:600,color:activeDb.isTest?"var(--orange)":"var(--green)",display:"flex",alignItems:"center",gap:5,cursor:"pointer"}} onClick={()=>nav("settings","data")}>
                {activeDb.isTest?"🧪":"🗄️"} {activeDb.name.replace(".json","")}
              </div>
            )}
            <div style={{flex:1}}/>
            <div className="nbtn" onClick={()=>setNotifOpen(v=>!v)}>
              <I n="bell" s={15} c="var(--t2)"/>
              {unread>0&&<div className="ndot"/>}
            </div>
            <div style={{display:'flex',alignItems:'center',gap:6,flexShrink:0}}>
              <div style={{display:'flex',alignItems:'center',gap:7,padding:'5px 10px',background:'rgba(255,255,255,0.05)',border:'1px solid var(--glb)',borderRadius:10}}>
                <div style={{width:26,height:26,borderRadius:7,background:'rgba(10,132,255,0.2)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:700,color:'var(--blue)'}}>{currentUser.displayName?.[0]?.toUpperCase()||'U'}</div>
                <div style={{display:'flex',flexDirection:'column',lineHeight:1.2}}>
                  <span style={{fontSize:11.5,fontWeight:600,color:'var(--tx)'}}>{currentUser.displayName}</span>
                  <span style={{fontSize:10,color:'var(--t3)'}}>{(ROLES[currentUser.role]||ROLES.custom).label}</span>
                </div>
              </div>
              <button className="btn bg2 bsm" onClick={handleLogout} title="Sign out" style={{padding:'6px 10px'}}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/></svg>
              </button>
            </div>
          </div>

          {/* Notif panel */}
          {notifOpen&&(
            <div className="npanel" style={rtl?{left:14,right:"auto"}:{}}>
              <div style={{padding:"13px 15px",borderBottom:"1px solid var(--glb)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div style={{fontWeight:700,fontSize:13.5}}>{t.notifications}</div>
                <span style={{cursor:"pointer"}} onClick={()=>setNotifOpen(false)}><I n="close" s={14} c="var(--t3)"/></span>
              </div>
              <div style={{maxHeight:320,overflowY:"auto"}}>
                {notifs.length===0
                  ? <div className="empty" style={{padding:26}}><div className="ei">🔔</div><div className="et">{t.allClear}</div></div>
                  : notifs.map(n=>(
                    <div key={n.id} style={{padding:"10px 15px",borderBottom:"1px solid rgba(255,255,255,0.04)",background:n.read?"transparent":"rgba(10,132,255,0.05)"}}>
                      <div style={{fontSize:12.5,lineHeight:1.5}}>{n.msg}</div>
                      <div style={{fontSize:10,color:"var(--t3)",marginTop:2}}>{new Date(n.time).toLocaleString()}</div>
                    </div>
                  ))
                }
              </div>
              <div style={{padding:"8px 15px",borderTop:"1px solid var(--glb)"}}>
                <span style={{fontSize:12,color:"var(--blue)",cursor:"pointer"}} onClick={()=>{const u=notifs.map(n=>({...n,read:true}));SDB.set("notifications",u);setNotifs(u);}}>{t.markAllRead}</span>
              </div>
            </div>
          )}

          {page==="dashboard"   && canRead(currentUser,"dashboard")   && <DashboardPage   {...sharedProps} readOnly={!canWrite(currentUser,"dashboard")}/>}
          {page==="repairs"     && canRead(currentUser,"repairs")     && <RepairsPage     {...sharedProps} initTab={param} readOnly={!canWrite(currentUser,"repairs")} onViewRepair={id=>nav("repairDetail",id)} navSub={navSub}/>}
          {page==="repairDetail"&& canRead(currentUser,"repairs") && <RepairDetailPageWrapper repairs={repairs} param={param} nav={nav} saveRepairs={saveRepairs} fmt={fmt} t={t} customers={customers} readOnly={!canWrite(currentUser,"repairs")} pushNotif={pushNotif}/>}
          {page==="warranty"    && canRead(currentUser,"warranty")    && <WarrantyPage    {...sharedProps} readOnly={!canWrite(currentUser,"warranty")}/>}
          {page==="customParts" && canRead(currentUser,"customParts") && <CustomPartsPage {...sharedProps} readOnly={!canWrite(currentUser,"customParts")}/>}
          {page==="parts"       && canRead(currentUser,"parts")       && <PartsPage       {...sharedProps} readOnly={!canWrite(currentUser,"parts")} catalog={sharedProps.catalog||[]}/>}
          {page==="customers"   && canRead(currentUser,"customers")   && <CustomersPage   {...sharedProps} selectedCustomer={param&&typeof param!=='object'?param:null} readOnly={!canWrite(currentUser,"customers")}/>}
          {page==="finance"     && canRead(currentUser,"finance")     && <FinancePage     {...sharedProps} readOnly={!canWrite(currentUser,"finance")}/>}
          {page==="analytics"   && canRead(currentUser,"analytics")   && <AnalyticsPage   {...sharedProps} readOnly={!canWrite(currentUser,"analytics")}/>}
          {page==="report"      && canRead(currentUser,"report")      && <MonthlyReportPage {...sharedProps} readOnly={!canWrite(currentUser,"report")}/>}
          {page==="settings"    && canRead(currentUser,"settings")    && <SettingsPage    {...sharedProps} readOnly={!canWrite(currentUser,"settings")} onLangChange={l=>{SDB.set("language",l);setLang(l);}} onCurrencyChange={c=>{SDB.set("currency",c);setCurrency(c);}} onRtlChange={v=>{SDB.set("rtl_layout",v);setRtlLayout(v);}} onRestore={load}/>}
        </div>
      </div>

      <div className="tc">
        {toasts.map(t=>(
          <div key={t.id} className="toast"><div className="ti">{t.icon}</div><div><div className="tt">{t.title}</div><div className="tb">{t.body}</div></div></div>
        ))}
      </div>
    </>
  );
}

// ─── Stat Card ────────────────────────────────────────────────────────────────
function SC({icon,label,value,color,sub,onClick}){
  return(
    <div className={`sc ${onClick?"cl":""}`} onClick={onClick}>
      <div className="si" style={{background:color+"22"}}>{icon}</div>
      <div className="sv" style={{color}}>{value}</div>
      <div className="sl">{label}</div>
      {sub&&<div className="sc2">{sub}</div>}
    </div>
  );
}

// ─── Split Summary card ───────────────────────────────────────────────────────
function SplitSummary({netProfit,repairs,monthLabel,t,fmt}){
  const sp=SDB.get("split_pct")??DB.get("split_pct")??50;
  // If repairs array passed, compute correct owner/store cuts respecting ownerOnly
  // Only PAID done/delivered repairs count — unpaid work doesn't touch splits yet
  let oc, sc2, unpaidP=0, unpaidN=0;
  if(repairs){
    const paidDone=(repairs||[]).filter(r=>(r.status==="Done"||r.status==="Delivered")&&r.paid);
    const unpaidDone=(repairs||[]).filter(r=>(r.status==="Done"||r.status==="Delivered")&&!r.paid);
    oc=paidDone.reduce((s,r)=>{const p=calcRepairProfit(r);if(r.ownerOnly)return s+p;if(r.storeOnly)return s;return s+p*(sp/100);},0);
    sc2=paidDone.reduce((s,r)=>{const p=calcRepairProfit(r);if(r.ownerOnly)return s;if(r.storeOnly)return s+p;return s+p*((100-sp)/100);},0);
    netProfit=paidDone.reduce((s,r)=>s+calcRepairProfit(r),0);
    unpaidP=unpaidDone.reduce((s,r)=>s+calcRepairProfit(r),0);
    unpaidN=unpaidDone.length;
  } else {
    oc=netProfit*(sp/100);
    sc2=netProfit*((100-sp)/100);
  }
  return(
    <div className="card mb14">
      <div className="stitle">💼 {t.profitSplit}{monthLabel?` — ${monthLabel}`:" (All-time)"}</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:13}}>
        <div style={{background:"rgba(10,132,255,0.07)",border:"1px solid rgba(10,132,255,0.2)",borderRadius:12,padding:"16px 18px"}}>
          {(()=>{const hasOwnerOnly=(repairs||[]).some(r=>(r.status==="Done"||r.status==="Delivered")&&r.paid?r.ownerOnly:false);return(<div style={{fontSize:11,color:"var(--blue)",fontWeight:700,marginBottom:6}}>👤 {t.yourCut}{hasOwnerOnly?" (mixed — includes mine-only)":(` (${sp}%)`)} </div>);})()}
          <div style={{fontSize:26,fontWeight:700,color:oc>=0?"var(--blue)":"var(--red)"}}>{fmt(oc)}</div>
          <div style={{fontSize:11,color:"var(--t3)",marginTop:4}}>{t.netProfit}: {fmt(netProfit)}</div>
        </div>
        <div style={{background:"rgba(48,209,88,0.07)",border:"1px solid rgba(48,209,88,0.18)",borderRadius:12,padding:"16px 18px"}}>
          <div style={{fontSize:11,color:"var(--green)",fontWeight:700,marginBottom:6}}>🏪 {t.storeCut} ({100-sp}%)</div>
          <div style={{fontSize:26,fontWeight:700,color:sc2>=0?"var(--green)":"var(--red)"}}>{fmt(sc2)}</div>
          <div style={{fontSize:11,color:"var(--t3)",marginTop:4}}>{t.storeCut}</div>
        </div>
      </div>
      {unpaidN>0&&(
        <div style={{marginTop:11,padding:"9px 13px",background:"rgba(255,159,10,0.08)",border:"1px solid rgba(255,159,10,0.22)",borderRadius:9,fontSize:12,color:"var(--orange)",fontWeight:600,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:6}}>
          <span>⏳ {unpaidN} unpaid repair{unpaidN!==1?"s":""} — excluded from split</span>
          <span style={{fontWeight:800}}>{fmt(unpaidP)} pending</span>
        </div>
      )}
      {netProfit<0&&<div style={{marginTop:11,padding:"9px 13px",background:"rgba(255,69,58,0.08)",border:"1px solid rgba(255,69,58,0.2)",borderRadius:9,fontSize:12.5,color:"var(--red)",fontWeight:500}}>⚠️ Net profit is negative</div>}
    </div>
  );
}

// ─── DASHBOARD ────────────────────────────────────────────────────────────────
function DashboardPage({t,fmt,repairs,parts,customers,withdrawals,fin,nav,splitPct,lang,MONTHS}){
  const pending=repairs.filter(r=>r.status==="Pending").length;
  const inProg=repairs.filter(r=>r.status==="In Progress").length;
  const lowStock=parts.filter(p=>p.stock<=3).length;
  const done=repairs.filter(r=>r.status==="Done"||r.status==="Delivered"); // counts only
  const paidDone=repairs.filter(r=>(r.status==="Done"||r.status==="Delivered")&&r.paid); // for $ chart
  const [chartRange,setChartRange]=useState("7d");
  const now2=new Date();
  function getChartData(){
    const ranges={
      "7d":{days:7,fmt:{weekday:"short"}},
      "30d":{days:30,fmt:{month:"short",day:"numeric"}},
      "90d":{days:90,fmt:{month:"short",day:"numeric"}},
    };
    if(chartRange==="month"){
      // this month day by day
      const daysInMonth=now2.getDate();
      return Array.from({length:daysInMonth},(_,i)=>{
        const d=new Date(now2.getFullYear(),now2.getMonth(),i+1);
        const ds=d.toDateString();
        const dayDone=paidDone.filter(r=>getFinanceDate(r).toDateString()===ds);
        const rev=dayDone.reduce((s,r)=>s+(parseFloat(r.price)||0),0);
        const cost=dayDone.reduce((s,r)=>s+(r.partsUsed||[]).reduce((x,p)=>x+(parseFloat(p.cost)||0)*(p.qty||1),0),0);
        return{day:String(i+1),val:rev-cost};
      });
    }
    const {days,fmt}=ranges[chartRange]||ranges["7d"];
    return Array.from({length:days},(_,i)=>{
      const d=new Date();d.setDate(d.getDate()-(days-1-i));
      const ds=d.toDateString();
      const dayDone=paidDone.filter(r=>getFinanceDate(r).toDateString()===ds);
      const rev=dayDone.reduce((s,r)=>s+(parseFloat(r.price)||0),0);
      const cost=dayDone.reduce((s,r)=>s+(r.partsUsed||[]).reduce((x,p)=>x+(parseFloat(p.cost)||0)*(p.qty||1),0),0);
      return{day:d.toLocaleDateString(lang==="ar"?"ar-IQ":"en-US",fmt),val:rev-cost};
    });
  }
  const chartData=getChartData();
  const chartRangeLabel={"7d":t.sevenDays,"30d":t.thirtyDays,"month":t.thisMonth,"90d":t.ninetyDays}[chartRange]||"7d";
  const recent=[...repairs].sort((a,b)=>new Date(b.createdAt)-new Date(a.createdAt)).slice(0,5);
  const warrantyAlerts=repairs.filter(r=>{if(!r.warrantyUntil)return false;const days=(new Date(r.warrantyUntil)-new Date())/864e5;return days>=0&&days<=7;});
  const lossJobs=repairs.filter(r=>(r.status==="Done"||r.status==="Delivered")&&calcRepairProfit(r)<0);
  return(
    <div className="page">
      <div className="ph"><div><div className="pt">{t.dashboard}</div></div></div>
      <div className="sg4">
        <SC icon="💰" label={t.netProfit} value={fmt(fin.netProfit)} color={fin.netProfit>=0?"var(--green)":"var(--red)"} sub={`${t.revenue} ${fmt(fin.totalRevenue)}`} onClick={()=>nav("finance")}/>
        <SC icon="🔧" label={t.inProgress2} value={inProg} color="var(--blue)" sub={`${pending} ${t.pending}`} onClick={()=>nav("repairs","active")}/>
        <SC icon="👥" label={t.customers} value={customers.length} color="var(--purple)" onClick={()=>nav("customers")}/>
        <SC icon="⚠️" label={t.lowStock} value={lowStock} color="var(--orange)" sub="≤3" onClick={()=>nav("parts")}/>
      </div>
      {(warrantyAlerts.length>0||lossJobs.length>0)&&(
        <div style={{display:"flex",gap:10,marginBottom:14,flexWrap:"wrap"}}>
          {warrantyAlerts.length>0&&(<div style={{flex:1,minWidth:200,background:"rgba(255,159,10,0.08)",border:"1px solid rgba(255,159,10,0.25)",borderRadius:12,padding:"11px 14px",display:"flex",alignItems:"center",gap:10,cursor:"pointer"}} onClick={()=>nav("warranty")}>
            <span style={{fontSize:18}}>🛡️</span><div><div style={{fontWeight:600,fontSize:12.5,color:"var(--orange)"}}>{t.warrantyExpiring}</div><div style={{fontSize:11,color:"var(--t3)",marginTop:1}}>{warrantyAlerts.length} — within 7 days</div></div>
          </div>)}
          {lossJobs.length>0&&(<div style={{flex:1,minWidth:200,background:"rgba(255,69,58,0.08)",border:"1px solid rgba(255,69,58,0.22)",borderRadius:12,padding:"11px 14px",display:"flex",alignItems:"center",gap:10,cursor:"pointer"}} onClick={()=>nav("analytics")}>
            <span style={{fontSize:18}}>📉</span><div><div style={{fontWeight:600,fontSize:12.5,color:"var(--red)"}}>{t.lossRepairs}</div><div style={{fontSize:11,color:"var(--t3)",marginTop:1}}>{lossJobs.length}</div></div>
          </div>)}
        </div>
      )}
      <div className="g2 mb14">
        <div className="card" style={{cursor:"pointer"}} onClick={()=>nav("finance")}>
          <div className="stitle">💼 {t.profitSplit}</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            <div style={{textAlign:"center",padding:"12px 0",background:"rgba(10,132,255,0.07)",borderRadius:10,border:"1px solid rgba(10,132,255,0.18)"}}>
              <div style={{fontSize:19,fontWeight:700,color:"var(--blue)"}}>{fmt(fin.ownerCut)}</div>
              <div style={{fontSize:10.5,color:"var(--t3)",marginTop:3}}>{t.yourCut} ({splitPct}%)</div>
            </div>
            <div style={{textAlign:"center",padding:"12px 0",background:"rgba(48,209,88,0.07)",borderRadius:10,border:"1px solid rgba(48,209,88,0.18)"}}>
              <div style={{fontSize:19,fontWeight:700,color:"var(--green)"}}>{fmt(fin.storeCut)}</div>
              <div style={{fontSize:10.5,color:"var(--t3)",marginTop:3}}>{t.storeCut} ({100-splitPct}%)</div>
            </div>
          </div>
          <div style={{marginTop:10,paddingTop:10,borderTop:"1px solid var(--glb)",display:"flex",justifyContent:"space-between",fontSize:12}}>
            <span style={{color:"var(--t3)"}}>{t.withdrawn}</span><span style={{fontWeight:600,color:"var(--orange)"}}>{fmt(fin.totalWithdrawn)}</span>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:12.5,marginTop:6}}>
            <span style={{color:"var(--t3)"}}>{t.balance}</span><span style={{fontWeight:700,color:fin.ownerBalance>=0?"var(--green)":"var(--red)"}}>{fmt(fin.ownerBalance)}</span>
          </div>
        </div>
        <div className="card">
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
            <div className="stitle" style={{marginBottom:0}}>📈 {t.netProfit}</div>
            <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
              {[["7d",t.sevenDays],["30d",t.thirtyDays],["month",t.thisMonth],["90d",t.ninetyDays]].map(([k,label])=>(
                <span key={k} className={`chip ${chartRange===k?"on":""}`} style={{fontSize:10,padding:"2px 8px"}} onClick={()=>setChartRange(k)}>{label}</span>
              ))}
            </div>
          </div>
          <ResponsiveContainer width="100%" height={130}>
            <LineChart data={chartData}>
              <XAxis dataKey="day" axisLine={false} tickLine={false} tick={{fill:"rgba(255,255,255,0.3)",fontSize:9}} interval="preserveStartEnd"/>
              <YAxis hide/>
              <Tooltip cursor={false} wrapperStyle={{outline:"none",background:"transparent"}} contentStyle={{background:"var(--bg2)",border:"1px solid rgba(255,255,255,0.09)",borderRadius:9,fontSize:12,color:"#fff"}} formatter={v=>[fmt(v),t.netProfit]}/>
              <Line type="monotone" dataKey="val" stroke="#30D158" strokeWidth={2.5} dot={false}/>
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="card">
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <div className="stitle" style={{marginBottom:0}}>{t.repairs}</div>
          <span style={{fontSize:11.5,color:"var(--blue)",cursor:"pointer"}} onClick={()=>nav("repairs","active")}>{t.allRepairs} →</span>
        </div>
        {recent.length===0
          ? <div className="empty"><div className="ei">📱</div><div className="et">{t.noRepairs}</div></div>
          : <div style={{display:"flex",flexDirection:"column",gap:6}}>{recent.map(r=>{
              const s=STATUS_CFG[r.status]||STATUS_CFG["Pending"];
              const rp=calcRepairProfit(r);
              const isLoss=(r.status==="Done"||r.status==="Delivered")&&rp<0;
              return(
                <div key={r.id} onClick={()=>nav("repairs","active")}
                  style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",
                    background:"var(--gl)",border:"1px solid var(--glb)",borderRadius:13,
                    cursor:"pointer",position:"relative",overflow:"hidden",transition:"border-color .15s"}}
                  onMouseEnter={e=>e.currentTarget.style.borderColor="rgba(255,255,255,0.12)"}
                  onMouseLeave={e=>e.currentTarget.style.borderColor="var(--glb)"}>
                  {/* Accent bar */}
                  <div style={{position:"absolute",left:0,top:0,bottom:0,width:3,background:isLoss?"var(--red)":s.color,borderRadius:"13px 0 0 13px",flexShrink:0}}/>
                  <div style={{marginLeft:6,width:34,height:34,borderRadius:10,background:isLoss?"rgba(255,69,58,0.13)":s.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>{isLoss?"📉":s.icon}</div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:600,fontSize:13,display:"flex",alignItems:"center",gap:4,flexWrap:"wrap"}}>
                      {r.customerName}
                      <span style={{fontWeight:400,color:"var(--t3)",fontSize:11}}>#{r.id}</span>
                      {isLoss&&<span style={{fontSize:10}}>📉</span>}
                      {r.ownerOnly&&<span style={{fontSize:9.5,background:"rgba(191,90,242,0.12)",color:"var(--purple)",padding:"1px 6px",borderRadius:9,fontWeight:700,border:"1px solid rgba(191,90,242,0.2)"}}>👤</span>}
                    </div>
                    <div style={{fontSize:11,color:"var(--t3)",marginTop:2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.device}</div>
                  </div>
                  <div style={{textAlign:"right",flexShrink:0}}>
                    <span style={{display:"inline-flex",alignItems:"center",fontSize:10,fontWeight:700,padding:"2px 7px",borderRadius:8,background:s.bg,color:s.color}}>{s.icon} {r.status}</span>
                    <div style={{fontSize:11.5,color:isLoss?"var(--red)":parseFloat(r.price)>0?"var(--tx)":"var(--t3)",marginTop:3,fontWeight:isLoss?700:400}}>{fmt(r.price||0)}</div>
                  </div>
                </div>
              );
            })}</div>
        }
      </div>
    </div>
  );
}

// ─── REPAIRS ──────────────────────────────────────────────────────────────────
// ─── QuickRepairButton — dropdown of presets ─────────────────────────────────
function QuickRepairButton({onSelect,t}){
  const [open,setOpen]=useState(false);
  const [presets,setPresets]=useState(getRepairPresets);
  const ref=useRef();
  const btnRef=useRef();
  const [pos,setPos]=useState({top:0,left:8,width:240,maxH:400});
  // Refresh presets when opened, and work out where the menu can fit on screen
  const handleOpen=()=>{
    setPresets(getRepairPresets());
    if(!open&&btnRef.current){
      const b=btnRef.current.getBoundingClientRect();
      const vw=window.innerWidth,vh=window.innerHeight;
      const width=Math.min(280,vw-16);
      const left=Math.max(8,Math.min(b.right-width,vw-width-8));
      const top=b.bottom+6;
      setPos({top,left,width,maxH:Math.max(160,vh-top-12)});
    }
    setOpen(v=>!v);
  };
  useEffect(()=>{
    if(!open) return;
    function h(e){if(ref.current&&!ref.current.contains(e.target))setOpen(false);}
    const close=()=>setOpen(false);
    document.addEventListener("mousedown",h);
    document.addEventListener("touchstart",h,{passive:true});
    window.addEventListener("resize",close);
    document.addEventListener("scroll",close,true); // menu is fixed, so close it if the page scrolls
    return()=>{
      document.removeEventListener("mousedown",h);
      document.removeEventListener("touchstart",h);
      window.removeEventListener("resize",close);
      document.removeEventListener("scroll",close,true);
    };
  },[open]);
  if(presets.length===0) return null;
  return(
    <div style={{position:"relative"}} ref={ref}>
      <button ref={btnRef} className="btn bg2 bsm" style={{gap:5}} onClick={handleOpen}>
        ⚡ <span style={{fontSize:11.5}}>Quick</span>
        <span style={{fontSize:9,opacity:.6}}>▾</span>
      </button>
      {open&&(
        <div style={{position:"fixed",top:pos.top,left:pos.left,width:pos.width,maxHeight:pos.maxH,overflowY:"auto",background:"var(--bg2)",border:"1px solid var(--glb)",borderRadius:14,zIndex:300,boxShadow:"0 12px 36px rgba(0,0,0,0.7)",animation:"fadeInScale .13s ease"}}>
          <div style={{padding:"8px 12px 5px",fontSize:10.5,fontWeight:700,color:"var(--t3)",letterSpacing:".04em",textTransform:"uppercase"}}>Quick Add Preset</div>
          {presets.map((p,i)=>(
            <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",cursor:"pointer",transition:"background .12s",borderTop:i===0?"1px solid var(--glb)":""}}
              onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.06)"}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}
              onClick={()=>{onSelect(p);setOpen(false);}}>
              <span style={{fontSize:18,flexShrink:0}}>{p.icon||"⚡"}</span>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:700,fontSize:13,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</div>
                {(p.type||p.price)&&<div style={{fontSize:11,color:"var(--t3)",marginTop:1}}>{[p.type,p.price?`${p.price}`:null].filter(Boolean).join(" · ")}</div>}
              </div>
              <span style={{fontSize:12,color:"var(--blue)",fontWeight:700,flexShrink:0}}>+</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function RepairsPage({t,fmt,repairs,parts,customers,catalog,saveRepairs,saveCustomers,saveParts,saveCatalog,pushNotif,lang,currency,initTab,readOnly,onViewRepair,navSub}){
  // Coming back from a repair's page? Restore the exact tab, filters, search and scroll.
  const [restore]=useState(()=>REPAIRS_VIEW&&REPAIRS_VIEW.pending?REPAIRS_VIEW:null);
  const mountInit=useRef(initTab);
  const [tab,setTab]=useState(restore?restore.tab:(typeof initTab==="string"&&!initTab.startsWith("edit:")?initTab:"active"));
  const [modal,setModal]=useState(null);
  const [search,setSearch]=useState(restore?restore.search:"");
  const [filterS,setFilterS]=useState(restore?restore.filterS:"All");
  const [unpaidOnly,setUnpaidOnly]=useState(restore?!!restore.unpaidOnly:false);
  useEffect(()=>{ saveRepairsView({tab,filterS,search,unpaidOnly}); },[tab,filterS,search,unpaidOnly]);
  useViewScroll("repairs:"+tab);
  useEffect(()=>{
    if(!restore) return;
    const sc=restore.scroll||0;
    const apply=()=>{const m=document.querySelector(".main");if(m) m.scrollTop=sc;};
    const ids=[0,60,200].map(ms=>setTimeout(()=>requestAnimationFrame(apply),ms));
    if(REPAIRS_VIEW) REPAIRS_VIEW.pending=false;
    return()=>ids.forEach(clearTimeout);
  },[]);
  function rememberRepairsView(){
    const m=document.querySelector(".main");
    saveRepairsView({tab,filterS,search,unpaidOnly,scroll:m?m.scrollTop:0,pending:true});
  }
  useEffect(()=>{
    if(!initTab) return;
    // When restoring, the param that got us here is stale — ignore it (but still honour "edit:")
    if(restore&&initTab===mountInit.current&&!(typeof initTab==="string"&&initTab.startsWith("edit:"))) return;
    const tabStr = typeof initTab==='string' ? initTab : null;
    if(!tabStr) return;
    if(tabStr.startsWith("edit:")){
      const id=tabStr.replace("edit:","");
      const found=repairs.find(r=>String(r.id)===id);
      if(found) setModal(found);
    } else {
      setTab(tabStr);setFilterS("All");setUnpaidOnly(tabStr==="unpaid");
    }
  },[initTab]);
  const isHist=tab==="history"||tab==="unpaid";
  const isWait=tab==="waiting";
  const isUnpaid=tab==="unpaid";
  const pool=repairs.filter(r=>isUnpaid?(r.status==="Delivered"||r.status==="Done")&&!r.paid:isHist?HISTORY_S.includes(r.status):isWait?WAITING_S.includes(r.status):ACTIVE_S.includes(r.status));
  const statOpts=isUnpaid?["All","Done","Delivered"]:isHist?["All","Delivered","Cancelled"]:isWait?["All","Awaiting Customer"]:["All","Pending","In Progress","Done"];
  const filtered=pool.filter(r=>{
    const q=search.toLowerCase();
    const matchQ=(!q||r.customerName?.toLowerCase().includes(q)||r.device?.toLowerCase().includes(q)||r.type?.toLowerCase().includes(q)||r.imei?.includes(q));
    const matchS=(filterS==="All"||r.status===filterS);
    const matchPaid=true;
    return matchQ&&matchS&&matchPaid;
  }).sort((a,b)=>new Date(b.createdAt)-new Date(a.createdAt));

  async function changeStatus(repair,newStatus,opts){
    const updated=repairs.map(r=>r.id===repair.id?applyStatusChange(r,newStatus,opts):r);
    saveRepairs(updated);
    toast("✅",t.statusUpdated,`${repair.customerName} → "${newStatus}${opts&&opts.paid?" & Paid":""}"`);
    if(newStatus==="Done"){
      pushNotif(`Repair #${repair.id} for ${repair.customerName} marked Done`);
      const vars={name:repair.customerName,device:repair.device,shop:SDB.get("shop_name")||"RepairOS",id:repair.id,type:repair.type||"",price:repair.price||"",deposit:repair.deposit||"0",phone:repair.phone||"",imei:repair.imei||"",priority:repair.priority||"Normal",warranty:repair.warrantyMonths||"0",technician:repair.techName||""};
      await notifyTechnicians("repair_done",vars);
      const token=SDB.get("tg_token");
      const tgId=repair.telegramId||customers.find(c=>c.name===repair.customerName)?.telegramId;
      if(token&&tgId){
        let msg=SDB.get("msg_done")||"Hi {name}! Your {device} is ready!";
        Object.entries(vars).forEach(([k,v])=>{msg=msg.replaceAll(`{${k}}`,v||"");});
        const ok=await sendTelegram(token,tgId,msg);
        toast(ok?"💬":"⚠️",ok?t.customerNotified:t.telegramFailed,ok?repair.customerName:t.checkToken);
      }
      if(SDB.get("wa_auto")&&repair.phone){
        let msg=SDB.get("msg_done_wa")||SDB.get("msg_done")||"Hi {name}! Your *{device}* is ready!";
        Object.entries(vars).forEach(([k,v])=>{msg=msg.replaceAll(`{${k}}`,v||"");});
        window.open(`https://wa.me/${repair.phone.replace(/\D/g,"")}?text=${encodeURIComponent(msg)}`,"_blank");
      }
    }
    if(newStatus==="Delivered") await notifyTechnicians("repair_delivered",{name:repair.customerName,device:repair.device,id:repair.id,shop:SDB.get("shop_name")||"RepairOS",price:repair.price||"",phone:repair.phone||"",warranty:repair.warrantyMonths||"0"});
  }

  async function saveRepair(data){
    // Ensure customer name always has a value
    if(!data.customerName||!data.customerName.trim()) data={...data,customerName:"No name"};
    if(modal==="add"){
      const chosenDate=data.createdAt?new Date(data.createdAt).toISOString():new Date().toISOString();
      const typeArr=data.types&&data.types.length?data.types:(data.type?[data.type]:[]);
      const nr={...normalizeDateFields(data),customerName:(data.customerName||"").trim()||"No name",types:typeArr,type:typeArr[0]||"",id:SDB.nextId(),createdAt:chosenDate,updatedAt:new Date().toISOString()};
      saveRepairs([nr,...repairs]);
      // If linked to a customer, update their devices list
      if(data.customerId && data.device){
        const cust=customers.find(c=>c.id===data.customerId);
        if(cust){
          const devs=cust.devices||[];
          const already=devs.find(d=>d.model===data.device);
          if(!already){
            const newDevs=[...devs,{id:Date.now().toString(),model:data.device,imei:data.imei||""}];
            saveCustomers(customers.map(c=>c.id===cust.id?{...c,devices:newDevs}:c));
          } else if(data.imei&&!already.imei){
            const newDevs=devs.map(d=>d.model===data.device?{...d,imei:data.imei}:d);
            saveCustomers(customers.map(c=>c.id===cust.id?{...c,devices:newDevs}:c));
          }
        }
      }
      // Don't auto-create customer from typed name
      pushNotif(`New repair: ${data.customerName} — ${data.device}`);
      toast("🔧",t.added,`${data.customerName} ${data.device}`);
      await notifyTechnicians("new_repair",{name:data.customerName,device:data.device,type:getRepairTypesDisplay({types:typeArr}),id:nr.id,shop:SDB.get("shop_name")||"RepairOS",phone:data.phone||"",imei:data.imei||"",priority:data.priority||"Normal",price:data.price||"",deposit:data.deposit||"0",notes:data.notes||""});
    } else {
      const typeArr2=data.types&&data.types.length?data.types:(data.type?[data.type]:[]);
      saveRepairs(repairs.map(r=>{if(r.id!==modal.id)return r;const ec=data.createdAt?new Date(data.createdAt).toISOString():r.createdAt;return{...r,...normalizeDateFields(data),types:typeArr2,type:typeArr2[0]||"",createdAt:ec,updatedAt:new Date().toISOString()};}));
      toast("✏️",t.updated,"Repair saved");
    }
    setModal(null);
  }

  const waitCount=repairs.filter(r=>WAITING_S.includes(r.status)).length;
  const unpaidCount=repairs.filter(r=>(r.status==="Delivered"||r.status==="Done")&&!r.paid).length;
  return(
    <div className="page">
      {readOnly&&<ReadOnlyBanner/>}
      {/* Header */}
      <div className="ph" style={{marginBottom:0,paddingBottom:16}}>
        <div>
          <div className="pt">{t.repairs}</div>
          <div className="ps" style={{display:"flex",gap:10,marginTop:3}}>
            <span style={{color:"var(--blue)",fontWeight:600}}>{repairs.filter(r=>ACTIVE_S.includes(r.status)).length} {t.active}</span>
            <span style={{opacity:.35}}>·</span>
            <span>{repairs.filter(r=>WAITING_S.includes(r.status)).length} waiting</span>
            <span style={{opacity:.35}}>·</span>
            <span>{repairs.filter(r=>HISTORY_S.includes(r.status)).length} done</span>
          </div>
        </div>
        {!readOnly&&(
          <div style={{display:"flex",gap:7,alignItems:"center"}}>
            <QuickRepairButton t={t} onSelect={preset=>{
              const now=new Date();
              const typeArr=preset.type?[preset.type]:[];
              const nr={
                customerName:preset.customerName||"No name",
                phone:"",telegramId:"",device:preset.device||"",imei:"",
                types:typeArr,type:typeArr[0]||"",
                status:"Pending",priority:preset.priority||"Normal",
                price:preset.price||"",deposit:"",
                notes:preset.notes||"",partsUsed:[],
                warrantyMonths:preset.warrantyMonths||"0",
                customerId:null,
                ownerOnly:!!preset.ownerOnly,storeOnly:!!preset.storeOnly,
                createdAt:now.toISOString(),updatedAt:now.toISOString(),
                id:SDB.nextId()
              };
              saveRepairs([nr,...repairs]);
              toast("⚡","Quick add",`${preset.name}${preset.device?" — "+preset.device:""}`);
            }}/>
            <button className="btn bp" style={{gap:7,paddingLeft:14,paddingRight:16,height:38,fontSize:13.5,fontWeight:700,borderRadius:12,boxShadow:"0 4px 18px rgba(10,132,255,0.35)"}} onClick={()=>setModal("add")}>
              <I n="plus" s={14} c="#fff"/>{t.newRepair}
            </button>
          </div>
        )}
      </div>

      {/* Tab bar — underline style, scrollable */}
      <div className="tabs">
        <div className={`tab ${tab==="active"?"on":""}`} onClick={()=>{setTab("active");setFilterS("All");}}>
          ⚡ {t.active}
        </div>
        <div className={`tab ${tab==="waiting"?"on":""}`} onClick={()=>{setTab("waiting");setFilterS("All");}}>
          🕐 Waiting{waitCount>0&&<span className="tab-badge" style={{background:"rgba(191,90,242,0.2)",color:"var(--purple)"}}>{waitCount}</span>}
        </div>
        <div className={`tab ${tab==="history"?"on":""}`} onClick={()=>{setTab("history");setFilterS("All");}}>
          📁 {t.history}
        </div>
        <div className={`tab ${tab==="unpaid"?"on":""}`} onClick={()=>{setTab("unpaid");setFilterS("All");}}>
          💳 Unpaid{unpaidCount>0&&<span className="tab-badge" style={{background:"rgba(255,159,10,0.2)",color:"var(--orange)"}}>{unpaidCount}</span>}
        </div>
      </div>

      {/* Awaiting Customer summary — total amount is the headline, profit secondary */}
      {isWait&&(()=>{
        const wl=repairs.filter(r=>WAITING_S.includes(r.status));
        const wTotal=wl.reduce((s,r)=>s+(parseFloat(r.price)||0),0);
        const wProfit=wl.reduce((s,r)=>s+calcRepairProfit(r),0);
        return(
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))",gap:10,marginBottom:14}}>
            <SC icon="🕐" label="Total Amount" value={fmt(wTotal)} color="var(--purple)" sub={`${wl.length} repair${wl.length!==1?"s":""} waiting`}/>
            <SC icon="📈" label="Profit" value={fmt(wProfit)} color={wProfit>=0?"var(--green)":"var(--red)"} sub="After parts cost"/>
          </div>
        );
      })()}

      {/* Search + filter chips */}
      <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap",alignItems:"center"}}>
        <div className="sbar" style={{flex:"1 1 180px",maxWidth:300}}>
          <I n="search" s={13} c="var(--t3)"/>
          <input placeholder={`${t.search}…`} value={search} onChange={e=>setSearch(e.target.value)}/>
          {search&&<span style={{cursor:"pointer",color:"var(--t3)",fontSize:15,lineHeight:1}} onClick={()=>setSearch("")}>×</span>}
        </div>
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {statOpts.map(s=>(
            <span key={s} className={`chip ${filterS===s?"on":""}`} onClick={()=>setFilterS(s)}
              style={filterS===s?{fontWeight:700}:{}}>
              {s}
            </span>
          ))}
        </div>
      </div>

      {/* Count indicator */}
      {filtered.length>0&&(
        <div style={{fontSize:11.5,color:"var(--t3)",marginBottom:10,fontWeight:500}}>
          {filtered.length} repair{filtered.length!==1?"s":""}
          {search&&<span> matching <strong style={{color:"var(--tx)"}}>{search}</strong></span>}
        </div>
      )}

      {filtered.length===0
        ? <div className="empty" style={{padding:"60px 20px"}}>
            <div className="ei" style={{fontSize:52,marginBottom:14}}>{isUnpaid?"💳":isHist?"📁":isWait?"🕐":"🔧"}</div>
            <div className="et" style={{fontSize:16,fontWeight:700,marginBottom:6}}>
              {isUnpaid?"All settled up ✅":isHist?t.noHistory:isWait?"Nothing waiting":"No repairs yet"}
            </div>
            <div className="es" style={{fontSize:13,color:"var(--t3)"}}>
              {isUnpaid?"No unpaid repairs found":isHist?"Completed repairs will appear here":isWait?"Customers are up to date":!readOnly?"Tap + New Repair to get started":""}
            </div>
          </div>
        : <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {filtered.map(r=>(
              <RepairRow key={r.id} repair={r} onStatus={changeStatus}
                onView={r=>{rememberRepairsView();onViewRepair&&onViewRepair(r.id);}}
                onEdit={()=>setModal(r)}
                onDel={()=>{saveRepairs(repairs.filter(x=>x.id!==r.id));toast("🗑️",t.deleted,"");}}
                fmt={fmt}
                onPaid={(id,paid)=>{saveRepairs(repairs.map(x=>x.id===id?{...x,...paidDatePatch(x,paid)}:x));toast(paid?"✅":"💳",paid?"Marked paid":"Marked unpaid","");}}
              />
            ))}
          </div>
      }
      {modal&&<RepairModal saveParts={saveParts} saveCatalog={saveCatalog} repair={modal==="add"?null:modal} parts={parts} customers={customers} catalog={catalog} onClose={()=>setModal(null)} onSave={saveRepair} onNewDevice={devName=>{const newDev={name:devName,id:Date.now().toString(),parts:[]};saveCatalog([...(catalog||[]),newDev]);toast("📋",t.newDeviceAdded,devName);}} onNewCustomer={newC=>{saveCustomers([...customers,newC]);}} t={t} fmt={fmt}/> }
    </div>
  );
}

// Call / WhatsApp / Telegram buttons — shared by the customer page and repair pages.
// Renders just the buttons; put it inside a flex row.
function ContactActions({phone}){
  if(!phone) return null;
  const num=contactNumber(phone);
  const base={textDecoration:"none",display:"flex",alignItems:"center",gap:5,fontSize:11.5,fontWeight:600};
  return(
    <>
      <a href={`tel:${phone}`} className="btn bg2 bsm" style={base}>📞 Call</a>
      <a href={`https://wa.me/${num}`} target="_blank" rel="noopener noreferrer" className="btn bsm"
        style={{...base,background:"rgba(37,211,102,0.14)",border:"1px solid rgba(37,211,102,0.28)",color:"#25D366"}}>
        <WaIcon s={13}/> WhatsApp
      </a>
      <a href={`https://t.me/+${num}`} target="_blank" rel="noopener noreferrer" className="btn bsm"
        style={{...base,background:"rgba(0,136,204,0.14)",border:"1px solid rgba(0,136,204,0.28)",color:"#29B6F6"}}>
        <TgIcon s={13}/> Telegram
      </a>
    </>
  );
}
// Date rows for the repair info cards. Only dates that were actually recorded
// are shown, so older repairs (received date only) look exactly as before.
function repairDateRows(r){
  const f=d=>new Date(d).toLocaleString();
  const rows=[{icon:"📥",label:"Received",value:f(r.createdAt)}];
  if(r.doneAt) rows.push({icon:"✅",label:"Fixed (Done)",value:f(r.doneAt)});
  if(r.deliveredAt) rows.push({icon:"📦",label:"Delivered",value:f(r.deliveredAt)});
  if(r.paid&&r.paidAt) rows.push({icon:"💵",label:"Paid on",value:f(r.paidAt)});
  const w=daysWaitingPickup(r);
  if(w!==null) rows.push({icon:"⏱",label:"Waiting pickup",value:w===0?"Ready today":`${w} day${w!==1?"s":""} since fixed`,color:w>=7?"var(--red)":"var(--orange)"});
  if(r.doneAt&&r.deliveredAt){const d=daysBetween(r.doneAt,r.deliveredAt);rows.push({icon:"⏳",label:"Sat fixed for",value:`${d} day${d!==1?"s":""} before pickup`});}
  return rows;
}

// ─── Repair Detail Overlay ────────────────────────────────────────────────────
// Shown as modal overlay from repairDetail page and customer history
function RepairDetailOverlay({repair:r,onClose,onEdit,onStatus,onPaid,onDel,fmt,t,customers,readOnly,allowEdit}){
  const s=STATUS_CFG[r.status]||STATUS_CFG["Pending"];
  const profit=calcRepairProfit(r);
  const isLoss=(r.status==="Done"||r.status==="Delivered")&&profit<0;
  const wDays=r.warrantyUntil?Math.ceil((new Date(r.warrantyUntil)-new Date())/864e5):null;
  const wActive=wDays!==null&&wDays>=0;
  const depositNum=parseFloat(r.deposit)||0;
  const priceNum=parseFloat(r.price)||0;
  const allTypes=r.types&&r.types.length?r.types:(r.type?[r.type]:[]);
  const [confirmDel,setConfirmDel]=useState(false);
  const [ddOpen,setDdOpen]=useState(false);

  return(
    <div className="mo" onClick={onClose} style={{zIndex:200}}>
      <div className="md" style={{maxWidth:520,maxHeight:"90dvh",overflowY:"auto",padding:0,display:"flex",flexDirection:"column"}} onClick={e=>e.stopPropagation()}>
        {/* Header banner */}
        <div style={{position:"relative",padding:"22px 20px 18px",background:`linear-gradient(135deg,${s.color}22,${s.color}08)`,borderBottom:"1px solid var(--glb)",flexShrink:0,borderRadius:"var(--r) var(--r) 0 0",overflow:"hidden"}}>
          <div style={{position:"absolute",left:0,top:0,bottom:0,width:5,background:isLoss?"var(--red)":s.color}}/>
          <div style={{display:"flex",alignItems:"flex-start",gap:12}}>
            <div style={{width:52,height:52,borderRadius:15,background:isLoss?"rgba(255,69,58,0.15)":s.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,flexShrink:0}}>{isLoss?"📉":s.icon}</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:3,flexWrap:"wrap"}}>
                <span style={{fontWeight:800,fontSize:18,lineHeight:1.2}}>{r.customerName}</span>
                <span style={{fontSize:12,color:"var(--t3)",fontWeight:400}}>#{r.id}</span>
                {r.priority==="High"&&<span style={{fontSize:10,fontWeight:800,padding:"2px 7px",borderRadius:10,background:"rgba(255,69,58,0.14)",color:"var(--red)"}}>🔥 High</span>}
                {r.priority==="Urgent"&&<span style={{fontSize:10,fontWeight:800,padding:"2px 7px",borderRadius:10,background:"rgba(191,90,242,0.14)",color:"var(--purple)"}}>⚡ Urgent</span>}
              </div>
              <div style={{fontSize:13,color:"var(--t2)",fontWeight:500}}>{r.device}</div>
              {allTypes.length>0&&<div style={{fontSize:12,color:"var(--t3)",marginTop:2}}>{allTypes.map(tp=>getTypeIcon(tp)+" "+tp).join(" · ")}</div>}
            </div>
            <button style={{background:"none",border:"none",color:"var(--t3)",cursor:"pointer",fontSize:20,padding:4,lineHeight:1,flexShrink:0}} onClick={onClose}>×</button>
          </div>
        </div>

        {/* Body */}
        <div style={{padding:"18px 20px",display:"flex",flexDirection:"column",gap:14,overflowY:"auto",flex:1}}>
          {/* Status + pay */}
          <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
            <div style={{position:"relative"}}>
              <button className="rpill" style={{background:s.bg,color:s.color,border:`1px solid ${s.color}44`,fontSize:13,padding:"5px 13px"}} onClick={()=>setDdOpen(v=>!v)}>
                {s.icon} {r.status} <span style={{opacity:.6,fontSize:10}}>▾</span>
              </button>
              {ddOpen&&!readOnly&&(
                <div style={{position:"absolute",top:"calc(100% + 6px)",left:0,background:"var(--bg2)",border:"1px solid var(--glb)",borderRadius:13,overflow:"hidden",zIndex:10,minWidth:170,boxShadow:"0 16px 40px rgba(0,0,0,0.7)",animation:"fadeInScale .15s ease"}}>
                  {Object.entries(STATUS_CFG).map(([st,sc])=>(
                    <div key={st} className={`rdd-item${r.status===st?" active":""}`} style={{color:sc.color}}
                      onClick={()=>{onStatus(r,st);setDdOpen(false);}}>
                      <span>{sc.icon}</span><span style={{flex:1}}>{st}</span>{r.status===st&&<span style={{opacity:.5}}>✓</span>}
                    </div>
                  ))}
                  <div className="rdd-item" style={{color:"var(--green)",borderTop:"1px solid var(--glb)"}}
                    onClick={()=>{onStatus(r,"Delivered",{paid:true});setDdOpen(false);}}>
                    <span>💵</span><span style={{flex:1}}>Delivered &amp; Paid</span>{r.status==="Delivered"&&r.paid&&<span style={{opacity:.5}}>✓</span>}
                  </div>
                </div>
              )}
            </div>
            {(r.status==="Done"||r.status==="Delivered")&&!readOnly&&(
              <button className="btn bsm" style={{background:r.paid?"rgba(48,209,88,0.15)":"rgba(255,159,10,0.15)",color:r.paid?"var(--green)":"var(--orange)",border:`1px solid ${r.paid?"rgba(48,209,88,0.3)":"rgba(255,159,10,0.3)"}`,fontWeight:700}}
                onClick={()=>onPaid(r.id,!r.paid)}>
                {r.paid?"✅ Paid":"💳 Mark Paid"}
              </button>
            )}
            {r.ownerOnly&&<span style={{fontSize:11,fontWeight:700,padding:"3px 9px",borderRadius:10,background:"rgba(191,90,242,0.12)",color:"var(--purple)",border:"1px solid rgba(191,90,242,0.2)"}}>👤 Mine</span>}
          </div>

          {/* Finance row */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
            {[
              {label:"Price",value:fmt(priceNum),color:isLoss?"var(--red)":"var(--tx)"},
              {label:"Deposit",value:depositNum>0?fmt(depositNum):"—",color:"var(--orange)"},
              {label:isLoss?"Loss":"Profit",value:fmt(Math.abs(profit)),color:isLoss?"var(--red)":"var(--green)"},
            ].map(cell=>(
              <div key={cell.label} style={{background:"rgba(255,255,255,0.04)",border:"1px solid var(--glb)",borderRadius:11,padding:"10px 12px",textAlign:"center"}}>
                <div style={{fontSize:10,color:"var(--t3)",fontWeight:600,marginBottom:3,textTransform:"uppercase",letterSpacing:".04em"}}>{cell.label}</div>
                <div style={{fontWeight:800,fontSize:16,color:cell.color}}>{cell.value}</div>
              </div>
            ))}
          </div>

          {/* Contact — call / WhatsApp / Telegram when a phone number exists */}
          {r.phone&&(
            <div style={{display:"flex",gap:7,flexWrap:"wrap"}}>
              <ContactActions phone={r.phone}/>
            </div>
          )}

          {/* Details grid */}
          <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:13,overflow:"hidden"}}>
            {[
              r.phone&&{icon:"📱",label:"Phone",value:r.phone},
              r.imei&&{icon:"🔢",label:"IMEI",value:r.imei,mono:true},
              r.techName&&{icon:"👷",label:"Technician",value:r.techName},
              ...repairDateRows(r),
              r.warrantyUntil&&{icon:wActive?"🛡️":"⚠️",label:"Warranty",value:wActive?`${wDays} days left (${new Date(r.warrantyUntil).toLocaleDateString()})`:`Expired (${new Date(r.warrantyUntil).toLocaleDateString()})`,color:wActive?"var(--green)":"var(--red)"},
            ].filter(Boolean).map((row,i,arr)=>(
              <div key={row.label} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",borderBottom:i<arr.length-1?"1px solid rgba(255,255,255,0.05)":"none"}}>
                <span style={{fontSize:16,flexShrink:0}}>{row.icon}</span>
                <span style={{fontSize:11.5,color:"var(--t3)",fontWeight:600,minWidth:80,flexShrink:0}}>{row.label}</span>
                <span style={{fontSize:12.5,fontFamily:row.mono?"monospace":"inherit",color:row.color||"var(--tx)",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{row.value}</span>
              </div>
            ))}
          </div>

          {/* Parts used */}
          {r.partsUsed?.length>0&&(
            <div>
              <div style={{fontSize:11,fontWeight:700,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".06em",marginBottom:7}}>🔩 Parts Used</div>
              <div style={{display:"flex",flexDirection:"column",gap:4}}>
                {r.partsUsed.map((p,i)=>(
                  <div key={i} style={{display:"flex",alignItems:"center",padding:"8px 12px",background:"rgba(90,200,250,0.06)",border:"1px solid rgba(90,200,250,0.15)",borderRadius:9}}>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:12.5,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</div>
                      <div style={{fontSize:10.5,color:"var(--t3)",marginTop:1}}>Cost {fmt(p.cost||0)} · Sale {fmt(p.price||0)} × {p.qty||1}</div>
                    </div>
                    <div style={{fontWeight:700,fontSize:13,color:"var(--green)",marginLeft:10,flexShrink:0}}>{fmt((p.price||0)*(p.qty||1))}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Notes */}
          {r.notes&&(
            <div>
              <div style={{fontSize:11,fontWeight:700,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".06em",marginBottom:7}}>📝 Notes</div>
              <div style={{fontSize:13,lineHeight:1.6,color:"var(--t2)",padding:"12px 14px",background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:11,whiteSpace:"pre-wrap"}}>{r.notes}</div>
            </div>
          )}
        </div>

        {/* Footer actions */}
        {!readOnly&&(
          <div style={{padding:"14px 20px",borderTop:"1px solid var(--glb)",display:"flex",gap:8,flexShrink:0,background:"var(--bg)"}}>
            <button className="btn bg2" style={{flex:1,justifyContent:"center",gap:6}} onClick={onClose}>← Back</button>
            <button className="btn bg2 bsm" style={{flexShrink:0}} title="Print receipt" onClick={()=>printReceipt(r,fmt)}>🖨️</button>
            <button className="btn bp" style={{flex:2,justifyContent:"center",gap:6,fontWeight:700}} onClick={()=>onEdit(r)}>
              <I n="edit" s={13} c="#fff"/> Edit Repair
            </button>
            {!confirmDel
              ? <button className="btn bd bsm" style={{flexShrink:0}} onClick={()=>setConfirmDel(true)}><I n="trash" s={13}/></button>
              : <button className="btn bd bsm" style={{flexShrink:0,fontWeight:700,fontSize:11}} onClick={()=>{onDel(r);setConfirmDel(false);}}>Confirm?</button>
            }
          </div>
        )}
        {readOnly&&(
          <div style={{padding:"14px 20px",borderTop:"1px solid var(--glb)",display:"flex",gap:8,flexShrink:0,background:"var(--bg)"}}>
            <button className="btn bg2" style={{flex:1,justifyContent:"center"}} onClick={onClose}>← Back</button>
            <button className="btn bg2 bsm" style={{flexShrink:0}} title="Print receipt" onClick={()=>printReceipt(r,fmt)}>🖨️ Print</button>
            {allowEdit&&onEdit&&(
              <button className="btn bp" style={{flex:1,justifyContent:"center",gap:6,fontWeight:700}} onClick={()=>onEdit(r)}>
                <I n="edit" s={13} c="#fff"/> Edit
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Repair Detail Page Wrapper (avoids IIFE in JSX) ────────────────────────
function RepairDetailPageWrapper({repairs,param,nav,saveRepairs,fmt,t,customers,readOnly,pushNotif}){
  const r=repairs.find(x=>String(x.id)===String(param));
  if(!r) return null;
  function onStatus(rep,st,opts){saveRepairs(repairs.map(x=>x.id===rep.id?applyStatusChange(x,st,opts):x));toast("✅","Status updated",st+(opts&&opts.paid?" & Paid":""));}
  function onPaid(id,paid){saveRepairs(repairs.map(x=>x.id===id?{...x,...paidDatePatch(x,paid)}:x));toast(paid?"✅":"💳",paid?"Marked paid":"Marked unpaid","");}
  function onDel(rep){saveRepairs(repairs.filter(x=>x.id!==rep.id));toast("🗑️","Deleted","");nav("repairs");}
  return <RepairDetailPage repair={r} onBack={()=>{ if(NAV_COUNT>0) window.history.back(); else nav("repairs"); }} onEdit={rep=>nav("repairs","edit:"+rep.id)} onStatus={onStatus} onPaid={onPaid} onDel={onDel} fmt={fmt} t={t} customers={customers} readOnly={readOnly}/>;
}

// ─── Repair Detail — full app page ───────────────────────────────────────────
function RepairDetailPage({repair:r,onBack,onEdit,onStatus,onPaid,onDel,fmt,t,customers,readOnly}){
  const [confirmDel,setConfirmDel]=useState(false);
  const [ddOpen,setDdOpen]=useState(false);
  if(!r) return null;
  const s=STATUS_CFG[r.status]||STATUS_CFG["Pending"];
  const profit=calcRepairProfit(r);
  const isLoss=(r.status==="Done"||r.status==="Delivered")&&profit<0;
  const wDays=r.warrantyUntil?Math.ceil((new Date(r.warrantyUntil)-new Date())/864e5):null;
  const wActive=wDays!==null&&wDays>=0;
  const depositNum=parseFloat(r.deposit)||0;
  const priceNum=parseFloat(r.price)||0;
  const allTypes=r.types&&r.types.length?r.types:(r.type?[r.type]:[]);

  return(
    <div className="page">
      {/* Page header */}
      <div className="ph" style={{marginBottom:0,paddingBottom:16}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <button className="btn bg2 bsm" style={{gap:5,paddingLeft:10}} onClick={onBack}><I n="back" s={13}/> Back</button>
          <div>
            <div className="pt" style={{fontSize:16}}>{r.customerName}</div>
            <div className="ps">{r.device} · #{r.id}</div>
          </div>
        </div>
        <div style={{display:"flex",gap:7}}>
          <button className="btn bg2 bsm" title="Print receipt" onClick={()=>printReceipt(r,fmt)}>🖨️</button>
          {!readOnly&&(
            <button className="btn bp" style={{gap:7,fontWeight:700}} onClick={()=>onEdit(r)}>
              <I n="edit" s={13} c="#fff"/> Edit
            </button>
          )}
        </div>
      </div>

      {/* Hero banner */}
      <div style={{position:"relative",padding:"20px 18px 18px",background:`linear-gradient(160deg,${s.color}18 0%,transparent 65%)`,border:"1px solid var(--glb)",borderRadius:18,marginBottom:16,overflow:"hidden"}}>
        <div style={{position:"absolute",left:0,top:0,bottom:0,width:5,background:isLoss?"var(--red)":s.color,borderRadius:"18px 0 0 18px"}}/>
        <div style={{display:"flex",alignItems:"flex-start",gap:14}}>
          <div style={{width:58,height:58,borderRadius:17,background:isLoss?"rgba(255,69,58,0.15)":s.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:27,flexShrink:0,boxShadow:`0 4px 20px ${s.color}33`}}>{isLoss?"📉":s.icon}</div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",marginBottom:4}}>
              <span style={{fontWeight:800,fontSize:20,lineHeight:1.15}}>{r.customerName}</span>
              <span style={{fontSize:12,color:"var(--t3)"}}>#{r.id}</span>
              {r.priority==="High"&&<span style={{fontSize:10,fontWeight:800,padding:"2px 8px",borderRadius:10,background:"rgba(255,69,58,0.14)",color:"var(--red)"}}>🔥 High</span>}
              {r.priority==="Urgent"&&<span style={{fontSize:10,fontWeight:800,padding:"2px 8px",borderRadius:10,background:"rgba(191,90,242,0.14)",color:"var(--purple)"}}>⚡ Urgent</span>}
            </div>
            <div style={{fontSize:14,fontWeight:600,color:"var(--t2)",marginBottom:6}}>{r.device}</div>
            {allTypes.length>0&&(
              <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                {allTypes.map((tp,i)=>(
                  <span key={i} style={{display:"inline-flex",alignItems:"center",gap:4,fontSize:11.5,padding:"3px 9px",borderRadius:20,background:"rgba(255,255,255,0.07)",border:"1px solid rgba(255,255,255,0.1)",color:"var(--t2)"}}>
                    {getTypeIcon(tp)} {tp}
                  </span>
                ))}
              </div>
            )}
          </div>
          <div style={{textAlign:"right",flexShrink:0}}>
            <div style={{fontWeight:900,fontSize:24,color:isLoss?"var(--red)":"var(--tx)",lineHeight:1}}>{fmt(priceNum)}</div>
            {depositNum>0&&<div style={{fontSize:11,color:"var(--orange)",marginTop:3,fontWeight:600}}>+{fmt(depositNum)} dep</div>}
          </div>
        </div>
      </div>

      {/* Status row */}
      <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap",marginBottom:16}}>
        <div style={{position:"relative"}}>
          <button className="rpill" style={{background:s.bg,color:s.color,border:`1px solid ${s.color}44`,fontSize:13,padding:"6px 14px",fontWeight:700}} onClick={()=>setDdOpen(v=>!v)}>
            {s.icon} {r.status} <span style={{opacity:.6,fontSize:10,marginLeft:2}}>▾</span>
          </button>
          {ddOpen&&!readOnly&&(
            <div style={{position:"absolute",top:"calc(100% + 6px)",left:0,background:"var(--bg2)",border:"1px solid var(--glb)",borderRadius:13,overflow:"hidden",zIndex:20,minWidth:180,boxShadow:"0 16px 40px rgba(0,0,0,0.7)",animation:"fadeInScale .15s ease"}}>
              {Object.entries(STATUS_CFG).map(([st,sc])=>(
                <div key={st} className={`rdd-item${r.status===st?" active":""}`} style={{color:sc.color}}
                  onClick={()=>{onStatus(r,st);setDdOpen(false);}}>
                  <span style={{fontSize:15}}>{sc.icon}</span><span style={{flex:1}}>{st}</span>{r.status===st&&<span style={{opacity:.5}}>✓</span>}
                </div>
              ))}
              <div className="rdd-item" style={{color:"var(--green)",borderTop:"1px solid var(--glb)"}}
                onClick={()=>{onStatus(r,"Delivered",{paid:true});setDdOpen(false);}}>
                <span style={{fontSize:15}}>💵</span><span style={{flex:1}}>Delivered &amp; Paid</span>{r.status==="Delivered"&&r.paid&&<span style={{opacity:.5}}>✓</span>}
              </div>
            </div>
          )}
        </div>
        {(r.status==="Done"||r.status==="Delivered")&&!readOnly&&(
          <button className="btn bsm" style={{background:r.paid?"rgba(48,209,88,0.15)":"rgba(255,159,10,0.15)",color:r.paid?"var(--green)":"var(--orange)",border:`1px solid ${r.paid?"rgba(48,209,88,0.3)":"rgba(255,159,10,0.3)"}`,fontWeight:700}}
            onClick={()=>onPaid(r.id,!r.paid)}>
            {r.paid?"✅ Paid":"💳 Mark Paid"}
          </button>
        )}
        {r.ownerOnly&&<span style={{fontSize:11,fontWeight:700,padding:"3px 10px",borderRadius:10,background:"rgba(191,90,242,0.12)",color:"var(--purple)",border:"1px solid rgba(191,90,242,0.2)"}}>👤 Mine</span>}
        {r.status==="Awaiting Customer"&&<span style={{fontSize:11,fontWeight:700,padding:"3px 10px",borderRadius:10,background:"rgba(191,90,242,0.1)",color:"var(--purple)",border:"1px solid rgba(191,90,242,0.18)"}}>🕐 Awaiting</span>}
      </div>

      {/* Finance grid */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:16}}>
        {[
          {label:"Total Price",value:fmt(priceNum),color:isLoss?"var(--red)":"var(--tx)",icon:"💰"},
          {label:"Deposit",value:depositNum>0?fmt(depositNum):"—",color:depositNum>0?"var(--orange)":"var(--t3)",icon:"💳"},
          {label:isLoss?"Loss":"Profit",value:fmt(Math.abs(profit)),color:isLoss?"var(--red)":"var(--green)",icon:isLoss?"📉":"📈"},
        ].map(cell=>(
          <div key={cell.label} style={{background:"rgba(255,255,255,0.04)",border:"1px solid var(--glb)",borderRadius:14,padding:"13px 10px",textAlign:"center"}}>
            <div style={{fontSize:17,marginBottom:4}}>{cell.icon}</div>
            <div style={{fontWeight:800,fontSize:17,color:cell.color,marginBottom:2}}>{cell.value}</div>
            <div style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".04em"}}>{cell.label}</div>
          </div>
        ))}
      </div>

      {/* Contact — call / WhatsApp / Telegram when a phone number exists */}
      {r.phone&&(
        <div style={{display:"flex",gap:7,flexWrap:"wrap",marginBottom:16}}>
          <ContactActions phone={r.phone}/>
        </div>
      )}

      {/* Info rows */}
      <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:16,overflow:"hidden",marginBottom:16}}>
        <div style={{padding:"10px 16px",borderBottom:"1px solid rgba(255,255,255,0.06)",fontSize:11,fontWeight:700,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".06em"}}>Details</div>
        {[
          r.phone&&{icon:"📱",label:"Phone",value:r.phone},
          r.imei&&{icon:"🔢",label:"IMEI",value:r.imei,mono:true},
          r.techName&&{icon:"👷",label:"Technician",value:r.techName},
          ...repairDateRows(r),
          r.updatedAt&&r.updatedAt!==r.createdAt&&{icon:"✏️",label:"Updated",value:new Date(r.updatedAt).toLocaleString()},
          r.warrantyUntil&&{icon:wActive?"🛡️":"⚠️",label:"Warranty",value:wActive?`${wDays} days remaining (until ${new Date(r.warrantyUntil).toLocaleDateString()})`:`Expired (${new Date(r.warrantyUntil).toLocaleDateString()})`,color:wActive?"var(--green)":"var(--red)"},
        ].filter(Boolean).map((row,i,arr)=>(
          <div key={row.label} style={{display:"flex",alignItems:"center",gap:12,padding:"11px 16px",borderBottom:i<arr.length-1?"1px solid rgba(255,255,255,0.05)":"none"}}>
            <span style={{fontSize:17,flexShrink:0,width:24,textAlign:"center"}}>{row.icon}</span>
            <span style={{fontSize:12,color:"var(--t3)",fontWeight:600,minWidth:88,flexShrink:0}}>{row.label}</span>
            <span style={{fontSize:13,fontFamily:row.mono?"monospace":"inherit",color:row.color||"var(--tx)",flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{row.value}</span>
          </div>
        ))}
      </div>

      {/* Parts */}
      {r.partsUsed?.length>0&&(
        <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:16,overflow:"hidden",marginBottom:16}}>
          <div style={{padding:"10px 16px",borderBottom:"1px solid rgba(255,255,255,0.06)",fontSize:11,fontWeight:700,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".06em"}}>🔩 Parts Used ({r.partsUsed.length})</div>
          {r.partsUsed.map((p,i)=>(
            <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"11px 16px",borderBottom:i<r.partsUsed.length-1?"1px solid rgba(255,255,255,0.05)":"none"}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:13,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</div>
                <div style={{fontSize:11,color:"var(--t3)",marginTop:2}}>Cost {fmt(p.cost||0)} · Sale {fmt(p.price||0)} × {p.qty||1}</div>
              </div>
              <div style={{textAlign:"right",flexShrink:0}}>
                <div style={{fontWeight:700,fontSize:14,color:"var(--green)"}}>{fmt((p.price||0)*(p.qty||1))}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Notes */}
      {r.notes&&(
        <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:16,overflow:"hidden",marginBottom:16}}>
          <div style={{padding:"10px 16px",borderBottom:"1px solid rgba(255,255,255,0.06)",fontSize:11,fontWeight:700,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".06em"}}>📝 Notes</div>
          <div style={{padding:"14px 16px",fontSize:13.5,lineHeight:1.7,color:"var(--t2)",whiteSpace:"pre-wrap"}}>{r.notes}</div>
        </div>
      )}

      {/* Action row */}
      {!readOnly&&(
        <div style={{display:"flex",gap:8,marginTop:4}}>
          <button className="btn bp" style={{flex:1,justifyContent:"center",gap:6,fontWeight:700,fontSize:14}} onClick={()=>onEdit(r)}>
            <I n="edit" s={13} c="#fff"/> Edit Repair
          </button>
          {!confirmDel
            ? <button className="btn bd" style={{padding:"10px 14px"}} onClick={()=>setConfirmDel(true)}><I n="trash" s={13}/></button>
            : <button className="btn bd" style={{padding:"10px 14px",fontWeight:700,fontSize:12}} onClick={()=>{onDel(r);setConfirmDel(false);}}>Delete?</button>
          }
        </div>
      )}
    </div>
  );
}

// ─── Type icon with CSS tooltip ─────────────────────────────────────────────
function ImeiIconTip({imei}){
  return(
    <span className="type-icon-btn imei-icon-btn" onClick={e=>e.stopPropagation()} style={{fontFamily:"monospace",fontSize:11,letterSpacing:"-.04em"}}>
      #
      <span className="type-tooltip">
        <span className="type-tooltip-name" style={{fontFamily:"monospace",letterSpacing:".04em"}}>📋 {imei}</span>
      </span>
    </span>
  );
}
function TypeIconTip({type}){
  const icon=getTypeIcon(type);
  return(
    <span className="type-icon-btn" onClick={e=>e.stopPropagation()}>
      {icon}
      <span className="type-tooltip">
        <span className="type-tooltip-name">{icon} {type}</span>
      </span>
    </span>
  );
}

function RepairRow({repair:r,onStatus,onEdit,onDel,fmt,onPaid,onView}){
  const s=STATUS_CFG[r.status]||STATUS_CFG["Pending"];
  const [dd,setDd]=useState(false);
  const [ddCoords,setDdCoords]=useState({top:0,right:0});
  const ddRef=useRef();
  const pillRef=useRef();
  const profit=calcRepairProfit(r);
  const isLoss=(r.status==="Done"||r.status==="Delivered")&&profit<0;
  const wDays=r.warrantyUntil?Math.ceil((new Date(r.warrantyUntil)-new Date())/864e5):null;
  const wActive=wDays!==null&&wDays>=0;
  const pickupDays=daysWaitingPickup(r); // null for older repairs with no done date
  const depositNum=parseFloat(r.deposit)||0;
  const priceNum=parseFloat(r.price)||0;
  const remaining=priceNum-depositNum;
  const allTypes=r.types&&r.types.length?r.types:(r.type?[r.type]:[]);
  const dateStr=new Date(r.createdAt).toLocaleDateString(undefined,{month:"short",day:"numeric"});
  const timeStr=new Date(r.createdAt).toLocaleTimeString(undefined,{hour:"2-digit",minute:"2-digit"});

  // Close status dropdown on outside click
  useEffect(()=>{
    if(!dd)return;
    function h(e){
      const inDd=ddRef.current&&ddRef.current.contains(e.target);
      const inPill=pillRef.current&&pillRef.current.contains(e.target);
      if(!inDd&&!inPill)setDd(false);
    }
    document.addEventListener("mousedown",h);
    return()=>document.removeEventListener("mousedown",h);
  },[dd]);

  return(
    <div style={{position:"relative"}}>
    <div className="rrow" onClick={()=>onView?onView(r):onEdit()}>
      {/* Left accent bar — clipped by rrow overflow:hidden */}
      <div className="rrow-accent" style={{background:isLoss?"var(--red)":s.color}}/>

      {/* Card body */}
      <div className="rrow-body">
        {/* Icon */}
        <div className="rav" style={{background:isLoss?"rgba(255,69,58,0.13)":s.bg}}>
          {isLoss?"📉":s.icon}
        </div>

        {/* Main content */}
        <div className="rrow-content">
          {/* Row 1: Name + Price */}
          <div className="rrow-top">
            <div style={{minWidth:0,flex:1}}>
              <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
                <span className="rrow-name">{r.customerName}</span>
                <span className="repair-id" style={{fontSize:11,color:"var(--t3)",fontWeight:400,flexShrink:0}}>#{r.id}</span>
                {r.priority==="High"&&<span className="pri-badge" style={{background:"rgba(255,69,58,0.14)",color:"var(--red)"}}>🔥 High</span>}
                {r.priority==="Urgent"&&<span className="pri-badge" style={{background:"rgba(191,90,242,0.14)",color:"var(--purple)"}}>⚡ Urgent</span>}
              </div>
              {/* Row 2: Device + types */}
              <div style={{display:"flex",alignItems:"center",gap:5,marginTop:3,flexWrap:"wrap"}}>
                <span className="rrow-device">{r.device}</span>
                {allTypes.length>0&&<><span style={{opacity:.3,fontSize:11}}>·</span><span style={{display:"inline-flex",gap:3,alignItems:"center",flexShrink:0}}>{allTypes.map((tp,i)=><TypeIconTip key={i} type={tp}/>)}</span></>}
                {r.imei&&<><span style={{opacity:.3,fontSize:11}}>·</span><ImeiIconTip imei={r.imei}/></>}
              </div>
            </div>
            {/* Price block */}
            <div style={{textAlign:"right",flexShrink:0}}>
              <div className="rrow-price" style={{color:isLoss?"var(--red)":priceNum>0?"var(--tx)":"var(--t3)"}}>{fmt(priceNum)}</div>
              {depositNum>0&&<div style={{fontSize:10,color:"var(--orange)",marginTop:2,fontWeight:600}}>+{fmt(depositNum)} dep</div>}
            </div>
          </div>

          {/* Badges row */}
          {(r.ownerOnly||r.storeOnly||wDays!==null||isLoss||pickupDays!==null||(r.partsUsed?.length>0)||(r.status==="Awaiting Customer"))&&(
            <div className="rrow-badges" style={{marginTop:7}}>
              {r.ownerOnly&&<span className="ibadge" style={{background:"rgba(191,90,242,0.12)",color:"var(--purple)",border:"1px solid rgba(191,90,242,0.2)"}}>👤 Mine</span>}
              {r.storeOnly&&<span className="ibadge" style={{background:"rgba(48,209,88,0.12)",color:"var(--green)",border:"1px solid rgba(48,209,88,0.2)"}}>🏪 Store</span>}
              {pickupDays!==null&&<span className="ibadge" title="Days since this was marked Done and not yet collected" style={{background:pickupDays>=7?"rgba(255,69,58,0.12)":"rgba(255,159,10,0.12)",color:pickupDays>=7?"var(--red)":"var(--orange)",border:`1px solid ${pickupDays>=7?"rgba(255,69,58,0.22)":"rgba(255,159,10,0.22)"}`}}>⏱ {pickupDays===0?"Ready today":`Ready ${pickupDays}d`}</span>}
              {r.status==="Awaiting Customer"&&<span className="ibadge" style={{background:"rgba(191,90,242,0.1)",color:"var(--purple)",border:"1px solid rgba(191,90,242,0.18)"}}>🕐 Awaiting</span>}
              {wActive&&<span className="ibadge" style={{background:"rgba(48,209,88,0.1)",color:"var(--green)",border:"1px solid rgba(48,209,88,0.2)"}}>🛡️ Warranty {wDays}d</span>}
              {wDays!==null&&!wActive&&<span className="ibadge" style={{background:"rgba(255,69,58,0.1)",color:"var(--red)",border:"1px solid rgba(255,69,58,0.2)"}}>⚠️ Expired</span>}
              {isLoss&&<span className="ibadge" style={{background:"rgba(255,69,58,0.12)",color:"var(--red)",border:"1px solid rgba(255,69,58,0.22)"}}>📉 Loss {fmt(Math.abs(profit))}</span>}
              {(r.partsUsed?.length>0)&&<span className="ibadge" style={{background:"rgba(90,200,250,0.08)",color:"var(--teal)",border:"1px solid rgba(90,200,250,0.18)"}}>🔩 {r.partsUsed.length} part{r.partsUsed.length!==1?"s":""}</span>}
            </div>
          )}
        </div>
      </div>

      {/* Footer strip */}
      <div className="rrow-footer" onClick={e=>e.stopPropagation()}>
        {/* Date/time */}
        <div className="rrow-date">{dateStr} · {timeStr}</div>

        {/* Actions */}
        <div className="rrow-actions">
          {/* Pay button */}
          {(r.status==="Delivered"||r.status==="Done")&&onPaid&&(
            <button className={`ract-btn ${r.paid?"ract-btn-pay-yes":"ract-btn-pay-no"}`}
              onClick={e=>{e.stopPropagation();onPaid(r.id,!r.paid);}}>
              {r.paid?"✓ Paid":"💳 Pay"}
            </button>
          )}

          {/* Status pill */}
          <button className="rpill" style={{background:s.bg,color:s.color,border:`1px solid ${s.color}40`}} ref={pillRef}
            onClick={e=>{
              e.stopPropagation();
              if(pillRef.current){
                const b=pillRef.current.getBoundingClientRect();
                setDdCoords({top:b.bottom+4,right:window.innerWidth-b.right});
              }
              setDd(v=>!v);
            }}>
            <span style={{fontSize:12}}>{s.icon}</span>
            <span style={{maxWidth:76,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.status}</span>
            <span style={{opacity:.55,fontSize:9,marginLeft:1}}>▾</span>
          </button>

          {/* Edit */}
          <button className="ract-btn ract-btn-ghost"
            onClick={e=>{e.stopPropagation();onEdit();}}>
            <I n="edit" s={11}/>
          </button>
          {/* Delete */}
          <button className="ract-btn ract-btn-del"
            onClick={e=>{e.stopPropagation();onDel(r.id);}}>
            <I n="trash" s={11}/>
          </button>
        </div>
      </div>
    </div>
    {/* Dropdown lives outside .rrow so overflow:hidden doesn't clip it */}
    {dd&&(
      <div className="rdd" ref={ddRef} style={{top:ddCoords.top,right:ddCoords.right}}>
        {Object.entries(STATUS_CFG).map(([st,sc])=>(
          <div key={st} className={`rdd-item${r.status===st?" active":""}`} style={{color:sc.color}}
            onMouseDown={e=>{e.stopPropagation();onStatus(r,st);setDd(false);}}>
            <span style={{fontSize:15}}>{sc.icon}</span>
            <span style={{flex:1}}>{st}</span>
            {r.status===st&&<span style={{opacity:.5,fontSize:11}}>✓</span>}
          </div>
        ))}
        <div className="rdd-item" style={{color:"var(--green)",borderTop:"1px solid var(--glb)"}}
          onMouseDown={e=>{e.stopPropagation();onStatus(r,"Delivered",{paid:true});setDd(false);}}>
          <span style={{fontSize:15}}>💵</span>
          <span style={{flex:1}}>Delivered &amp; Paid</span>
          {r.status==="Delivered"&&r.paid&&<span style={{opacity:.5,fontSize:11}}>✓</span>}
        </div>
      </div>
    )}
    </div>
  );
}


// ─── Customer Combobox ───────────────────────────────────────────────────────
function CustomerCombobox({value,customers,onChange,onPick,onNewCustomer,t}){
  const [open,setOpen]=useState(false);
  const [input,setInput]=useState(value||"");
  const ref=useRef();

  useEffect(()=>{setInput(value||"");},[value]);
  useEffect(()=>{
    function handle(e){if(ref.current&&!ref.current.contains(e.target))setOpen(false);}
    document.addEventListener("mousedown",handle);
    return()=>document.removeEventListener("mousedown",handle);
  },[]);

  const q=input.toLowerCase().trim();
  const filtered=q
    ? customers.filter(c=>c.name?.toLowerCase().includes(q)||c.phone?.includes(q))
    : customers;
  const exactMatch=customers.some(c=>c.name?.toLowerCase()===input.toLowerCase().trim());

  function pick(c){onPick(c);setInput(c.name);setOpen(false);}
  function handleInput(e){const v=e.target.value;setInput(v);onChange(v);setOpen(true);}
  function createNewCustomer(){
    const name=input.trim();if(!name)return;
    // Create customer object, save it, then pick it so the repair is linked
    const newC={id:SDB.nextId(),name,phone:"",telegramId:"",email:"",notes:"",devices:[],createdAt:new Date().toISOString()};
    onNewCustomer(newC); // saves to customers list
    onPick(newC);        // auto-fills form + sets customerId
    setInput(name);
    setOpen(false);
    toast("👤","New customer saved",name);
  }

  return(
    <div ref={ref} style={{position:"relative"}}>
      <div style={{position:"relative"}}>
        <input
          className="inp"
          value={input}
          onChange={handleInput}
          onFocus={()=>setOpen(true)}
          placeholder="Customer name…"
          style={{paddingRight:32}}
        />
        <span style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",color:"var(--t3)",fontSize:11,pointerEvents:"none"}}>▾</span>
      </div>
      {open&&(filtered.length>0||(!exactMatch&&input.trim()))&&(
        <div style={{position:"absolute",top:"calc(100% + 4px)",left:0,right:0,background:"var(--bg2)",border:"1px solid var(--glb)",borderRadius:11,zIndex:60,maxHeight:240,overflowY:"auto",boxShadow:"0 10px 28px rgba(0,0,0,0.6)"}}>
          {filtered.map(c=>(
            <div key={c.id} onMouseDown={()=>pick(c)}
              style={{padding:"10px 14px",cursor:"pointer",borderBottom:"1px solid rgba(255,255,255,0.04)"}}
              onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.06)"}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <div style={{display:"flex",alignItems:"center",gap:9}}>
                <div style={{width:28,height:28,borderRadius:8,background:"rgba(10,132,255,0.18)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:700,color:"var(--blue)",flexShrink:0,overflow:"hidden"}}>
                  {c.photoUrl?<img src={c.photoUrl} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:c.name?.[0]?.toUpperCase()||"?"}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:600,fontSize:13}}>{c.name}</div>
                  <div style={{fontSize:11,color:"var(--t3)",marginTop:1,display:"flex",gap:8,flexWrap:"wrap"}}>
                    {c.phone&&<span>📱 {c.phone}</span>}
                    {c.telegramId&&<span style={{display:"inline-flex",alignItems:"center",gap:3}}>TG: {c.telegramId}</span>}
                    {c.email&&<span>✉️ {c.email}</span>}
                  </div>
                </div>
              </div>
            </div>
          ))}
          {!exactMatch&&input.trim()&&(
            <div onMouseDown={createNewCustomer}
              style={{padding:"10px 14px",fontSize:12.5,cursor:"pointer",color:"var(--blue)",display:"flex",alignItems:"center",gap:8,fontWeight:600,borderTop:filtered.length>0?"1px solid var(--glb)":"none"}}
              onMouseEnter={e=>e.currentTarget.style.background="rgba(10,132,255,0.08)"}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <span>➕</span> Save &amp; link new customer: "{input.trim()}"
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ─── Device Combobox ─────────────────────────────────────────────────────────
function DeviceCombobox({value,onChange,catalog,onNewDevice,t}){
  const [open,setOpen]=useState(false);
  const [input,setInput]=useState(value||"");
  const ref=useRef();
  const devices=(catalog||[]).map(d=>d.name);
  const filtered=input.trim()?devices.filter(d=>d.toLowerCase().includes(input.toLowerCase())):devices;
  const exactMatch=devices.some(d=>d.toLowerCase()===input.toLowerCase().trim());

  useEffect(()=>{setInput(value||"");},[value]);
  useEffect(()=>{
    function handle(e){if(ref.current&&!ref.current.contains(e.target))setOpen(false);}
    document.addEventListener("mousedown",handle);return()=>document.removeEventListener("mousedown",handle);
  },[]);

  function pick(name){onChange(name);setInput(name);setOpen(false);}
  function handleInput(e){const v=e.target.value;setInput(v);onChange(v);setOpen(true);}
  function handleBlur(){setTimeout(()=>setOpen(false),150);}
  function createNew(){
    const name=input.trim();if(!name)return;
    if(!exactMatch)onNewDevice(name);
    pick(name);
  }

  return(
    <div ref={ref} style={{position:"relative"}}>
      <div style={{position:"relative"}}>
        <input className="inp" value={input} onChange={handleInput} onFocus={()=>setOpen(true)} onBlur={handleBlur}
          placeholder="iPhone 14 Pro…" style={{paddingRight:32}}/>
        <span style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",color:"var(--t3)",fontSize:11,pointerEvents:"none"}}>▾</span>
      </div>
      {open&&(filtered.length>0||(!exactMatch&&input.trim()))&&(
        <div style={{position:"absolute",top:"calc(100% + 4px)",left:0,right:0,background:"var(--bg2)",border:"1px solid var(--glb)",borderRadius:11,zIndex:50,maxHeight:200,overflowY:"auto",boxShadow:"0 10px 28px rgba(0,0,0,0.55)"}}>
          {filtered.map(d=>(
            <div key={d} onMouseDown={()=>pick(d)}
              style={{padding:"9px 13px",fontSize:12.5,cursor:"pointer",display:"flex",alignItems:"center",gap:8}}
              onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.06)"}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <span style={{fontSize:15}}>📱</span>{d}
            </div>
          ))}
          {!exactMatch&&input.trim()&&(
            <div onMouseDown={createNew}
              style={{padding:"9px 13px",fontSize:12.5,cursor:"pointer",color:"var(--blue)",borderTop:"1px solid var(--glb)",display:"flex",alignItems:"center",gap:8,fontWeight:600}}
              onMouseEnter={e=>e.currentTarget.style.background="rgba(10,132,255,0.08)"}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <span>➕</span> Add "{input.trim()}" to catalog
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ── PartUsedRow: inline cost editing with optional inventory sync ─────────────
function PartUsedRow({p, fmt, onRemove, onUpdate}){
  const [open,setOpen]=useState(false);
  const [costVal,setCostVal]=useState(String(p.cost||0));
  const [saveToInv,setSaveToInv]=useState(false);
  const margin=(p.price-(p.cost||0))*(p.qty||1);

  function commit(){
    const c=parseFloat(costVal)||0;
    onUpdate({cost:c},saveToInv);
    setOpen(false);
  }

  return(
    <div style={{borderRadius:9,overflow:"hidden",border:"1px solid var(--glb)"}}>
      <div className="prow" style={{border:"none",borderRadius:0,gap:8}}>
        <span style={{fontSize:14,flexShrink:0}}>{p.fromCatalog?"📋":p.fromInv?"📦":"🛒"}</span>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:12.5,fontWeight:500,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</div>
          <div style={{fontSize:10.5,color:"var(--t3)",marginTop:1,display:"flex",gap:5,flexWrap:"wrap",alignItems:"center"}}>
            <button
              onClick={()=>{setCostVal(String(p.cost||0));setSaveToInv(false);setOpen(v=>!v);}}
              style={{background:"none",border:"none",padding:0,cursor:"pointer",color:"var(--orange)",fontSize:10.5,fontWeight:600,textDecoration:"underline dotted",textUnderlineOffset:2,fontFamily:"inherit"}}>
              Cost {fmt(p.cost||0)} ✏️
            </button>
            <span style={{opacity:.4}}>·</span>
            <span>Sale {fmt(p.price)} × {p.qty||1}</span>
          </div>
        </div>
        <span style={{fontWeight:700,fontSize:12.5,flexShrink:0,color:margin>=0?"var(--green)":"var(--red)"}}>{fmt(margin)}</span>
        <button className="btn bd bsm" style={{padding:"3px 7px",flexShrink:0}} onClick={onRemove}><I n="trash" s={11}/></button>
      </div>
      {open&&(
        <div style={{padding:"10px 12px 12px",background:"rgba(255,159,10,0.06)",borderTop:"1px solid rgba(255,159,10,0.18)"}}>
          <div style={{fontSize:10.5,fontWeight:700,color:"var(--orange)",marginBottom:7}}>✏️ Edit cost for this repair</div>
          <div style={{display:"flex",gap:7,alignItems:"center",flexWrap:"wrap",marginBottom:8}}>
            <input type="number" min="0" step={priceStep()} value={costVal} onChange={e=>setCostVal(e.target.value)}
              onKeyDown={e=>{if(e.key==="Enter")commit();if(e.key==="Escape")setOpen(false);}}
              autoFocus
              style={{width:100,padding:"6px 10px",background:"var(--gl)",border:"1px solid var(--glb)",borderRadius:8,color:"var(--tx)",fontSize:13,fontFamily:"inherit",outline:"none"}}/>
            <button className="btn bp bsm" onClick={commit}>✓ Apply</button>
            <button className="btn bg2 bsm" onClick={()=>setOpen(false)}>Cancel</button>
          </div>
          {p.fromInv&&(
            <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer"}}>
              <div className="tog" style={{transform:"scale(0.78)",transformOrigin:"left",flexShrink:0}}>
                <input type="checkbox" checked={saveToInv} onChange={e=>setSaveToInv(e.target.checked)}/>
                <span className="ts"/>
              </div>
              <span style={{fontSize:11,color:"var(--t2)"}}>Also save this cost to the inventory part permanently</span>
            </label>
          )}
          {p.fromCatalog&&p.catDevId&&(
            <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",marginTop:4}}>
              <div className="tog" style={{transform:"scale(0.78)",transformOrigin:"left",flexShrink:0}}>
                <input type="checkbox" checked={saveToInv} onChange={e=>setSaveToInv(e.target.checked)}/>
                <span className="ts"/>
              </div>
              <span style={{fontSize:11,color:"var(--t2)"}}>Also save this cost to the parts catalog permanently</span>
            </label>
          )}
          {p.fromCatalog&&!p.catDevId&&<div style={{fontSize:10,color:"var(--t3)",marginTop:6}}>Cost change applies to this repair only.</div>}
        </div>
      )}
    </div>
  );
}

function RepairModal({repair,parts,customers,catalog,saveParts,saveCatalog,onClose,onSave,onNewDevice,onNewCustomer,t,fmt}){
  const nowLocal=()=>{const d=new Date();d.setMinutes(d.getMinutes()-d.getTimezoneOffset());return d.toISOString().slice(0,16);};
  const isoToLocal=(iso)=>{if(!iso)return nowLocal();const d=new Date(iso);d.setMinutes(d.getMinutes()-d.getTimezoneOffset());return d.toISOString().slice(0,16);};
  const blank={customerName:"",phone:"",telegramId:"",device:"",imei:"",types:[],status:"Pending",priority:"Normal",price:"",deposit:"",notes:"",partsUsed:[],warrantyMonths:"0",customerId:null,createdAt:nowLocal(),ownerOnly:false,storeOnly:false};
  const [form,setForm]=useState(()=>{
    if(!repair)return blank;
    const d=new Date(repair.createdAt||Date.now());d.setMinutes(d.getMinutes()-d.getTimezoneOffset());
    // Migrate legacy r.type (string) to r.types (array)
    const types=repair.types&&repair.types.length?repair.types:(repair.type?[repair.type]:[]);
    // Done / delivered / paid dates: only converted if the repair has them (older repairs don't)
    const dateInputs={};
    DATE_FIELDS.forEach(k=>{ if(repair[k]) dateInputs[k]=isoToLocal(repair[k]); });
    return{...repair,types,createdAt:d.toISOString().slice(0,16),...dateInputs};
  });
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));
  const [pMode,setPMode]=useState("inventory");
  const [selId,setSelId]=useState("");const [selQty,setSelQty]=useState(1);
  const [cName,setCName]=useState("");const [cPrice,setCPrice]=useState("");const [cCost,setCCost]=useState("");
  // Catalog quick-pick state
  const [catDev,setCatDev]=useState("");const [catPart,setCatPart]=useState("");const [catType,setCatType]=useState("");
  const [autoFilled,setAutoFilled]=useState(false);

  // Auto-select device+part when catalog tab opens OR when repair types change.
  // Works with single OR multiple types selected.
  useEffect(()=>{
    if(pMode!=="catalog"||!catalog?.length) return;
    const selTypes=form.types&&form.types.length?form.types:(form.type?[form.type]:[]);
    function findPartMatch(parts){
      if(!parts||!parts.length) return null;
      // Priority 1: repairTypeLink matches any selected type (exact)
      let m=selTypes.length?parts.find(p=>selTypes.includes(p.repairTypeLink)):null;
      if(m) return m;
      // Priority 2: keyword match on first selected type
      if(selTypes.length){
        const ft=selTypes[0];
        const kw=ft.toLowerCase().replace(/replacement|repair|fix|change|screen/g,"").trim().split(/\s+/).filter(w=>w.length>2);
        m=parts.find(p=>p.name.toLowerCase()===ft.toLowerCase().split(" ")[0])
          ||parts.find(p=>kw.some(w=>p.name.toLowerCase().includes(w)))
          ||parts.find(p=>p.name.toLowerCase().includes(ft.toLowerCase().split(" ")[0]));
      }
      return m||null;
    }
    // Case A: device not yet selected — try matching by form.device name
    if(!catDev&&form.device){
      const q=form.device.toLowerCase();
      const match=catalog.find(d=>d.name.toLowerCase()===q)
        ||catalog.find(d=>d.name.toLowerCase().includes(q)||q.includes(d.name.toLowerCase()));
      if(match){
        setCatDev(match.id);
        if(!catPart&&match.parts?.length){
          const pm=findPartMatch(match.parts);
          if(pm){setCatPart(pm.id);if(pm.types?.length===1)setCatType(pm.types[0].id);}
        }
      }
    // Case B: device already selected but no part yet — re-try auto-pick when types change
    } else if(catDev&&!catPart){
      const dev=catalog.find(d=>d.id===catDev);
      if(dev?.parts?.length){
        const pm=findPartMatch(dev.parts);
        if(pm){setCatPart(pm.id);if(pm.types?.length===1)setCatType(pm.types[0].id);}
      }
    }
  },[pMode, form.types]);

  function addInv(){if(!selId)return;const p=parts.find(x=>x.id===parseInt(selId));if(!p)return;const ex=form.partsUsed.find(x=>x.sourceId===p.id);if(ex)set("partsUsed",form.partsUsed.map(x=>x.sourceId===p.id?{...x,qty:x.qty+selQty}:x));else set("partsUsed",[...(form.partsUsed||[]),{id:Date.now(),sourceId:p.id,name:p.name,price:p.price,cost:p.cost,qty:selQty,fromInv:true}]);setSelId("");setSelQty(1);}
  function addCustom(){if(!cName)return;set("partsUsed",[...(form.partsUsed||[]),{id:Date.now(),name:cName,price:parseFloat(cPrice)||0,cost:parseFloat(cCost)||0,qty:1,fromInv:false}]);setCName("");setCPrice("");setCCost("");}
  function addFromCatalog(){
    const dev=catalog.find(d=>d.id===catDev);if(!dev)return;
    const part=dev.parts?.find(p=>p.id===catPart);if(!part)return;
    const type=part.types?.find(tp=>tp.id===catType);if(!type)return;
    const name=`${dev.name} — ${part.name} (${type.name})`;
    // Store catalog IDs so cost can be written back to the catalog later
    set("partsUsed",[...(form.partsUsed||[]),{id:Date.now(),name,price:parseFloat(type.price)||0,cost:parseFloat(type.cost)||0,qty:1,fromInv:false,fromCatalog:true,catDevId:catDev,catPartId:catPart,catTypeId:catType}]);
  }
  function rmPart(id){set("partsUsed",form.partsUsed.filter(p=>p.id!==id));}
  const partsTotal=(form.partsUsed||[]).reduce((s,p)=>s+(p.price*(p.qty||1)),0);
  const partsCost=(form.partsUsed||[]).reduce((s,p)=>s+(p.cost||0)*(p.qty||1),0);
  const projProfit=(parseFloat(form.price)||0)-partsCost;
  const warrantyUntil=parseInt(form.warrantyMonths||0)>0?(()=>{const d=new Date();d.setMonth(d.getMonth()+parseInt(form.warrantyMonths));return d.toISOString().slice(0,10);})():null;
  const imeiHistory=form.imei?.length>5?(SDB.get("repairs")||[]).filter(r=>r.imei===form.imei&&(!repair||r.id!==repair.id)):[];
  const catDevObj=catalog.find(d=>d.id===catDev);
  const catPartObj=catDevObj?.parts?.find(p=>p.id===catPart);
  return(
    <div className="mo">
      <div className="md md-w" onClick={e=>e.stopPropagation()}>
        <div className="mh"><div className="mt2">{repair?"✏️ Edit":"🔧 "+t.newRepair}</div><span style={{cursor:"pointer"}} onClick={onClose}><I n="close" s={16} c="var(--t3)"/></span></div>
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <div className="slabel">{t.customers}</div>
          <div className="fg2">
            <div className="fg"><label className="fl">{t.name}</label>
              <CustomerCombobox
                value={form.customerName}
                customers={customers}
                onChange={name=>{set("customerName",name);set("customerId",null);}}
                onPick={c=>{setForm(f=>({...f,customerName:c.name,phone:c.phone||f.phone,telegramId:c.telegramId||f.telegramId,email:c.email||f.email,customerId:c.id,ownerOnly:c.ownerOnlyDefault===true?true:f.ownerOnly}));setAutoFilled(true);}}
                onNewCustomer={onNewCustomer}
                t={t}
              />
            </div>
            <div className="fg"><label className="fl">{t.phone}</label><input className="inp" value={form.phone} onChange={e=>{set("phone",e.target.value);setAutoFilled(false);}}/></div>
          </div>
          {autoFilled&&<div style={{fontSize:11,color:"var(--blue)",marginTop:-6,display:"flex",alignItems:"center",gap:5}}><span>✓</span> {t.autofilled}</div>}
          {form.customerId&&(()=>{
            const linkedCust=customers.find(c=>c.id===form.customerId);
            const devs=linkedCust?.devices||[];
            if(devs.length===0) return null;
            return(
              <div style={{background:"rgba(10,132,255,0.06)",border:"1px solid rgba(10,132,255,0.2)",borderRadius:9,padding:"10px 13px",marginTop:-4}}>
                <div style={{fontSize:11,color:"var(--blue)",fontWeight:600,marginBottom:7}}>📱 {t.customerDevices}</div>
                <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                  {devs.map(d=>(
                    <div key={d.id} style={{padding:"5px 11px",background:"rgba(255,255,255,0.05)",border:`1px solid ${form.device===d.model?"rgba(10,132,255,0.5)":"var(--glb)"}`,borderRadius:20,cursor:"pointer",fontSize:12,fontWeight:form.device===d.model?700:400,color:form.device===d.model?"var(--blue)":"var(--tx)"}}
                      onClick={()=>setForm(f=>({...f,device:d.model,imei:d.imei||f.imei}))}>
                      📱 {d.model}{d.imei&&<span style={{color:"var(--t3)",fontSize:10.5,marginLeft:5}}>···{d.imei.slice(-4)}</span>}
                    </div>
                  ))}
                </div>
              </div>
            );
          })()}
          <div className="fg"><label className="fl">Telegram ID</label><input className="inp" value={form.telegramId} onChange={e=>set("telegramId",e.target.value)} placeholder="@username or chat ID"/></div>
          <div className="hr"/>
          <div className="slabel">{t.device}</div>
          <div className="fg2">
            <div className="fg"><label className="fl">{t.device}</label>
              <DeviceCombobox value={form.device} onChange={v=>set("device",v)} catalog={catalog} onNewDevice={onNewDevice} t={t}/>
            </div>
            <div className="fg"><label className="fl">{t.imei}</label><input className="inp" value={form.imei} onChange={e=>set("imei",e.target.value)} maxLength={20}/></div>
          </div>
          {imeiHistory.length>0&&(<div style={{background:"rgba(255,159,10,0.09)",border:"1px solid rgba(255,159,10,0.25)",borderRadius:9,padding:"10px 13px"}}>
            <div style={{color:"var(--orange)",fontWeight:600,fontSize:12.5}}>⚠️ IMEI seen before — {imeiHistory.length} prior repair(s)</div>
            {imeiHistory.slice(0,3).map(r=><div key={r.id} style={{color:"var(--t2)",fontSize:11.5,marginTop:3}}>#{r.id} · {getRepairTypesIcons(r)} {getRepairTypesDisplay(r)} · {new Date(r.createdAt).toLocaleDateString()}</div>)}
          </div>)}
          <div className="fg">
            <label className="fl">{t.type} <span style={{fontWeight:400,color:"var(--t3)",fontSize:10}}>(select all that apply)</span></label>
            <div style={{display:"flex",flexWrap:"wrap",gap:5,marginTop:4}}>
              {getRepairTypes().map(({name,icon})=>{
                const sel=(form.types||[]).includes(name);
                return(
                  <button key={name} type="button" onClick={()=>{const cur=form.types||[];set("types",sel?cur.filter(x=>x!==name):[...cur,name]);}}
                    style={{padding:"4px 10px",borderRadius:18,border:`1px solid ${sel?"var(--blue)":"var(--glb)"}`,background:sel?"rgba(10,132,255,0.15)":"rgba(255,255,255,0.04)",color:sel?"var(--blue)":"var(--t2)",fontSize:11.5,cursor:"pointer",display:"flex",alignItems:"center",gap:4,transition:"all .12s",fontWeight:sel?700:400}}>
                    <span>{icon}</span><span>{name}</span>
                  </button>
                );
              })}
            </div>
            {(form.types||[]).length===0&&<div style={{fontSize:10.5,color:"var(--orange)",marginTop:4}}>⚠️ Select at least one repair type</div>}
          </div>
          <div className="hr"/>
          <div className="slabel">Job</div>
          <div className="fg3">
            <div className="fg"><label className="fl">{t.status}</label><select className="inp" value={form.status} onChange={e=>{
              // Changing the status stamps the matching date automatically (still editable below)
              const st=e.target.value;
              setForm(f=>{
                const patch=statusDatePatch(f,st,nowLocal());
                const asInputs=Object.fromEntries(Object.entries(patch).map(([k,v])=>[k,v||""]));
                return{...f,status:st,...asInputs};
              });
            }}>{Object.keys(STATUS_CFG).map(s=><option key={s}>{s}</option>)}</select></div>
            <div className="fg"><label className="fl">{t.priority}</label><select className="inp" value={form.priority} onChange={e=>set("priority",e.target.value)}><option>{t.normal}</option><option>{t.high}</option><option>{t.urgent}</option></select></div>
            <div className="fg"><label className="fl">{t.warranty2}</label><select className="inp" value={form.warrantyMonths} onChange={e=>set("warrantyMonths",e.target.value)}>{getWarrantyOptions().map(o=><option key={o.value} value={o.value}>{o.label}</option>)}</select></div>
          </div>
          <div className="fg"><label className="fl">📅 {t.date} <span style={{fontWeight:400,color:"var(--t3)",fontSize:10.5}}>(defaults to now — change if adding late)</span></label>
            <input className="inp" type="datetime-local" value={form.createdAt||nowLocal()} onChange={e=>set("createdAt",e.target.value)}/>
          </div>
          {(form.status==="Done"||form.status==="Delivered"||form.doneAt||form.deliveredAt||form.paid||form.paidAt)&&(
            <div className="fg2">
              {(form.status==="Done"||form.status==="Delivered"||form.doneAt)&&(
                <div className="fg"><label className="fl">✅ Done date</label>
                  <input className="inp" type="datetime-local" value={form.doneAt||""} onChange={e=>set("doneAt",e.target.value)}/>
                </div>
              )}
              {(form.status==="Delivered"||form.deliveredAt)&&(
                <div className="fg"><label className="fl">📦 Delivered date</label>
                  <input className="inp" type="datetime-local" value={form.deliveredAt||""} onChange={e=>set("deliveredAt",e.target.value)}/>
                </div>
              )}
              {(form.paid||form.paidAt)&&(
                <div className="fg"><label className="fl">💵 Payment date <span style={{fontWeight:400,color:"var(--t3)",fontSize:10.5}}>(counts toward this month's report)</span></label>
                  <input className="inp" type="datetime-local" value={form.paidAt||""} onChange={e=>set("paidAt",e.target.value)}/>
                </div>
              )}
            </div>
          )}
          {warrantyUntil&&<div style={{fontSize:11,color:"var(--green)",marginTop:-6}}>🛡️ {t.warrantyUntil}: {warrantyUntil}</div>}
          <div className="fg2">
            <div className="fg"><label className="fl">{t.price} ({SDB.get("currency")||DB.get("currency")||"USD"})</label><input className="inp" type="number" step={priceStep()} value={form.price} onChange={e=>set("price",e.target.value)}/></div>
            <div className="fg"><label className="fl">{t.deposit2}</label><input className="inp" type="number" step={priceStep()} value={form.deposit} onChange={e=>set("deposit",e.target.value)}/></div>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <div style={{flex:1,minWidth:150,display:"flex",alignItems:"center",gap:9,padding:"9px 12px",background:form.ownerOnly?"rgba(191,90,242,0.09)":"rgba(255,255,255,0.03)",border:`1px solid ${form.ownerOnly?"rgba(191,90,242,0.25)":"var(--glb)"}`,borderRadius:9,cursor:"pointer",transition:"all .15s",userSelect:"none"}}
              onClick={()=>{if(!form.ownerOnly){set("ownerOnly",true);set("storeOnly",false);}else set("ownerOnly",false);}}>
              <div className="tog" style={{transform:"scale(0.85)",transformOrigin:"left",pointerEvents:"none"}}>
                <input type="checkbox" checked={!!form.ownerOnly} readOnly tabIndex={-1}/>
                <span className="ts"/>
              </div>
              <div>
                <div style={{fontSize:12.5,fontWeight:600,color:form.ownerOnly?"var(--purple)":"var(--tx)"}}>👤 Mine only</div>
                <div style={{fontSize:10.5,color:"var(--t3)"}}>100% to my balance</div>
              </div>
            </div>
            <div style={{flex:1,minWidth:150,display:"flex",alignItems:"center",gap:9,padding:"9px 12px",background:form.storeOnly?"rgba(48,209,88,0.09)":"rgba(255,255,255,0.03)",border:`1px solid ${form.storeOnly?"rgba(48,209,88,0.25)":"var(--glb)"}`,borderRadius:9,cursor:"pointer",transition:"all .15s",userSelect:"none"}}
              onClick={()=>{if(!form.storeOnly){set("storeOnly",true);set("ownerOnly",false);}else set("storeOnly",false);}}>
              <div className="tog" style={{transform:"scale(0.85)",transformOrigin:"left",pointerEvents:"none"}}>
                <input type="checkbox" checked={!!form.storeOnly} readOnly tabIndex={-1}/>
                <span className="ts"/>
              </div>
              <div>
                <div style={{fontSize:12.5,fontWeight:600,color:form.storeOnly?"var(--green)":"var(--tx)"}}>🏪 Store only</div>
                <div style={{fontSize:10.5,color:"var(--t3)"}}>100% to store</div>
              </div>
            </div>
          </div>
          {(form.price||partsTotal>0)&&<div style={{display:"flex",gap:10,padding:"10px 12px",background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:10,flexWrap:"wrap"}}>
            <div style={{fontSize:12,color:"var(--t3)"}}>{t.partsCost}: <strong style={{color:"var(--orange)"}}>{fmt(partsCost)}</strong></div>
            <div style={{fontSize:12,color:"var(--t3)"}}>{t.projProfit}: <strong style={{color:projProfit>=0?"var(--green)":"var(--red)"}}>{fmt(projProfit)}</strong></div>
            {projProfit<0&&<span style={{fontSize:11,fontWeight:700,color:"var(--red)"}}>⚠️ LOSS</span>}
          </div>}
          <div className="hr"/>
          <div className="slabel">{t.partsUsed}</div>
          <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:11,padding:13}}>
            <div style={{display:"flex",gap:6,marginBottom:10,flexWrap:"wrap"}}>
              <span className={`chip ${pMode==="inventory"?"on":""}`} onClick={()=>setPMode("inventory")}>📦 {t.fromInventory}</span>
              <span className={`chip ${pMode==="custom"?"on":""}`} onClick={()=>setPMode("custom")}>🛒 {t.ordered}</span>
              {catalog.length>0&&<span className={`chip ${pMode==="catalog"?"on":""}`} onClick={()=>setPMode("catalog")}>📋 {t.customParts}</span>}
            </div>
            {pMode==="inventory"&&(<div style={{display:"flex",gap:7,alignItems:"flex-end",flexWrap:"wrap"}}>
              <div className="fg" style={{flex:2,minWidth:140}}><label className="fl">{t.parts}</label><select className="inp" value={selId} onChange={e=>setSelId(e.target.value)}><option value="">— Choose —</option>{parts.map(p=><option key={p.id} value={p.id}>{p.name} ({fmt(p.price)} · {p.stock} left)</option>)}</select></div>
              <div className="fg" style={{width:60}}><label className="fl">Qty</label><input className="inp" type="number" min="1" value={selQty} onChange={e=>setSelQty(parseInt(e.target.value)||1)}/></div>
              <button className="btn bp" style={{height:36,flexShrink:0,alignSelf:"flex-end"}} onClick={addInv}><I n="plus" s={13} c="#fff"/></button>
            </div>)}
            {pMode==="custom"&&(<div style={{display:"flex",gap:7,alignItems:"flex-end",flexWrap:"wrap"}}>
              <div className="fg" style={{flex:2,minWidth:140}}><label className="fl">{t.partName}</label><input className="inp" value={cName} onChange={e=>setCName(e.target.value)}/></div>
              <div className="fg" style={{width:90}}><label className="fl">{t.price}</label><input className="inp" type="number" step={priceStep()} value={cPrice} onChange={e=>setCPrice(e.target.value)}/></div>
              <div className="fg" style={{width:90}}><label className="fl">Cost</label><input className="inp" type="number" step={priceStep()} value={cCost} onChange={e=>setCCost(e.target.value)}/></div>
              <button className="btn bp" style={{height:36,flexShrink:0,alignSelf:"flex-end"}} onClick={addCustom}><I n="plus" s={13} c="#fff"/></button>
            </div>)}
            {pMode==="catalog"&&(<div style={{display:"flex",gap:7,alignItems:"flex-end",flexWrap:"wrap"}}>
              <div className="fg" style={{flex:1,minWidth:110}}><label className="fl">{t.device}</label>
                <select className="inp" value={catDev} onChange={e=>{setCatDev(e.target.value);setCatPart("");setCatType("");}}><option value="">— Device —</option>{catalog.map(d=><option key={d.id} value={d.id}>{d.name}</option>)}</select>
              </div>
              <div className="fg" style={{flex:1,minWidth:110}}><label className="fl">{t.partName}</label>
                <select className="inp" value={catPart} onChange={e=>{setCatPart(e.target.value);setCatType("");}} disabled={!catDev}><option value="">— Part —</option>{(catDevObj?.parts||[]).map(p=><option key={p.id} value={p.id}>{p.name}</option>)}</select>
              </div>
              <div className="fg" style={{flex:1,minWidth:110}}><label className="fl">{t.partType}</label>
                <select className="inp" value={catType} onChange={e=>setCatType(e.target.value)} disabled={!catPart}><option value="">— Type —</option>{(catPartObj?.types||[]).map(tp=><option key={tp.id} value={tp.id}>{tp.name} ({fmt(tp.price)})</option>)}</select>
              </div>
              <button className="btn bp" style={{height:36,flexShrink:0,alignSelf:"flex-end"}} onClick={addFromCatalog} disabled={!catType}><I n="plus" s={13} c="#fff"/></button>
            </div>)}
          </div>
          {(form.partsUsed||[]).length>0&&(<div style={{display:"flex",flexDirection:"column",gap:5}}>
            {form.partsUsed.map(p=>(
              <PartUsedRow key={p.id} p={p} fmt={fmt}
                onRemove={()=>rmPart(p.id)}
                onUpdate={(patch,saveToInv)=>{
                  set("partsUsed",form.partsUsed.map(x=>x.id===p.id?{...x,...patch}:x));
                  if(saveToInv&&patch.cost!=null){
                    if(p.fromInv&&p.sourceId){
                      // Write cost back to inventory part
                      saveParts(parts.map(pt=>pt.id===p.sourceId?{...pt,cost:patch.cost}:pt));
                    } else if(p.fromCatalog&&p.catDevId&&p.catPartId&&p.catTypeId){
                      // Write cost back to the matching type in the parts catalog
                      const newCat=catalog.map(dev=>dev.id!==p.catDevId?dev:{...dev,parts:(dev.parts||[]).map(pt=>pt.id!==p.catPartId?pt:{...pt,types:(pt.types||[]).map(tp=>tp.id!==p.catTypeId?tp:{...tp,cost:patch.cost})})});
                      saveCatalog(newCat);
                    }
                  }
                }}
              />
            ))}
            <div style={{textAlign:"right",fontSize:11.5,color:"var(--t3)"}}>Total: <strong style={{color:"var(--tx)"}}>{fmt(partsTotal)}</strong> · Cost: <strong style={{color:"var(--orange)"}}>{fmt(partsCost)}</strong></div>
          </div>)}
          <div className="fg"><label className="fl">{t.notes}</label><textarea className="inp" rows={3} value={form.notes} onChange={e=>set("notes",e.target.value)} style={{resize:"vertical"}}/></div>
        </div>
        <div className="ma">
          <button className="btn bg2" onClick={onClose}>{t.cancel}</button>
          <button className="btn bp" onClick={()=>{if(!form.device){toast("⚠️",t.missing,t.required);return;}onSave({...form,warrantyUntil:warrantyUntil||form.warrantyUntil||null});}}>
            {repair?t.save:t.newRepair}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── WARRANTY ─────────────────────────────────────────────────────────────────
function WarrantyPage({t,fmt,repairs,readOnly}){
  const [search,setSearch]=useState("");
  const [filter,setFilter]=useState("All");
  const [tab,setTab]=useState("active"); // "active" | "history"
  const now=new Date();
  const cats=repairs.filter(r=>r.warrantyUntil).map(r=>{
    const days=Math.ceil((new Date(r.warrantyUntil)-now)/864e5);
    let status="Active";if(days<0)status="Expired";else if(days<=7)status="Expiring Soon";
    return{...r,warrantyDays:days,warrantyStatus:status};
  });
  const active=cats.filter(r=>r.warrantyStatus!=="Expired");
  const expired=cats.filter(r=>r.warrantyStatus==="Expired").sort((a,b)=>b.warrantyDays-a.warrantyDays);
  const pool=tab==="active"?active:expired;
  const filtered=pool.filter(r=>{
    const q=search.toLowerCase();
    return(!q||r.customerName?.toLowerCase().includes(q)||r.device?.toLowerCase().includes(q)||r.imei?.includes(q))&&(tab==="history"||filter==="All"||r.warrantyStatus===filter);
  }).sort((a,b)=>a.warrantyDays-b.warrantyDays);
  const counts={Active:0,"Expiring Soon":0,Expired:0};cats.forEach(r=>counts[r.warrantyStatus]++);
  const wColor=st=>st==="Active"?"var(--green)":st==="Expiring Soon"?"var(--orange)":"var(--red)";
  const wBg=st=>st==="Active"?"rgba(48,209,88,0.12)":st==="Expiring Soon"?"rgba(255,159,10,0.12)":"rgba(255,69,58,0.12)";
  return(
    <div className="page">
      <div className="ph"><div><div className="pt">{t.warrantyTracker}</div><div className="ps">{cats.length} {t.devicesUnderWarranty}</div></div></div>
      <div className="sg3">
        <SC icon="🛡️" label={t.active2} value={counts.Active} color="var(--green)"/>
        <SC icon="⚠️" label={t.expiringSoon} value={counts["Expiring Soon"]} color="var(--orange)"/>
        <SC icon="❌" label={t.expired} value={counts.Expired} color="var(--red)"/>
      </div>
      <div className="tabs" style={{marginBottom:12}}>
        <div className={`tab ${tab==="active"?"on":""}`} onClick={()=>{setTab("active");setFilter("All");}}>🛡️ Active <span style={{marginLeft:4,fontSize:10,background:"rgba(48,209,88,0.15)",color:"var(--green)",borderRadius:10,padding:"0 6px"}}>{active.length}</span></div>
        <div className={`tab ${tab==="history"?"on":""}`} onClick={()=>setTab("history")}>📋 Expired History <span style={{marginLeft:4,fontSize:10,background:"rgba(255,69,58,0.15)",color:"var(--red)",borderRadius:10,padding:"0 6px"}}>{expired.length}</span></div>
      </div>
      <div style={{display:"flex",gap:7,marginBottom:14,flexWrap:"wrap",alignItems:"center"}}>
        <div className="sbar" style={{maxWidth:280}}><I n="search" s={13} c="var(--t3)"/><input placeholder={`${t.search}…`} value={search} onChange={e=>setSearch(e.target.value)}/></div>
        {tab==="active"&&["All",t.active2,t.expiringSoon].map((f,i)=>{
          const vals=["All","Active","Expiring Soon"];
          return (<span key={f} className={`chip ${filter===vals[i]?"on":""}`} onClick={()=>setFilter(vals[i])}>{f}</span>);
        })}
      </div>
      {filtered.length===0
        ? <div className="empty"><div className="ei">{tab==="history"?"📋":"🛡️"}</div><div className="et">{tab==="history"?"No expired warranties yet":t.noRepairs}</div></div>
        : <div style={{display:"flex",flexDirection:"column",gap:7}}>
            {filtered.map(r=>{
              const s=STATUS_CFG[r.status]||STATUS_CFG["Pending"];
              const daysText=r.warrantyDays<0?`Expired ${Math.abs(r.warrantyDays)}d ago`:r.warrantyDays===0?t.expiresToday:`${r.warrantyDays} ${t.daysLeft}`;
              return(
                <div key={r.id} className="warr-card" style={{borderColor:r.warrantyStatus==="Expiring Soon"?"rgba(255,159,10,0.25)":r.warrantyStatus==="Expired"?"rgba(255,69,58,0.2)":"rgba(48,209,88,0.15)"}}>
                  <div style={{width:40,height:40,borderRadius:10,background:wBg(r.warrantyStatus),display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>{r.warrantyStatus==="Active"?"🛡️":r.warrantyStatus==="Expiring Soon"?"⚠️":"❌"}</div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:600,fontSize:13,display:"flex",alignItems:"center",gap:7}}>{r.customerName}<span className="repair-id" style={{fontWeight:400,color:"var(--t3)",fontSize:11.5}}>#{r.id}</span><span className="sbadge" style={{background:s.bg,color:s.color,fontSize:10}}>{r.status}</span></div>
                    <div style={{fontSize:11.5,color:"var(--t3)",marginTop:2,display:"flex",gap:7,flexWrap:"wrap"}}><span>{r.device}</span><span>·</span><span>{r.type}</span>{r.imei&&<><span>·</span><span className="imei-tag">···{r.imei.slice(-4)}</span></>}</div>
                    <div style={{fontSize:11,color:"var(--t3)",marginTop:3}}>{getTypeIcon(r.type)} {r.type} · 📅 {new Date(r.createdAt).toLocaleDateString()} · 🛡️ {new Date(r.warrantyUntil).toLocaleDateString()}</div>
                  </div>
                  <div style={{textAlign:"right",flexShrink:0}}>
                    <div style={{fontSize:13,fontWeight:700,color:wColor(r.warrantyStatus)}}>{daysText}</div>
                    <div style={{fontSize:11.5,color:"var(--t3)",marginTop:3}}>{fmt(r.price||0)}</div>
                    {r.phone&&<a href={`tel:${r.phone}`} style={{fontSize:11,color:"var(--blue)",textDecoration:"none",display:"block",marginTop:3}}>{r.phone}</a>}
                  </div>
                </div>
              );
            })}
          </div>
      }
    </div>
  );
}

// ─── Brand data ──────────────────────────────────────────────────────────────
// ─── Default brand definitions (editable via Settings > Brands) ──────────────
const BRANDS_DEFAULTS=[
  {name:"Apple",    emoji:"🍎", color:"#555"},
  {name:"Samsung",  emoji:"🌀", color:"#1428A0"},
  {name:"Huawei",   emoji:"🌸", color:"#CF0A2C"},
  {name:"Honor",    emoji:"⚡", color:"#C8102E"},
  {name:"Xiaomi",   emoji:"〽️", color:"#FF6900"},
  {name:"Oppo",     emoji:"◉",  color:"#1D8348"},
  {name:"Vivo",     emoji:"◈",  color:"#415FFF"},
  {name:"Realme",   emoji:"◆",  color:"#FFCC00"},
  {name:"OnePlus",  emoji:"1️⃣", color:"#F5010C"},
  {name:"Nokia",    emoji:"🔵", color:"#005AFF"},
  {name:"Motorola", emoji:"〓", color:"#E1000F"},
  {name:"Sony",     emoji:"🎵", color:"#003087"},
  {name:"LG",       emoji:"🔲", color:"#A50034"},
  {name:"Asus",     emoji:"⬡",  color:"#00AEEF"},
  {name:"Google",   emoji:"🔍", color:"#4285F4"},
  {name:"Lenovo",   emoji:"💼", color:"#E2231A"},
  {name:"ZTE",      emoji:"📡", color:"#004B87"},
  {name:"Tecno",    emoji:"🟦", color:"#2A6DB5"},
  {name:"Infinix",  emoji:"∞",  color:"#E20025"},
  {name:"iTel",     emoji:"📲", color:"#FF6B00"},
  {name:"Other",    emoji:"📱", color:"#666"},
];

// Live brands = defaults merged with user overrides stored in SDB
function getActiveBrands(){
  const custom=SDB.get("custom_brands")||[];
  const map=Object.fromEntries(BRANDS_DEFAULTS.map(b=>[b.name,{...b}]));
  custom.forEach(b=>{map[b.name]={...map[b.name],...b};});
  // add any custom-only brands not in defaults
  custom.forEach(b=>{if(!BRANDS_DEFAULTS.find(d=>d.name===b.name))map[b.name]=b;});
  return Object.values(map);
}
function saveActiveBrands(brands){SDB.set("custom_brands",brands);}

// Get assets list
function getAssets(){return SDB.get("user_assets")||[];}
function saveAssets(assets){SDB.set("user_assets",assets);}

function getBrandEntry(brand){
  const all=getActiveBrands();
  return all.find(b=>b.name===brand)||{name:brand||"",emoji:"📱",color:"#666"};
}
function getBrandEmoji(brand){return getBrandEntry(brand).emoji||"📱";}
function getBrandDisplay(brand,logo,size=32){
  if(logo) return <img src={logo} alt={brand||""} style={{width:size,height:size,objectFit:"contain",borderRadius:6}} onError={e=>{e.target.style.display="none";}}/>;
  const entry=getBrandEntry(brand);
  if(entry.logoUrl) return <img src={entry.logoUrl} alt={brand||""} style={{width:size,height:size,objectFit:"contain",borderRadius:6}} onError={e=>{e.target.style.display="none";}}/>;
  return <span style={{fontSize:size*0.75}}>{entry.emoji||"📱"}</span>;
}

// ─── Asset Picker — shows uploaded assets as a dropdown ──────────────────────
function AssetPicker({value,onChange,placeholder,label}){
  const [open,setOpen]=useState(false);
  const [tab,setTab]=useState("assets"); // "assets" | "url"
  const [urlInput,setUrlInput]=useState(value&&!getAssets().find(a=>a.dataUrl===value)?value:"");
  const ref=useRef();
  const assets=getAssets();
  useEffect(()=>{
    function h(e){if(ref.current&&!ref.current.contains(e.target))setOpen(false);}
    document.addEventListener("mousedown",h);return()=>document.removeEventListener("mousedown",h);
  },[]);
  const current=assets.find(a=>a.dataUrl===value);
  return(
    <div ref={ref} style={{position:"relative"}}>
      {label&&<label className="fl">{label}</label>}
      <div className="inp" style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",padding:"6px 11px",minHeight:38}} onClick={()=>setOpen(o=>!o)}>
        {value
          ? <><img src={value} alt="" style={{width:26,height:26,objectFit:"contain",borderRadius:5,flexShrink:0}} onError={e=>e.target.style.display="none"}/><span style={{flex:1,fontSize:12,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{current?.name||"Custom URL"}</span></>
          : <span style={{flex:1,color:"var(--t3)",fontSize:12.5}}>{placeholder||"No image"}</span>
        }
        {value&&<span style={{color:"var(--t3)",fontSize:14,cursor:"pointer"}} onMouseDown={e=>{e.stopPropagation();onChange("");setUrlInput("");}}>×</span>}
        <I n="chevron" s={10} c="var(--t3)"/>
      </div>
      {open&&(
        <div style={{position:"absolute",top:"calc(100% + 3px)",left:0,right:0,background:"var(--bg2)",border:"1px solid var(--glb)",borderRadius:12,zIndex:110,boxShadow:"0 10px 30px rgba(0,0,0,0.7)",overflow:"hidden"}}>
          <div style={{display:"flex",borderBottom:"1px solid var(--glb)"}}>
            {["assets","url"].map(tb=>(
              <div key={tb} onClick={()=>setTab(tb)}
                style={{flex:1,padding:"8px 0",textAlign:"center",fontSize:12,fontWeight:600,cursor:"pointer",
                  background:tab===tb?"rgba(10,132,255,0.12)":"transparent",
                  color:tab===tb?"var(--blue)":"var(--t3)"}}>
                {tb==="assets"?"🖼️ My Assets":"🔗 URL"}
              </div>
            ))}
          </div>
          {tab==="assets"&&(
            <div style={{maxHeight:200,overflowY:"auto",padding:6}}>
              {assets.length===0
                ? <div style={{padding:"14px 12px",color:"var(--t3)",fontSize:12,textAlign:"center"}}>No assets yet — upload in Settings → Assets</div>
                : <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(64px,1fr))",gap:5}}>
                    {assets.map(a=>(
                      <div key={a.id} onMouseDown={()=>{onChange(a.dataUrl);setOpen(false);}}
                        style={{cursor:"pointer",borderRadius:8,border:`2px solid ${value===a.dataUrl?"var(--blue)":"transparent"}`,padding:3,display:"flex",flexDirection:"column",alignItems:"center",gap:3,background:"rgba(255,255,255,0.03)"}}
                        title={a.name}>
                        <img src={a.dataUrl} alt={a.name} style={{width:44,height:44,objectFit:"contain",borderRadius:5}}/>
                        <span style={{fontSize:9,color:"var(--t3)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",width:"100%",textAlign:"center"}}>{a.name}</span>
                      </div>
                    ))}
                  </div>
              }
            </div>
          )}
          {tab==="url"&&(
            <div style={{padding:"10px 10px 12px"}}>
              <input className="inp" value={urlInput} onChange={e=>setUrlInput(e.target.value)} placeholder="https://example.com/logo.png" style={{fontSize:12,marginBottom:6}}/>
              {urlInput&&<img src={urlInput} alt="" style={{width:40,height:40,objectFit:"contain",borderRadius:6,marginBottom:6,display:"block"}} onError={e=>e.target.style.display="none"}/>}
              <button className="btn bp" style={{width:"100%",justifyContent:"center"}} onMouseDown={()=>{if(urlInput){onChange(urlInput);setOpen(false);}}}> Use this URL</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ─── Brand picker dropdown ────────────────────────────────────────────────────
function BrandPicker({brand,logoUrl,onBrandChange,onLogoChange,allBrands,t}){
  const [open,setOpen]=useState(false);
  const ref=useRef();
  useEffect(()=>{
    function h(e){if(ref.current&&!ref.current.contains(e.target))setOpen(false);}
    document.addEventListener("mousedown",h);return()=>document.removeEventListener("mousedown",h);
  },[]);
  const [brandSearch,setBrandSearch]=useState("");
  const activeBrands=getActiveBrands();
  // Merge in any brands from catalog not already in active list
  const extraBrands=(allBrands||[]).filter(b=>!activeBrands.find(ab=>ab.name===b)).map(b=>({name:b,emoji:"📱",color:"#666"}));
  const combined=[...activeBrands,...extraBrands];
  const filteredBrands=brandSearch.trim()
    ? combined.filter(b=>b.name.toLowerCase().includes(brandSearch.toLowerCase()))
    : combined;
  const selectedBrand=combined.find(b=>b.name===brand);
  return(
    <div ref={ref} style={{position:"relative"}}>
      <label className="fl">Brand</label>
      <div className="inp" style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",padding:"7px 11px"}} onClick={()=>{setOpen(o=>!o);setBrandSearch("");}}>
        <span style={{width:24,height:24,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          {getBrandDisplay(brand,selectedBrand?.logoUrl,22)}
        </span>
        <span style={{flex:1,fontSize:12.5}}>{brand||<span style={{color:"var(--t3)"}}>Select brand…</span>}</span>
        <I n="chevron" s={11} c="var(--t3)"/>
      </div>
      {open&&(
        <div style={{position:"absolute",top:"calc(100% + 3px)",left:0,right:0,background:"var(--bg2)",border:"1px solid var(--glb)",borderRadius:12,zIndex:100,boxShadow:"0 10px 30px rgba(0,0,0,0.7)"}}>
          {/* Search box */}
          <div style={{padding:"8px 8px 4px",borderBottom:"1px solid var(--glb)"}}>
            <input
              className="inp" autoFocus
              placeholder="Search brands…"
              value={brandSearch} onChange={e=>setBrandSearch(e.target.value)}
              onKeyDown={e=>{
                if(e.key==="Escape"){setOpen(false);setBrandSearch("");}
                if(e.key==="Enter"&&filteredBrands.length===1){onBrandChange(filteredBrands[0].name);setOpen(false);setBrandSearch("");}
              }}
              style={{fontSize:12.5,padding:"6px 10px"}}
              onClick={e=>e.stopPropagation()}
            />
          </div>
          <div style={{maxHeight:200,overflowY:"auto"}}>
          {filteredBrands.length===0&&<div style={{padding:"12px 14px",fontSize:12,color:"var(--t3)",textAlign:"center"}}>No brands match</div>}
          {filteredBrands.map(b=>(
            <div key={b.name} onMouseDown={()=>{onBrandChange(b.name);setOpen(false);setBrandSearch("");}}
              style={{display:"flex",alignItems:"center",gap:10,padding:"8px 12px",cursor:"pointer",
                background:brand===b.name?"rgba(10,132,255,0.12)":"transparent",borderRadius:6,margin:"2px 4px"}}
              onMouseEnter={e=>e.currentTarget.style.background=brand===b.name?"rgba(10,132,255,0.15)":"rgba(255,255,255,0.05)"}
              onMouseLeave={e=>e.currentTarget.style.background=brand===b.name?"rgba(10,132,255,0.12)":"transparent"}>
              <span style={{width:26,height:26,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                {getBrandDisplay(b.name,b.logoUrl,22)}
              </span>
              <span style={{fontSize:12.5,flex:1}}>{b.name}</span>
              {brand===b.name&&<I n="check" s={11} c="var(--blue)"/>}
            </div>
          ))}
          </div>
        </div>
      )}
      {/* Logo for this device — uses AssetPicker */}
      <div style={{marginTop:8}}>
        <label className="fl" style={{marginBottom:4}}>Device Logo <span style={{fontWeight:400,color:"var(--t3)",fontSize:10.5}}>(overrides brand logo for this device)</span></label>
        <AssetPicker value={logoUrl||""} onChange={onLogoChange} placeholder="Use brand default logo"/>
      </div>
    </div>
  );
}

// ─── Cross-Compatibility Search ───────────────────────────────────────────────
// Compatibility model: sharedPartId on PARTS (not types).
// Parts sharing the same sharedPartId are fully linked:
// all their types sync automatically, prices update on all linked devices.
// Get all parts (across all devices) sharing the same sharedPartId
function getLinkedParts(catalog, sharedPartId){
  if(!sharedPartId) return [];
  const found=[];
  catalog.forEach(dev=>(dev.parts||[]).forEach(part=>{
    if(part.sharedPartId===sharedPartId) found.push({dev,part});
  }));
  return found;
}

function CompatibilitySearch({catalog,fmt,t,onNavigate,onUnlink}){
  const [devQ,setDevQ]=useState("");
  const [partQ,setPartQ]=useState("");
  const [devOpen,setDevOpen]=useState(false);
  const [partOpen,setPartOpen]=useState(false);
  const devRef=useRef(); const partRef=useRef();
  useEffect(()=>{
    function h(e){
      if(devRef.current&&!devRef.current.contains(e.target))setDevOpen(false);
      if(partRef.current&&!partRef.current.contains(e.target))setPartOpen(false);
    }
    document.addEventListener("mousedown",h);return()=>document.removeEventListener("mousedown",h);
  },[]);

  const allDevNames=Array.from(new Set(catalog.map(d=>d.name))).sort();
  const allPartNames=Array.from(new Set(catalog.flatMap(d=>(d.parts||[]).map(p=>p.name)))).sort();
  const filtDevNames=devQ.trim()?allDevNames.filter(n=>n.toLowerCase().includes(devQ.toLowerCase())):allDevNames;
  const filtPartNames=partQ.trim()?allPartNames.filter(n=>n.toLowerCase().includes(partQ.toLowerCase())):allPartNames;

  // Build results: find all linked part groups matching both filters
  const results=[];
  const seen=new Set();
  if(devQ.trim()||partQ.trim()){
    const dq=devQ.toLowerCase(); const pq=partQ.toLowerCase();
    catalog.forEach(dev=>{
      (dev.parts||[]).forEach(part=>{
        if(pq&&!part.name.toLowerCase().includes(pq)) return;
        // Get all devices this part is linked to (via sharedPartId)
        const sid=part.sharedPartId;
        const key=sid||`${dev.id}/${part.id}`;
        if(seen.has(key)) return;
        // Find all parts sharing this sid
        let linkedDevs=[];
        if(sid){
          catalog.forEach(d=>(d.parts||[]).forEach(p=>{if(p.sharedPartId===sid)linkedDevs.push({dev:d,part:p});}));
        } else {
          linkedDevs=[{dev,part}];
        }
        const allDeviceNames=linkedDevs.map(x=>x.dev.name);
        if(dq&&!allDeviceNames.some(n=>n.toLowerCase().includes(dq))) return;
        seen.add(key);
        results.push({part,dev,linkedDevs,allDeviceNames});
      });
    });
  }

  return(
    <div style={{display:"flex",flexDirection:"column",gap:13}}>
      <div style={{background:"rgba(90,200,250,0.06)",border:"1px solid rgba(90,200,250,0.15)",borderRadius:11,padding:"13px 15px"}}>
        <div style={{fontSize:12.5,fontWeight:600,color:"var(--teal)",marginBottom:10}}>🔍 Find compatible parts</div>
        <div className="fg2">
          {/* Device combobox */}
          <div className="fg" ref={devRef} style={{position:"relative"}}>
            <label className="fl">Device you are repairing</label>
            <div className="inp" style={{display:"flex",alignItems:"center",gap:6,cursor:"text",padding:"7px 11px"}} onClick={()=>setDevOpen(true)}>
              <I n="search" s={12} c="var(--t3)"/>
              <input style={{background:"transparent",border:"none",outline:"none",color:"var(--tx)",fontSize:12.5,flex:1,width:0}} value={devQ} onChange={e=>{setDevQ(e.target.value);setDevOpen(true);}} placeholder="e.g. Huawei Y6b" onFocus={()=>setDevOpen(true)}/>
              {devQ&&<span style={{cursor:"pointer",color:"var(--t3)",fontSize:14}} onClick={e=>{e.stopPropagation();setDevQ("");}}>×</span>}
            </div>
            {devOpen&&(
              <div style={{position:"absolute",top:"calc(100% + 2px)",left:0,right:0,background:"var(--bg2)",border:"1px solid var(--glb)",borderRadius:10,zIndex:80,maxHeight:180,overflowY:"auto",boxShadow:"0 8px 24px rgba(0,0,0,0.6)"}}>
                {filtDevNames.length===0?<div style={{padding:"10px 12px",color:"var(--t3)",fontSize:12}}>No devices found</div>
                  :filtDevNames.map(n=>(
                    <div key={n} onMouseDown={()=>{setDevQ(n);setDevOpen(false);}}
                      style={{padding:"8px 12px",cursor:"pointer",fontSize:12.5,display:"flex",alignItems:"center",gap:8}}
                      onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.06)"}
                      onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                      📱 {n}
                    </div>
                  ))}
              </div>
            )}
          </div>
          {/* Part combobox */}
          <div className="fg" ref={partRef} style={{position:"relative"}}>
            <label className="fl">Part name</label>
            <div className="inp" style={{display:"flex",alignItems:"center",gap:6,cursor:"text",padding:"7px 11px"}} onClick={()=>setPartOpen(true)}>
              <I n="search" s={12} c="var(--t3)"/>
              <input style={{background:"transparent",border:"none",outline:"none",color:"var(--tx)",fontSize:12.5,flex:1,width:0}} value={partQ} onChange={e=>{setPartQ(e.target.value);setPartOpen(true);}} placeholder="e.g. Screen" onFocus={()=>setPartOpen(true)}/>
              {partQ&&<span style={{cursor:"pointer",color:"var(--t3)",fontSize:14}} onClick={e=>{e.stopPropagation();setPartQ("");}}>×</span>}
            </div>
            {partOpen&&(
              <div style={{position:"absolute",top:"calc(100% + 2px)",left:0,right:0,background:"var(--bg2)",border:"1px solid var(--glb)",borderRadius:10,zIndex:80,maxHeight:180,overflowY:"auto",boxShadow:"0 8px 24px rgba(0,0,0,0.6)"}}>
                {filtPartNames.length===0?<div style={{padding:"10px 12px",color:"var(--t3)",fontSize:12}}>No parts found</div>
                  :filtPartNames.map(n=>(
                    <div key={n} onMouseDown={()=>{setPartQ(n);setPartOpen(false);}}
                      style={{padding:"8px 12px",cursor:"pointer",fontSize:12.5,display:"flex",alignItems:"center",gap:8}}
                      onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.06)"}
                      onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                      🔩 {n}
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
        <div style={{fontSize:11,color:"var(--t3)",marginTop:8}}>Parts linked to multiple devices appear here with all compatible devices listed.</div>
      </div>

      {(devQ.trim()||partQ.trim())&&results.length===0&&(
        <div className="empty" style={{padding:"20px 0"}}>
          <div className="ei">🔗</div><div className="et">No compatible parts found</div>
          <div className="es">Open a device, go to a part, and use "Link to other devices"</div>
        </div>
      )}

      {results.length>0&&(
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {results.map(({part,dev,linkedDevs,allDeviceNames},i)=>(
            <div key={i} style={{background:"rgba(255,255,255,0.03)",border:`1px solid ${part.sharedPartId?"rgba(90,200,250,0.3)":"var(--glb)"}`,borderRadius:12,overflow:"hidden"}}>
              {/* Part header */}
              <div style={{display:"flex",alignItems:"center",gap:10,padding:"11px 14px",background:"rgba(90,200,250,0.05)",borderBottom:"1px solid var(--glb)"}}>
                <span style={{fontSize:18}}>🔩</span>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700,fontSize:13}}>{part.name}</div>
                  <div style={{fontSize:11,color:"var(--t3)",marginTop:1}}>Listed under: 📱 {dev.name}{part.repairTypeLink?<span style={{marginLeft:8,color:"var(--blue)"}}>→ {part.repairTypeLink}</span>:""}</div>
                </div>
                {part.sharedPartId&&<span style={{fontSize:10,background:"rgba(90,200,250,0.12)",color:"var(--teal)",padding:"2px 8px",borderRadius:10,fontWeight:600}}>🔗 Linked</span>}
              </div>
              {/* Types */}
              {(part.types||[]).length>0&&(
                <div style={{padding:"10px 14px",borderBottom:"1px solid var(--glb)"}}>
                  <div style={{fontSize:11,color:"var(--t3)",marginBottom:6,fontWeight:600,textTransform:"uppercase",letterSpacing:.4}}>Types & Pricing</div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                    {(part.types||[]).map(tp=>(
                      <div key={tp.id} style={{padding:"5px 11px",background:"rgba(10,132,255,0.07)",border:"1px solid rgba(10,132,255,0.18)",borderRadius:9}}>
                        <div style={{fontSize:12,fontWeight:600}}>{tp.name}</div>
                        <div style={{fontSize:13,fontWeight:700,color:"var(--green)"}}>{fmt(tp.price)}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {/* Compatible devices */}
              <div style={{padding:"10px 14px"}}>
                <div style={{fontSize:11,color:"var(--t3)",marginBottom:6,fontWeight:600,textTransform:"uppercase",letterSpacing:.4}}>Compatible with</div>
                <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                  {linkedDevs.map(({dev:ld,part:lp})=>(
                    <span key={ld.id}
                      style={{display:"flex",alignItems:"center",gap:4,padding:"3px 10px",background:ld.name.toLowerCase()===devQ.toLowerCase()?"rgba(90,200,250,0.2)":"rgba(90,200,250,0.07)",border:`1px solid ${ld.name.toLowerCase()===devQ.toLowerCase()?"rgba(90,200,250,0.4)":"rgba(90,200,250,0.18)"}`,borderRadius:20,fontSize:11.5,fontWeight:ld.name.toLowerCase()===devQ.toLowerCase()?700:400,color:ld.name.toLowerCase()===devQ.toLowerCase()?"var(--teal)":"var(--tx)"}}>
                      <span style={{cursor:"pointer"}} onClick={()=>onNavigate&&onNavigate(ld.id)}>📱 {ld.name}</span>
                      {onUnlink&&<span title="Unlink this device" style={{cursor:"pointer",color:"var(--red)",fontWeight:700,fontSize:13,marginLeft:2,lineHeight:1}} onClick={e=>{e.stopPropagation();onUnlink(ld.id,lp.sharedPartId);}}>×</span>}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {!devQ.trim()&&!partQ.trim()&&(
        <div style={{color:"var(--t3)",fontSize:13,textAlign:"center",padding:"24px 0"}}>Search by device name or part name to find compatible parts</div>
      )}
    </div>
  );
}

// ─── CUSTOM PARTS CATALOG ─────────────────────────────────────────────────────
function DeviceModal({device,onSave,onClose,t,catalog,defaultBrand}){
  const [name,setName]=useState(device?.name||"");
  const [brand,setBrand]=useState(device?.brand||defaultBrand||"");
  const [logoUrl,setLogoUrl]=useState(device?.logoUrl||"");
  const [models,setModels]=useState((device?.models||[]).join("\n"));
  const allBrands=Array.from(new Set((catalog||[]).map(d=>d.brand).filter(Boolean))).sort();
  const preview=logoUrl||"";
  return(
    <div className="mo">
      <div className="md" style={{maxWidth:420}} onClick={e=>e.stopPropagation()}>
        <div className="mh"><div className="mt2">{device?"Edit Device":"Add Device"}</div><span style={{cursor:"pointer"}} onClick={onClose}><I n="close" s={15} c="var(--t3)"/></span></div>
        <div style={{display:"flex",flexDirection:"column",gap:14,marginBottom:16}}>
          {/* Preview */}
          <div style={{display:"flex",alignItems:"center",gap:14,padding:"12px 14px",background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:12}}>
            <div style={{width:52,height:52,borderRadius:14,background:"rgba(10,132,255,0.1)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              {getBrandDisplay(brand,preview,36)}
            </div>
            <div>
              <div style={{fontWeight:700,fontSize:14}}>{name||<span style={{color:"var(--t3)"}}>Device name</span>}</div>
              <div style={{fontSize:11.5,color:"var(--t3)",marginTop:2}}>{brand||"No brand"}</div>
            </div>
          </div>
          <div className="fg"><label className="fl">Device Name</label><input className="inp" value={name} onChange={e=>setName(e.target.value)} placeholder="e.g. Huawei Y6b" autoFocus/></div>
          <BrandPicker brand={brand} logoUrl={logoUrl} onBrandChange={setBrand} onLogoChange={setLogoUrl} allBrands={allBrands} t={t}/>
          <div className="fg">
            <label className="fl">Model Numbers <span style={{fontWeight:400,color:"var(--t3)",fontSize:10.5}}>(one per line or comma-separated — searchable)</span></label>
            <textarea className="inp" rows={3} value={models} onChange={e=>setModels(e.target.value)}
              placeholder={"SM-S928B\nSM-S928B/DS\nSM-S928U\n…"}
              style={{resize:"vertical",fontFamily:"monospace",fontSize:12}}/>
            {models.trim()&&<div style={{fontSize:10.5,color:"var(--t3)",marginTop:3}}>{models.split(/[,\n]/).map(m=>m.trim()).filter(Boolean).length} models</div>}
          </div>
        </div>
        <div className="ma">
          <button className="btn bg2" onClick={onClose}>{t.cancel}</button>
          <button className="btn bp" onClick={()=>{
            if(!name.trim())return;
            const parsedModels=models.split(/[,\n]/).map(m=>m.trim()).filter(Boolean);
            onSave({name:name.trim(),brand:brand.trim(),logoUrl:logoUrl.trim(),models:parsedModels});
          }}>{t.save}</button>
        </div>
      </div>
    </div>
  );
}
function CustomPartsPage({t,fmt,catalog,saveCatalog,parts,saveParts,readOnly,navSub,param}){
  // ── ALL hooks at top — never after a conditional return ──────────────
  const [viewDev,setViewDev]=useState(null);
  const [devModal,setDevModal]=useState(null);
  const [partModal,setPartModal]=useState(null);
  const [typeModal,setTypeModal]=useState(null);
  const [cpTab,setCpTab]=useState("devices");
  const [catSearch,setCatSearch]=useState("");
  const [viewBrand,setViewBrand]=useState(null); // brand name being drilled into
  const [brandView,setBrandViewState]=useState(SDB.get("catalog_brand_view")===true);
  const [wasInBrandView,setWasInBrandView]=useState(false);
  // Sync internal view state with param (handles back button popstate)
  useEffect(()=>{
    if(param&&typeof param==='object'){
      if(param.cpView==='device'&&param.devId){
        setViewDev(param.devId); setViewBrand(null);
      } else if(param.cpView==='brand'&&param.brand){
        setViewBrand(param.brand); setViewDev(null);
        if(SDB.get("catalog_brand_view")) setBrandViewState(true);
      } else {
        setViewDev(null); setViewBrand(null);
      }
    } else {
      // param is null or plain string → reset to top level
      setViewDev(null); setViewBrand(null);
    }
  },[param]);
  function toggleBrandView(){const v=!brandView;SDB.set("catalog_brand_view",v);setBrandViewState(v);setCatSearch("");setViewBrand(null);setWasInBrandView(false);}
  function handleCatSearch(val){
    setCatSearch(val);
    if(viewBrand) return; // inside a brand: search stays scoped, no view switch
    if(val.trim()&&brandView){
      // User started typing while in brand view → temporarily switch to device list
      setWasInBrandView(true);
      setBrandViewState(false);
    } else if(!val.trim()&&wasInBrandView){
      // User cleared search → restore brand view
      setBrandViewState(true);
      setWasInBrandView(false);
    }
  }

  // Forward drill: push history so back button can pop
  useViewScroll(viewDev?"cp:device":viewBrand?"cp:brand":"cp:list");
  function drillDevice(devId){ rememberScroll(viewBrand?"cp:brand":"cp:list"); if(navSub) navSub({cpView:'device',devId}); setViewDev(devId); }
  function drillBrand(brand){ rememberScroll("cp:list"); if(navSub) navSub({cpView:'brand',brand}); setViewBrand(brand); }
  // Back buttons in UI: just clear state (no navSub push — phone back pops history)
  function backToList(){ setViewDev(null); setViewBrand(null); }
  function backToBrand(){ setViewDev(null); }

  // ── Derived data ────────────────────────────────────────────────────
  const activeDev=viewDev ? catalog.find(d=>d.id===viewDev)||null : null;
  const catalogFiltered=catSearch.trim()
    ? catalog.filter(d=>{
        const q=catSearch.toLowerCase();
        return d.name.toLowerCase().includes(q)
          ||d.brand?.toLowerCase().includes(q)
          ||(d.models||[]).some(m=>m.toLowerCase().includes(q));
      })
    : catalog;
  const brands=Array.from(new Set(catalog.map(d=>d.brand||"Other"))).sort();
  const brandDevs=viewBrand ? catalog.filter(d=>(d.brand||"Other")===viewBrand) : [];

  // ── Helpers ─────────────────────────────────────────────────────────
  function saveDev(data){
    if(devModal==="add") saveCatalog([...catalog,{...data,id:Date.now().toString(),parts:[]}]);
    else saveCatalog(catalog.map(d=>d.id===devModal.id?{...d,...data}:d));
    setDevModal(null);toast("✅",t.saved,data.name);
  }
  function delDev(id){
    saveCatalog(catalog.filter(d=>d.id!==id));
    if(viewDev===id){setViewDev(null);}
    toast("🗑️",t.deleted,"");
  }
  // savePart: if part has sharedPartId, sync name/repairTypeLink to all linked parts
  function savePart(devId,data){
    if(partModal.part?.sharedPartId){
      const sid=partModal.part.sharedPartId;
      saveCatalog(catalog.map(d=>({...d,parts:(d.parts||[]).map(p=>
        p.sharedPartId===sid ? {...p,name:data.name,repairTypeLink:data.repairTypeLink} : p
      )})));
    } else {
      saveCatalog(catalog.map(d=>{
        if(d.id!==devId)return d;
        if(partModal.part) return{...d,parts:d.parts.map(p=>p.id===partModal.part.id?{...p,...data}:p)};
        return{...d,parts:[...(d.parts||[]),{...data,id:Date.now().toString(),types:[]}]};
      }));
    }
    setPartModal(null);toast("✅",t.saved,data.name);
  }
  function delPart(devId,partId){
    const part=catalog.find(d=>d.id===devId)?.parts?.find(p=>p.id===partId);
    const sid=part?.sharedPartId;
    let updated;
    if(sid){
      // Remove ONLY this device's copy of the linked part; other devices keep theirs
      updated=catalog.map(d=>d.id!==devId?d:{...d,parts:d.parts.filter(p=>p.id!==partId)});
    } else {
      updated=catalog.map(d=>d.id!==devId?d:{...d,parts:d.parts.filter(p=>p.id!==partId)});
    }
    saveCatalog(updated);toast("🗑️",t.deleted,"");
  }

  // saveType: sync price/cost/name to ALL parts sharing sharedPartId across catalog
  function saveType(devId,partId,data){
    const srcPart=catalog.find(d=>d.id===devId)?.parts?.find(p=>p.id===partId);
    const sid=srcPart?.sharedPartId;
    let newCatalog;
    if(sid){
      // Sync this type (matched by name) across all linked parts
      newCatalog=catalog.map(d=>({...d,parts:(d.parts||[]).map(p=>{
        if(p.sharedPartId!==sid) return p;
        if(typeModal?.type){
          // Editing existing type — update by id on source, by name on mirrors
          return{...p,types:(p.types||[]).map(tp=>{
            if(p.id===partId&&tp.id===typeModal.type.id) return{...tp,...data};
            if(p.id!==partId&&tp.name===typeModal.type.name) return{...tp,...data};
            return tp;
          })};
        } else {
          // Adding new type — add to all linked parts
          if(p.id===partId) return{...p,types:[...(p.types||[]),{...data,id:Date.now().toString()+"_"+p.id}]};
          const alreadyHas=(p.types||[]).some(tp=>tp.name===data.name);
          if(!alreadyHas) return{...p,types:[...(p.types||[]),{...data,id:Date.now().toString()+"_m_"+p.id}]};
          return p;
        }
      })}));
    } else {
      newCatalog=catalog.map(d=>{
        if(d.id!==devId)return d;
        return{...d,parts:d.parts.map(p=>{
          if(p.id!==partId)return p;
          if(typeModal?.type) return{...p,types:p.types.map(tp=>tp.id===typeModal.type.id?{...tp,...data}:tp)};
          return{...p,types:[...(p.types||[]),{...data,id:Date.now().toString()}]};
        })};
      });
    }
    saveCatalog(newCatalog);
    setTypeModal(null);toast("✅",t.saved,data.name);
  }

  function delType(devId,partId,typeId){
    const srcPart=catalog.find(d=>d.id===devId)?.parts?.find(p=>p.id===partId);
    const sid=srcPart?.sharedPartId;
    const typeName=srcPart?.types?.find(tp=>tp.id===typeId)?.name;
    let updated;
    if(sid&&typeName){
      // Remove this type name from all linked parts
      updated=catalog.map(d=>({...d,parts:(d.parts||[]).map(p=>
        p.sharedPartId===sid ? {...p,types:(p.types||[]).filter(tp=>tp.name!==typeName)} : p
      )}));
    } else {
      updated=catalog.map(d=>d.id!==devId?d:{...d,parts:d.parts.map(p=>p.id!==partId?p:{...p,types:p.types.filter(tp=>tp.id!==typeId)})});
    }
    saveCatalog(updated);toast("🗑️",t.deleted,"");
  }

  // linkPartToDevices: link a whole part (with all its types) to other devices
  // Reuses existing sharedPartId so adding more devices never breaks old links
  function linkPartToDevices(devId,partId,targetDeviceNames,newDevicesToCreate){
    const srcPart=catalog.find(d=>d.id===devId)?.parts?.find(p=>p.id===partId);
    if(!srcPart) return;
    // Reuse existing sharedId to preserve all current links
    const sharedId=srcPart.sharedPartId||("sp_"+Date.now().toString(36));
    let newCatalog=[...catalog];
    // Create missing devices
    for(const nm of (newDevicesToCreate||[])){
      newCatalog=[...newCatalog,{id:Date.now().toString()+"_nd_"+Math.random().toString(36).slice(2),name:nm,brand:"",logoUrl:"",parts:[]}];
    }
    const allTargetNames=[...targetDeviceNames,...(newDevicesToCreate||[])];
    newCatalog=newCatalog.map(dev=>{
      if(dev.id===devId){
        // Mark source part as shared
        return{...dev,parts:dev.parts.map(p=>p.id!==partId?p:{...p,sharedPartId:sharedId})};
      }
      if(!allTargetNames.includes(dev.name)) return dev;
      const alreadyLinked=(dev.parts||[]).some(p=>p.sharedPartId===sharedId);
      if(alreadyLinked) return dev;
      const existing=(dev.parts||[]).find(p=>p.name===srcPart.name);
      const mirrorPart={...srcPart,id:Date.now().toString()+"_mp_"+dev.id,sharedPartId:sharedId,
        types:(srcPart.types||[]).map(tp=>({...tp,id:Date.now().toString()+"_mt_"+dev.id+"_"+tp.id}))};
      if(existing){
        // Merge: update existing part to be linked, copy types it doesn't have
        const mergedTypes=[...(existing.types||[])];
        for(const tp of (srcPart.types||[])){
          if(!mergedTypes.some(x=>x.name===tp.name)){
            mergedTypes.push({...tp,id:Date.now().toString()+"_mt_"+dev.id+"_"+tp.id});
          }
        }
        return{...dev,parts:dev.parts.map(p=>p.id!==existing.id?p:{...p,sharedPartId:sharedId,types:mergedTypes})};
      }
      return{...dev,parts:[...(dev.parts||[]),mirrorPart]};
    });
    saveCatalog(newCatalog);
    toast("🔗","Linked","Part synced to "+allTargetNames.length+" device(s)");
  }

  // unlinkPartFromDevice: remove the sharedPartId from a specific device's copy of the part
  // The part stays on that device, it just loses the link (prices no longer sync)
  function unlinkPartFromDevice(devId,sharedPartId){
    const updated=catalog.map(dev=>{
      if(dev.id!==devId) return dev;
      return{...dev,parts:dev.parts.map(p=>p.sharedPartId!==sharedPartId?p:(()=>{const{sharedPartId:_,...rest}=p;return rest;})())};
    });
    // If only 1 device left with this sharedId, remove its link too (no point staying "linked")
    const remaining=[];
    updated.forEach(d=>(d.parts||[]).forEach(p=>{if(p.sharedPartId===sharedPartId)remaining.push({d,p});}));
    let final=updated;
    if(remaining.length<=1){
      final=updated.map(dev=>({...dev,parts:dev.parts.map(p=>p.sharedPartId===sharedPartId?(()=>{const{sharedPartId:_,...rest}=p;return rest;})():p)}));
    }
    saveCatalog(final);
    toast("🔓","Unlinked","Device removed from link group");
  }

  // ── DEVICE DETAIL VIEW ───────────────────────────────────────────────
  if(activeDev){
    return(
      <div className="page">
        {/* Header */}
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
          <button className="btn bg2 bsm" onClick={()=>{ if(viewBrand) backToBrand(); else if(wasInBrandView||SDB.get("catalog_brand_view")) backToList(); else backToList(); }} style={{flexShrink:0}}><I n="back" s={13}/></button>
          <div style={{width:38,height:38,borderRadius:11,background:"rgba(10,132,255,0.12)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
            {getBrandDisplay(activeDev.brand,activeDev.logoUrl,26)}
          </div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontWeight:800,fontSize:16,letterSpacing:"-.01em",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{activeDev.name}</div>
            <div style={{fontSize:11,color:"var(--t3)",marginTop:1}}>{activeDev.brand&&`${activeDev.brand} · `}{(activeDev.parts||[]).length} parts</div>
          </div>
          <div style={{display:"flex",gap:6,flexShrink:0}}>
            <button className="btn bp bsm" onClick={()=>setPartModal({device:activeDev,part:null})}><I n="plus" s={12} c="#fff"/><span style={{display:"none"}}>Add</span></button>
            <button className="btn bg2 bsm" onClick={()=>setDevModal(activeDev)}><I n="edit" s={12}/></button>
            <button className="btn bd bsm" onClick={()=>delDev(activeDev.id)}><I n="trash" s={12}/></button>
          </div>
        </div>

        {(activeDev.parts||[]).length===0
          ? <div className="empty"><div className="ei">🔩</div><div className="et">No parts yet</div><div className="es">Tap + to add the first part</div></div>
          : <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {(activeDev.parts||[]).map(part=>{
                const linkedInvParts=(parts||[]).filter(ip=>(part.invLink||[]).includes(ip.id));
                const totalPartStock=linkedInvParts.reduce((s,ip)=>s+ip.stock,0);
                const partHasInv=linkedInvParts.length>0;
                const partLow=partHasInv&&totalPartStock<=3;
                return(
                  <div key={part.id} className="part-section">
                    {/* Part header */}
                    <div className="part-section-head">
                      <div style={{display:"flex",alignItems:"center",gap:9,flex:1,minWidth:0}}>
                        <div style={{width:34,height:34,borderRadius:9,background:"rgba(90,200,250,0.12)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>{getPartIcon(part)}</div>
                        <div style={{minWidth:0}}>
                          <div style={{fontWeight:700,fontSize:14,display:"flex",alignItems:"center",gap:5,flexWrap:"wrap"}}>
                            <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{part.name}</span>
                            {part.sharedPartId&&<span style={{fontSize:9.5,background:"rgba(90,200,250,0.12)",color:"var(--teal)",padding:"1px 6px",borderRadius:8,fontWeight:700,flexShrink:0}}>🔗</span>}
                            {partHasInv&&<span style={{fontSize:9.5,background:partLow?"rgba(255,69,58,0.12)":"rgba(48,209,88,0.1)",color:partLow?"var(--red)":"var(--green)",padding:"1px 6px",borderRadius:8,fontWeight:700,border:`1px solid ${partLow?"rgba(255,69,58,0.25)":"rgba(48,209,88,0.2)"}`,flexShrink:0}}>📦 {totalPartStock}{partLow?" ⚠️":""}</span>}
                          </div>
                          <div style={{fontSize:10.5,color:"var(--t3)",marginTop:1}}>{(part.types||[]).length} {(part.types||[]).length===1?"type":"types"}{part.repairTypeLink&&<span style={{color:"var(--blue)",marginLeft:5}}>· {part.repairTypeLink}</span>}</div>
                        </div>
                      </div>
                      <div style={{display:"flex",gap:5,flexShrink:0}}>
                        <button className="btn bp bsm" style={{fontSize:11,padding:"4px 8px"}} onClick={()=>setTypeModal({device:activeDev,part,type:null})}><I n="plus" s={11} c="#fff"/></button>
                        <button className="btn bg2 bsm" style={{padding:"4px 7px"}} onClick={()=>setPartModal({device:activeDev,part})}><I n="edit" s={11}/></button>
                        <button className="btn bd bsm" style={{padding:"4px 7px"}} onClick={()=>delPart(activeDev.id,part.id)}><I n="trash" s={11}/></button>
                      </div>
                    </div>
                    {/* Linked devices chips */}
                    {part.sharedPartId&&(()=>{
                      const lp=getLinkedParts(catalog,part.sharedPartId).filter(x=>x.dev.id!==activeDev.id);
                      return lp.length>0?(
                        <div style={{display:"flex",flexWrap:"wrap",gap:4,padding:"7px 14px 0",borderBottom:"1px solid var(--glb)",paddingBottom:8}}>
                          <span style={{fontSize:10,color:"var(--t3)",marginRight:2}}>Also in:</span>
                          {lp.map(({dev})=><span key={dev.id} style={{fontSize:10.5,padding:"1px 8px",background:"rgba(90,200,250,0.07)",border:"1px solid rgba(90,200,250,0.18)",borderRadius:10,color:"var(--teal)"}}>📱 {dev.name}</span>)}
                        </div>
                      ):null;
                    })()}
                    {/* Types list */}
                    <div className="part-section-body">
                      {(part.types||[]).length===0
                        ? <div style={{textAlign:"center",padding:"10px 0",color:"var(--t3)",fontSize:12}}>No pricing types yet — tap + to add</div>
                        : <div style={{display:"flex",flexDirection:"column",gap:7}}>
                            {(part.types||[]).map(tp=>{
                              const typeInvIds=(tp.invLink||[]).length>0?(tp.invLink||[]):(part.invLink||[]);
                              const linkedInv=(parts||[]).filter(ip=>typeInvIds.includes(ip.id));
                              const totalStock=linkedInv.reduce((s,ip)=>s+ip.stock,0);
                              const hasInv=linkedInv.length>0;
                              const low=hasInv&&totalStock<=3;
                              const profit=tp.cost>0&&tp.price>0?tp.price-tp.cost:null;
                              const mg=tp.cost>0&&tp.price>0?((tp.price-tp.cost)/tp.price*100).toFixed(0):null;
                              return(
                                <div key={tp.id} className="type-pill">
                                  <div style={{flex:1,minWidth:0}}>
                                    <div className="type-pill-name">{tp.name}</div>
                                    {(tp.cost>0||hasInv)&&(
                                      <div style={{display:"flex",gap:7,alignItems:"center",marginTop:2,flexWrap:"wrap"}}>
                                        {tp.cost>0&&<span className="type-pill-meta">Cost: {fmt(tp.cost)}</span>}
                                        {mg!==null&&<span className="type-pill-meta" style={{color:parseFloat(mg)>=0?"var(--green)":"var(--red)",fontWeight:600}}>+{fmt(profit)} ({mg}%)</span>}
                                        {hasInv&&<span className="type-pill-meta" style={{color:low?"var(--red)":"var(--green)",fontWeight:600}}>📦 {totalStock}{low?" ⚠️":""}</span>}
                                      </div>
                                    )}
                                  </div>
                                  <div className="type-pill-price">{fmt(tp.price)}</div>
                                  <div className="type-pill-actions">
                                    <button className="btn bg2 bsm" style={{padding:"3px 7px"}} onClick={()=>setTypeModal({device:activeDev,part,type:tp})}><I n="edit" s={10}/></button>
                                    <button className="btn bd bsm" style={{padding:"3px 7px"}} onClick={()=>delType(activeDev.id,part.id,tp.id)}><I n="trash" s={10}/></button>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                      }
                    </div>
                  </div>
                );
              })}
            </div>
        }
        {devModal&&<DeviceModal device={typeof devModal==="object"?devModal:null} onSave={saveDev} onClose={()=>setDevModal(null)} t={t} catalog={catalog}/>}
        {partModal&&<PartForm partModal={partModal} catalog={catalog} invParts={parts} onSave={(devId,data)=>savePart(devId,data)} onLink={linkPartToDevices} onUnlink={unlinkPartFromDevice} onClose={()=>setPartModal(null)} t={t}/>}
        {typeModal&&<TypeForm typeModal={typeModal} onSave={saveType} onClose={()=>setTypeModal(null)} t={t} fmt={fmt} catalog={catalog} invParts={parts}/>}
      </div>
    );
  }

  // ── BRAND DRILL-DOWN VIEW ────────────────────────────────────────────
  if(brandView&&viewBrand){
    return(
      <div className="page">
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
          <button className="btn bg2 bsm" onClick={()=>backToList()}><I n="back" s={13}/></button>
          <div style={{flex:1}}>
            <div style={{fontWeight:800,fontSize:16}}>{viewBrand}</div>
            <div style={{fontSize:11,color:"var(--t3)"}}>{brandDevs.length} device{brandDevs.length!==1?"s":""}</div>
          </div>
          <button className="btn bp bsm" onClick={()=>setDevModal("add")}><I n="plus" s={12} c="#fff"/> Add</button>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:7}}>
          {(catSearch.trim()?brandDevs.filter(d=>{const q=catSearch.toLowerCase();return d.name.toLowerCase().includes(q)||(d.models||[]).some(m=>m.toLowerCase().includes(q));}) : brandDevs).map(dev=>{
            const partCount=(dev.parts||[]).length;
            const typeCount=(dev.parts||[]).reduce((s,p)=>s+(p.types||[]).length,0);
            const minPrice=Math.min(...(dev.parts||[]).flatMap(p=>(p.types||[]).map(tp=>tp.price)).filter(Boolean));
            const maxPrice=Math.max(...(dev.parts||[]).flatMap(p=>(p.types||[]).map(tp=>tp.price)).filter(Boolean));
            const hasPrice=isFinite(minPrice)&&minPrice>0;
            return(
              <div key={dev.id} className="cat-dev-row" onClick={()=>drillDevice(dev.id)}>
                <div style={{width:40,height:40,borderRadius:11,background:"rgba(10,132,255,0.1)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  {getBrandDisplay(dev.brand,dev.logoUrl,28)}
                </div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:700,fontSize:14,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{dev.name}</div>
                  <div style={{fontSize:11,color:"var(--t3)",marginTop:2,display:"flex",gap:7,flexWrap:"wrap"}}>
                    <span>{partCount} parts · {typeCount} types</span>
                    {hasPrice&&<span style={{color:"var(--green)",fontWeight:600}}>{fmt(minPrice)}{minPrice!==maxPrice&&` – ${fmt(maxPrice)}`}</span>}
                  </div>
                </div>
                <div style={{display:"flex",gap:5}} onClick={e=>e.stopPropagation()}>
                  <button className="btn bg2 bsm" style={{padding:"4px 8px"}} onClick={()=>setDevModal(dev)}><I n="edit" s={10}/></button>
                  <button className="btn bd bsm" style={{padding:"4px 8px"}} onClick={()=>delDev(dev.id)}><I n="trash" s={10}/></button>
                </div>
                <div style={{color:"var(--t3)",fontSize:16,flexShrink:0,pointerEvents:"none"}}>›</div>
              </div>
            );
          })}
        </div>
        {devModal&&<DeviceModal device={typeof devModal==="object"?devModal:null} defaultBrand={typeof devModal!=="object"?viewBrand:undefined} onSave={saveDev} onClose={()=>setDevModal(null)} t={t} catalog={catalog}/>}
      </div>
    );
  }

  // ── MAIN LIST VIEW ───────────────────────────────────────────────────
  return(
    <div className="page">
      <div className="ph">
        <div><div className="pt">{t.customParts}</div><div className="ps">{catalog.length} device{catalog.length!==1?"s":""}</div></div>
        <div style={{display:"flex",gap:7,alignItems:"center"}}>
          {cpTab==="devices"&&<button className="btn bp bsm" onClick={()=>setDevModal("add")}><I n="plus" s={12} c="#fff"/> Add</button>}
          <button className="btn bg2 bsm" onClick={toggleBrandView} style={{fontSize:11.5}}>
            {brandView?"📱 All":"🏷️ Brands"}
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="tabs" style={{marginBottom:12}}>
        <div className={`tab ${cpTab==="devices"?"on":""}`} onClick={()=>setCpTab("devices")}>📱 {brandView?"Brands":"Devices"}</div>
        <div className={`tab ${cpTab==="compat"?"on":""}`} onClick={()=>setCpTab("compat")}>🔗 Compatibility</div>
      </div>

      {cpTab==="compat"&&<CompatibilitySearch catalog={catalog} fmt={fmt} t={t} onNavigate={id=>{if(id)drillDevice(id);}} onUnlink={unlinkPartFromDevice}/>}

      {cpTab==="devices"&&(<>
        {/* Search */}
        <div style={{marginBottom:12}}>
          <div className="sbar"><I n="search" s={13} c="var(--t3)"/><input placeholder={viewBrand?`Search in ${viewBrand}…`:brandView?"Search brands or devices…":"Search devices, brands, models…"} value={catSearch} onChange={e=>handleCatSearch(e.target.value)}/></div>
        </div>

        {catalog.length===0
          ? <div className="empty"><div className="ei">📋</div><div className="et">{t.deviceCatalog}</div><div className="es">Add devices and their repair pricing</div></div>
          : brandView
            ? (()=>{
                const filtBrands=catSearch.trim()
                  ? brands.filter(b=>{const q=catSearch.toLowerCase();return b.toLowerCase().includes(q)||catalog.some(d=>(d.brand||"Other")===b&&(d.name.toLowerCase().includes(q)||(d.models||[]).some(m=>m.toLowerCase().includes(q))));})
                  : brands;
                return filtBrands.length===0
                  ? <div className="empty"><div className="ei">🔍</div><div className="et">No brands match</div></div>
                  : <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(110px,1fr))",gap:10}}>
                      {filtBrands.map(brand=>{
                        const devs=catalog.filter(d=>(d.brand||"Other")===brand);
                        const sampleDev=devs[0];
                        const BPAL=["#0A84FF","#30D158","#FF9F0A","#BF5AF2","#FF453A","#5AC8FA","#FFD60A","#FF6B00","#64D2FF","#34C759"];
                        const bc=BPAL[(brand.charCodeAt(0)||65)%BPAL.length];
                        return(
                          <div key={brand} className="cat-brand-card" onClick={()=>drillBrand(brand)}>
                            {/* Full-card logo area */}
                            <div className="cat-brand-banner" style={{background:`linear-gradient(145deg,${bc}22 0%,${bc}08 55%,rgba(0,0,0,0.18) 100%)`}}>
                              <div style={{position:"absolute",width:100,height:100,borderRadius:"50%",background:`${bc}0a`,top:-28,right:-28,pointerEvents:"none"}}/>
                              <div style={{position:"absolute",width:60,height:60,borderRadius:"50%",background:`${bc}12`,bottom:-18,left:-18,pointerEvents:"none"}}/>
                              <div style={{position:"absolute",width:30,height:30,borderRadius:"50%",background:`${bc}10`,top:10,left:12,pointerEvents:"none"}}/>
                              <div style={{position:"relative",width:58,height:58,borderRadius:18,background:`linear-gradient(145deg,${bc}28,${bc}10)`,border:`1.5px solid ${bc}38`,display:"flex",alignItems:"center",justifyContent:"center",boxShadow:`0 6px 22px ${bc}35,0 2px 6px rgba(0,0,0,0.4)`}}>
                                {getBrandDisplay(brand,sampleDev?.logoUrl,40)}
                              </div>
                            </div>
                            {/* Name only */}
                            <div className="cat-brand-body" style={{textAlign:"center",padding:"7px 8px 10px"}}>
                              <div style={{fontWeight:800,fontSize:12.5,letterSpacing:"-.02em",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",color:"var(--tx)"}}>{brand}</div>
                            </div>
                          </div>
                        );
                      })}
                    </div>;
              })()
            : catalogFiltered.length===0
              ? <div className="empty"><div className="ei">🔍</div><div className="et">No devices match "{catSearch}"</div><div className="es" style={{cursor:"pointer",color:"var(--blue)"}} onClick={()=>setDevModal("add")}>+ Add as new device</div></div>
              : <div style={{display:"flex",flexDirection:"column",gap:7}}>
                  {catalogFiltered.map(dev=>{
                    const partCount=(dev.parts||[]).length;
                    const typeCount=(dev.parts||[]).reduce((s,p)=>s+(p.types||[]).length,0);
                    const allPrices=(dev.parts||[]).flatMap(p=>(p.types||[]).map(tp=>tp.price)).filter(Boolean);
                    const minP=Math.min(...allPrices);
                    const maxP=Math.max(...allPrices);
                    const hasP=isFinite(minP)&&minP>0;
                    return(
                      <div key={dev.id} className="cat-dev-row" onClick={()=>drillDevice(dev.id)}>
                        <div style={{width:42,height:42,borderRadius:12,background:"rgba(10,132,255,0.1)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,border:"1px solid rgba(10,132,255,0.12)"}}>
                          {getBrandDisplay(dev.brand,dev.logoUrl,28)}
                        </div>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontWeight:700,fontSize:14,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{dev.name}</div>
                          <div style={{fontSize:11,color:"var(--t3)",marginTop:2,display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
                            {dev.brand&&<span>{dev.brand}</span>}
                            <span>{partCount} parts · {typeCount} types</span>
                            {hasP&&<span style={{color:"var(--green)",fontWeight:600}}>{fmt(minP)}{minP!==maxP&&` – ${fmt(maxP)}`}</span>}
                          </div>
                          {catSearch.trim()&&(dev.models||[]).some(m=>m.toLowerCase().includes(catSearch.toLowerCase()))&&(
                            <div style={{fontSize:10,color:"var(--teal)",marginTop:2}}>
                              Matches: {(dev.models||[]).filter(m=>m.toLowerCase().includes(catSearch.toLowerCase())).slice(0,3).join(" · ")}
                            </div>
                          )}
                        </div>
                        <div style={{display:"flex",gap:5,flexShrink:0}} onClick={e=>e.stopPropagation()}>
                          <button className="btn bg2 bsm" style={{padding:"4px 8px"}} onClick={()=>setDevModal(dev)}><I n="edit" s={10}/></button>
                          <button className="btn bd bsm" style={{padding:"4px 8px"}} onClick={()=>delDev(dev.id)}><I n="trash" s={10}/></button>
                        </div>
                        <div style={{color:"var(--t3)",fontSize:18,flexShrink:0,pointerEvents:"none"}}>›</div>
                      </div>
                    );
                  })}
                </div>
        }
        {devModal&&<DeviceModal device={typeof devModal==="object"?devModal:null} onSave={saveDev} onClose={()=>setDevModal(null)} t={t} catalog={catalog}/>}
      </>)}
    </div>
  );
}
function SimpleNameForm({initial,label,onSave,onCancel,t}){
  const [val,setVal]=useState(initial);
  return(<>
    <div className="fg" style={{marginBottom:16}}><label className="fl">{label}</label><input className="inp" value={val} onChange={e=>setVal(e.target.value)} autoFocus/></div>
    <div className="ma"><button className="btn bg2" onClick={onCancel}>{t.cancel}</button><button className="btn bp" onClick={()=>{if(!val.trim())return;onSave(val.trim());}}>{t.save}</button></div>
  </>);
}

// ─── PartForm: edit part name, repair-type link, and device linking ────────────
function PartForm({partModal,catalog,invParts,onSave,onLink,onUnlink,onClose,t}){
  const [name,setName]=useState(partModal.part?.name||"");
  const [repairTypeLink,setRepairTypeLink]=useState(partModal.part?.repairTypeLink||"");
  const [invLink,setInvLink]=useState(partModal.part?.invLink||[]);
  const [invSearch,setInvSearch]=useState("");
  const [invOpen,setInvOpen]=useState(false);
  const invRef=useRef();
  const [linkMode,setLinkMode]=useState(false);
  const [linkInput,setLinkInput]=useState("");
  const [linkDrop,setLinkDrop]=useState(false);
  const [toLink,setToLink]=useState([]);
  const [newDevs,setNewDevs]=useState([]);
  const linkRef=useRef();
  useEffect(()=>{
    function h(e){
      if(linkRef.current&&!linkRef.current.contains(e.target))setLinkDrop(false);
      if(invRef.current&&!invRef.current.contains(e.target))setInvOpen(false);
    }
    document.addEventListener("mousedown",h);return()=>document.removeEventListener("mousedown",h);
  },[]);

  const isLinked=!!partModal.part?.sharedPartId;
  const existingLinks=isLinked?getLinkedParts(catalog,partModal.part.sharedPartId).filter(x=>x.dev.id!==partModal.device.id):[];
  const otherDevs=(catalog||[]).filter(d=>d.id!==partModal.device.id);
  const unlinked=otherDevs.filter(d=>!existingLinks.some(l=>l.dev.id===d.id)&&!toLink.includes(d.name));
  const filtUnlinked=linkInput.trim()?unlinked.filter(d=>d.name.toLowerCase().includes(linkInput.toLowerCase())):unlinked;
  const showAddNew=linkInput.trim()&&!catalog.some(d=>d.name.toLowerCase()===linkInput.toLowerCase().trim())&&!newDevs.includes(linkInput.trim());

  function handleSave(){
    if(!name.trim())return;
    const data={...(partModal.part||{}),name:name.trim(),repairTypeLink:repairTypeLink.trim(),invLink};
    if((toLink.length>0||newDevs.length>0)&&onLink&&partModal.part){
      onSave(partModal.device.id,data);
      setTimeout(()=>onLink(partModal.device.id,partModal.part.id,toLink,newDevs),30);
    } else {
      onSave(partModal.device.id,data);
    }
  }

  return(
    <div className="mo">
      <div className="md" style={{maxWidth:460}} onClick={e=>e.stopPropagation()}>
        <div className="mh">
          <div className="mt2">{partModal.part?`${getPartIcon(partModal.part)} Edit Part`:"➕ Add Part"}</div>
          <span style={{cursor:"pointer"}} onClick={onClose}><I n="close" s={15} c="var(--t3)"/></span>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:13,marginBottom:16}}>
          <div className="fg"><label className="fl">Part Name</label>
            <input className="inp" value={name} onChange={e=>setName(e.target.value)} placeholder="e.g. Screen, Battery…" autoFocus/>
          </div>
          {/* Repair type link */}
          <div className="fg">
            <label className="fl">🔗 Link to Repair Type <span style={{fontWeight:400,color:"var(--t3)",fontSize:10.5}}>(auto-selects this part when that repair type is chosen)</span></label>
            <select className="inp" value={repairTypeLink} onChange={e=>setRepairTypeLink(e.target.value)}>
              <option value="">— No link —</option>
              {(typeof REPAIR_TYPES!=="undefined"?REPAIR_TYPES:[]).map(rt=><option key={rt} value={rt}>{rt}</option>)}
            </select>
            {repairTypeLink&&<div style={{fontSize:10.5,color:"var(--blue)",marginTop:3}}>When a repair of type "{repairTypeLink}" is opened, this part will be auto-suggested in the catalog tab.</div>}
          </div>
          {/* Inventory link */}
          <div style={{background:"rgba(48,209,88,0.05)",border:"1px solid rgba(48,209,88,0.18)",borderRadius:10,padding:"12px 14px"}}>
            <div style={{fontSize:12.5,fontWeight:600,color:"var(--green)",marginBottom:8}}>📦 Link to Inventory</div>
            {invLink.length>0&&(
              <div style={{display:"flex",flexWrap:"wrap",gap:4,marginBottom:8}}>
                {invLink.map(id=>{
                  const ip=(invParts||[]).find(p=>p.id===id);
                  if(!ip) return null;
                  const low=ip.stock<=3;
                  return(
                    <span key={id} style={{display:"flex",alignItems:"center",gap:5,padding:"3px 10px",background:low?"rgba(255,69,58,0.1)":"rgba(48,209,88,0.1)",border:`1px solid ${low?"rgba(255,69,58,0.25)":"rgba(48,209,88,0.25)"}`,borderRadius:12,fontSize:11.5,fontWeight:600,color:low?"var(--red)":"var(--green)"}}>
                      📦 {ip.name} <span style={{opacity:.7}}>({ip.stock} left)</span>
                      <span style={{cursor:"pointer",color:"var(--t3)",marginLeft:2,fontWeight:400}} onClick={()=>setInvLink(l=>l.filter(x=>x!==id))}>×</span>
                    </span>
                  );
                })}
              </div>
            )}
            <div ref={invRef} style={{position:"relative"}}>
              <div className="inp" style={{display:"flex",alignItems:"center",gap:6,padding:"7px 11px"}}>
                <I n="search" s={12} c="var(--t3)"/>
                <input style={{background:"transparent",border:"none",outline:"none",color:"var(--tx)",fontSize:12.5,flex:1}}
                  value={invSearch} onChange={e=>{setInvSearch(e.target.value);setInvOpen(true);}}
                  onFocus={()=>setInvOpen(true)} placeholder="Search inventory…"/>
              </div>
              {invOpen&&(()=>{
                const q=invSearch.toLowerCase();
                const opts=(invParts||[]).filter(ip=>!invLink.includes(ip.id)&&(!q||ip.name.toLowerCase().includes(q)||ip.brand.toLowerCase().includes(q)));
                if(!opts.length) return null;
                return(
                  <div style={{position:"absolute",top:"calc(100% + 2px)",left:0,right:0,background:"var(--bg2)",border:"1px solid var(--glb)",borderRadius:10,zIndex:95,maxHeight:180,overflowY:"auto",boxShadow:"0 8px 24px rgba(0,0,0,0.6)"}}>
                    {opts.map(ip=>{
                      const low=ip.stock<=3;
                      return(
                        <div key={ip.id} onMouseDown={()=>{setInvLink(l=>[...l,ip.id]);setInvSearch("");setInvOpen(false);}}
                          style={{padding:"8px 12px",cursor:"pointer",fontSize:12.5,display:"flex",alignItems:"center",gap:8}}
                          onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.06)"}
                          onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                          <span style={{flex:1}}>{ip.name}</span>
                          <span style={{fontSize:11,color:"var(--t3)"}}>{ip.brand}</span>
                          <span style={{fontSize:11,fontWeight:600,color:low?"var(--red)":"var(--green)",minWidth:50,textAlign:"right"}}>📦 {ip.stock}{low?" ⚠️":""}</span>
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
            </div>
            <div style={{fontSize:10.5,color:"var(--t3)",marginTop:5}}>Link to show live stock counts on this part's card. Multiple items can be linked (e.g. different grades of the same screen).</div>
          </div>

          {/* Device linking */}
          {partModal.part&&(
            <div style={{background:"rgba(90,200,250,0.05)",border:"1px solid rgba(90,200,250,0.18)",borderRadius:10,padding:"12px 14px"}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:existingLinks.length>0||linkMode?8:0}}>
                <div style={{fontSize:12.5,fontWeight:600,color:"var(--teal)"}}>📱 Link to other devices</div>
                {!linkMode&&!isLinked&&<button className="btn bg2 bsm" onClick={()=>setLinkMode(true)}>+ Link</button>}
                {isLinked&&!linkMode&&<button className="btn bg2 bsm" onClick={()=>setLinkMode(true)}>+ More</button>}
              </div>
              {existingLinks.length>0&&(
                <div style={{marginBottom:8}}>
                  <div style={{fontSize:11,color:"var(--t3)",marginBottom:4}}>Already linked — price &amp; types sync automatically:</div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:4}}>
                    {existingLinks.map(({dev})=>(
                      <span key={dev.id} style={{display:"flex",alignItems:"center",gap:4,padding:"2px 9px",background:"rgba(90,200,250,0.08)",border:"1px solid rgba(90,200,250,0.2)",borderRadius:12,fontSize:11.5,color:"var(--teal)",fontWeight:600}}>
                        📱 {dev.name}
                        {onUnlink&&<span title="Unlink this device" style={{cursor:"pointer",color:"var(--red)",marginLeft:2,fontWeight:700,fontSize:13,lineHeight:1}} onClick={e=>{e.stopPropagation();onUnlink(dev.id,partModal.part.sharedPartId);}}>×</span>}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              {linkMode&&(
                <div ref={linkRef}>
                  {(toLink.length>0||newDevs.length>0)&&(
                    <div style={{display:"flex",flexWrap:"wrap",gap:4,marginBottom:7}}>
                      {toLink.map(n=>(
                        <span key={n} style={{display:"flex",alignItems:"center",gap:3,padding:"2px 9px",background:"rgba(48,209,88,0.1)",border:"1px solid rgba(48,209,88,0.2)",borderRadius:12,fontSize:11.5,fontWeight:600}}>
                          📱 {n}<span style={{cursor:"pointer",color:"var(--t3)",marginLeft:2}} onClick={()=>setToLink(p=>p.filter(x=>x!==n))}>×</span>
                        </span>
                      ))}
                      {newDevs.map(n=>(
                        <span key={n} style={{display:"flex",alignItems:"center",gap:3,padding:"2px 9px",background:"rgba(255,159,10,0.1)",border:"1px solid rgba(255,159,10,0.2)",borderRadius:12,fontSize:11.5,fontWeight:600}}>
                          ✨ {n}<span style={{cursor:"pointer",color:"var(--t3)",marginLeft:2}} onClick={()=>setNewDevs(p=>p.filter(x=>x!==n))}>×</span>
                        </span>
                      ))}
                    </div>
                  )}
                  <div style={{position:"relative"}}>
                    <div className="inp" style={{display:"flex",alignItems:"center",gap:6,padding:"7px 11px"}}>
                      <I n="search" s={12} c="var(--t3)"/>
                      <input style={{background:"transparent",border:"none",outline:"none",color:"var(--tx)",fontSize:12.5,flex:1}} value={linkInput}
                        onChange={e=>{setLinkInput(e.target.value);setLinkDrop(true);}} onFocus={()=>setLinkDrop(true)}
                        placeholder="Search device…"/>
                    </div>
                    {linkDrop&&(filtUnlinked.length>0||showAddNew)&&(
                      <div style={{position:"absolute",top:"calc(100% + 2px)",left:0,right:0,background:"var(--bg2)",border:"1px solid var(--glb)",borderRadius:10,zIndex:90,maxHeight:180,overflowY:"auto",boxShadow:"0 8px 24px rgba(0,0,0,0.6)"}}>
                        {filtUnlinked.map(d=>(
                          <div key={d.id} onMouseDown={()=>{setToLink(p=>[...p,d.name]);setLinkInput("");setLinkDrop(false);}}
                            style={{padding:"8px 12px",cursor:"pointer",fontSize:12.5,display:"flex",alignItems:"center",gap:8}}
                            onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.06)"}
                            onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                            {getBrandDisplay(d.brand,d.logoUrl,18)} {d.name} {d.brand&&<span style={{color:"var(--t3)",fontSize:10.5}}>({d.brand})</span>}
                          </div>
                        ))}
                        {showAddNew&&(
                          <div onMouseDown={()=>{setNewDevs(p=>[...p,linkInput.trim()]);setLinkInput("");setLinkDrop(false);}}
                            style={{padding:"8px 12px",cursor:"pointer",fontSize:12.5,color:"var(--orange)",fontWeight:600,borderTop:filtUnlinked.length>0?"1px solid var(--glb)":"none"}}
                            onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.06)"}
                            onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                            ✨ Create &amp; link "{linkInput.trim()}" as new device
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div style={{fontSize:10.5,color:"var(--t3)",marginTop:4}}>Linking copies all types of this part to the other device and keeps prices in sync.</div>
                </div>
              )}
              {existingLinks.length===0&&!linkMode&&(
                <div style={{fontSize:11.5,color:"var(--t3)"}}>Link this part to other devices — they'll share all types and sync prices automatically.</div>
              )}
            </div>
          )}
        </div>
        <div className="ma">
          <button className="btn bg2" onClick={onClose}>{t.cancel}</button>
          <button className="btn bp" onClick={handleSave}>
            {t.save}{(toLink.length+newDevs.length)>0?` & Link ${toLink.length+newDevs.length} device${toLink.length+newDevs.length>1?"s":""}`:""}</button>
        </div>
      </div>
    </div>
  );
}

// ─── TypeForm: edit type price/cost/name ─────────────────────────────────────
function TypeForm({typeModal,onSave,onClose,t,fmt,catalog,invParts}){
  const [name,setName]=useState(typeModal.type?.name||"");
  const [price,setPrice]=useState(typeModal.type?.price||"");
  const [cost,setCost]=useState(typeModal.type?.cost||"");
  const [invLink,setInvLink]=useState(typeModal.type?.invLink||[]);
  const [invSearch,setInvSearch]=useState("");
  const [invOpen,setInvOpen]=useState(false);
  const invRef=useRef();
  useEffect(()=>{
    function h(e){if(invRef.current&&!invRef.current.contains(e.target))setInvOpen(false);}
    document.addEventListener("mousedown",h);return()=>document.removeEventListener("mousedown",h);
  },[]);
  const margin=price&&cost?((parseFloat(price)-parseFloat(cost))/parseFloat(price)*100).toFixed(0):null;
  const srcPart=catalog?.find(d=>d.id===typeModal.device.id)?.parts?.find(p=>p.id===typeModal.part.id);
  const isPartLinked=!!srcPart?.sharedPartId;
  // inherited from part if type has no own invLink
  const partInvLink=srcPart?.invLink||[];

  return(
    <div className="mo">
      <div className="md" style={{maxWidth:440}} onClick={e=>e.stopPropagation()}>
        <div className="mh">
          <div className="mt2">{typeModal.type?"Edit":"Add"} {getPartIcon(typeModal.part)} {typeModal.part.name}{isPartLinked&&<span style={{fontSize:10,marginLeft:8,background:"rgba(90,200,250,0.12)",color:"var(--teal)",padding:"2px 7px",borderRadius:10}}>🔗 syncs to all linked devices</span>}</div>
          <span style={{cursor:"pointer"}} onClick={onClose}><I n="close" s={15} c="var(--t3)"/></span>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:12,marginBottom:16}}>
          <div className="fg"><label className="fl">{t.partType}</label><input className="inp" value={name} onChange={e=>setName(e.target.value)} placeholder="In-Cell, Change Glass, Soft OLED…" autoFocus/></div>
          <div className="fg"><label className="fl">{t.partPrice} (Sale)</label><input className="inp" type="number" step={priceStep()} value={price} onChange={e=>setPrice(e.target.value)} placeholder="0"/></div>
          <div className="fg"><label className="fl">{t.costPrice}</label><input className="inp" type="number" step={priceStep()} value={cost} onChange={e=>setCost(e.target.value)} placeholder="0"/></div>
          {margin!==null&&(
            <div style={{display:"flex",gap:12,padding:"9px 13px",background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:9,fontSize:12}}>
              <span style={{color:"var(--t3)"}}>{t.margin}:</span>
              <span style={{fontWeight:700,color:parseFloat(margin)>=0?"var(--green)":"var(--red)"}}>{margin}%</span>
              <span style={{color:"var(--t3)",marginLeft:4}}>Profit:</span>
              <span style={{fontWeight:700,color:parseFloat(price)-parseFloat(cost)>=0?"var(--green)":"var(--red)"}}>{fmt((parseFloat(price)||0)-(parseFloat(cost)||0))}</span>
            </div>
          )}
          {isPartLinked&&(
            <div style={{fontSize:11,color:"var(--teal)",padding:"7px 11px",background:"rgba(90,200,250,0.06)",borderRadius:8}}>
              ℹ️ Saving will sync this type's name and price across all linked devices.
            </div>
          )}
          {/* Per-type inventory link */}
          <div style={{background:"rgba(48,209,88,0.05)",border:"1px solid rgba(48,209,88,0.18)",borderRadius:10,padding:"12px 14px"}}>
            <div style={{fontSize:12.5,fontWeight:600,color:"var(--green)",marginBottom:4}}>📦 Inventory Link <span style={{fontWeight:400,fontSize:10.5,color:"var(--t3)"}}>(overrides part-level link for this type)</span></div>
            {partInvLink.length>0&&invLink.length===0&&<div style={{fontSize:11,color:"var(--t3)",marginBottom:6}}>Inheriting {partInvLink.length} item{partInvLink.length>1?"s":""} from part — set below to override for this specific type.</div>}
            {invLink.length>0&&(
              <div style={{display:"flex",flexWrap:"wrap",gap:4,marginBottom:8}}>
                {invLink.map(id=>{
                  const ip=(invParts||[]).find(p=>p.id===id);
                  if(!ip) return null;
                  const low=ip.stock<=3;
                  return(
                    <span key={id} style={{display:"flex",alignItems:"center",gap:5,padding:"3px 10px",background:low?"rgba(255,69,58,0.1)":"rgba(48,209,88,0.1)",border:`1px solid ${low?"rgba(255,69,58,0.25)":"rgba(48,209,88,0.25)"}`,borderRadius:12,fontSize:11.5,fontWeight:600,color:low?"var(--red)":"var(--green)"}}>
                      📦 {ip.name} <span style={{opacity:.7}}>({ip.stock} left)</span>
                      <span style={{cursor:"pointer",color:"var(--t3)",marginLeft:2,fontWeight:400}} onClick={()=>setInvLink(l=>l.filter(x=>x!==id))}>×</span>
                    </span>
                  );
                })}
              </div>
            )}
            <div ref={invRef} style={{position:"relative"}}>
              <div className="inp" style={{display:"flex",alignItems:"center",gap:6,padding:"7px 11px"}}>
                <I n="search" s={12} c="var(--t3)"/>
                <input style={{background:"transparent",border:"none",outline:"none",color:"var(--tx)",fontSize:12.5,flex:1}}
                  value={invSearch} onChange={e=>{setInvSearch(e.target.value);setInvOpen(true);}}
                  onFocus={()=>setInvOpen(true)} placeholder="Search inventory to link…"/>
              </div>
              {invOpen&&(()=>{
                const q=invSearch.toLowerCase();
                const opts=(invParts||[]).filter(ip=>!invLink.includes(ip.id)&&(!q||ip.name.toLowerCase().includes(q)||ip.brand.toLowerCase().includes(q)));
                if(!opts.length) return null;
                return(
                  <div style={{position:"absolute",top:"calc(100% + 2px)",left:0,right:0,background:"var(--bg2)",border:"1px solid var(--glb)",borderRadius:10,zIndex:95,maxHeight:160,overflowY:"auto",boxShadow:"0 8px 24px rgba(0,0,0,0.6)"}}>
                    {opts.map(ip=>{
                      const low=ip.stock<=3;
                      return(
                        <div key={ip.id} onMouseDown={()=>{setInvLink(l=>[...l,ip.id]);setInvSearch("");setInvOpen(false);}}
                          style={{padding:"8px 12px",cursor:"pointer",fontSize:12.5,display:"flex",alignItems:"center",gap:8}}
                          onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.06)"}
                          onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                          <span style={{flex:1}}>{ip.name}</span>
                          <span style={{fontSize:11,color:"var(--t3)"}}>{ip.brand}</span>
                          <span style={{fontSize:11,fontWeight:600,color:low?"var(--red)":"var(--green)",minWidth:50,textAlign:"right"}}>📦 {ip.stock}{low?" ⚠️":""}</span>
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
            </div>
          </div>
        </div>
        <div className="ma">
          <button className="btn bg2" onClick={onClose}>{t.cancel}</button>
          <button className="btn bp" onClick={()=>{if(!name.trim())return;onSave(typeModal.device.id,typeModal.part.id,{...(typeModal.type||{}),name:name.trim(),price:parseFloat(price)||0,cost:parseFloat(cost)||0,invLink});}}>{t.save}</button>
        </div>
      </div>
    </div>
  );
}
// ─── INVENTORY ────────────────────────────────────────────────────────────────
// Reliable touch filter chip row
function FilterChipRow({label,items,active,onSelect,useValue=false}){
  return(
    <div style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
      <span style={{fontSize:10.5,color:"var(--t3)",fontWeight:600,flexShrink:0}}>{label}:</span>
      {items.map(item=>{
        const val=useValue?(item.value??item):item;
        const lbl=useValue?(item.label??item):item;
        const isOn=active===val;
        return(
          <button key={val}
            style={{display:"inline-flex",alignItems:"center",padding:"5px 13px",borderRadius:20,
              fontSize:12,fontWeight:600,cursor:"pointer",border:"none",
              touchAction:"manipulation",WebkitTapHighlightColor:"transparent",
              transition:"background .12s,color .12s,border-color .12s",
              background:isOn?"rgba(10,132,255,0.18)":"var(--gl)",
              color:isOn?"var(--blue)":"var(--t2)",
              outline:isOn?"1px solid rgba(10,132,255,0.4)":"1px solid var(--glb)"}}
            onPointerDown={e=>{e.preventDefault();onSelect(val);}}>
            {lbl}
          </button>
        );
      })}
    </div>
  );
}
function PartsPage({t,fmt,parts,saveParts,catalog,readOnly}){
  const [modal,setModal]=useState(null);
  const [search,setSearch]=useState("");
  const [fCat,setFCat]=useState("All");
  const [fBrand,setFBrand]=useState("All");
  const [fDevice,setFDevice]=useState("All");
  const [fStock,setFStock]=useState("all"); // all | low | out | tracked
  const [sortBy,setSortBy]=useState("name"); // name | stock | cost | margin

  const cats=["All",...Array.from(new Set(parts.map(p=>p.category).filter(Boolean)))];
  // Use system brands (from Assets & Brands settings) plus any brands already on parts
  const sysBrandNames=getActiveBrands().map(b=>b.name);
  const partBrandNames=parts.map(p=>p.brand).filter(Boolean);
  const allBrandNames=Array.from(new Set([...sysBrandNames,...partBrandNames])).sort();
  const brands=["All",...allBrandNames];
  // Devices: parts may have a linkedDevices[] array (from catalog linking)
  const allDeviceNames=["All",...Array.from(new Set(
    parts.flatMap(p=>p.linkedDevices||[]).filter(Boolean)
  )).sort()];

  const tv=parts.reduce((s,p)=>s+p.stock*p.cost,0);
  const outCount=parts.filter(p=>p.stock===0).length;
  const lowCount=parts.filter(p=>{
    const thr=p.lowStockThreshold!=null?p.lowStockThreshold:3;
    return thr>0&&p.stock>0&&p.stock<=thr; // exclude out-of-stock (counted separately)
  }).length;

  function getThreshold(p){return p.lowStockThreshold!=null?p.lowStockThreshold:3;}
  function isLow(p){const t=getThreshold(p);return t>0&&p.stock>0&&p.stock<=t;} // never includes stock===0
  function isOut(p){return p.stock===0;}

  const filtered=parts.filter(p=>{
    const q=search.toLowerCase();
    const pBrand=(p.brand||"").toLowerCase();
    const pCat=p.category||"";
    const matchQ=!q||p.name.toLowerCase().includes(q)||pBrand.includes(q)||(p.sku||"").toLowerCase().includes(q);
    const matchCat=fCat==="All"||pCat===fCat;
    const matchBrand=fBrand==="All"||(p.brand||"")===fBrand;
    const matchDev=fDevice==="All"||(p.linkedDevices||[]).includes(fDevice);
    const matchStock=fStock==="all"||(fStock==="low"&&isLow(p))||(fStock==="out"&&isOut(p))||(fStock==="tracked"&&getThreshold(p)>0);
    return matchQ&&matchCat&&matchBrand&&matchDev&&matchStock;
  }).sort((a,b)=>{
    if(sortBy==="stock") return a.stock-b.stock;
    if(sortBy==="cost") return (b.cost||0)-(a.cost||0);
    if(sortBy==="margin"){const ma=a.price>0?((a.price-a.cost)/a.price):0;const mb=b.price>0?((b.price-b.cost)/b.price):0;return mb-ma;}
    return (a.name||"").localeCompare(b.name||"");
  });

  function checkAndNotifyLowStock(part,newStock){
    const thr=getThreshold(part);
    if(thr>0&&newStock<=thr&&newStock>=0){
      notifyTechnicians("low_stock",{part:part.name,brand:part.brand||"",qty:String(newStock),threshold:String(thr),shop:SDB.get("shop_name")||"RepairOS"});
    }
  }
  function adj(id,delta){
    const updated=parts.map(p=>{
      if(p.id!==id)return p;
      const ns=Math.max(0,p.stock+delta);
      if(delta<0)checkAndNotifyLowStock(p,ns);
      // Auto-delete if flag set and stock hits 0
      if(ns===0&&p.autoDelete)return null;
      return{...p,stock:ns};
    }).filter(Boolean);
    saveParts(updated);
  }
  function handleSave(data){
    if(modal==="add"){
      const np={...data,id:SDB.nextId()};
      saveParts([...parts,np]);
      if((data.stock||0)<=getThreshold(data))checkAndNotifyLowStock(data,data.stock||0);
      toast("📦",t.added,data.name);
    }else{
      saveParts(parts.map(p=>p.id===modal.id?{...p,...data}:p));
      if((data.stock||0)<=getThreshold(data))checkAndNotifyLowStock(data,data.stock||0);
      toast("✏️",t.updated,data.name);
    }
    setModal(null);
  }

  const hasFilters=fCat!=="All"||fBrand!=="All"||fDevice!=="All"||fStock!=="all"||search;

  return(
    <div className="page">
      {readOnly&&<ReadOnlyBanner/>}
      <div className="ph">
        <div><div className="pt">{t.parts}</div><div className="ps">Inventory value: {fmt(tv)}</div></div>
        {!readOnly&&<button className="btn bp" onClick={()=>setModal("add")}><I n="plus" s={13} c="#fff"/> {t.add}</button>}
      </div>

      {/* Stats row */}
      <div className="sg4">
        <SC icon="📦" label="Total SKUs" value={parts.length} color="var(--blue)"/>
        <SC icon="⚠️" label={t.lowStock} value={lowCount} color="var(--orange)" onClick={()=>setFStock(fStock==="low"?"all":"low")}/>
        <SC icon="🚫" label="Out of stock" value={outCount} color="var(--red)" onClick={()=>setFStock(fStock==="out"?"all":"out")}/>
        <SC icon="💵" label="Total value" value={fmt(tv)} color="var(--green)"/>
      </div>

      {/* Filter bar */}
      <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:12}}>
        <div style={{display:"flex",gap:7,flexWrap:"wrap",alignItems:"center"}}>
          <div className="sbar" style={{flex:1,minWidth:180,maxWidth:320}}>
            <I n="search" s={13} c="var(--t3)"/>
            <input placeholder="Search name, brand, SKU…" value={search} onChange={e=>setSearch(e.target.value)}/>
          </div>
          <select className="inp" style={{width:"auto",fontSize:12}} value={sortBy} onChange={e=>setSortBy(e.target.value)}>
            <option value="name">Sort: Name</option>
            <option value="stock">Sort: Stock ↑</option>
            <option value="cost">Sort: Cost ↓</option>
            <option value="margin">Sort: Margin ↓</option>
          </select>
          {hasFilters&&<button className="btn bg2 bsm" onClick={()=>{setFCat("All");setFBrand("All");setFDevice("All");setFStock("all");setSearch("");}}>✕ Clear</button>}
        </div>
        {/* Filter rows — using FilterRow helper for reliable mobile touch */}
        {cats.length>1&&<FilterChipRow label="Category" items={cats} active={fCat} onSelect={v=>setFCat(v)}/>}
        <FilterChipRow label="Brand" items={brands} active={fBrand} onSelect={v=>setFBrand(v)}/>
        {allDeviceNames.length>1&&<FilterChipRow label="Device" items={allDeviceNames} active={fDevice} onSelect={v=>setFDevice(v)}/>}
        <FilterChipRow label="Stock" items={[["all","All"],["low","⚠️ Low"],["out","🚫 Out"],["tracked","📊 Tracked"]].map(([v,l])=>({value:v,label:l}))} active={fStock} onSelect={v=>setFStock(v)} useValue/>
      </div>

      <div className="card">
        {filtered.length===0
          ? <div className="empty"><div className="ei">📦</div><div className="et">No parts match filters</div></div>
          : <div className="tw"><table>
          <thead><tr>
            <th>Name</th><th>Brand</th><th>Category</th>
            <th>Stock</th><th>Cost</th><th>Price</th><th>Margin</th><th>Threshold</th><th></th>
          </tr></thead>
          <tbody>{filtered.map(p=>{
            const mg=p.price>0?((p.price-p.cost)/p.price*100).toFixed(0):0;
            const low=isLow(p); const out=isOut(p);
            const thr=getThreshold(p);
            return(
              <tr key={p.id} style={{opacity:out?0.65:1}}>
                <td>
                  <div style={{fontWeight:500}}>{p.name}</div>
                  {p.sku&&<div style={{fontSize:10,color:"var(--t3)",fontFamily:"monospace"}}>SKU: {p.sku}</div>}
                  {p.autoDelete&&<span style={{fontSize:9,background:"rgba(255,69,58,0.1)",color:"var(--red)",padding:"1px 5px",borderRadius:4,fontWeight:700}}>🗑️ auto-delete</span>}
                  {(p.linkedDevices||[]).length>0&&<div style={{fontSize:10,color:"var(--blue)",marginTop:1}}>{(p.linkedDevices||[]).slice(0,2).join(", ")}{(p.linkedDevices||[]).length>2&&` +${(p.linkedDevices||[]).length-2}`}</div>}
                </td>
                <td style={{color:"var(--t3)",fontSize:12}}>{p.brand}</td>
                <td><span className="cat-pill" style={{background:"rgba(90,200,250,0.1)",color:"var(--teal)",fontSize:11}}>{p.category}</span></td>
                <td>
                  <div style={{display:"flex",alignItems:"center",gap:4}}>
                    {!readOnly&&<button onClick={()=>adj(p.id,-1)} style={{background:"rgba(255,255,255,0.07)",border:"none",color:"#fff",width:20,height:20,borderRadius:5,cursor:"pointer",fontSize:13,display:"flex",alignItems:"center",justifyContent:"center"}}>−</button>}
                    <span style={{fontWeight:700,minWidth:22,textAlign:"center",fontSize:13,color:out?"var(--red)":low?"var(--orange)":"var(--tx)"}}>{p.stock}</span>
                    {!readOnly&&<button onClick={()=>adj(p.id,+1)} style={{background:"rgba(255,255,255,0.07)",border:"none",color:"#fff",width:20,height:20,borderRadius:5,cursor:"pointer",fontSize:13,display:"flex",alignItems:"center",justifyContent:"center"}}>+</button>}
                    {out&&<span title="Out of stock">🚫</span>}
                    {low&&!out&&<span title={`Low (≤${thr})`}>⚠️</span>}
                  </div>
                </td>
                <td style={{fontSize:12}}>{fmt(p.cost)}</td>
                <td style={{fontWeight:600,fontSize:12}}>{fmt(p.price)}</td>
                <td style={{color:mg>50?"var(--green)":"var(--orange)",fontSize:12}}>{mg}%</td>
                <td style={{fontSize:11,color:"var(--t3)"}}>
                  {thr===0?<span style={{color:"var(--t3)"}}>—</span>:<span style={{color:low?"var(--orange)":"var(--t3)"}}>≤{thr}</span>}
                </td>
                <td>
                  <div style={{display:"flex",gap:4}}>
                    {!readOnly&&<button className="btn bg2 bsm" onClick={()=>setModal(p)}><I n="edit" s={11}/></button>}
                    {!readOnly&&<button className="btn bd bsm" onClick={()=>{saveParts(parts.filter(x=>x.id!==p.id));toast("🗑️",t.removed,p.name);}}><I n="trash" s={11}/></button>}
                  </div>
                </td>
              </tr>
            );
          })}</tbody>
        </table></div>
        }
      </div>
      {filtered.length>0&&<div style={{fontSize:11,color:"var(--t3)",marginTop:6,textAlign:"right"}}>{filtered.length} of {parts.length} parts · {fmt(filtered.reduce((s,p)=>s+p.stock*p.cost,0))} filtered value</div>}
      {modal&&<PartModal part={modal==="add"?null:modal} brands={allBrandNames} catalog={catalog||[]} onClose={()=>setModal(null)} onSave={handleSave} t={t}/>}
    </div>
  );
}

function PartModal({part,onClose,onSave,brands,catalog,t}){
  const PART_CATS=["Display","Battery","Charging","Camera","Audio","Button","Housing","Cable","Adhesive","Tool","Other"];
  const[f,setF]=useState(part||{name:"",brand:"",sku:"",category:"Display",stock:0,cost:0,price:0,lowStockThreshold:3,autoDelete:false,linkedDevices:[]});
  const s=(k,v)=>setF(x=>({...x,[k]:v}));
  const [brandDrop,setBrandDrop]=useState(false);const brandRef=useRef();
  const devNames=(catalog||[]).map(d=>d.name).sort();
  const [devInput,setDevInput]=useState("");const [devDrop,setDevDrop]=useState(false);const devRef=useRef();

  useEffect(()=>{
    const h=(e)=>{
      if(brandRef.current&&!brandRef.current.contains(e.target))setBrandDrop(false);
      if(devRef.current&&!devRef.current.contains(e.target))setDevDrop(false);
    };
    document.addEventListener("mousedown",h);return()=>document.removeEventListener("mousedown",h);
  },[]);

  const filteredBrands=brands.filter(b=>!f.brand||b.toLowerCase().includes(f.brand.toLowerCase()));
  const filtDevs=devNames.filter(n=>!devInput||n.toLowerCase().includes(devInput.toLowerCase()));
  function addDevice(name){if(!name)return;if(!(f.linkedDevices||[]).includes(name))s("linkedDevices",[...(f.linkedDevices||[]),name]);setDevInput("");setDevDrop(false);}
  function removeDevice(name){s("linkedDevices",(f.linkedDevices||[]).filter(d=>d!==name));}

  return(
    <div className="mo">
      <div className="md md-w" onClick={e=>e.stopPropagation()}>
        <div className="mh"><div className="mt2">{part?"✏️ Edit Part":"📦 Add Part"}</div><span style={{cursor:"pointer"}} onClick={onClose}><I n="close" s={15} c="var(--t3)"/></span></div>
        <div style={{display:"flex",flexDirection:"column",gap:11}}>
          {/* Row 1: name + SKU */}
          <div className="fg2">
            <div className="fg" style={{flex:2}}><label className="fl">Part Name</label><input className="inp" value={f.name} onChange={e=>s("name",e.target.value)} placeholder="e.g. iPhone 14 Screen OLED"/></div>
            <div className="fg"><label className="fl">SKU / Code</label><input className="inp" value={f.sku||""} onChange={e=>s("sku",e.target.value)} placeholder="optional" style={{fontFamily:"monospace"}}/></div>
          </div>
          {/* Row 2: brand combobox + category */}
          <div className="fg2">
            <div className="fg" ref={brandRef} style={{position:"relative"}}>
              <label className="fl">Brand</label>
              <div style={{position:"relative"}}>
                <input className="inp" value={f.brand} onChange={e=>{s("brand",e.target.value);setBrandDrop(true);}} onFocus={()=>setBrandDrop(true)} placeholder="Apple, Samsung…" style={{paddingRight:26}}/>
                <span style={{position:"absolute",right:9,top:"50%",transform:"translateY(-50%)",color:"var(--t3)",fontSize:11,pointerEvents:"none"}}>▾</span>
              </div>
              {brandDrop&&filteredBrands.length>0&&(
                <div style={{position:"absolute",top:"calc(100% + 3px)",left:0,right:0,background:"var(--bg2)",border:"1px solid var(--glb)",borderRadius:9,zIndex:70,maxHeight:160,overflowY:"auto",boxShadow:"0 8px 24px rgba(0,0,0,0.5)"}}>
                  {filteredBrands.map(b=><div key={b} onMouseDown={e=>{e.preventDefault();s("brand",b);setBrandDrop(false);}} style={{padding:"8px 12px",cursor:"pointer",fontSize:12.5,color:"var(--tx)"}} onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.06)"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>{b}</div>)}
                </div>
              )}
            </div>
            <div className="fg"><label className="fl">Category</label>
              <select className="inp" value={f.category} onChange={e=>s("category",e.target.value)}>
                {PART_CATS.map(c=><option key={c}>{c}</option>)}
              </select>
            </div>
          </div>
          {/* Row 3: pricing */}
          <div className="fg3">
            <div className="fg"><label className="fl">Stock Qty</label><input className="inp" type="number" min="0" value={f.stock} onChange={e=>s("stock",+e.target.value)}/></div>
            <div className="fg"><label className="fl">Cost Price</label><input className="inp" type="number" min="0" step={priceStep()} value={f.cost} onChange={e=>s("cost",+e.target.value)}/></div>
            <div className="fg"><label className="fl">Sell Price</label><input className="inp" type="number" min="0" step={priceStep()} value={f.price} onChange={e=>s("price",+e.target.value)}/></div>
          </div>
          {f.cost>0&&f.price>0&&<div style={{fontSize:11,color:"var(--green)",marginTop:-6}}>📈 Margin: {((f.price-f.cost)/f.price*100).toFixed(0)}% · Profit per unit: {(f.price-f.cost).toLocaleString()}</div>}
          {/* Row 4: low stock control */}
          <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:9,padding:"11px 13px"}}>
            <div style={{fontSize:11,fontWeight:700,color:"var(--t2)",marginBottom:9}}>📊 Stock Alerts</div>
            <div className="fg2">
              <div className="fg">
                <label className="fl">Low stock threshold <span style={{fontWeight:400,color:"var(--t3)"}}>(0 = no alert)</span></label>
                <input className="inp" type="number" min="0" max="99" value={f.lowStockThreshold!=null?f.lowStockThreshold:3} onChange={e=>s("lowStockThreshold",+e.target.value)}/>
                <div style={{fontSize:10,color:"var(--t3)",marginTop:3}}>Send alert to technicians when stock ≤ this value.</div>
              </div>
              <div className="fg" style={{display:"flex",flexDirection:"column",justifyContent:"center",gap:8}}>
                <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer"}}>
                  <div className="tog" style={{transform:"scale(0.85)",transformOrigin:"left",flexShrink:0}}>
                    <input type="checkbox" checked={!!f.autoDelete} onChange={e=>s("autoDelete",e.target.checked)}/>
                    <span className="ts"/>
                  </div>
                  <div>
                    <div style={{fontSize:12,fontWeight:600,color:f.autoDelete?"var(--red)":"var(--t2)"}}>🗑️ Auto-delete when out</div>
                    <div style={{fontSize:10,color:"var(--t3)"}}>Remove from list when stock hits 0</div>
                  </div>
                </label>
              </div>
            </div>
          </div>
          {/* Row 5: linked devices */}
          <div style={{background:"rgba(10,132,255,0.04)",border:"1px solid rgba(10,132,255,0.15)",borderRadius:9,padding:"11px 13px"}}>
            <div style={{fontSize:11,fontWeight:700,color:"var(--blue)",marginBottom:8}}>📱 Linked Devices <span style={{fontWeight:400,color:"var(--t3)"}}>(for device-based filtering)</span></div>
            <div style={{display:"flex",flexWrap:"wrap",gap:5,marginBottom:8}}>
              {(f.linkedDevices||[]).map(d=>(
                <span key={d} style={{display:"flex",alignItems:"center",gap:5,padding:"3px 9px",background:"rgba(10,132,255,0.1)",border:"1px solid rgba(10,132,255,0.25)",borderRadius:12,fontSize:11.5,color:"var(--blue)",fontWeight:600}}>
                  📱 {d}
                  <span onClick={()=>removeDevice(d)} style={{cursor:"pointer",color:"var(--red)",marginLeft:2,fontWeight:700,fontSize:14,lineHeight:1}}>×</span>
                </span>
              ))}
            </div>
            <div className="fg" ref={devRef} style={{position:"relative"}}>
              <div style={{position:"relative"}}>
                <input className="inp" value={devInput} onChange={e=>{setDevInput(e.target.value);setDevDrop(true);}} onFocus={()=>setDevDrop(true)} placeholder="Link a device from catalog…" style={{paddingRight:26}}/>
                <span style={{position:"absolute",right:9,top:"50%",transform:"translateY(-50%)",color:"var(--t3)",fontSize:11,pointerEvents:"none"}}>▾</span>
              </div>
              {devDrop&&(filtDevs.length>0||devInput.trim())&&(
                <div style={{position:"absolute",top:"calc(100% + 3px)",left:0,right:0,background:"var(--bg2)",border:"1px solid var(--glb)",borderRadius:9,zIndex:70,maxHeight:180,overflowY:"auto",boxShadow:"0 8px 24px rgba(0,0,0,0.5)"}}>
                  {filtDevs.filter(n=>!(f.linkedDevices||[]).includes(n)).map(n=>(
                    <div key={n} onMouseDown={e=>{e.preventDefault();addDevice(n);}} style={{padding:"8px 12px",cursor:"pointer",fontSize:12.5,display:"flex",alignItems:"center",gap:7}} onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.06)"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                      <span>📱</span><span>{n}</span>
                    </div>
                  ))}
                  {devInput.trim()&&!devNames.includes(devInput.trim())&&(
                    <div onMouseDown={e=>{e.preventDefault();addDevice(devInput.trim());toast("📋","Device created",devInput.trim());}} style={{padding:"8px 12px",cursor:"pointer",fontSize:12.5,display:"flex",alignItems:"center",gap:7,borderTop:"1px solid var(--glb)",color:"var(--blue)"}} onMouseEnter={e=>e.currentTarget.style.background="rgba(10,132,255,0.08)"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                      <span>➕</span><span>Create &amp; link "<strong>{devInput.trim()}</strong>"</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="ma">
          <button className="btn bg2" onClick={onClose}>{t.cancel}</button>
          <button className="btn bp" onClick={()=>{if(!f.name)return;onSave(f);}}>💾 {t.save}</button>
        </div>
      </div>
    </div>
  );
}

// ─── CUSTOMERS ────────────────────────────────────────────────────────────────
function CustomersPage({t,fmt,customers,repairs,parts,saveCustomers,saveRepairs,saveParts,catalog,saveCatalog,nav,navSub,param,selectedCustomer,readOnly,canWrite,onNavToRepairs}){
  const [viewCustRepair,setViewCustRepair]=useState(null);
  const [editRepair,setEditRepair]=useState(null);
  // Editing a repair needs write access to Repairs, not just to Customers
  const canEditRepairs=typeof canWrite==="function"?canWrite("repairs"):!readOnly;
  function saveEditedRepair(data){
    if(!data.customerName||!data.customerName.trim()) data={...data,customerName:"No name"};
    const typeArr=data.types&&data.types.length?data.types:(data.type?[data.type]:[]);
    saveRepairs(repairs.map(r=>{
      if(r.id!==editRepair.id) return r;
      const ec=data.createdAt?new Date(data.createdAt).toISOString():r.createdAt;
      return{...r,...normalizeDateFields(data),types:typeArr,type:typeArr[0]||"",createdAt:ec,updatedAt:new Date().toISOString()};
    }));
    toast("✏️",t.updated,"Repair saved");
    setEditRepair(null);
  }
  const [modal,setModal]=useState(null);
  const [search,setSearch]=useState("");
  const [confirmDelete,setConfirmDelete]=useState(false);
  // Store customer ID (not object) to avoid stale reference bugs
  const [viewCustomer,setViewCustomer]=useState(()=>{
    if(!selectedCustomer||typeof selectedCustomer==='object') return null;
    return String(selectedCustomer);
  });
  // Sync internal view state with param (handles back button popstate)
  useEffect(()=>{
    if(param&&typeof param==='object'&&param.custView==='detail'&&param.custId){
      setViewCustomer(String(param.custId));
    } else {
      // param is null, a string, or a non-detail object → go to list
      setViewCustomer(null);
    }
  },[param]);
  // Forward drill: push history entry so back button can pop it
  function drillCustomer(id){
    rememberScroll("customers:list");
    if(navSub) navSub({custView:'detail',custId:id});
    setViewCustomer(String(id));
  }
  // Back button in UI: just clear state; phone back pops history separately
  function backToCustomers(){ setViewCustomer(null); }
  useViewScroll(viewCustomer?"customers:detail":"customers:list");

  useEffect(()=>{
    if(selectedCustomer!=null&&typeof selectedCustomer!=='object'){
      setViewCustomer(String(selectedCustomer));
    }
  },[selectedCustomer]);

  const filt=customers.filter(c=>{const q=search.toLowerCase();return !q||c.name?.toLowerCase().includes(q)||c.phone?.includes(q);});

  function handleSave(data){
    if(modal==="add"){saveCustomers([...customers,{...data,id:SDB.nextId(),createdAt:new Date().toISOString()}]);toast("👤",t.added,data.name);}
    else{
      const old=customers.find(c=>c.id===modal.id);
      saveCustomers(customers.map(c=>c.id===modal.id?{...c,...data}:c));
      // Propagate name change to all linked repairs
      if(old&&old.name!==data.name){
        const updated=repairs.map(r=>r.customerId===modal.id?{...r,customerName:data.name}:r);
        saveRepairs(updated);
      }
      toast("✏️",t.updated,data.name);
    }
    setModal(null);
  }

  // Customer repair history view
  if(viewCustomer){
    const c=customers.find(x=>String(x.id)===String(viewCustomer));
    if(!c){return <div className="page"><button className="btn bg2 bsm" onClick={()=>setViewCustomer(null)}><I n="back" s={13}/></button></div>;}
    const cRepairs=[...repairs].filter(r=>r.customerId===c.id).sort((a,b)=>new Date(b.createdAt)-new Date(a.createdAt));
    const spent=cRepairs.filter(r=>r.status==="Done"||r.status==="Delivered").reduce((s,r)=>s+(parseFloat(r.price)||0),0);
    return(
      <div className="page">
        {/* Inline delete confirm — replaces window.confirm which is blocked in many envs */}
        {confirmDelete&&(
          <div className="mo" onClick={()=>setConfirmDelete(false)}>
            <div className="md" style={{maxWidth:340,textAlign:"center"}} onClick={e=>e.stopPropagation()}>
              <div style={{fontSize:32,marginBottom:10}}>🗑️</div>
              <div style={{fontWeight:700,fontSize:15,marginBottom:6}}>Delete "{c.name}"?</div>
              <div style={{fontSize:12.5,color:"var(--t3)",marginBottom:18}}>This cannot be undone. All customer data will be removed.</div>
              <div style={{display:"flex",gap:9,justifyContent:"center"}}>
                <button className="btn bg2" style={{minWidth:90}} onClick={()=>setConfirmDelete(false)}>Cancel</button>
                <button className="btn bd" style={{minWidth:90}} onClick={()=>{
                  const nm=c.name; const cid=c.id;
                  setConfirmDelete(false);
                  backToCustomers();
                  saveCustomers(customers.filter(x=>String(x.id)!==String(cid)));
                  toast("🗑️",t.deleted,nm);
                }}>Delete</button>
              </div>
            </div>
          </div>
        )}
        {/* Hero profile banner */}
        {(()=>{
          const avatarColors=[["#0A84FF","#5E5CE6"],["#30D158","#34C759"],["#FF9F0A","#FF6B00"],["#BF5AF2","#9B59B6"],["#FF453A","#FF2D55"],["#5AC8FA","#0A84FF"],["#FFD60A","#FF9F0A"],["#64D2FF","#30D158"]];
          const ci=(c.name?.charCodeAt(0)||0)%avatarColors.length;
          const [c1,c2]=avatarColors[ci];
          const initials=(c.name||"?").slice(0,2).toUpperCase();
          return(
            <div style={{position:"relative",borderRadius:18,overflow:"hidden",marginBottom:16,border:"1px solid var(--glb)"}}>
              {/* Banner */}
              <div style={{height:72,background:`linear-gradient(135deg,${c1}33,${c2}18)`,position:"relative"}}>
                <div style={{position:"absolute",inset:0,background:`radial-gradient(ellipse at 70% 50%,${c1}28,transparent 70%)`}}/>
                <div style={{position:"absolute",top:10,right:12,display:"flex",gap:6}}>
                  <button className="btn bg2 bsm" style={{gap:5}} onClick={()=>setModal(c)}><I n="edit" s={11}/> Edit</button>
                  <button className="btn bd bsm" onClick={()=>setConfirmDelete(true)}><I n="trash" s={11}/></button>
                </div>
                <div style={{position:"absolute",top:10,left:12}}>
                  <button className="btn bg2 bsm" style={{gap:5,backdropFilter:"blur(8px)",background:"rgba(255,255,255,0.08)"}} onClick={()=>backToCustomers()}><I n="back" s={12}/> Back</button>
                </div>
              </div>
              {/* Avatar */}
              <div style={{position:"absolute",left:16,top:72-24,width:52,height:52,borderRadius:16,border:"3px solid var(--bg)",background:c.photoUrl?"transparent":`linear-gradient(135deg,${c1},${c2})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:19,fontWeight:800,color:"#fff",overflow:"hidden",boxShadow:`0 4px 16px ${c1}44`}}>
                {c.photoUrl?<img src={c.photoUrl} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:initials}
              </div>
              {/* Name + meta */}
              <div style={{padding:"30px 16px 14px",background:"var(--gl)"}}>
                <div style={{fontWeight:800,fontSize:18,letterSpacing:"-.01em",marginBottom:3}}>{c.name}</div>
                {/* Contact info line */}
                <div style={{display:"flex",gap:10,flexWrap:"wrap",marginBottom:10,alignItems:"center"}}>
                  {c.phone&&<span style={{fontSize:12,color:"var(--t3)"}}>📱 {c.phone}</span>}
                  {c.telegramId&&<span style={{fontSize:12,color:"var(--t3)",display:"flex",alignItems:"center",gap:3}}><TgIcon s={12}/>{c.telegramId}</span>}
                  {c.email&&<span style={{fontSize:12,color:"var(--t3)"}}>✉️ {c.email}</span>}
                </div>
                {/* Quick-action buttons */}
                {(c.phone||c.telegramId)&&(
                  <div style={{display:"flex",gap:7,flexWrap:"wrap"}}>
                    {c.phone&&<ContactActions phone={c.phone}/>}
                  </div>
                )}
                {c.notes&&<div style={{marginTop:8,fontSize:12,color:"var(--t3)",padding:"7px 10px",background:"rgba(255,255,255,0.04)",borderRadius:9,border:"1px solid var(--glb)"}}>{c.notes}</div>}
              </div>
            </div>
          );
        })()}
        {/* KPIs */}
        {(()=>{
          const unpaidR=cRepairs.filter(r=>(r.status==="Done"||r.status==="Delivered")&&!r.paid);
          const unpaidAmt=unpaidR.reduce((s,r)=>s+(parseFloat(r.price)||0),0);
          return(
            <div className="sg3">
              <SC icon="🔧" label="Total Repairs" value={cRepairs.filter(r=>!WAITING_S.includes(r.status)).length} color="var(--blue)"/>
              <SC icon="💰" label={t.totalSpent} value={fmt(spent)} color="var(--green)"/>
              <SC icon="💳" label="Unpaid" value={fmt(unpaidAmt)} color={unpaidAmt>0?"var(--orange)":"var(--green)"} sub={`${unpaidR.length} repair${unpaidR.length!==1?"s":""}`}/>
            </div>
          );
        })()}
        {/* Repairs list */}
        <div style={{background:"var(--gl)",border:"1px solid var(--glb)",borderRadius:18,overflow:"hidden"}}>
          <div style={{padding:"13px 16px 11px",borderBottom:"1px solid var(--glb)",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <span style={{fontSize:11,fontWeight:700,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".06em"}}>🔧 Repair History</span>
            <span style={{fontSize:11,fontWeight:700,color:"var(--t3)"}}>{cRepairs.length}</span>
          </div>
          {cRepairs.length===0
            ? <div style={{padding:"28px 16px",textAlign:"center",color:"var(--t3)",fontSize:13}}>{t.noRepairs}</div>
            : <div>
                {cRepairs.map((r,ri)=>{
                  const s=STATUS_CFG[r.status]||STATUS_CFG["Pending"];
                  const rp=calcRepairProfit(r);
                  const isLoss=(r.status==="Done"||r.status==="Delivered")&&rp<0;
                  const allT=r.types&&r.types.length?r.types:(r.type?[r.type]:[]);
                  return(
                    <div key={r.id} onClick={()=>setViewCustRepair(r)} className="clist-row"
                      style={{margin:"4px 8px",borderRadius:12}}>
                      {/* Left accent bar */}
                      <div style={{width:3,alignSelf:"stretch",borderRadius:3,background:isLoss?"var(--red)":s.color,flexShrink:0,minHeight:40}}/>
                      {/* Status icon */}
                      <div style={{width:38,height:38,borderRadius:12,background:isLoss?"rgba(255,69,58,0.13)":s.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:17,flexShrink:0}}>
                        {isLoss?"📉":s.icon}
                      </div>
                      {/* Info */}
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontWeight:700,fontSize:13,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.device}</div>
                        <div style={{display:"flex",gap:5,alignItems:"center",marginTop:2,flexWrap:"wrap"}}>
                          {allT.slice(0,2).map((tp,i)=>(
                            <span key={i} style={{fontSize:10,color:"var(--t3)",display:"inline-flex",alignItems:"center",gap:2}}>{getTypeIcon(tp)} {tp}</span>
                          ))}
                          {allT.length>2&&<span style={{fontSize:10,color:"var(--t3)"}}>+{allT.length-2}</span>}
                          <span style={{opacity:.3,fontSize:10}}>·</span>
                          <span style={{fontSize:10,color:"var(--t3)"}}>{new Date(r.createdAt).toLocaleDateString(undefined,{month:"short",day:"numeric",year:"numeric"})}</span>
                        </div>
                      </div>
                      {/* Price + status */}
                      <div style={{textAlign:"right",flexShrink:0}}>
                        <div style={{fontWeight:800,fontSize:14,color:isLoss?"var(--red)":parseFloat(r.price)>0?"var(--tx)":"var(--t3)"}}>{fmt(r.price||0)}</div>
                        <div style={{display:"flex",alignItems:"center",gap:4,justifyContent:"flex-end",marginTop:3}}>
                          <span style={{fontSize:9.5,fontWeight:700,padding:"1px 6px",borderRadius:7,background:s.bg,color:s.color,whiteSpace:"nowrap"}}>{s.icon} {r.status}</span>
                          {(r.status==="Done"||r.status==="Delivered")&&<span style={{fontSize:11,color:r.paid?"var(--green)":"var(--orange)"}}>{r.paid?"✅":"💳"}</span>}
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div style={{height:8}}/>
              </div>
          }
        </div>
        {modal&&<CustomerModal customer={modal==="add"?null:modal} onClose={()=>setModal(null)} onSave={handleSave} catalog={catalog} saveCatalog={saveCatalog} t={t}/>}
        {viewCustRepair&&<RepairDetailOverlay repair={repairs.find(r=>r.id===viewCustRepair.id)||viewCustRepair} onClose={()=>setViewCustRepair(null)}
          onEdit={rep=>{setViewCustRepair(null);setEditRepair(rep);}}
          onStatus={(rep,st,opts)=>{saveRepairs(repairs.map(x=>x.id===rep.id?applyStatusChange(x,st,opts):x));toast("✅","Status updated",st+(opts&&opts.paid?" & Paid":""));}}
          onPaid={(id,paid)=>{saveRepairs(repairs.map(x=>x.id===id?{...x,...paidDatePatch(x,paid)}:x));toast(paid?"✅":"💳",paid?"Marked paid":"Marked unpaid","");}}
          onDel={rep=>{saveRepairs(repairs.filter(x=>x.id!==rep.id));setViewCustRepair(null);toast("🗑️",t.deleted,"");}}
          fmt={fmt} t={t} customers={customers} readOnly={!canEditRepairs}/>}
        {editRepair&&<RepairModal saveParts={saveParts} saveCatalog={saveCatalog} repair={editRepair} parts={parts||[]} customers={customers} catalog={catalog} onClose={()=>setEditRepair(null)} onSave={saveEditedRepair}
          onNewDevice={devName=>{const newDev={name:devName,id:Date.now().toString(),parts:[]};saveCatalog([...(catalog||[]),newDev]);toast("📋",t.newDeviceAdded,devName);}}
          onNewCustomer={newC=>{saveCustomers([...customers,newC]);}} t={t} fmt={fmt}/>}
      </div>
    );
  }

  return(
    <div className="page">
      <div className="ph"><div><div className="pt">{t.customers}</div><div className="ps">{customers.length}</div></div><button className="btn bp" onClick={()=>setModal("add")}><I n="plus" s={13} c="#fff"/> {t.add}</button></div>
      <div style={{display:"flex",gap:7,marginBottom:13}}><div className="sbar" style={{maxWidth:260}}><I n="search" s={13} c="var(--t3)"/><input placeholder={`${t.search}…`} value={search} onChange={e=>setSearch(e.target.value)}/></div></div>
      {filt.length===0
        ? <div className="empty"><div className="ei">👥</div><div className="et">{t.noCustomers}</div></div>
        : <div className="g3">{filt.map(c=>{
            const cR=repairs.filter(r=>r.customerId===c.id);
            const activeR=cR.filter(r=>ACTIVE_S.includes(r.status)||WAITING_S.includes(r.status));
            const spent=cR.filter(r=>r.status==="Done"||r.status==="Delivered").reduce((s,r)=>s+(parseFloat(r.price)||0),0);
            const unpaid=cR.filter(r=>(r.status==="Done"||r.status==="Delivered")&&!r.paid).length;
            // Avatar gradient based on name
            const avatarColors=[
              ["#0A84FF","#5E5CE6"],["#30D158","#34C759"],["#FF9F0A","#FF6B00"],
              ["#BF5AF2","#9B59B6"],["#FF453A","#FF2D55"],["#5AC8FA","#0A84FF"],
              ["#FFD60A","#FF9F0A"],["#64D2FF","#30D158"],
            ];
            const ci=(c.name?.charCodeAt(0)||0)%avatarColors.length;
            const [c1,c2]=avatarColors[ci];
            const initials=(c.name||"?").slice(0,2).toUpperCase();
            return(
              <div key={c.id} className="ccard" onClick={()=>drillCustomer(String(c.id))}>
                {/* Banner */}
                <div className="ccard-banner" style={{background:`linear-gradient(135deg,${c1}33,${c2}18)`}}>
                  <div style={{position:"absolute",inset:0,background:`radial-gradient(ellipse at 80% 50%,${c1}22,transparent 70%)`}}/>
                  {/* Channel icons top-right */}
                  <div style={{position:"absolute",top:10,right:12,display:"flex",gap:5}}>
                    {c.telegramId&&<div style={{width:22,height:22,borderRadius:7,background:"rgba(0,136,204,0.25)",border:"1px solid rgba(0,136,204,0.3)",display:"flex",alignItems:"center",justifyContent:"center"}}><TgIcon s={12}/></div>}
                    {c.phone&&<div style={{width:22,height:22,borderRadius:7,background:"rgba(37,211,102,0.2)",border:"1px solid rgba(37,211,102,0.3)",display:"flex",alignItems:"center",justifyContent:"center"}}><WaIcon s={12}/></div>}
                  </div>
                  {/* Active badge */}
                  {activeR.length>0&&<div style={{position:"absolute",top:10,left:12,fontSize:9.5,fontWeight:800,padding:"2px 7px",borderRadius:8,background:"rgba(10,132,255,0.22)",border:"1px solid rgba(10,132,255,0.35)",color:"#5AC8FA",textTransform:"uppercase",letterSpacing:".04em"}}>🔧 {activeR.length} active</div>}
                </div>
                {/* Body — avatar sits here with negative margin-top to overlap the banner */}
                <div className="ccard-body">
                <div className="ccard-avatar" style={{background:c.photoUrl?"transparent":`linear-gradient(135deg,${c1},${c2})`}}>
                  {c.photoUrl?<img src={c.photoUrl} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:initials}
                </div>
                  <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",marginTop:8,gap:6}}>
                    <div style={{minWidth:0,flex:1}}>
                      <div className="ccard-name">{c.name}</div>
                      <div className="ccard-sub">{c.phone||c.email||"No contact info"}</div>
                    </div>
                    {/* Badges inline next to name — never expand height */}
                    <div style={{display:"flex",flexDirection:"column",gap:3,alignItems:"flex-end",flexShrink:0}}>
                      {unpaid>0&&<span className="ccard-badge" style={{background:"rgba(255,159,10,0.15)",color:"var(--orange)",border:"1px solid rgba(255,159,10,0.25)"}}>💳 {unpaid}</span>}
                      {c.notes&&<span className="ccard-badge" style={{background:"rgba(255,255,255,0.06)",color:"var(--t2)",border:"1px solid var(--glb)"}}>📝</span>}
                    </div>
                  </div>
                  <div className="ccard-divider" style={{marginTop:8}}/>
                  <div className="ccard-stats">
                    <div>
                      <div className="ccard-stat-label">Repairs</div>
                      <div className="ccard-stat-value" style={{color:"var(--blue)"}}>{cR.filter(r=>!WAITING_S.includes(r.status)).length}</div>
                    </div>
                    <div style={{textAlign:"right"}}>
                      <div className="ccard-stat-label">Total Spent</div>
                      <div className="ccard-stat-value" style={{color:"var(--green)"}}>{fmt(spent)}</div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}</div>
      }
      {modal&&<CustomerModal customer={modal==="add"?null:modal} onClose={()=>setModal(null)} onSave={handleSave} catalog={catalog} saveCatalog={saveCatalog} t={t}/>}
    </div>
  );
}
function CustomerModal({customer,onClose,onSave,catalog,saveCatalog,t}){
  const[f,setF]=useState(customer||{name:"",phone:"",telegramId:"",email:"",notes:"",devices:[],photoUrl:"",ownerOnlyDefault:false});
  const s=(k,v)=>setF(x=>({...x,[k]:v}));
  const [tab,setTab]=useState("info");
  const [devInput,setDevInput]=useState("");
  const [devDropOpen,setDevDropOpen]=useState(false);
  const [devImei,setDevImei]=useState("");
  const devRef=useRef();

  useEffect(()=>{
    function handle(e){if(devRef.current&&!devRef.current.contains(e.target))setDevDropOpen(false);}
    document.addEventListener("mousedown",handle);
    return()=>document.removeEventListener("mousedown",handle);
  },[]);

  // All device names from parts catalog
  const catalogDevNames=(catalog||[]).map(d=>d.name);
  const devFiltered=devInput.trim()
    ? catalogDevNames.filter(n=>n.toLowerCase().includes(devInput.toLowerCase()))
    : catalogDevNames;
  const devExact=catalogDevNames.some(n=>n.toLowerCase()===devInput.toLowerCase().trim());
  const showAddNew=devInput.trim()&&!devExact;
  // Also check if already added
  const alreadyAdded=false; // multiple devices of same model allowed

  function pickDev(name){setDevInput(name);setDevDropOpen(false);}
  function addNewCatalogDevice(name,saveCatalogFn){
    // Create in catalog too if saveCatalog is passed (feature 4)
    if(saveCatalogFn){
      const newCatDev={id:Date.now().toString(),name:name.trim(),parts:[]};
      saveCatalogFn(newCatDev);
    }
    setDevInput(name.trim());setDevDropOpen(false);
    toast("📱","Device added to catalog",name.trim());
  }
  function addDev(){
    const model=devInput.trim();if(!model)return;
    // Allow multiple devices of same model (different IMEIs) — e.g. 2x iPhone 14
    s("devices",[...(f.devices||[]),{id:Date.now().toString(),model,imei:devImei.trim(),notes:""}]);
    setDevInput("");setDevImei("");
  }
  function removeDev(id){s("devices",(f.devices||[]).filter(d=>d.id!==id));}
  function updateDevImei(id,imei){s("devices",(f.devices||[]).map(d=>d.id===id?{...d,imei}:d));}

  return(
    <div className="mo">
      <div className="md" style={{maxWidth:500}} onClick={e=>e.stopPropagation()}>
        <div className="mh"><div className="mt2">{customer?t.edit:t.add} {t.customers}</div><span style={{cursor:"pointer"}} onClick={onClose}><I n="close" s={15} c="var(--t3)"/></span></div>
        <div className="tabs" style={{marginBottom:14}}>
          <div className={`tab ${tab==="info"?"on":""}`} onClick={()=>setTab("info")}>👤 Info</div>
          <div className={`tab ${tab==="devices"?"on":""}`} onClick={()=>setTab("devices")}>📱 {t.customerDevices} {(f.devices||[]).length>0&&<span style={{marginLeft:5,background:"rgba(10,132,255,0.2)",color:"var(--blue)",borderRadius:10,padding:"0 6px",fontSize:10,fontWeight:700}}>{(f.devices||[]).length}</span>}</div>
        </div>
        {tab==="info"&&(
          <div style={{display:"flex",flexDirection:"column",gap:11}}>
            <div style={{display:"flex",alignItems:"flex-start",gap:14}}>
              <PhotoPicker value={f.photoUrl||""} onChange={v=>s("photoUrl",v)} size={54}/>
              <div className="fg" style={{flex:1}}><label className="fl">{t.name}</label><input className="inp" value={f.name} onChange={e=>s("name",e.target.value)}/></div>
            </div>
            <div className="fg2">
              <div className="fg"><label className="fl">{t.phone}</label><input className="inp" value={f.phone} onChange={e=>s("phone",e.target.value)}/></div>
              <div className="fg"><label className="fl">Email</label><input className="inp" type="email" value={f.email||""} onChange={e=>s("email",e.target.value)}/></div>
            </div>
            <div className="fg"><label className="fl">Telegram ID</label><input className="inp" value={f.telegramId||""} onChange={e=>s("telegramId",e.target.value)}/></div>
            <div className="fg"><label className="fl">{t.notes}</label><textarea className="inp" rows={3} value={f.notes||""} onChange={e=>s("notes",e.target.value)} style={{resize:"vertical"}}/></div>
            <div style={{marginTop:4}}>
              <div style={{fontSize:10,color:"var(--t3)",fontWeight:700,letterSpacing:.5,marginBottom:6,paddingTop:6,borderTop:"1px solid var(--glb)"}}>⚙️ REPAIR DEFAULTS</div>
              <label style={{display:"flex",alignItems:"center",gap:9,padding:"8px 11px",background:f.ownerOnlyDefault?"rgba(191,90,242,0.08)":"rgba(255,255,255,0.03)",border:`1px solid ${f.ownerOnlyDefault?"rgba(191,90,242,0.22)":"var(--glb)"}`,borderRadius:8,cursor:"pointer",transition:"all .15s"}}>
                <div className="tog" style={{transform:"scale(0.8)",transformOrigin:"left",flexShrink:0}}>
                  <input type="checkbox" checked={!!f.ownerOnlyDefault} onChange={e=>s("ownerOnlyDefault",e.target.checked)}/>
                  <span className="ts"/>
                </div>
                <div>
                  <div style={{fontSize:12,fontWeight:600,color:f.ownerOnlyDefault?"var(--purple)":"var(--t2)"}}>👤 Auto-enable "Mine Only" for this customer</div>
                  <div style={{fontSize:10,color:"var(--t3)"}}>New repairs will default to 100% profit — no store split. Ideal for personal/store devices.</div>
                </div>
              </label>
            </div>
          </div>
        )}
        {tab==="devices"&&(
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            <div style={{display:"flex",gap:7,alignItems:"flex-end",flexWrap:"wrap"}}>
              {/* Device name combobox */}
              <div className="fg" style={{flex:2,minWidth:140,position:"relative"}} ref={devRef}>
                <label className="fl">{t.deviceModel}</label>
                <div style={{position:"relative"}}>
                  <input className="inp" value={devInput}
                    onChange={e=>{setDevInput(e.target.value);setDevDropOpen(true);}}
                    onFocus={()=>setDevDropOpen(true)}
                    placeholder="iPhone 14 Pro…"
                    style={{paddingRight:28}}
                  />
                  <span style={{position:"absolute",right:9,top:"50%",transform:"translateY(-50%)",color:"var(--t3)",fontSize:11,pointerEvents:"none"}}>▾</span>
                </div>
                {devDropOpen&&(devFiltered.length>0||(!devExact&&devInput.trim()))&&(
                  <div style={{position:"absolute",top:"calc(100% + 3px)",left:0,right:0,background:"var(--bg2)",border:"1px solid var(--glb)",borderRadius:10,zIndex:70,maxHeight:180,overflowY:"auto",boxShadow:"0 8px 24px rgba(0,0,0,0.6)"}}>
                    {devFiltered.map(n=>(
                      <div key={n} onMouseDown={()=>pickDev(n)}
                        style={{padding:"8px 12px",cursor:"pointer",fontSize:12.5,display:"flex",alignItems:"center",gap:8}}
                        onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.06)"}
                        onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                        <span style={{fontSize:14}}>📱</span>{n}
                      </div>
                    ))}
                    {!devExact&&devInput.trim()&&(
                      <div onMouseDown={()=>{
                          const n=devInput.trim();
                          if(saveCatalog){saveCatalog([...(catalog||[]),{id:Date.now().toString(),name:n,parts:[]}]);}
                          pickDev(n);toast("📱","Added to catalog",n);
                        }}
                        style={{padding:"8px 12px",fontSize:12.5,cursor:"pointer",color:"var(--blue)",fontWeight:600,borderTop:devFiltered.length>0?"1px solid var(--glb)":"none",display:"flex",alignItems:"center",gap:8}}
                        onMouseEnter={e=>e.currentTarget.style.background="rgba(10,132,255,0.08)"}
                        onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                        + Add "{devInput.trim()}" as new device
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="fg" style={{flex:1,minWidth:110}}><label className="fl">{t.imei}</label><input className="inp" value={devImei} onChange={e=>setDevImei(e.target.value)} placeholder="IMEI / Serial"/></div>
              <button className="btn bp" style={{height:36,flexShrink:0,alignSelf:"flex-end"}} onClick={addDev} disabled={!devInput.trim()||alreadyAdded} title={alreadyAdded?"Already added":"Add device"}><I n="plus" s={13} c="#fff"/></button>
            </div>
            {alreadyAdded&&devInput.trim()&&<div style={{fontSize:11,color:"var(--orange)",marginTop:-4}}>⚠️ Already in list</div>}
            {(f.devices||[]).length===0
              ? <div style={{color:"var(--t3)",fontSize:13,padding:"12px 0",textAlign:"center"}}>📱 {t.noDevices}</div>
              : <div style={{display:"flex",flexDirection:"column",gap:6}}>
                  {(f.devices||[]).map(d=>(
                    <div key={d.id} style={{display:"flex",alignItems:"center",gap:8,padding:"9px 12px",background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:9}}>
                      <span style={{fontSize:16}}>📱</span>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontWeight:600,fontSize:13}}>{d.model}</div>
                        <div style={{display:"flex",gap:6,marginTop:4}}>
                          <input className="inp" style={{fontSize:11,padding:"3px 8px",height:"auto",flex:1}} value={d.imei||""} onChange={e=>s("devices",(f.devices||[]).map(x=>x.id===d.id?{...x,imei:e.target.value}:x))} placeholder="IMEI / Serial…"/>
                          <input className="inp" style={{fontSize:11,padding:"3px 8px",height:"auto",flex:1}} value={d.notes||""} onChange={e=>s("devices",(f.devices||[]).map(x=>x.id===d.id?{...x,notes:e.target.value}:x))} placeholder="Color / Notes…"/>
                        </div>
                      </div>
                      <button className="btn bd bsm" style={{padding:"3px 7px"}} onClick={()=>removeDev(d.id)}><I n="trash" s={11}/></button>
                    </div>
                  ))}
                </div>
            }
          </div>
        )}
        <div className="ma"><button className="btn bg2" onClick={onClose}>{t.cancel}</button><button className="btn bp" onClick={()=>{if(!f.name)return;onSave(f);}}>{t.save}</button></div>
      </div>
    </div>
  );
}

// ─── FINANCE ──────────────────────────────────────────────────────────────────
function FinancePage({t,fmt,repairs,withdrawals,saveWithdrawals,pushNotif,fin,readOnly}){
  const [splitPct,setSplitPct]=useState(SDB.get("split_pct")||50);
  const [wModal,setWModal]=useState(false);const [wAmount,setWAmount]=useState("");const [wNote,setWNote]=useState("");
  const paidCompleted=repairs.filter(r=>(r.status==="Done"||r.status==="Delivered")&&r.paid);
  const lossJobs=paidCompleted.filter(r=>calcRepairProfit(r)<0);
  const unpaidCompleted=repairs.filter(r=>(r.status==="Done"||r.status==="Delivered")&&!r.paid);
  function updateSplit(v){const p=Math.max(1,Math.min(99,parseInt(v)||50));setSplitPct(p);SDB.set("split_pct",p);}
  function addWithdrawal(){
    const amt=parseFloat(wAmount);
    if(!amt||amt<=0){toast("⚠️",t.missing,"Enter valid amount");return;}
    if(amt>fin.ownerBalance+0.01){toast("⚠️","Insufficient","Exceeds your balance");return;}
    const w={id:SDB.nextId(),amount:amt,note:wNote||t.withdrawal,date:new Date().toISOString()};
    saveWithdrawals([w,...withdrawals]);
    pushNotif(`💸 ${t.withdrawal}: ${fmt(amt)} — ${w.note}`);
    notifyTechnicians("withdrawal",{amount:fmt(amt),note:w.note});
    toast("💸",t.withdrawal,fmt(amt));setWAmount("");setWNote("");setWModal(false);
  }
  return(
    <div className="page">
      <div className="ph"><div><div className="pt">{t.finance}</div></div><button className="btn bp" onClick={()=>setWModal(true)}><I n="withdraw" s={13} c="#fff"/> {t.withdraw}</button></div>
      {/* Split config */}
      <div className="card mb14">
        <div className="stitle">⚙️ {t.splitConfig}</div>
        <div style={{display:"flex",alignItems:"center",gap:16,flexWrap:"wrap"}}>
          <div style={{flex:1,minWidth:200}}>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:12.5,marginBottom:6}}>
              <span style={{color:"var(--blue)",fontWeight:600}}>{t.yourCut}: {splitPct}%</span>
              <span style={{color:"var(--green)",fontWeight:600}}>{t.storeCut}: {100-splitPct}%</span>
            </div>
            <input type="range" min="1" max="99" value={splitPct} onChange={e=>updateSplit(e.target.value)} style={{width:"100%",accentColor:"var(--blue)"}}/>
          </div>
          <div style={{display:"flex",gap:10}}>
            <div style={{textAlign:"center",padding:"10px 20px",background:"rgba(10,132,255,0.08)",border:"1px solid rgba(10,132,255,0.2)",borderRadius:11}}><div style={{fontSize:20,fontWeight:700,color:"var(--blue)"}}>{fmt(fin.ownerCut)}</div><div style={{fontSize:11,color:"var(--t3)",marginTop:2}}>{t.yourCut}</div></div>
            <div style={{textAlign:"center",padding:"10px 20px",background:"rgba(48,209,88,0.07)",border:"1px solid rgba(48,209,88,0.18)",borderRadius:11}}><div style={{fontSize:20,fontWeight:700,color:"var(--green)"}}>{fmt(fin.storeCut)}</div><div style={{fontSize:11,color:"var(--t3)",marginTop:2}}>{t.storeCut}</div></div>
          </div>
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))",gap:12,marginBottom:16}}>
        <SC icon="💰" label={t.netProfit} value={fmt(fin.netProfit)} color={fin.netProfit>=0?"var(--green)":"var(--red)"} sub="Paid only"/>
        <SC icon="⏳" label="Pending Profit" value={fmt(fin.unpaidProfit)} color="var(--orange)" sub={`${fin.unpaidCount} unpaid`}/>
        <SC icon="📉" label={t.losses} value={fmt(Math.abs(fin.lossTotal))} color="var(--red)" sub={`${fin.lossJobCount} jobs`}/>
        <SC icon="💸" label={t.withdrawn} value={fmt(fin.totalWithdrawn)} color="var(--orange)" sub={`${withdrawals.length}`}/>
        <SC icon="💼" label={t.balance} value={fmt(fin.ownerBalance)} color={fin.ownerBalance>=0?"var(--blue)":"var(--red)"}/>
      </div>
      <div className="g2 mb14">
        <div className="card">
          <div className="stitle">📊 P&amp;L</div>
          {[
            {label:t.revenue,            val:fmt(fin.totalRevenue),  col:"var(--green)"},
            {label:"Parts Cost",         val:"-"+fmt(fin.totalPartsCost), col:"var(--orange)"},
            {label:t.netProfit,          val:fmt(fin.netProfit),    col:fin.netProfit>=0?"var(--blue)":"var(--red)"},
            {label:`${t.losses} (${fin.lossJobCount} jobs)`,val:fmt(fin.lossTotal), col:"var(--red)"},
            {label:`${t.yourCut} (${splitPct}%)`,val:fmt(fin.ownerCut),col:"var(--blue)"},
            {label:"-"+t.withdrawn,      val:"-"+fmt(fin.totalWithdrawn),col:"var(--orange)"},
            {label:t.balance,            val:fmt(fin.ownerBalance), col:fin.ownerBalance>=0?"var(--green)":"var(--red)"},
          ].map((row,i)=>(
            <div key={i} className="mrow" style={i===6?{borderBottom:"none",paddingTop:12,borderTop:"1px solid var(--glb)",marginTop:4}:{}}>
              <span style={{fontSize:12.5,color:i===6?"var(--tx)":"var(--t2)",fontWeight:i===6?700:400}}>{row.label}</span>
              <span style={{fontWeight:700,fontSize:13.5,color:row.col}}>{row.val}</span>
            </div>
          ))}
          {fin.unpaidCount>0&&(
            <div style={{marginTop:10,padding:"10px 12px",background:"rgba(255,159,10,0.07)",border:"1px solid rgba(255,159,10,0.2)",borderRadius:10}}>
              <div style={{fontSize:11,fontWeight:700,color:"var(--orange)",marginBottom:4}}>⏳ Pending Payment ({fin.unpaidCount} repair{fin.unpaidCount!==1?"s":""})</div>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:12}}>
                <span style={{color:"var(--t3)"}}>Revenue if paid: {fmt(fin.unpaidRevenue)}</span>
                <span style={{fontWeight:700,color:"var(--orange)"}}>{fmt(fin.unpaidProfit)}</span>
              </div>
            </div>
          )}
        </div>
        <div className="card">
          <div className="stitle">📉 {t.lossJobs}</div>
          {lossJobs.length===0
            ? <div style={{color:"var(--t3)",fontSize:13,paddingTop:8}}>✅ {t.noLossJobs}</div>
            : <div style={{display:"flex",flexDirection:"column",gap:6}}>{lossJobs.map(r=>{
                const p=calcRepairProfit(r);const pc=(r.partsUsed||[]).reduce((x,q)=>x+(parseFloat(q.cost)||0)*(q.qty||1),0);
                return(<div key={r.id} style={{padding:"10px 12px",background:"rgba(255,69,58,0.07)",border:"1px solid rgba(255,69,58,0.18)",borderRadius:10}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div><div style={{fontWeight:600,fontSize:13}}>{r.customerName} · {r.device}</div><div style={{fontSize:11,color:"var(--t3)",marginTop:2}}>{r.type} · #{r.id}</div></div>
                    <div style={{textAlign:"right"}}><div style={{fontWeight:700,color:"var(--red)",fontSize:14}}>{fmt(p)}</div><div style={{fontSize:10.5,color:"var(--t3)"}}>Rev {fmt(r.price||0)} · Parts {fmt(pc)}</div></div>
                  </div>
                </div>);
              })}
            </div>
          }
        </div>
      </div>
      <div className="card">
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <div className="stitle" style={{marginBottom:0}}>💸 {t.withdrawHistory}</div>
          <button className="btn bp bsm" onClick={()=>setWModal(true)}><I n="plus" s={12} c="#fff"/> {t.add}</button>
        </div>
        {withdrawals.length===0
          ? <div style={{color:"var(--t3)",fontSize:13,padding:"16px 0"}}>{t.noWithdrawals}</div>
          : <div style={{display:"flex",flexDirection:"column",gap:6}}>
              {[...withdrawals].sort((a,b)=>new Date(b.date)-new Date(a.date)).map(w=>(
                <div key={w.id} className="wdraw-row">
                  <div style={{width:34,height:34,background:"rgba(255,159,10,0.12)",borderRadius:9,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>💸</div>
                  <div style={{flex:1}}><div style={{fontWeight:600,fontSize:13}}>{w.note||t.withdrawal}</div><div style={{fontSize:11,color:"var(--t3)",marginTop:1}}>{new Date(w.date).toLocaleString()}</div></div>
                  <div style={{fontWeight:700,fontSize:15,color:"var(--orange)"}}>{fmt(w.amount)}</div>
                  <button className="btn bd bsm" style={{padding:"3px 7px"}} onClick={()=>{saveWithdrawals(withdrawals.filter(x=>x.id!==w.id));toast("🗑️",t.removed,"");}}><I n="trash" s={11}/></button>
                </div>
              ))}
            </div>
        }
      </div>
      {wModal&&(<div className="mo"><div className="md" style={{maxWidth:420}} onClick={e=>e.stopPropagation()}>
        <div className="mh"><div className="mt2">💸 {t.recordWithdrawal}</div><span style={{cursor:"pointer"}} onClick={()=>setWModal(false)}><I n="close" s={16} c="var(--t3)"/></span></div>
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <div style={{padding:"12px 14px",background:"rgba(10,132,255,0.07)",border:"1px solid rgba(10,132,255,0.18)",borderRadius:10,fontSize:13,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span>{t.availableWithdraw}: <strong style={{color:fin.ownerBalance>=0?"var(--green)":"var(--red)"}}>{fmt(fin.ownerBalance)}</strong></span>
            <button className="btn bp bsm" style={{fontSize:11}} onClick={()=>setWAmount(String(Math.max(0,fin.ownerBalance)))}>Withdraw All</button>
          </div>
          <div className="fg">
            <label className="fl">{t.amount}</label>
            <input className="inp" type="number" step={priceStep()} value={wAmount} onChange={e=>setWAmount(e.target.value)} style={{fontSize:20,fontWeight:700,textAlign:"center"}} autoFocus/>
            {wAmount&&parseFloat(wAmount)>fin.ownerBalance+0.001&&(
              <div style={{marginTop:5,padding:"6px 10px",background:"rgba(255,69,58,0.09)",border:"1px solid rgba(255,69,58,0.2)",borderRadius:8,fontSize:11.5,color:"var(--red)",fontWeight:600}}>⚠️ Amount exceeds your balance of {fmt(fin.ownerBalance)}</div>
            )}
          </div>
          <div className="fg"><label className="fl">Note</label><input className="inp" value={wNote} onChange={e=>setWNote(e.target.value)} placeholder="Personal use, rent…"/></div>
        </div>
        <div className="ma"><button className="btn bg2" onClick={()=>setWModal(false)}>{t.cancel}</button><button className="btn bp" onClick={addWithdrawal} disabled={!!wAmount&&parseFloat(wAmount)>fin.ownerBalance+0.001}>{t.withdraw}</button></div>
      </div></div>)}
    </div>
  );
}


// ─── Top Catalog Insights ─────────────────────────────────────────────────────
// Shows most-repaired devices (from catalog), their most-used parts & types
function TopCatalogInsights({repairs,catalog,t,fmt,sliceRepairs}){
  // Build device -> part -> type usage map from partsUsed on completed repairs
  const pool = sliceRepairs || repairs.filter(r=>r.status==="Done"||r.status==="Delivered");

  // Map catalog device names to lowercase for matching
  const catNames = (catalog||[]).map(d=>d.name.toLowerCase());

  // Count repairs per device name (matches catalog OR just any device on repair)
  const devCount = {};
  pool.forEach(r=>{
    const dn = (r.device||"Unknown").trim();
    devCount[dn] = (devCount[dn]||0) + 1;
  });

  // Count catalog parts used across all repairs
  // partsUsed entries from catalog have name like "DeviceName — PartName (TypeName)"
  const partUsage = {}; // key = "DeviceName||PartName||TypeName"
  pool.forEach(r=>{
    (r.partsUsed||[]).filter(p=>p.fromCatalog).forEach(p=>{
      // parse "Dev — Part (Type)"
      const m = p.name.match(/^(.+?) — (.+?) \((.+?)\)$/);
      if(m){
        const [,dev,part,type] = m;
        const k = `${dev}||${part}||${type}`;
        partUsage[k] = (partUsage[k]||0) + (p.qty||1);
      }
    });
  });

  // Also count non-catalog parts by device
  const partByDev = {}; // devName -> { partName -> count }
  pool.forEach(r=>{
    const dn=(r.device||"Unknown").trim();
    (r.partsUsed||[]).forEach(p=>{
      if(!partByDev[dn])partByDev[dn]={};
      partByDev[dn][p.name]=(partByDev[dn][p.name]||0)+(p.qty||1);
    });
  });

  const topDevices = Object.entries(devCount).sort((a,b)=>b[1]-a[1]).slice(0,5);
  if(topDevices.length===0) return null;

  return(
    <div className="card mb14">
      <div className="stitle">🏆 {t.topDevices}</div>
      <div style={{display:"flex",flexDirection:"column",gap:10}}>
        {topDevices.map(([devName,repairCount],di)=>{
          const devParts = partByDev[devName]||{};
          const topParts = Object.entries(devParts).sort((a,b)=>b[1]-a[1]).slice(0,3);
          // catalog types for this device
          const catDev = (catalog||[]).find(d=>d.name.toLowerCase()===devName.toLowerCase());
          const topTypes = Object.entries(partUsage)
            .filter(([k])=>k.startsWith(devName+"||"))
            .map(([k,cnt])=>{const [,part,type]=k.split("||");return{part,type,cnt};})
            .sort((a,b)=>b.cnt-a.cnt).slice(0,3);

          return(
            <div key={devName} style={{background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:12,overflow:"hidden"}}>
              {/* Device header */}
              <div style={{display:"flex",alignItems:"center",gap:10,padding:"12px 14px",background:"rgba(10,132,255,0.06)",borderBottom:"1px solid var(--glb)"}}>
                <div style={{width:32,height:32,borderRadius:8,background:"rgba(10,132,255,0.18)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>
                  {di===0?"🥇":di===1?"🥈":di===2?"🥉":"📱"}
                </div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700,fontSize:13.5}}>{devName}</div>
                  <div style={{fontSize:11,color:"var(--t3)",marginTop:1}}>{repairCount} repair{repairCount!==1?"s":""}</div>
                </div>
                <div style={{display:"flex",gap:3}}>
                  {Array.from({length:Math.min(repairCount,5)}).map((_,i)=>(
                    <div key={i} style={{width:6,height:20,borderRadius:3,background:`rgba(10,132,255,${0.3+i*0.14})`}}/>
                  ))}
                </div>
              </div>
              {/* Most used parts */}
              {topParts.length>0&&(
                <div style={{padding:"10px 14px"}}>
                  <div style={{fontSize:10.5,fontWeight:600,color:"var(--t3)",marginBottom:7,letterSpacing:.4,textTransform:"uppercase"}}>{t.topParts}</div>
                  <div style={{display:"flex",flexDirection:"column",gap:5}}>
                    {topParts.map(([partName,cnt],pi)=>(
                      <div key={partName} style={{display:"flex",alignItems:"center",gap:8}}>
                        <span style={{fontSize:10,color:"var(--t3)",minWidth:14,fontWeight:700}}>#{pi+1}</span>
                        <span style={{fontSize:12.5,flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{partName}</span>
                        <span style={{fontSize:12,fontWeight:700,color:"var(--blue)",minWidth:20,textAlign:"right"}}>{cnt}×</span>
                        <div style={{width:50,height:4,borderRadius:2,background:"rgba(255,255,255,0.07)"}}>
                          <div style={{height:"100%",borderRadius:2,background:"var(--blue)",width:`${Math.min(cnt/topParts[0][1]*100,100)}%`}}/>
                        </div>
                      </div>
                    ))}
                  </div>
                  {/* Catalog type breakdown if available */}
                  {topTypes.length>0&&(
                    <div style={{marginTop:10,paddingTop:10,borderTop:"1px solid rgba(255,255,255,0.05)"}}>
                      <div style={{fontSize:10.5,fontWeight:600,color:"var(--t3)",marginBottom:6,letterSpacing:.4,textTransform:"uppercase"}}>📋 Catalog Types Used</div>
                      <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
                        {topTypes.map(({part,type,cnt})=>(
                          <div key={part+type} style={{background:"rgba(48,209,88,0.08)",border:"1px solid rgba(48,209,88,0.2)",borderRadius:20,padding:"3px 10px",fontSize:11}}>
                            <span style={{color:"var(--t3)"}}>{part} · </span>
                            <span style={{fontWeight:600}}>{type}</span>
                            <span style={{color:"var(--green)",marginLeft:5,fontWeight:700}}>{cnt}×</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
              {topParts.length===0&&<div style={{padding:"10px 14px",fontSize:12,color:"var(--t3)"}}>No parts recorded yet</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}


// ─── AppearanceCard ──────────────────────────────────────────────────────────
function AppearanceCard({appearance, updateAppearance, currentUser, t}){
  const ap = appearance || {};
  const themeKey   = ap.theme   || 'obsidian';
  const fontKey    = ap.font    || 'system';
  const radiusKey  = ap.radius  || 'normal';
  const densityKey = ap.density || 'normal';
  const accent     = ap.accent  || '';

  const ACCENT_PRESETS = [
    {label:'Default', value:''},
    {label:'Blue',    value:'#0A84FF'},
    {label:'Purple',  value:'#BF5AF2'},
    {label:'Green',   value:'#30D158'},
    {label:'Orange',  value:'#FF9F0A'},
    {label:'Red',     value:'#FF453A'},
    {label:'Pink',    value:'#FF375F'},
    {label:'Teal',    value:'#5AC8FA'},
    {label:'Gold',    value:'#FFD60A'},
    {label:'Coral',   value:'#FF6B6B'},
  ];

  function ThemeCard({id,th,active}){
    return(
      <div onClick={()=>updateAppearance({theme:id})} style={{
        cursor:'pointer', borderRadius:12, overflow:'hidden',
        border:`2px solid ${active?'var(--blue)':'var(--glb)'}`,
        transition:'all .18s', transform:active?'scale(1.03)':'scale(1)',
        boxShadow:active?'0 0 0 1px var(--blue)':'none',
      }}>
        <div style={{background:th.bg, height:52, display:'flex', alignItems:'center', justifyContent:'space-between', padding:'8px 10px'}}>
          <div style={{display:'flex', flexDirection:'column', gap:4}}>
            <div style={{height:5, width:32, borderRadius:3, background:th.blue}}/>
            <div style={{height:4, width:22, borderRadius:3, background:th.t3}}/>
            <div style={{height:4, width:28, borderRadius:3, background:th.t3}}/>
          </div>
          <div style={{width:20, height:20, borderRadius:5, background:th.blue, display:'flex', alignItems:'center', justifyContent:'center', fontSize:10}}>
            {th.icon||'●'}
          </div>
        </div>
        <div style={{background:th.bg2, padding:'5px 8px', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
          <span style={{fontSize:10.5, fontWeight:600, color:th.tx}}>{th.name}</span>
          {active&&<span style={{fontSize:9, color:th.blue, fontWeight:700}}>✓</span>}
        </div>
      </div>
    );
  }

  return(
    <div style={{display:'flex', flexDirection:'column', gap:13}}>
      {/* Themes */}
      <div className="card">
        <div className="stitle">🎨 Appearance</div>

        {/* Theme grid */}
        <div style={{marginBottom:14}}>
          <div style={{fontSize:11,fontWeight:600,color:'var(--t3)',marginBottom:8,letterSpacing:.4}}>THEME</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(100px,1fr))',gap:8}}>
            {Object.entries(THEMES).map(([id,th])=>(
              <ThemeCard key={id} id={id} th={th} active={themeKey===id}/>
            ))}
          </div>
        </div>

        {/* Accent color */}
        <div style={{marginBottom:14}}>
          <div style={{fontSize:11,fontWeight:600,color:'var(--t3)',marginBottom:8,letterSpacing:.4}}>ACCENT COLOR</div>
          <div style={{display:'flex',gap:6,flexWrap:'wrap',alignItems:'center'}}>
            {ACCENT_PRESETS.map(p=>(
              <div key={p.label} onClick={()=>updateAppearance({accent:p.value})}
                title={p.label}
                style={{
                  width:26,height:26,borderRadius:'50%',cursor:'pointer',
                  background: p.value || (THEMES[themeKey]||THEMES.obsidian).blue,
                  border: accent===p.value ? '2.5px solid var(--tx)':'2px solid transparent',
                  boxShadow: accent===p.value ? '0 0 0 1px var(--blue)':'none',
                  transition:'all .15s',
                  display:'flex',alignItems:'center',justifyContent:'center',
                  fontSize: p.value ? '' : 11,
                }}>
                {!p.value&&<span style={{color:'var(--tx)',fontWeight:700,fontSize:11}}>A</span>}
              </div>
            ))}
            {/* Custom color picker */}
            <label title="Custom color" style={{width:26,height:26,borderRadius:'50%',cursor:'pointer',background:'conic-gradient(red,yellow,lime,cyan,blue,magenta,red)',overflow:'hidden',display:'flex',alignItems:'center',justifyContent:'center',border:'2px solid var(--glb)'}}>
              <input type="color" style={{opacity:0,width:1,height:1}} value={accent||'#0A84FF'} onChange={e=>updateAppearance({accent:e.target.value})}/>
            </label>
          </div>
        </div>

        {/* Font */}
        <div style={{marginBottom:14}}>
          <div style={{fontSize:11,fontWeight:600,color:'var(--t3)',marginBottom:8,letterSpacing:.4}}>FONT</div>
          <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
            {Object.entries(FONTS).map(([id,fn])=>(
              <button key={id} onClick={()=>updateAppearance({font:id})}
                className={`chip ${fontKey===id?'on':''}`}
                style={{fontFamily:fn.value, fontSize:12}}>
                {fn.name}
              </button>
            ))}
          </div>
        </div>

        {/* Corner Radius */}
        <div style={{marginBottom:14}}>
          <div style={{fontSize:11,fontWeight:600,color:'var(--t3)',marginBottom:8,letterSpacing:.4}}>CORNER RADIUS</div>
          <div style={{display:'flex',gap:6}}>
            {Object.entries(RADIUS_PRESETS).map(([id,rd])=>(
              <button key={id} onClick={()=>updateAppearance({radius:id})}
                className={`chip ${radiusKey===id?'on':''}`}>
                {rd.name}
              </button>
            ))}
          </div>
        </div>

        {/* Density */}
        <div>
          <div style={{fontSize:11,fontWeight:600,color:'var(--t3)',marginBottom:8,letterSpacing:.4}}>DENSITY</div>
          <div style={{display:'flex',gap:6}}>
            {Object.entries(DENSITY_PRESETS).map(([id,dn])=>(
              <button key={id} onClick={()=>updateAppearance({density:id})}
                className={`chip ${densityKey===id?'on':''}`}>
                {dn.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Sidebar customization */}
      <div className="card">
        <div className="stitle">🖼️ Interface Options</div>
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          {[
            {key:'compactSidebar', label:'Compact sidebar (icons only)', icon:'◀'},
            {key:'animationsReduced', label:'Reduce animations (accessibility)', icon:'⚡'},
            {key:'stickyHeader', label:'Sticky top bar always visible', icon:'📌'},
            {key:'showRepairId', label:'Show repair # in lists', icon:'🔢'},
            {key:'confirmDeletes', label:'Confirm before deleting', icon:'🛡️'},
          ].map(opt=>(
            <div key={opt.key} className="mrow">
              <div style={{display:'flex',alignItems:'center',gap:8}}>
                <span style={{fontSize:14}}>{opt.icon}</span>
                <span style={{fontSize:12.5,fontWeight:500}}>{opt.label}</span>
              </div>
              <label className="tog">
                <input type="checkbox" checked={ap[opt.key]||false} onChange={e=>updateAppearance({[opt.key]:e.target.checked})}/>
                <span className="ts"/>
              </label>
            </div>
          ))}
        </div>
      </div>

      {/* Reset */}
      <div className="card">
        <button className="btn bd" style={{width:'100%'}} onClick={()=>{
          updateAppearance({theme:'obsidian',font:'system',radius:'normal',density:'normal',accent:'',compactSidebar:false,showBalance:true,animationsReduced:false,stickyHeader:true,showRepairId:true,confirmDeletes:true});
          toast('🎨','Reset','Appearance reset to defaults');
        }}>↩ Reset to Defaults</button>
      </div>
    </div>
  );
}

// ─── ANALYTICS ────────────────────────────────────────────────────────────────
function AnalyticsPage({t,fmt,repairs,catalog,MONTHS}){
  const done=repairs.filter(r=>r.status==="Done"||r.status==="Delivered"); // for completion-rate/count metrics only
  const paid=repairs.filter(r=>(r.status==="Done"||r.status==="Delivered")&&r.paid); // for all $ figures
  const revenue=paid.reduce((s,r)=>s+(parseFloat(r.price)||0),0);
  const cost=paid.reduce((s,r)=>s+(r.partsUsed||[]).reduce((x,p)=>x+(parseFloat(p.cost)||0)*(p.qty||1),0),0);
  const profit=revenue-cost;
  const lossTotal=paid.filter(r=>calcRepairProfit(r)<0).reduce((s,r)=>s+calcRepairProfit(r),0);
  const unpaidCompleted=repairs.filter(r=>(r.status==="Done"||r.status==="Delivered")&&!r.paid);
  const unpaidProfit=unpaidCompleted.reduce((s,r)=>s+calcRepairProfit(r),0);
  const visibleRepairs=repairs.filter(r=>!WAITING_S.includes(r.status));
  const compRate=visibleRepairs.length?done.length/visibleRepairs.length*100:0;
  const monthly=Array.from({length:6},(_,i)=>{
    const d=new Date();d.setMonth(d.getMonth()-(5-i));
    const m=d.getMonth(),y=d.getFullYear();
    const mDone=paid.filter(r=>isInMonth(getFinanceDate(r),m,y));
    const rev=mDone.reduce((s,r)=>s+(parseFloat(r.price)||0),0);
    const loss=Math.abs(mDone.filter(r=>calcRepairProfit(r)<0).reduce((s,r)=>s+calcRepairProfit(r),0));
    return{month:MONTHS[m],rev,loss};
  });
  const tc={};repairs.filter(r=>!WAITING_S.includes(r.status)).forEach(r=>{(r.types&&r.types.length?r.types:[r.type||'']).forEach(t=>{if(t)tc[t]=(tc[t]||0)+1;});});
  const typeData=Object.entries(tc).sort((a,b)=>b[1]-a[1]).slice(0,8).map(([name,value])=>({name:name.replace(" Replacement","").replace(" Repair",""),value}));
  const statusData=Object.entries(repairs.filter(r=>!WAITING_S.includes(r.status)).reduce((acc,r)=>{acc[r.status]=(acc[r.status]||0)+1;return acc;},{})).map(([name,value])=>({name,value,color:STATUS_CFG[name]?.color||"var(--blue)"}));
  const tt={contentStyle:{background:"var(--bg2)",border:"1px solid rgba(255,255,255,0.09)",borderRadius:9,fontSize:12,color:"#fff"},cursor:false,wrapperStyle:{outline:"none",background:"transparent"}};
  return(
    <div className="page">
      <div className="ph"><div><div className="pt">{t.analytics}</div><div className="ps">{t.allTimePerformance}</div></div></div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))",gap:12,marginBottom:16}}>
        <SC icon="💰" label={t.revenue} value={fmt(revenue)} color="var(--green)" sub={`${paid.length} paid`}/>
        <SC icon="📈" label={t.netProfit} value={fmt(profit)} color={profit>=0?"var(--blue)":"var(--red)"} sub="After parts"/>
        <SC icon="⏳" label="Pending Profit" value={fmt(unpaidProfit)} color="var(--orange)" sub={`${unpaidCompleted.length} unpaid`}/>
        <SC icon="📉" label={t.losses} value={fmt(Math.abs(lossTotal))} color="var(--red)" sub={`${paid.filter(r=>calcRepairProfit(r)<0).length} jobs`}/>
        <SC icon="✅" label={t.completion} value={`${compRate.toFixed(0)}%`} color="var(--purple)"/>
      </div>
      <SplitSummary repairs={repairs} t={t} fmt={fmt}/>
      <TopCatalogInsights repairs={repairs} catalog={catalog||[]} t={t} fmt={fmt}/>
      <div className="g2 mb14">
        <div className="card"><div className="stitle">{t.last6Months}</div><ResponsiveContainer width="100%" height={160}><BarChart data={monthly} barSize={20}><XAxis dataKey="month" axisLine={false} tickLine={false} tick={{fill:"rgba(255,255,255,0.3)",fontSize:10}}/><YAxis hide/><Tooltip {...tt}/><Bar dataKey="rev" fill="#0A84FF" radius={[4,4,0,0]} name={t.revenue}/><Bar dataKey="loss" fill="#FF453A" radius={[4,4,0,0]} name={t.losses}/></BarChart></ResponsiveContainer></div>
        <div className="card"><div className="stitle">{t.byRepairType}</div><ResponsiveContainer width="100%" height={160}><BarChart data={typeData} layout="vertical" barSize={11}><XAxis type="number" hide/><YAxis type="category" dataKey="name" width={88} axisLine={false} tickLine={false} tick={{fill:"rgba(255,255,255,0.4)",fontSize:10}}/><Tooltip {...tt}/><Bar dataKey="value" fill="#30D158" radius={[0,4,4,0]}/></BarChart></ResponsiveContainer></div>
      </div>
      <div className="g2">
        <div className="card"><div className="stitle">{t.statusBreakdown}</div>{statusData.map(s=><div key={s.name} style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}><span className="dot" style={{background:s.color,flexShrink:0}}/><span style={{fontSize:12,width:90,flexShrink:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{s.name}</span><div className="prog" style={{flex:1}}><div className="progf" style={{width:`${visibleRepairs.length?s.value/visibleRepairs.length*100:0}%`,background:s.color}}/></div><span style={{fontWeight:700,fontSize:13,width:24,textAlign:"right",flexShrink:0}}>{s.value}</span></div>)}</div>
        <div className="card"><div className="stitle">{t.topRepairTypes}</div>{typeData.slice(0,5).map((tp,i)=><div key={tp.name} className="mrow"><div style={{display:"flex",alignItems:"center",gap:7}}><span style={{color:"var(--t3)",fontSize:11,minWidth:18,fontWeight:600}}>#{i+1}</span><span style={{fontSize:12.5}}>{tp.name}</span></div><span style={{fontWeight:700,fontSize:13}}>{tp.value}</span></div>)}{!typeData.length&&<div style={{color:"var(--t3)",fontSize:13}}>{t.noData}</div>}</div>
      </div>
    </div>
  );
}

// ─── MONTHLY REPORT ───────────────────────────────────────────────────────────
// ─── ReportRepairTable — clickable repair rows with profit split indicator ────
function ReportRepairTable({repairs,fmt,t,onEditRepair,canEdit}){
  const [viewRepair,setViewRepair]=useState(null);
  const sorted=[...repairs].sort((a,b)=>new Date(b.createdAt)-new Date(a.createdAt));
  return(
    <>
      <div className="tw"><table>
        <thead><tr>
          <th>#</th><th>{t.customers}</th><th>{t.device}</th><th>{t.type}</th>
          <th>{t.status}</th><th>{t.price}</th><th>Parts</th><th>{t.netProfit}</th>
          <th>Split</th><th>{t.date}</th>
        </tr></thead>
        <tbody>{sorted.map(r=>{
          const s=STATUS_CFG[r.status]||STATUS_CFG["Pending"];
          const pC=(r.partsUsed||[]).reduce((x,p)=>x+(parseFloat(p.cost)||0)*(p.qty||1),0);
          const rP=(parseFloat(r.price)||0)-pC;
          const splitBadge=r.ownerOnly
            ?<span style={{fontSize:10,fontWeight:700,padding:"1px 6px",borderRadius:8,background:"rgba(191,90,242,0.13)",color:"var(--purple)",border:"1px solid rgba(191,90,242,0.25)",whiteSpace:"nowrap"}}>👤 Mine</span>
            :r.storeOnly
              ?<span style={{fontSize:10,fontWeight:700,padding:"1px 6px",borderRadius:8,background:"rgba(48,209,88,0.12)",color:"var(--green)",border:"1px solid rgba(48,209,88,0.22)",whiteSpace:"nowrap"}}>🏪 Store</span>
              :null;
          return(
            <tr key={r.id} style={{cursor:"pointer"}} onClick={()=>setViewRepair(r)}
              onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,0.04)"}
              onMouseLeave={e=>e.currentTarget.style.background=""}>
              <td style={{color:"var(--t3)",fontSize:11}}>#{r.id}</td>
              <td style={{fontWeight:500}}>{r.customerName||"No name"}</td>
              <td style={{color:"var(--t3)"}}>{r.device}</td>
              <td style={{color:"var(--t3)",fontSize:11.5}}>{getTypeIcon(r.type)} {r.type}</td>
              <td><span className="sbadge" style={{background:s.bg,color:s.color}}>{s.icon} {r.status}</span></td>
              <td style={{fontWeight:600}}>{fmt(r.price||0)}</td>
              <td style={{color:"var(--orange)"}}>{fmt(pC)}</td>
              <td style={{color:rP>=0?"var(--green)":"var(--red)",fontWeight:600}}>{fmt(rP)}</td>
              <td>{splitBadge}</td>
              <td style={{color:"var(--t3)",fontSize:11}}>{new Date(r.createdAt).toLocaleDateString()}{r.paid&&r.paidAt&&<div style={{color:"var(--green)",fontSize:10,fontWeight:600}}>💵 {new Date(r.paidAt).toLocaleDateString()}</div>}</td>
            </tr>
          );
        })}</tbody>
      </table></div>
      {viewRepair&&(
        <RepairDetailOverlay
          repair={viewRepair}
          onClose={()=>setViewRepair(null)}
          onEdit={rep=>{setViewRepair(null);if(onEditRepair) onEditRepair(rep);}}
          onStatus={()=>{}} onPaid={()=>{}} onDel={()=>{}}
          fmt={fmt} t={t} customers={[]} readOnly={true} allowEdit={!!canEdit&&!!onEditRepair}
        />
      )}
    </>
  );
}

function MonthlyReportPage({t,fmt,repairs,parts,customers,catalog,saveRepairs,saveCustomers,saveParts,saveCatalog,MONTHS,canWrite}){
  const now=new Date();
  const [selY,setSelY]=useState(now.getFullYear());
  const [selM,setSelM]=useState(now.getMonth());
  // Repair being edited in a popup — the report stays exactly where it is underneath
  const [editRepair,setEditRepair]=useState(null);
  function saveEditedRepair(data){
    if(!data.customerName||!data.customerName.trim()) data={...data,customerName:"No name"};
    const typeArr=data.types&&data.types.length?data.types:(data.type?[data.type]:[]);
    saveRepairs(repairs.map(r=>{
      if(r.id!==editRepair.id) return r;
      const ec=data.createdAt?new Date(data.createdAt).toISOString():r.createdAt;
      return{...r,...normalizeDateFields(data),types:typeArr,type:typeArr[0]||"",createdAt:ec,updatedAt:new Date().toISOString()};
    }));
    toast("✏️",t.updated,"Repair saved");
    setEditRepair(null);
  }
  // Last 3 years, plus whichever year is selected (so stepping back never leaves the dropdown blank)
  const YEARS=[...new Set([...Array.from({length:3},(_,i)=>now.getFullYear()-i),selY])].sort((a,b)=>b-a);
  // Step the month back/forward, rolling over the year
  function stepMonth(delta){
    const d=new Date(selY,selM+delta,1);
    setSelM(d.getMonth()); setSelY(d.getFullYear());
  }
  const atCurrentMonth=selY===now.getFullYear()&&selM===now.getMonth();
  const afterCurrentMonth=selY>now.getFullYear()||(selY===now.getFullYear()&&selM>=now.getMonth());
  const mR=repairs.filter(r=>!WAITING_S.includes(r.status)).filter(r=>{const d=new Date(r.createdAt);return d.getMonth()===selM&&d.getFullYear()===selY;});
  const done=mR.filter(r=>r.status==="Done"||r.status==="Delivered"); // for counts only
  // Money follows the PAYMENT date: a repair received last month but paid this
  // month counts here, and no longer touches last month's totals. Older repairs
  // with no recorded payment date fall back to their received date (unchanged).
  const paidM=repairs.filter(r=>isPaidRealised(r)&&isInMonth(getFinanceDate(r),selM,selY));
  const unpaidM=mR.filter(r=>(r.status==="Done"||r.status==="Delivered")&&!r.paid);
  // Rows shown in the table / print: received this month + paid this month
  const reportRows=[...mR,...paidM.filter(p=>!mR.some(r=>r.id===p.id))];
  const revenue=paidM.reduce((s,r)=>s+(parseFloat(r.price)||0),0);
  const deposits=mR.reduce((s,r)=>s+(parseFloat(r.deposit)||0),0);
  const partsCost=paidM.reduce((s,r)=>s+(r.partsUsed||[]).reduce((x,p)=>x+(parseFloat(p.cost)||0)*(p.qty||1),0),0);
  const profit=revenue-partsCost;
  const margin=revenue>0?(profit/revenue*100):0;
  const lossTotal=paidM.filter(r=>calcRepairProfit(r)<0).reduce((s,r)=>s+calcRepairProfit(r),0);
  const unpaidProfitM=unpaidM.reduce((s,r)=>s+calcRepairProfit(r),0);
  const outstanding=mR.filter(r=>!["Delivered","Cancelled"].includes(r.status)).reduce((s,r)=>s+(parseFloat(r.price)||0)-(parseFloat(r.deposit)||0),0);
  const tc={};mR.forEach(r=>{(r.types&&r.types.length?r.types:[r.type||'']).forEach(t=>{if(t)tc[t]=(tc[t]||0)+1;});});
  const typeRows=Object.entries(tc).sort((a,b)=>b[1]-a[1]);
  const pu={};mR.forEach(r=>(r.partsUsed||[]).forEach(p=>{pu[p.name]=pu[p.name]||{name:p.name,qty:0,rev:0};pu[p.name].qty+=p.qty||1;pu[p.name].rev+=p.price*(p.qty||1);}));
  const partRows=Object.values(pu).sort((a,b)=>b.qty-a.qty).slice(0,8);
  const dc={};mR.forEach(r=>{const day=new Date(r.createdAt).getDate();dc[day]=dc[day]||{day,count:0,rev:0};dc[day].count++;if(r.status==="Done"||r.status==="Delivered")dc[day].rev+=(parseFloat(r.price)||0);});
  const dailyArr=Object.values(dc).sort((a,b)=>a.day-b.day);
  const busiest=Object.values(dc).sort((a,b)=>b.count-a.count).slice(0,3);
  const hc=Array(24).fill(0);mR.forEach(r=>{const h=new Date(r.createdAt).getHours();hc[h]++;});
  const peakH=hc.indexOf(Math.max(...hc));
  const tt={contentStyle:{background:"var(--bg2)",border:"1px solid rgba(255,255,255,0.09)",borderRadius:9,fontSize:12,color:"#fff"},cursor:false,wrapperStyle:{outline:"none",background:"transparent"}};
  return(
    <div className="page">
      <div className="ph">
        <div><div className="pt">{t.monthlyReport}</div><div className="ps">{MONTHS[selM]} {selY}</div></div>
        <div style={{display:"flex",gap:7,flexWrap:"wrap"}}>
          {/* Leftmost in the group: its (hidden) space sits in the empty area, so the other buttons never move */}
          <button className="btn bg2 bsm" title="Jump to the current month" disabled={atCurrentMonth} tabIndex={atCurrentMonth?-1:0}
            style={{visibility:atCurrentMonth?"hidden":"visible"}}
            onClick={()=>{setSelM(now.getMonth());setSelY(now.getFullYear());}}>This month</button>
          <button className="btn bg2" style={{padding:"7px 14px",fontSize:16,lineHeight:1}} title="Previous month" onClick={()=>stepMonth(-1)}>‹</button>
          <select className="inp" style={{width:"auto",padding:"7px 11px"}} value={selM} onChange={e=>setSelM(+e.target.value)}>{MONTHS.map((m,i)=><option key={i} value={i}>{m}</option>)}</select>
          <select className="inp" style={{width:"auto",padding:"7px 11px"}} value={selY} onChange={e=>setSelY(+e.target.value)}>{YEARS.map(y=><option key={y}>{y}</option>)}</select>
          <button className="btn bg2" style={{padding:"7px 14px",fontSize:16,lineHeight:1,opacity:afterCurrentMonth?.35:1}} title="Next month" disabled={afterCurrentMonth} onClick={()=>stepMonth(1)}>›</button>
          <button className="btn bg2 bsm" onClick={()=>{
            const rs=getReportSettings();
            const lang=rs.lang||'en';
            const L=getReportI18n(lang,rs);
            const allCols=[
              {key:'id',label:L.colId},{key:'customer',label:L.colCustomer},{key:'device',label:L.colDevice},
              {key:'type',label:L.colType},{key:'status',label:L.colStatus},{key:'price',label:L.colPrice,align:'right'},
              {key:'cost',label:L.colCost,align:'right'},{key:'profit',label:L.colProfit,align:'right'},
              {key:'paid',label:L.colPaid},{key:'paidDate',label:L.colPaidDate},{key:'date',label:L.colDate},
            ];
            const columns=allCols.filter(c=>rs.columns[c.key]!==false);
            const monthNum=String(selM+1).padStart(2,'0');
            printReport({
              title:`${L.reportTitle} — ${monthNum} · ${MONTHS[selM]} ${selY}`,
              subtitle:`${reportRows.length} ${L.repairsWord} · ${L.generatedWord} ${new Date().toLocaleDateString(lang==='ar'?'ar-IQ':'en-US')}`,
              columns,
              lang, headerConfig:rs.header,
              rows:[...reportRows].sort((a,b)=>new Date(b.createdAt)-new Date(a.createdAt)).map(r=>{
                const rowCost=(r.partsUsed||[]).reduce((s,p)=>s+(parseFloat(p.cost)||0)*(p.qty||1),0);
                const rowProfit=(parseFloat(r.price)||0)-rowCost;
                const typesTranslated=(r.types&&r.types.length?r.types:[r.type||'']).map(tp=>translateRepairType(tp,lang,rs)).join(', ');
                return {
                  id:r.id, customer:r.customerName||'No name', device:r.device||'',
                  type:typesTranslated,
                  status:translateStatus(r.status,lang,L), price:fmt(r.price||0),
                  cost:fmt(rowCost), profit:fmt(rowProfit),
                  paid:(r.status==="Done"||r.status==="Delivered")?(r.paid?L.statusPaid:L.statusUnpaid):L.statusNA,
                  paidDate:(r.paid&&r.paidAt)?new Date(r.paidAt).toLocaleDateString(lang==='ar'?'ar-IQ':'en-US'):L.statusNA,
                  date:new Date(r.createdAt).toLocaleDateString(lang==='ar'?'ar-IQ':'en-US'),
                };
              }),
              summary:buildReportSummary({
                totalJobs:String(mR.length),
                paidJobs:String(paidM.length),
                unpaidJobs:String(unpaidM.length),
                revenue:fmt(revenue),
                partsCost:fmt(partsCost),
                netProfit:fmt(profit), netProfitColor:profit>=0?'#0A63C2':'#D92D20',
                pendingProfit:fmt(unpaidProfitM),
                losses:fmt(Math.abs(lossTotal)),
                lossCount:String(paidM.filter(r=>calcRepairProfit(r)<0).length),
                deposits:fmt(deposits),
                outstanding:fmt(Math.max(0,outstanding)),
                avgValue:fmt(paidM.length?revenue/paidM.length:0),
                completionRate:`${(mR.length?done.length/mR.length*100:0).toFixed(0)}%`,
              },lang,rs),
            });
          }}>🖨️ Print Report</button>
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:12,marginBottom:16}}>
        <SC icon="💰" label={t.revenue} value={fmt(revenue)} color="var(--green)" sub={`${paidM.length} paid`}/>
        <SC icon="📈" label={t.netProfit} value={fmt(profit)} color={profit>=0?"var(--blue)":"var(--red)"} sub={`${margin.toFixed(0)}% margin`}/>
        <SC icon="⏳" label="Pending Profit" value={fmt(unpaidProfitM)} color="var(--orange)" sub={`${unpaidM.length} unpaid`}/>
        <SC icon="📉" label={t.losses} value={fmt(Math.abs(lossTotal))} color="var(--red)"/>
        <SC icon="💳" label="Deposits" value={fmt(deposits)} color="var(--teal)"/>
        <SC icon="⏱️" label="Outstanding" value={fmt(Math.max(0,outstanding))} color="var(--orange)"/>
      </div>
      {reportRows.length===0&&<div className="empty"><div className="ei">📅</div><div className="et">No repairs in {MONTHS[selM]} {selY}</div></div>}
      {reportRows.length>0&&(<>
        <div className="card mb14"><div className="stitle">💰 {t.summary}</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(90px,1fr))",gap:10}}>
            {[{label:"Jobs",val:mR.length,col:"var(--tx)"},{label:"Done",val:done.length,col:"var(--green)"},{label:"Paid",val:paidM.length,col:"var(--blue)"},{label:t.revenue,val:fmt(revenue),col:"var(--green)"},{label:t.netProfit,val:fmt(profit),col:profit>=0?"var(--blue)":"var(--red)"},{label:t.losses,val:fmt(Math.abs(lossTotal)),col:"var(--red)"}].map(m=>(
              <div key={m.label} style={{textAlign:"center",padding:"12px 0",background:"rgba(255,255,255,0.03)",borderRadius:10,border:"1px solid var(--glb)"}}><div style={{fontSize:19,fontWeight:700,color:m.col}}>{m.val}</div><div style={{fontSize:10.5,color:"var(--t3)",marginTop:3}}>{m.label}</div></div>
            ))}
          </div>
        </div>
        <SplitSummary repairs={[...paidM,...unpaidM]} monthLabel={`${MONTHS[selM]} ${selY}`} t={t} fmt={fmt}/>
        <TopCatalogInsights repairs={repairs} catalog={catalog||[]} t={t} fmt={fmt} sliceRepairs={mR}/>
        <div className="g2 mb14">
          <div className="card"><div className="stitle">📅 {t.dailyVolume}</div><ResponsiveContainer width="100%" height={150}><BarChart data={dailyArr} barSize={8}><XAxis dataKey="day" axisLine={false} tickLine={false} tick={{fill:"rgba(255,255,255,0.3)",fontSize:9}}/><YAxis hide/><Tooltip {...tt}/><Bar dataKey="count" fill="#0A84FF" radius={[3,3,0,0]}/></BarChart></ResponsiveContainer></div>
          <div className="card"><div className="stitle">⏰ {t.peakHours}</div><div style={{display:"grid",gridTemplateColumns:"repeat(8,1fr)",gap:3,marginTop:4}}>{hc.map((count,h)=>{const mx=Math.max(...hc)||1;const pct=count/mx;return(<div key={h} style={{textAlign:"center"}}><div style={{height:30,borderRadius:4,background:`rgba(10,132,255,${0.1+pct*0.85})`,border:`1px solid rgba(10,132,255,${0.15+pct*0.4})`,marginBottom:2}}/><div style={{fontSize:8,color:"var(--t3)"}}>{h}h</div></div>);})}</div><div style={{fontSize:11,color:"var(--t3)",marginTop:8,textAlign:"center"}}>Peak: <strong style={{color:"var(--blue)"}}>{peakH}:00–{peakH+1}:00</strong></div></div>
        </div>
        {busiest.length>0&&<div className="card mb14"><div className="stitle">🔥 {t.busiestDays}</div><div style={{display:"flex",gap:9}}>{busiest.map((d,i)=>(
          <div key={d.day} style={{flex:1,background:i===0?"rgba(10,132,255,0.1)":"rgba(255,255,255,0.04)",border:`1px solid ${i===0?"rgba(10,132,255,0.3)":"var(--glb)"}`,borderRadius:11,padding:"12px",textAlign:"center"}}>
            <div style={{fontSize:10,color:"var(--t3)",marginBottom:3}}>{i===0?"🥇":i===1?"🥈":"🥉"}</div>
            <div style={{fontSize:18,fontWeight:700,color:i===0?"var(--blue)":"var(--tx)"}}>{MONTHS[selM]} {d.day}</div>
            <div style={{fontSize:11,color:"var(--t3)",marginTop:3}}>{d.count} · {fmt(d.rev)}</div>
          </div>
        ))}</div></div>}
        <div className="g2 mb14">
          <div className="card"><div className="stitle">🔧 {t.byType}</div>{typeRows.map(([type,count],i)=><div key={type} className="mrow"><div style={{display:"flex",alignItems:"center",gap:7}}><span style={{color:"var(--t3)",fontSize:10.5,minWidth:18,fontWeight:600}}>#{i+1}</span><span style={{fontSize:12.5}}>{type}</span></div><div style={{display:"flex",alignItems:"center",gap:8,flex:1,marginLeft:10}}><div className="prog" style={{flex:1}}><div className="progf" style={{width:`${mR.length?count/mR.length*100:0}%`,background:PIE_COLS[i%8]}}/></div><span style={{fontWeight:700,fontSize:12.5,minWidth:18}}>{count}</span></div></div>)}</div>
          <div className="card"><div className="stitle">🔩 {t.mostUsedParts}</div>{partRows.length===0?<div style={{color:"var(--t3)",fontSize:13}}>{t.noParts}</div>:partRows.map((p,i)=><div key={p.name} className="mrow"><div style={{display:"flex",alignItems:"center",gap:7}}><span style={{color:"var(--t3)",fontSize:10.5,minWidth:18,fontWeight:600}}>#{i+1}</span><span style={{fontSize:12,maxWidth:140,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</span></div><div style={{textAlign:"right"}}><div style={{fontWeight:700,fontSize:12.5}}>{p.qty}×</div><div style={{fontSize:10,color:"var(--t3)"}}>{fmt(p.rev)}</div></div></div>)}</div>
        </div>
        <div className="card">
          <div className="stitle">📋 {t.allRepairs} — {MONTHS[selM]} {selY}</div>
          <ReportRepairTable repairs={reportRows} fmt={fmt} t={t} canEdit={typeof canWrite==="function"?canWrite("repairs"):false} onEditRepair={rep=>setEditRepair(rep)}/>
        </div>
      </>)}
      {editRepair&&<RepairModal saveParts={saveParts} saveCatalog={saveCatalog} repair={editRepair} parts={parts||[]} customers={customers||[]} catalog={catalog} onClose={()=>setEditRepair(null)} onSave={saveEditedRepair}
        onNewDevice={devName=>{const newDev={name:devName,id:Date.now().toString(),parts:[]};saveCatalog([...(catalog||[]),newDev]);toast("📋",t.newDeviceAdded,devName);}}
        onNewCustomer={newC=>{saveCustomers([...(customers||[]),newC]);}} t={t} fmt={fmt}/>}
    </div>
  );
}


// ─── DB Manager Component ─────────────────────────────────────────────────────
function ServerSection({t,onDbSwitch}){
  const [serverOk,setServerOk]=useState(false);
  const [checking,setChecking]=useState(false);
  const [dbs,setDbs]=useState([]);
  const [newName,setNewName]=useState('');
  const [isTest,setIsTest]=useState(false);
  const [loading,setLoading]=useState(false);
  const [active,setActive]=useState(ServerDB._active);
  const [deviceDefault,setDeviceDefaultState]=useState(()=>ServerDB.getDeviceDefault());

  function toggleDefault(fname){
    ServerDB.setDeviceDefault(fname===deviceDefault?null:fname);
    setDeviceDefaultState(ServerDB.getDeviceDefault());
    toast('★', fname===deviceDefault?'Default cleared':'Default set', (fname===deviceDefault?'Removed':'This device will auto-load')+' '+fname.replace('.json',''));
  }

  async function refresh(){
    setChecking(true);
    const ok=await ServerDB._ping();
    setServerOk(ok);
    ServerDB._serverAvailable=ok;
    if(ok){ const list=await ServerDB.listDbs(); setDbs(list); }
    else setDbs([]);
    setActive(ServerDB._active);
    setChecking(false);
  }

  useEffect(()=>{ refresh(); },[]);

  async function createDb(){
    if(!newName.trim()) return;
    setLoading(true);
    const fname=await ServerDB.createDb(newName.trim(),isTest);
    setLoading(false);
    if(fname){ await refresh(); setActive(ServerDB._active); onDbSwitch(); toast('✅',t.dbCreated,fname); setNewName(''); setIsTest(false); }
  }

  async function switchDb(fname){
    setLoading(true);
    const ok=await ServerDB.switchDb(fname);
    if(ok){
      setActive(fname);
      await onDbSwitch();   // reload all app state from new DB
      await refresh();      // refresh the DB list UI
      toast('🗄️',t.dbSwitched,fname.replace('.json',''));
    } else {
      toast('❌','Switch failed','Could not load database');
    }
    setLoading(false);
  }

  async function deleteDb(fname){
    if(!window.confirm(`Delete "${fname.replace('.json','')}"? This cannot be undone.`)) return;
    await ServerDB.deleteDb(fname);
    await refresh();
    onDbSwitch();
    toast('🗑️',t.dbDeleted,fname.replace('.json',''));
  }

  async function switchToLocal(){
    await ServerDB.switchToNone();
    setActive(null);
    onDbSwitch();
    toast('💾','Using browser storage','Server DB disconnected');
  }

  return(
    <div style={{display:'flex',flexDirection:'column',gap:12}}>

      {/* Status row */}
      <div style={{display:'flex',alignItems:'center',gap:10,padding:'11px 14px',background:serverOk?'rgba(48,209,88,0.07)':'rgba(255,255,255,0.04)',border:`1px solid ${serverOk?'rgba(48,209,88,0.25)':'var(--glb)'}`,borderRadius:10}}>
        <span style={{fontSize:16}}>{serverOk?'🟢':'⚫'}</span>
        <div style={{flex:1,fontSize:12.5}}>
          {serverOk
            ? <span style={{color:'var(--green)',fontWeight:600}}>Server running — databases stored in <code style={{color:'var(--blue)'}}>data/</code> folder</span>
            : <span style={{color:'var(--t3)'}}>Server not detected — using browser localStorage. Run <code style={{color:'var(--orange)'}}>npm run dev</code> to enable.</span>
          }
        </div>
        <button className="btn bg2 bsm" onClick={refresh} disabled={checking}>{checking?'…':'↻ Check'}</button>
      </div>

      {/* Active DB */}
      {active?(
        <div style={{padding:'11px 14px',background:'rgba(48,209,88,0.08)',border:'1px solid rgba(48,209,88,0.25)',borderRadius:10,display:'flex',alignItems:'center',gap:9,flexWrap:'wrap'}}>
          <span style={{fontSize:16}}>{ServerDB._cache?.isTest?'🧪':'🗄️'}</span>
          <div style={{flex:1}}>
            <div style={{fontWeight:700,color:'var(--green)',fontSize:13}}>{active.replace('.json','')}</div>
            <div style={{fontSize:11,color:'var(--t3)',marginTop:1}}>
              {ServerDB._cache?.isTest?'🧪 TEST  ':''}{(ServerDB._cache?.repairs||[]).length} repairs · {(ServerDB._cache?.customers||[]).length} customers
            </div>
          </div>
          <button className="btn bg2 bsm" onClick={switchToLocal}>↩ Use localStorage</button>
        </div>
      ):(
        serverOk&&<div style={{fontSize:12,color:'var(--t3)',padding:'2px 0'}}>No server DB selected — create one or click Switch on an existing one.</div>
      )}

      {/* Create DB */}
      {serverOk&&(
        <div style={{display:'flex',gap:7,alignItems:'flex-end',flexWrap:'wrap'}}>
          <div className="fg" style={{flex:2,minWidth:140}}>
            <label className="fl">New Database Name</label>
            <input className="inp" value={newName} onChange={e=>setNewName(e.target.value)}
              placeholder="main, branch2, test…" onKeyDown={e=>e.key==='Enter'&&createDb()}/>
          </div>
          <div style={{display:'flex',alignItems:'center',gap:7,paddingBottom:2}}>
            <label className="tog"><input type="checkbox" checked={isTest} onChange={e=>setIsTest(e.target.checked)}/><span className="ts"/></label>
            <span style={{fontSize:12,color:'var(--t3)'}}>🧪 Test DB</span>
          </div>
          <button className="btn bp" style={{height:36,alignSelf:'flex-end'}} onClick={createDb} disabled={loading||!newName.trim()}>
            <I n="plus" s={13} c="#fff"/> Create
          </button>
        </div>
      )}

      {/* DB list */}
      {dbs.length>0&&(
        <div style={{display:'flex',flexDirection:'column',gap:6}}>
          {dbs.map(db=>{
            const isActive=db.name===active;
            return(
              <div key={db.name} style={{display:'flex',alignItems:'center',gap:9,padding:'10px 13px',background:isActive?'rgba(48,209,88,0.08)':'rgba(255,255,255,0.03)',border:`1px solid ${isActive?'rgba(48,209,88,0.3)':'var(--glb)'}`,borderRadius:10}}>
                <span style={{fontSize:16}}>{db.isTest?'🧪':'🗄️'}</span>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:isActive?700:500,fontSize:13,color:isActive?'var(--green)':'var(--tx)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                    {db.name.replace('.json','')}
                    {db.shopName&&db.shopName!==db.name.replace('.json','')&&<span style={{fontWeight:400,color:'var(--t3)',marginLeft:6,fontSize:11}}>({db.shopName})</span>}
                  </div>
                  <div style={{fontSize:10.5,color:'var(--t3)',marginTop:1,display:'flex',gap:8,flexWrap:'wrap'}}>
                    {isActive&&<span style={{color:'var(--green)',fontWeight:600}}>● Active</span>}
                    {db.name===deviceDefault&&<span style={{color:'var(--blue)',fontWeight:600}}>★ Default on this device</span>}
                    <span>{db.repairCount||0} repairs</span>
                    {db.isTest&&<span style={{color:'var(--orange)'}}>TEST</span>}
                  </div>
                </div>
                <button
                  title={db.name===deviceDefault?'Remove as device default':'Set as default for this device (auto-loads on open)'}
                  onClick={()=>toggleDefault(db.name)}
                  style={{fontSize:14,padding:'3px 7px',background:db.name===deviceDefault?'rgba(10,132,255,0.18)':'transparent',border:`1px solid ${db.name===deviceDefault?'rgba(10,132,255,0.3)':'var(--glb)'}`,borderRadius:7,cursor:'pointer',color:db.name===deviceDefault?'var(--blue)':'var(--t3)',lineHeight:1,flexShrink:0}}
                  >★</button>
                {!isActive&&<button className="btn bp bsm" onClick={()=>switchDb(db.name)} disabled={loading}>{t.switchDb}</button>}
                <button className="btn bd bsm" style={{padding:'3px 8px'}} onClick={()=>deleteDb(db.name)}><I n="trash" s={11}/></button>
              </div>
            );
          })}
        </div>
      )}
      {serverOk&&dbs.length===0&&<div style={{color:'var(--t3)',fontSize:13,textAlign:'center',padding:'12px 0'}}>No databases yet — create one above.</div>}

      {/* Not connected: setup hint */}
      {!serverOk&&(
        <div style={{background:'rgba(10,132,255,0.06)',border:'1px solid rgba(10,132,255,0.15)',borderRadius:10,padding:'14px 16px',fontSize:12,lineHeight:2}}>
          <div style={{fontWeight:700,marginBottom:4,fontSize:13}}>🖥️ How to enable the server</div>
          <div style={{color:'var(--t3)'}}>
            1. Make sure <strong style={{color:'var(--tx)'}}>server.js</strong> is in your <code style={{color:'var(--blue)'}}>ams/</code> folder<br/>
            2. Make sure <strong style={{color:'var(--tx)'}}>package.json</strong> has the proxy &amp; dev script (see instructions)<br/>
            3. Stop the current terminal (<kbd style={{background:'rgba(255,255,255,0.08)',padding:'1px 5px',borderRadius:4}}>Ctrl+C</kbd>)<br/>
            4. Run: <code style={{color:'var(--orange)',fontWeight:700}}>npm run dev</code> instead of <code style={{color:'var(--orange)'}}>npm start</code><br/>
            5. Come back here and click <strong style={{color:'var(--tx)'}}>↻ Check</strong>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── SETTINGS ─────────────────────────────────────────────────────────────────
// ─── AssetsCard ───────────────────────────────────────────────────────────────
function AssetsCard({assets,saveAssets}){
  const fileRef=useRef();
  const [renaming,setRenaming]=useState(null); // asset id being renamed
  const [renameVal,setRenameVal]=useState("");
  const [confirm,setConfirm]=useState(null); // id to delete

  function handleUpload(e){
    const files=[...e.target.files];
    if(!files.length)return;
    files.forEach(file=>{
      const reader=new FileReader();
      reader.onload=ev=>{
        const newA={id:Date.now().toString()+Math.random().toString(36).slice(2),name:file.name.replace(/\.[^/.]+$/,""),dataUrl:ev.target.result};
        saveAssets([...assets,newA]);
        toast("🖼️","Uploaded",newA.name);
      };
      reader.readAsDataURL(file);
    });
    e.target.value="";
  }
  function doRename(id){
    if(!renameVal.trim())return;
    saveAssets(assets.map(a=>a.id===id?{...a,name:renameVal.trim()}:a));
    setRenaming(null);
  }
  function doDelete(id){
    saveAssets(assets.filter(a=>a.id!==id));
    setConfirm(null);
    toast("🗑️","Deleted","Asset removed");
  }

  return(
    <div className="card">
      {confirm&&(
        <div className="mo" onClick={()=>setConfirm(null)}>
          <div className="md" style={{maxWidth:320,textAlign:"center"}} onClick={e=>e.stopPropagation()}>
            <div style={{fontSize:28,marginBottom:8}}>🗑️</div>
            <div style={{fontWeight:700,fontSize:14,marginBottom:12}}>Delete this asset?</div>
            <div style={{display:"flex",gap:8,justifyContent:"center"}}>
              <button className="btn bg2" onClick={()=>setConfirm(null)}>Cancel</button>
              <button className="btn bd" onClick={()=>doDelete(confirm)}>Delete</button>
            </div>
          </div>
        </div>
      )}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:13}}>
        <div className="stitle" style={{marginBottom:0}}>🖼️ Assets</div>
        <button className="btn bp bsm" onClick={()=>fileRef.current?.click()}><I n="plus" s={12} c="#fff"/> Upload</button>
        <input ref={fileRef} type="file" accept="image/*" multiple style={{display:"none"}} onChange={handleUpload}/>
      </div>
      <div style={{fontSize:11.5,color:"var(--t3)",marginBottom:12,lineHeight:1.6}}>
        Upload logos, icons, or images here. Use them anywhere in the app via the image picker dropdown.
      </div>
      {assets.length===0
        ? <div style={{color:"var(--t3)",fontSize:13,textAlign:"center",padding:"16px 0"}}>No assets yet — click Upload to add images</div>
        : <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(90px,1fr))",gap:8}}>
            {assets.map(a=>(
              <div key={a.id} style={{background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:11,padding:"9px 8px",display:"flex",flexDirection:"column",alignItems:"center",gap:6}}>
                <img src={a.dataUrl} alt={a.name} style={{width:52,height:52,objectFit:"contain",borderRadius:8}}/>
                {renaming===a.id
                  ? <div style={{display:"flex",flexDirection:"column",gap:4,width:"100%"}}>
                      <input className="inp" value={renameVal} onChange={e=>setRenameVal(e.target.value)}
                        onKeyDown={e=>{if(e.key==="Enter")doRename(a.id);if(e.key==="Escape")setRenaming(null);}}
                        style={{fontSize:11,padding:"3px 6px",textAlign:"center"}} autoFocus/>
                      <div style={{display:"flex",gap:3}}>
                        <button className="btn bp bsm" style={{flex:1,justifyContent:"center",fontSize:10}} onClick={()=>doRename(a.id)}>✓</button>
                        <button className="btn bg2 bsm" style={{flex:1,justifyContent:"center",fontSize:10}} onClick={()=>setRenaming(null)}>✕</button>
                      </div>
                    </div>
                  : <>
                      <div style={{fontSize:10.5,color:"var(--t2)",textAlign:"center",wordBreak:"break-word",lineHeight:1.3,width:"100%"}}>{a.name}</div>
                      <div style={{display:"flex",gap:4}}>
                        <button className="btn bg2 bsm" style={{padding:"2px 7px",fontSize:10}} onClick={()=>{setRenaming(a.id);setRenameVal(a.name);}} title="Rename">✏️</button>
                        <button className="btn bd bsm" style={{padding:"2px 7px",fontSize:10}} onClick={()=>setConfirm(a.id)} title="Delete"><I n="trash" s={10}/></button>
                      </div>
                    </>
                }
              </div>
            ))}
          </div>
      }
    </div>
  );
}

// ─── BrandsCard ───────────────────────────────────────────────────────────────
function BrandsCard({brands,saveBrands}){
  const [editing,setEditing]=useState(null); // brand object being edited (null=none, "add"=new)
  const [eForm,setEForm]=useState({name:"",emoji:"📱",logoUrl:""});
  const [confirmDel,setConfirmDel]=useState(null);
  // Merge defaults with saved overrides for display
  const allBrands=getActiveBrands();

  function openEdit(b){setEForm({name:b.name,emoji:b.emoji||"📱",logoUrl:b.logoUrl||""});setEditing(b.name);}
  function openAdd(){setEForm({name:"",emoji:"📱",logoUrl:""});setEditing("add");}
  function handleSave(){
    if(!eForm.name.trim())return;
    const entry={name:eForm.name.trim(),emoji:eForm.emoji||"📱",logoUrl:eForm.logoUrl||""};
    const existing=brands.find(b=>b.name===entry.name);
    if(existing) saveBrands(brands.map(b=>b.name===entry.name?{...b,...entry}:b));
    else saveBrands([...brands,entry]);
    setEditing(null);
    toast("✅","Saved",entry.name);
  }
  function handleDelete(name){
    saveBrands(brands.filter(b=>b.name!==name));
    setConfirmDel(null);
    toast("🗑️","Deleted",name);
  }
  // Reset a brand to its default
  function handleReset(name){
    saveBrands(brands.filter(b=>b.name!==name));
    toast("↩️","Reset",name+" to default");
  }

  return(
    <div className="card">
      {confirmDel&&(
        <div className="mo" onClick={()=>setConfirmDel(null)}>
          <div className="md" style={{maxWidth:320,textAlign:"center"}} onClick={e=>e.stopPropagation()}>
            <div style={{fontSize:28,marginBottom:8}}>🗑️</div>
            <div style={{fontWeight:700,fontSize:14,marginBottom:4}}>Delete brand "{confirmDel}"?</div>
            <div style={{fontSize:12,color:"var(--t3)",marginBottom:14}}>Default brands will revert to defaults. Custom-added brands will be removed.</div>
            <div style={{display:"flex",gap:8,justifyContent:"center"}}>
              <button className="btn bg2" onClick={()=>setConfirmDel(null)}>Cancel</button>
              <button className="btn bd" onClick={()=>handleDelete(confirmDel)}>Delete</button>
            </div>
          </div>
        </div>
      )}
      {editing&&(
        <div className="mo">
          <div className="md" style={{maxWidth:400}} onClick={e=>e.stopPropagation()}>
            <div className="mh">
              <div className="mt2">{editing==="add"?"Add Brand":"Edit Brand"}</div>
              <span style={{cursor:"pointer"}} onClick={()=>setEditing(null)}><I n="close" s={15} c="var(--t3)"/></span>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:13,marginBottom:16}}>
              {/* Preview */}
              <div style={{display:"flex",alignItems:"center",gap:12,padding:"10px 13px",background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:10}}>
                <div style={{width:44,height:44,borderRadius:12,background:"rgba(10,132,255,0.1)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  {getBrandDisplay(eForm.name,eForm.logoUrl,32)}
                </div>
                <div>
                  <div style={{fontWeight:700,fontSize:14}}>{eForm.name||<span style={{color:"var(--t3)"}}>Brand name</span>}</div>
                  <div style={{fontSize:11.5,color:"var(--t3)",marginTop:1}}>{eForm.emoji}</div>
                </div>
              </div>
              <div className="fg"><label className="fl">Brand Name</label>
                <input className="inp" value={eForm.name} onChange={e=>setEForm(f=>({...f,name:e.target.value}))} placeholder="e.g. Nothing" autoFocus={editing==="add"}/>
              </div>
              <div className="fg"><label className="fl">Emoji Icon <span style={{fontWeight:400,color:"var(--t3)",fontSize:10.5}}>(shown when no logo set)</span></label>
                <input className="inp" value={eForm.emoji} onChange={e=>setEForm(f=>({...f,emoji:e.target.value}))} placeholder="📱" style={{fontSize:20,letterSpacing:2}}/>
              </div>
              <div>
                <label className="fl" style={{marginBottom:6}}>Logo Image</label>
                <AssetPicker value={eForm.logoUrl} onChange={v=>setEForm(f=>({...f,logoUrl:v}))} placeholder="No logo (use emoji)"/>
              </div>
            </div>
            <div className="ma">
              <button className="btn bg2" onClick={()=>setEditing(null)}>Cancel</button>
              <button className="btn bp" onClick={handleSave}>Save Brand</button>
            </div>
          </div>
        </div>
      )}

      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:13}}>
        <div className="stitle" style={{marginBottom:0}}>📱 Brands</div>
        <button className="btn bp bsm" onClick={openAdd}><I n="plus" s={12} c="#fff"/> Add Brand</button>
      </div>
      <div style={{fontSize:11.5,color:"var(--t3)",marginBottom:12}}>Edit brand icons or logos. Changes apply everywhere in the app.</div>
      <div style={{display:"flex",flexDirection:"column",gap:6}}>
        {allBrands.map(b=>{
          const isCustomized=brands.find(cb=>cb.name===b.name);
          const isAddedByUser=isCustomized&&!BRANDS_DEFAULTS.find(d=>d.name===b.name);
          return(
            <div key={b.name} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 10px",background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:10}}>
              <div style={{width:48,height:48,borderRadius:11,background:"rgba(10,132,255,0.07)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                {getBrandDisplay(b.name,b.logoUrl,34)}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:13,fontWeight:600}}>{b.name}</div>
                <div style={{fontSize:10.5,color:"var(--t3)",marginTop:1,display:"flex",gap:5,alignItems:"center"}}>
                  <span>{b.emoji}</span>
                  {isAddedByUser&&<span style={{color:"var(--blue)"}}>custom</span>}
                  {isCustomized&&!isAddedByUser&&<span style={{color:"var(--orange)"}}>modified</span>}
                </div>
              </div>
              <div style={{display:"flex",gap:5}}>
                <button className="btn bg2 bsm" onClick={()=>openEdit(b)} title="Edit"><I n="edit" s={11}/></button>
                {isCustomized&&!isAddedByUser&&<button className="btn bg2 bsm" onClick={()=>handleReset(b.name)} title="Reset to default" style={{fontSize:11}}>↩️</button>}
                {isAddedByUser&&<button className="btn bd bsm" onClick={()=>setConfirmDel(b.name)} title="Delete"><I n="trash" s={11}/></button>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─── Template Editor (standalone component so hooks work correctly) ───────────

// Renders Telegram HTML-mode markup to React nodes
function renderTelegramMarkup(text){
  // Telegram HTML: <b>, <i>, <u>, <s>, <code>, <pre>, <tg-spoiler>, <a href>
  // Also supports markdown-style: *bold*, _italic_, __underline__, `code`, ||spoiler||
  const parts=[];let i=0;let key=0;
  const raw=text;
  // Convert markdown shortcuts to HTML-like tokens first
  const normalized=raw
    .replace(/\|\|(.+?)\|\|/g,'<tg-spoiler>$1</tg-spoiler>')
    .replace(/\*\*(.+?)\*\*/g,'<b>$1</b>')
    .replace(/__(.+?)__/g,'<u>$1</u>')
    .replace(/\*([^*\n]+?)\*/g,'<b>$1</b>')
    .replace(/_([^_\n]+?)_/g,'<i>$1</i>')
    .replace(/`([^`\n]+?)`/g,'<code>$1</code>');
  // Now parse HTML tags
  const tokenRe=/<(\/?)(\w[\w-]*)([^>]*)>|([^<]+)/g;
  let m; const stack=[];
  function flush(s){if(s) parts.push(<span key={key++}>{s}</span>);}
  // Simple recursive-ish approach: just do one-level inline replacement
  const segments=normalized.split(/(<[^>]+>.*?<\/[^>]+>|<[^>]+\/>)/s);
  // Fallback: just do a simpler regex-based pass
  const result=[];let src2=normalized;
  const tagRe=/<b>([\s\S]*?)<\/b>|<i>([\s\S]*?)<\/i>|<u>([\s\S]*?)<\/u>|<s>([\s\S]*?)<\/s>|<code>([\s\S]*?)<\/code>|<pre>([\s\S]*?)<\/pre>|<tg-spoiler>([\s\S]*?)<\/tg-spoiler>|<a href="([^"]*)">([\s\S]*?)<\/a>|([^<]+|<)/g;
  let match;
  while((match=tagRe.exec(src2))!==null){
    const[,b,it,u,s,code,pre,spoiler,href,atext,plain]=match;
    if(b!==undefined) result.push(<strong key={key++}>{b}</strong>);
    else if(it!==undefined) result.push(<em key={key++}>{it}</em>);
    else if(u!==undefined) result.push(<span key={key++} style={{textDecoration:'underline'}}>{u}</span>);
    else if(s!==undefined) result.push(<span key={key++} style={{textDecoration:'line-through'}}>{s}</span>);
    else if(code!==undefined) result.push(<code key={key++} style={{background:'rgba(255,255,255,0.12)',borderRadius:3,padding:'1px 4px',fontFamily:'monospace',fontSize:'0.92em'}}>{code}</code>);
    else if(pre!==undefined) result.push(<pre key={key++} style={{background:'rgba(255,255,255,0.08)',borderRadius:6,padding:'6px 9px',fontFamily:'monospace',fontSize:'0.88em',margin:'4px 0',overflowX:'auto'}}>{pre}</pre>);
    else if(spoiler!==undefined) result.push(<span key={key++} style={{background:'rgba(255,255,255,0.15)',borderRadius:3,padding:'1px 4px',cursor:'pointer',color:'transparent',userSelect:'none'}} title="Spoiler (tap to reveal)">{spoiler}</span>);
    else if(atext!==undefined) result.push(<a key={key++} href={href} style={{color:'#64b5f6'}} target="_blank" rel="noreferrer">{atext}</a>);
    else if(plain) result.push(<span key={key++}>{plain}</span>);
  }
  return result.length?result:[text];
}

// Renders WhatsApp formatting to React nodes
function renderWhatsAppMarkup(text){
  let key=0;
  const result=[];
  // WhatsApp: *bold*, _italic_, ~strikethrough~, `mono`, ```code block```
  const re=/```([\s\S]*?)```|`([^`\n]+?)`|\*([^*\n]+?)\*|_([^_\n]+?)_|~([^~\n]+?)~|([^`*_~\n]+|\n)/g;
  let m;
  while((m=re.exec(text))!==null){
    const[,codeBlock,mono,bold,ital,strike,plain]=m;
    if(codeBlock!==undefined) result.push(<pre key={key++} style={{background:'rgba(0,0,0,0.25)',borderRadius:6,padding:'6px 9px',fontFamily:'monospace',fontSize:'0.88em',margin:'4px 0',overflowX:'auto'}}>{codeBlock}</pre>);
    else if(mono!==undefined) result.push(<code key={key++} style={{background:'rgba(0,0,0,0.2)',borderRadius:3,padding:'1px 4px',fontFamily:'monospace',fontSize:'0.92em'}}>{mono}</code>);
    else if(bold!==undefined) result.push(<strong key={key++}>{bold}</strong>);
    else if(ital!==undefined) result.push(<em key={key++}>{ital}</em>);
    else if(strike!==undefined) result.push(<span key={key++} style={{textDecoration:'line-through',color:'rgba(255,255,255,0.55)'}}>{strike}</span>);
    else if(plain!==undefined) result.push(<span key={key++}>{plain}</span>);
  }
  return result.length?result:[text];
}

// Format legend for the cheat-sheet panel
const TG_FORMATS=[
  {syntax:'<b>text</b>  or  *text*',  label:'Bold',          preview:<strong>text</strong>},
  {syntax:'<i>text</i>  or  _text_',  label:'Italic',        preview:<em>text</em>},
  {syntax:'<u>text</u>  or  __text__',label:'Underline',     preview:<span style={{textDecoration:'underline'}}>text</span>},
  {syntax:'<s>text</s>',             label:'Strikethrough',  preview:<span style={{textDecoration:'line-through'}}>text</span>},
  {syntax:'`code`  or  <code>',      label:'Inline code',   preview:<code style={{background:'rgba(255,255,255,0.12)',borderRadius:3,padding:'1px 4px',fontFamily:'monospace',fontSize:'0.9em'}}>code</code>},
  {syntax:'<pre>block</pre>',         label:'Code block',    preview:<pre style={{background:'rgba(255,255,255,0.08)',borderRadius:4,padding:'3px 7px',fontFamily:'monospace',fontSize:'0.85em',margin:0,display:'inline'}}>block</pre>},
  {syntax:'||text||',                label:'Spoiler',        preview:<span style={{background:'rgba(255,255,255,0.15)',borderRadius:3,padding:'1px 4px',color:'transparent',cursor:'pointer'}}>text</span>},
  {syntax:'<a href="url">link</a>',   label:'Hyperlink',     preview:<a href="#" style={{color:'#64b5f6'}} onClick={e=>e.preventDefault()}>link</a>},
];
const WA_FORMATS=[
  {syntax:'*text*',   label:'Bold',         preview:<strong>text</strong>},
  {syntax:'_text_',   label:'Italic',       preview:<em>text</em>},
  {syntax:'~text~',   label:'Strikethrough',preview:<span style={{textDecoration:'line-through'}}>text</span>},
  {syntax:'`code`',   label:'Inline code',  preview:<code style={{background:'rgba(0,0,0,0.2)',borderRadius:3,padding:'1px 4px',fontFamily:'monospace',fontSize:'0.9em'}}>code</code>},
  {syntax:'```block```',label:'Code block', preview:<code style={{background:'rgba(0,0,0,0.25)',borderRadius:4,padding:'1px 6px',fontFamily:'monospace',fontSize:'0.85em'}}>block</code>},
];

const TEMPLATE_DEFS = [
  {
    key:'done', label:'✅ Repair Done', dest:'→ Customer via Telegram', app:'telegram',
    color:'rgba(48,209,88,0.12)', border:'rgba(48,209,88,0.25)', accent:'var(--green)',
    vars:[
      {v:'name',desc:'Customer name'},{v:'device',desc:'Device model'},{v:'type',desc:'Repair type'},
      {v:'id',desc:'Job number'},{v:'shop',desc:'Shop name'},{v:'price',desc:'Total price'},
      {v:'deposit',desc:'Deposit paid'},{v:'warranty',desc:'Warranty months'},
      {v:'phone',desc:'Customer phone'},{v:'imei',desc:'IMEI / Serial'},
      {v:'technician',desc:'Assigned technician'},{v:'priority',desc:'Priority level'},
    ],
    sample:{name:'Ahmed',device:'iPhone 14 Pro',type:'Screen Replacement',id:'1042',shop:'RepairOS',price:'65,000',deposit:'20,000',warranty:'3',phone:'+964 770 123 4567',imei:'357398110033456',technician:'Ali',priority:'High'},
  },
  {
    key:'done_wa', label:'✅ Repair Done (WhatsApp)', dest:'→ Customer via WhatsApp', app:'whatsapp',
    color:'rgba(37,211,102,0.1)', border:'rgba(37,211,102,0.28)', accent:'#25d366',
    vars:[
      {v:'name',desc:'Customer name'},{v:'device',desc:'Device model'},{v:'type',desc:'Repair type'},
      {v:'id',desc:'Job number'},{v:'shop',desc:'Shop name'},{v:'price',desc:'Total price'},
      {v:'deposit',desc:'Deposit paid'},{v:'warranty',desc:'Warranty months'},
      {v:'phone',desc:'Customer phone'},{v:'technician',desc:'Assigned technician'},
    ],
    sample:{name:'Ahmed',device:'iPhone 14 Pro',type:'Screen Replacement',id:'1042',shop:'RepairOS',price:'65,000',deposit:'20,000',warranty:'3',phone:'+964 770 123 4567',technician:'Ali'},
  },
  {
    key:'repair_delivered', label:'📦 Device Delivered', dest:'→ Technicians via Telegram', app:'telegram',
    color:'rgba(90,200,250,0.08)', border:'rgba(90,200,250,0.22)', accent:'var(--teal)',
    vars:[
      {v:'name',desc:'Customer name'},{v:'device',desc:'Device model'},{v:'id',desc:'Job number'},
      {v:'shop',desc:'Shop name'},{v:'price',desc:'Total price'},{v:'phone',desc:'Customer phone'},
      {v:'warranty',desc:'Warranty months'},
    ],
    sample:{name:'Sara',device:'Samsung S24',id:'1043',shop:'RepairOS',price:'45,000',phone:'+964 771 987 6543',warranty:'6'},
  },
  {
    key:'new_repair', label:'📱 New Repair', dest:'→ Technicians via Telegram', app:'telegram',
    color:'rgba(10,132,255,0.08)', border:'rgba(10,132,255,0.22)', accent:'var(--blue)',
    vars:[
      {v:'name',desc:'Customer name'},{v:'device',desc:'Device model'},{v:'type',desc:'Repair type'},
      {v:'id',desc:'Job number'},{v:'shop',desc:'Shop name'},{v:'phone',desc:'Customer phone'},
      {v:'imei',desc:'IMEI / Serial'},{v:'priority',desc:'Priority level'},
      {v:'price',desc:'Quoted price'},{v:'deposit',desc:'Deposit paid'},{v:'notes',desc:'Repair notes'},
    ],
    sample:{name:'Khalid',device:'iPad Pro 11"',type:'Battery Replacement',id:'1044',shop:'RepairOS',phone:'+964 772 555 1234',imei:'N/A',priority:'High',price:'55,000',deposit:'15,000',notes:'Screen has a minor crack, customer aware'},
  },
  {
    key:'warranty_expiring', label:'🛡️ Warranty Expiring', dest:'→ Technicians via Telegram', app:'telegram',
    color:'rgba(255,159,10,0.08)', border:'rgba(255,159,10,0.22)', accent:'var(--orange)',
    vars:[
      {v:'name',desc:'Customer name'},{v:'device',desc:'Device model'},
      {v:'date',desc:'Expiry date'},{v:'shop',desc:'Shop name'},
    ],
    sample:{name:'Layla',device:'MacBook Air M2',date:'Apr 15, 2026',shop:'RepairOS'},
  },
  {
    key:'low_stock', label:'⚠️ Low Stock', dest:'→ Technicians via Telegram', app:'telegram',
    color:'rgba(255,69,58,0.08)', border:'rgba(255,69,58,0.22)', accent:'var(--red)',
    vars:[
      {v:'part',desc:'Part name'},{v:'brand',desc:'Part brand'},{v:'qty',desc:'Remaining stock'},
      {v:'threshold',desc:'Low stock threshold'},{v:'shop',desc:'Shop name'},
    ],
    sample:{part:'iPhone 14 Pro Screen',brand:'Apple',qty:'2',threshold:'3',shop:'RepairOS'},
  },
  {
    key:'withdrawal', label:'💸 Withdrawal', dest:'→ Technicians via Telegram', app:'telegram',
    color:'rgba(191,90,242,0.08)', border:'rgba(191,90,242,0.22)', accent:'var(--purple)',
    vars:[
      {v:'amount',desc:'Withdrawn amount'},{v:'note',desc:'Reason / note'},
    ],
    sample:{amount:'150,000 IQD',note:'Weekly owner withdrawal'},
  },
];
function TemplateEditor({templates,saveTpl,saveAll}){
  const [activeKey,setActiveKey]=useState('done');
  const [previewOpen,setPreviewOpen]=useState(true);
  const [fmtOpen,setFmtOpen]=useState(false);
  const textareaRef=useRef();
  const def=TEMPLATE_DEFS.find(d=>d.key===activeKey)||TEMPLATE_DEFS[0];
  const isWA=def.app==='whatsapp';

  // Default messages map for Reset button
  const DEFAULTS={
    done:`✅ Hi {name}! Your <b>{device}</b> is ready! 🎉\nThank you for choosing <b>{shop}</b>!`,
    done_wa:`✅ Hi {name}! Your *{device}* is ready! 🎉\nThank you for choosing *{shop}*!`,
    repair_delivered:`📦 <b>Device Collected</b>\nCustomer: {name}\nDevice: {device}\nJob: #{id}`,
    new_repair:`🔧 <b>New Repair</b>\nCustomer: {name}\nDevice: {device}\nType: {type}\nJob: #{id}\nPriority: {priority}`,
    warranty_expiring:`🛡️ <b>Warranty Expiring</b>\nCustomer: {name}\nDevice: {device}\nExpires: {date}`,
    low_stock:`⚠️ <b>Low Stock Alert</b>\n{part} ({brand})\nOnly <b>{qty}</b> units left!\nShop: {shop}`,
    withdrawal:`💸 <b>Withdrawal: {amount}</b>\nNote: {note}`,
  };

  function insertVar(v){
    const ta=textareaRef.current; if(!ta) return;
    const start=ta.selectionStart, end=ta.selectionEnd;
    const cur=templates[activeKey]||'';
    const next=cur.slice(0,start)+`{${v}}`+cur.slice(end);
    saveTpl(activeKey,next);
    setTimeout(()=>{ta.focus();ta.setSelectionRange(start+v.length+2,start+v.length+2);},0);
  }
  function insertFmt(open,close){
    const ta=textareaRef.current; if(!ta) return;
    const start=ta.selectionStart, end=ta.selectionEnd;
    const cur=templates[activeKey]||'';
    const selected=cur.slice(start,end)||'text';
    const next=cur.slice(0,start)+open+selected+close+cur.slice(end);
    saveTpl(activeKey,next);
    setTimeout(()=>{ta.focus();ta.setSelectionRange(start+open.length,start+open.length+selected.length);},0);
  }
  function buildPreview(){
    const shopName=SDB.get('shop_name')||'RepairOS';
    let msg=templates[activeKey]||'';
    const sample={...def.sample,shop:shopName};
    Object.entries(sample).forEach(([k,v])=>{msg=msg.replaceAll(`{${k}}`,String(v));});
    // Mark unfilled vars
    msg=msg.replace(/\{[^}]+\}/g,m=>`⟦${m.slice(1,-1)}⟧`);
    return msg;
  }
  function renderPreview(){
    const raw=buildPreview();
    // Split by newlines first to preserve them
    return raw.split('\n').map((line,li,arr)=>(
      <span key={li}>
        {isWA?renderWhatsAppMarkup(line):renderTelegramMarkup(line)}
        {li<arr.length-1&&<br/>}
      </span>
    ));
  }
  const charCount=(templates[activeKey]||'').length;
  const lineCount=(templates[activeKey]||'').split('\n').length;

  // Telegram formatting toolbar buttons
  const tgToolbar=[
    {label:'B', title:'Bold',        open:'<b>',  close:'</b>',  style:{fontWeight:700}},
    {label:'I', title:'Italic',      open:'<i>',  close:'</i>',  style:{fontStyle:'italic'}},
    {label:'U', title:'Underline',   open:'<u>',  close:'</u>',  style:{textDecoration:'underline'}},
    {label:'S', title:'Strikethrough',open:'<s>', close:'</s>',  style:{textDecoration:'line-through'}},
    {label:'`', title:'Inline code', open:'`',    close:'`',     style:{fontFamily:'monospace'}},
    {label:'||',title:'Spoiler',     open:'||',   close:'||',    style:{opacity:.6}},
  ];
  const waToolbar=[
    {label:'B', title:'Bold',        open:'*',   close:'*',  style:{fontWeight:700}},
    {label:'I', title:'Italic',      open:'_',   close:'_',  style:{fontStyle:'italic'}},
    {label:'S', title:'Strikethrough',open:'~',  close:'~',  style:{textDecoration:'line-through'}},
    {label:'`', title:'Inline code', open:'`',   close:'`',  style:{fontFamily:'monospace'}},
  ];
  const toolbar=isWA?waToolbar:tgToolbar;

  return(
    <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(300px,1fr))',gap:13,alignItems:'start'}}>
      {/* Left: template selector + format cheatsheet */}
      <div style={{display:'flex',flexDirection:'column',gap:5}}>
        {TEMPLATE_DEFS.map(d=>{
          const used=d.vars.filter(({v})=>(templates[d.key]||'').includes(`{${v}}`)).length;
          const isWAd=d.app==='whatsapp';
          return(
            <button key={d.key} onClick={()=>setActiveKey(d.key)}
              style={{display:'flex',alignItems:'center',gap:9,padding:'9px 12px',borderRadius:10,border:`1px solid ${activeKey===d.key?d.border:'var(--glb)'}`,background:activeKey===d.key?d.color:'transparent',cursor:'pointer',textAlign:'left',transition:'all .15s'}}>
              <span style={{fontSize:17,flexShrink:0}}>{d.label.split(' ')[0]}</span>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:12,fontWeight:activeKey===d.key?700:500,color:activeKey===d.key?d.accent:'var(--tx)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{d.label.split(' ').slice(1).join(' ')}</div>
                <div style={{fontSize:10,color:'var(--t3)',marginTop:1,display:'flex',alignItems:'center',gap:5}}>
                  <span style={{padding:'1px 5px',borderRadius:4,fontSize:9,fontWeight:700,background:isWAd?'rgba(37,211,102,0.15)':'rgba(10,132,255,0.12)',color:isWAd?'#25d366':'var(--blue)'}}>{isWAd?'WhatsApp':'Telegram'}</span>
                  <span>{d.dest.replace('→ ','').replace(' via Telegram','').replace(' via WhatsApp','')}</span>
                </div>
              </div>
              <div style={{fontSize:10,color:'var(--t3)',flexShrink:0}}>{used}/{d.vars.length}</div>
            </button>
          );
        })}

        {/* Format cheat sheet */}
        <div style={{marginTop:4,background:'rgba(255,255,255,0.03)',border:'1px solid var(--glb)',borderRadius:10,overflow:'hidden'}}>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'9px 12px',cursor:'pointer'}} onClick={()=>setFmtOpen(v=>!v)}>
            <div style={{fontSize:11,fontWeight:700,color:'var(--t2)'}}>📐 Formatting reference</div>
            <span style={{color:'var(--t3)',fontSize:13,transform:fmtOpen?'rotate(180deg)':'none',display:'inline-block',transition:'transform .15s'}}>▾</span>
          </div>
          {fmtOpen&&(
            <div style={{borderTop:'1px solid var(--glb)',padding:'10px 12px'}}>
              <div style={{fontSize:10,fontWeight:700,color:'var(--t3)',marginBottom:7,letterSpacing:.4}}>TELEGRAM (HTML mode)</div>
              <div style={{display:'flex',flexDirection:'column',gap:5,marginBottom:12}}>
                {TG_FORMATS.map(f=>(
                  <div key={f.label} style={{display:'flex',alignItems:'center',gap:8}}>
                    <code style={{fontSize:9.5,color:'var(--blue)',minWidth:130,flexShrink:0,background:'rgba(10,132,255,0.08)',padding:'2px 5px',borderRadius:4}}>{f.syntax}</code>
                    <span style={{fontSize:11,color:'var(--t3)',minWidth:80}}>{f.label}</span>
                    <span style={{fontSize:11}}>{f.preview}</span>
                  </div>
                ))}
              </div>
              <div style={{fontSize:10,fontWeight:700,color:'var(--t3)',marginBottom:7,letterSpacing:.4}}>WHATSAPP</div>
              <div style={{display:'flex',flexDirection:'column',gap:5}}>
                {WA_FORMATS.map(f=>(
                  <div key={f.label} style={{display:'flex',alignItems:'center',gap:8}}>
                    <code style={{fontSize:9.5,color:'#25d366',minWidth:90,flexShrink:0,background:'rgba(37,211,102,0.08)',padding:'2px 5px',borderRadius:4}}>{f.syntax}</code>
                    <span style={{fontSize:11,color:'var(--t3)',minWidth:80}}>{f.label}</span>
                    <span style={{fontSize:11}}>{f.preview}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Right: editor + preview */}
      <div style={{display:'flex',flexDirection:'column',gap:11}}>
        {/* Editor card */}
        <div style={{padding:'13px 14px',background:def.color,border:`1px solid ${def.border}`,borderRadius:14}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:9}}>
            <div style={{display:'flex',alignItems:'center',gap:7}}>
              <div style={{fontSize:12.5,fontWeight:700,color:def.accent}}>{def.label}</div>
              <span style={{padding:'1px 6px',borderRadius:4,fontSize:9.5,fontWeight:700,background:isWA?'rgba(37,211,102,0.15)':'rgba(10,132,255,0.12)',color:isWA?'#25d366':'var(--blue)'}}>{isWA?'WhatsApp':'Telegram'}</span>
            </div>
            <div style={{display:'flex',gap:6,alignItems:'center'}}>
              <span style={{fontSize:10,color:'var(--t3)'}}>{charCount}ch · {lineCount}L</span>
              <button onClick={()=>saveTpl(activeKey,DEFAULTS[activeKey]||'')}
                style={{fontSize:10,padding:'2px 7px',background:'rgba(255,255,255,0.07)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:5,color:'var(--t3)',cursor:'pointer'}}>↺ Reset</button>
            </div>
          </div>
          {/* Formatting toolbar */}
          <div style={{display:'flex',gap:4,marginBottom:7,flexWrap:'wrap'}}>
            {toolbar.map(b=>(
              <button key={b.label} title={b.title} onClick={()=>insertFmt(b.open,b.close)}
                style={{...b.style,padding:'3px 8px',fontSize:11,background:'rgba(255,255,255,0.07)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:5,cursor:'pointer',color:'var(--t2)',minWidth:28,textAlign:'center'}}>
                {b.label}
              </button>
            ))}
            <div style={{flex:1}}/>
            <span style={{fontSize:9.5,color:'var(--t3)',alignSelf:'center',fontStyle:'italic'}}>select text then click</span>
          </div>
          <textarea ref={textareaRef} className="inp" rows={5} value={templates[activeKey]||''} onChange={e=>saveTpl(activeKey,e.target.value)}
            style={{resize:'vertical',fontSize:12.5,fontFamily:'monospace',lineHeight:1.7,background:'rgba(0,0,0,0.18)',border:'1px solid rgba(255,255,255,0.1)'}}/>
          {/* Variable chips */}
          <div style={{marginTop:9}}>
            <div style={{fontSize:9.5,color:'var(--t3)',fontWeight:700,letterSpacing:.5,marginBottom:5}}>📌 INSERT VARIABLE AT CURSOR</div>
            <div style={{display:'flex',flexWrap:'wrap',gap:4}}>
              {def.vars.map(({v,desc})=>{
                const inUse=(templates[activeKey]||'').includes(`{${v}}`);
                return(
                  <button key={v} onClick={()=>insertVar(v)} title={desc}
                    style={{fontSize:10.5,padding:'2px 9px',background:inUse?'rgba(10,132,255,0.15)':'rgba(255,255,255,0.05)',border:`1px solid ${inUse?'rgba(10,132,255,0.35)':'rgba(255,255,255,0.1)'}`,borderRadius:5,cursor:'pointer',color:inUse?'var(--blue)':'var(--t2)',fontFamily:'monospace',fontWeight:600}}>
                    {'{'+v+'}'}
                  </button>
                );
              })}
            </div>
            <div style={{marginTop:6,display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(150px,1fr))',gap:'2px 10px'}}>
              {def.vars.map(({v,desc})=>(
                <div key={v} style={{fontSize:9.5,color:'var(--t3)',display:'flex',gap:3}}>
                  <code style={{color:'var(--blue)',fontSize:9.5}}>{'{'+v+'}'}</code>
                  <span>— {desc}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Live preview */}
        <div style={{background:'rgba(255,255,255,0.03)',border:'1px solid var(--glb)',borderRadius:14,overflow:'hidden'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',cursor:'pointer',padding:'11px 14px'}} onClick={()=>setPreviewOpen(v=>!v)}>
            <div style={{fontSize:12,fontWeight:700,color:'var(--t2)'}}>👁️ Message Preview</div>
            <div style={{display:'flex',alignItems:'center',gap:8}}>
              <span style={{fontSize:10,color:'var(--t3)'}}>formatted · sample data</span>
              <span style={{color:'var(--t3)',display:'inline-block',transform:previewOpen?'rotate(180deg)':'none',transition:'transform .2s',fontSize:13}}>▾</span>
            </div>
          </div>
          {previewOpen&&(
            <div style={{padding:'0 14px 14px'}}>
              {/* App header bar */}
              <div style={{display:'flex',alignItems:'center',gap:8,padding:'8px 11px',marginBottom:10,borderRadius:10,background:isWA?'rgba(37,211,102,0.12)':'rgba(10,132,255,0.12)',border:`1px solid ${isWA?'rgba(37,211,102,0.25)':'rgba(10,132,255,0.2)'}`}}>
                <span style={{fontSize:16}}>{isWA?'💬':'✈️'}</span>
                <div>
                  <div style={{fontSize:11.5,fontWeight:700,color:isWA?'#25d366':'var(--blue)'}}>{isWA?'WhatsApp':'Telegram'}</div>
                  <div style={{fontSize:9.5,color:'var(--t3)'}}>Formatting: {isWA?'*bold* _italic_ ~strike~ `code`':'<b>bold</b> <i>italic</i> <u>underline</u> `code` ||spoiler||'}</div>
                </div>
              </div>
              {/* Chat bubble */}
              <div style={{display:'flex',justifyContent:'flex-end',marginBottom:9}}>
                <div style={{maxWidth:'88%',background:isWA?'rgba(37,211,102,0.18)':'rgba(10,132,255,0.18)',border:`1px solid ${isWA?'rgba(37,211,102,0.28)':'rgba(10,132,255,0.25)'}`,borderRadius:isWA?'13px 13px 3px 13px':'14px 14px 3px 14px',padding:'10px 13px',fontFamily:'system-ui,sans-serif',fontSize:13,lineHeight:1.75,color:'var(--tx)'}}>
                  {renderPreview()}
                  <div style={{fontSize:10,color:'rgba(255,255,255,0.4)',marginTop:5,textAlign:'right',display:'flex',alignItems:'center',justifyContent:'flex-end',gap:3}}>
                    {new Date().toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'})}
                    {isWA?<span style={{color:'#53bdeb'}}>✓✓</span>:<span>✓✓</span>}
                  </div>
                </div>
              </div>
              {/* Unfilled vars warning */}
              {buildPreview().includes('⟦')&&(
                <div style={{padding:'5px 9px',background:'rgba(255,159,10,0.1)',border:'1px solid rgba(255,159,10,0.25)',borderRadius:7,fontSize:10.5,color:'var(--orange)',marginBottom:8}}>
                  ⚠️ Variables shown as <code style={{fontFamily:'monospace'}}>⟦name⟧</code> have no sample data — they'll be filled at send time.
                </div>
              )}
              {/* Sample values legend */}
              <div style={{borderTop:'1px solid rgba(255,255,255,0.06)',paddingTop:8}}>
                <div style={{fontSize:9.5,color:'var(--t3)',fontWeight:700,marginBottom:5,letterSpacing:.4}}>SAMPLE VALUES</div>
                <div style={{display:'flex',flexWrap:'wrap',gap:4}}>
                  {Object.entries({...def.sample,shop:SDB.get('shop_name')||'RepairOS'}).map(([k,v])=>(
                    <span key={k} style={{fontSize:9.5,padding:'1px 7px',background:'rgba(255,255,255,0.04)',border:'1px solid var(--glb)',borderRadius:4,display:'inline-flex',gap:3}}>
                      <code style={{color:'var(--blue)'}}>{k}</code>
                      <span style={{color:'var(--t3)'}}>→</span>
                      <span style={{color:'var(--t2)'}}>{String(v).slice(0,24)}</span>
                    </span>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>

        <button className="btn bp" onClick={saveAll} style={{alignSelf:'flex-end'}}><I n="check" s={13} c="#fff"/> Save Templates</button>
      </div>
    </div>
  );
}

// ─── BioLockToggle — per-device biometric-on-launch setting ─────────────────
function BioLockToggle(){
  const avail = typeof isBiometricAvailable==='function' && isBiometricAvailable();
  const registered = typeof biometricIsRegistered==='function' && biometricIsRegistered();
  const [bioLock,setBioLock] = useState(()=>localStorage.getItem(BIO_LOCK_KEY)==='1');
  if(!avail||!registered) return null;
  return(
    <div className="card">
      <div className="stitle">🔐 Security — This Device</div>
      <div style={{display:'flex',alignItems:'center',gap:12,padding:'4px 0'}}>
        <label className="tog" style={{flexShrink:0}}>
          <input type="checkbox" checked={bioLock} onChange={e=>{
            const v=e.target.checked;
            setBioLock(v);
            if(v) localStorage.setItem(BIO_LOCK_KEY,'1');
            else localStorage.removeItem(BIO_LOCK_KEY);
          }}/>
          <span className="ts"/>
        </label>
        <div>
          <div style={{fontSize:13,fontWeight:600}}>Require biometrics on launch</div>
          <div style={{fontSize:11,color:'var(--t3)',marginTop:2}}>Even with "Stay signed in" active, Face ID / fingerprint will be required every time you open the app on this device.</div>
        </div>
      </div>
    </div>
  );
}

// ─── PresetsEditor — manages Quick Repair Presets in settings ────────────────
function PresetsEditor(){
  const [presets,setPresetsState]=useState(getRepairPresets);
  const empty={name:"",icon:"⚡",device:"",type:"",price:"",notes:"",ownerOnly:false,storeOnly:false,priority:"Normal",warrantyMonths:"0"};
  const [editIdx,setEditIdx]=useState(null); // null=list, -1=new, >=0=editing
  const [form,setForm]=useState(empty);
  const repairTypes=getRepairTypes().map(rt=>rt.name);
  function openNew(){setForm(empty);setEditIdx(-1);}
  function openEdit(i){setForm({...empty,...presets[i]});setEditIdx(i);}
  function cancel(){setEditIdx(null);}
  function save(){
    if(!form.name.trim()) return;
    const updated=editIdx===-1?[...presets,{...form}]:presets.map((p,i)=>i===editIdx?{...form}:p);
    saveRepairPresets(updated);setPresetsState(updated);setEditIdx(null);
    toast("✅","Preset saved",form.name);
  }
  function del(i){
    const updated=presets.filter((_,j)=>j!==i);
    saveRepairPresets(updated);setPresetsState(updated);
  }
  return(
    <div className="card">
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:11}}>
        <div className="stitle" style={{marginBottom:0}}>⚡ Quick Repair Presets</div>
        {editIdx===null&&<button className="btn bp bsm" onClick={openNew}><I n="plus" s={11} c="#fff"/> New</button>}
      </div>
      {editIdx!==null?(
        <div style={{display:"flex",flexDirection:"column",gap:9}}>
          <div className="fg2">
            <div className="fg">
              <label className="fl">Icon</label>
              <input className="inp" value={form.icon} onChange={e=>setForm(f=>({...f,icon:e.target.value}))} style={{width:52,textAlign:"center",fontSize:20}} maxLength={2}/>
            </div>
            <div className="fg" style={{flex:3}}>
              <label className="fl">Preset name *</label>
              <input className="inp" value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="e.g. Quick Cleaning" autoFocus/>
            </div>
          </div>
          <div className="fg2">
            <div className="fg">
              <label className="fl">Device (optional)</label>
              <input className="inp" value={form.device} onChange={e=>setForm(f=>({...f,device:e.target.value}))} placeholder="e.g. iPhone"/>
            </div>
            <div className="fg">
              <label className="fl">Repair type</label>
              <select className="inp" value={form.type} onChange={e=>setForm(f=>({...f,type:e.target.value}))}>
                <option value="">— none —</option>
                {repairTypes.map(rt=><option key={rt}>{rt}</option>)}
              </select>
            </div>
          </div>
          <div className="fg2">
            <div className="fg">
              <label className="fl">Price</label>
              <input className="inp" type="number" step={priceStep()} value={form.price} onChange={e=>setForm(f=>({...f,price:e.target.value}))} placeholder="0"/>
            </div>
            <div className="fg">
              <label className="fl">Warranty (months)</label>
              <input className="inp" type="number" value={form.warrantyMonths} onChange={e=>setForm(f=>({...f,warrantyMonths:e.target.value}))} placeholder="0"/>
            </div>
          </div>
          <div className="fg">
            <label className="fl">Notes (pre-filled on repair)</label>
            <input className="inp" value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} placeholder="Optional…"/>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            {[["ownerOnly","👤 Mine only","rgba(191,90,242,0.1)","var(--purple)"],["storeOnly","🏪 Store only","rgba(48,209,88,0.1)","var(--green)"]].map(([k,label,bg,col])=>(
              <div key={k} style={{flex:1,minWidth:120,display:"flex",alignItems:"center",gap:8,padding:"8px 11px",background:form[k]?bg:"rgba(255,255,255,0.03)",border:`1px solid ${form[k]?col+"66":"var(--glb)"}`,borderRadius:9,cursor:"pointer",userSelect:"none"}}
                onClick={()=>setForm(f=>form[k]?{...f,[k]:false}:{...f,ownerOnly:false,storeOnly:false,[k]:true})}>
                <div className="tog" style={{transform:"scale(.8)",transformOrigin:"left",pointerEvents:"none"}}>
                  <input type="checkbox" checked={!!form[k]} readOnly tabIndex={-1}/><span className="ts"/>
                </div>
                <span style={{fontSize:12,fontWeight:600,color:form[k]?col:"var(--tx)"}}>{label}</span>
              </div>
            ))}
          </div>
          <div className="ma">
            <button className="btn bg2" onClick={cancel}>Cancel</button>
            <button className="btn bp" onClick={save}>💾 Save preset</button>
          </div>
        </div>
      ):(
        presets.length===0
          ?<div style={{fontSize:12,color:"var(--t3)",textAlign:"center",padding:"14px 0"}}>No presets yet — tap New to create one</div>
          :<div style={{display:"flex",flexDirection:"column",gap:7}}>
            {presets.map((p,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 12px",background:"rgba(255,255,255,0.03)",border:"1px solid var(--glb)",borderRadius:11}}>
                <span style={{fontSize:20,flexShrink:0}}>{p.icon||"⚡"}</span>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:700,fontSize:13}}>{p.name}</div>
                  <div style={{fontSize:11,color:"var(--t3)",marginTop:1,display:"flex",gap:6,flexWrap:"wrap"}}>
                    {p.device&&<span>{p.device}</span>}
                    {p.type&&<span>{p.type}</span>}
                    {p.price&&<span style={{color:"var(--green)",fontWeight:600}}>{p.price}</span>}
                    {p.ownerOnly&&<span style={{color:"var(--purple)",fontWeight:600}}>👤 Mine</span>}
                    {p.storeOnly&&<span style={{color:"var(--green)",fontWeight:600}}>🏪 Store</span>}
                  </div>
                </div>
                <button className="btn bg2 bsm" style={{padding:"3px 8px"}} onClick={()=>openEdit(i)}><I n="edit" s={10}/></button>
                <button className="btn bd bsm" style={{padding:"3px 8px"}} onClick={()=>del(i)}><I n="trash" s={10}/></button>
              </div>
            ))}
          </div>
      )}
    </div>
  );
}

// ─── ReceiptSettingsPanel — receipt/report printing config with live preview ─
// ─── CollapsibleCard — used throughout Printing & Receipts settings ─────────
function CollapsibleCard({title,icon,defaultOpen=true,children}){
  const [open,setOpen]=useState(defaultOpen);
  return(
    <div className="card" style={{padding:0,overflow:'hidden'}}>
      <div onClick={()=>setOpen(v=>!v)}
        style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'14px 16px',cursor:'pointer',userSelect:'none'}}>
        <div style={{fontSize:13,fontWeight:700,display:'flex',alignItems:'center',gap:8}}>
          {icon&&<span>{icon}</span>}<span>{title}</span>
        </div>
        <span style={{fontSize:12,color:'var(--t3)',transform:open?'rotate(180deg)':'none',transition:'transform .18s'}}>▾</span>
      </div>
      {open&&<div style={{padding:'0 16px 16px'}}>{children}</div>}
    </div>
  );
}

// ─── PrintPreviewPanel — shared true-to-scale, resizable preview ────────────
// Used by both the Receipt tab and Report tab. Renders the given HTML at
// true physical size (mm → px at 96dpi) then scales it with a CSS transform
// to fill the available box, so what you see is pixel-proportional to what
// actually prints. Height is user-resizable via a drag handle at the bottom.
function PrintPreviewPanel({html,widthMm,onTestPrint,modeSwitcher}){
  const [naturalH,setNaturalH]=useState(500);
  const [containerW,setContainerW]=useState(360);
  const [boxH,setBoxH]=useState(560);
  const previewRef=useRef(null);
  const boxRef=useRef(null);
  const dragRef=useRef(null);

  function fitHeight(){
    const el=previewRef.current;
    if(!el) return;
    requestAnimationFrame(()=>{
      requestAnimationFrame(()=>{
        try{
          const doc=el.contentWindow.document;
          const h=Math.max(doc.documentElement.scrollHeight,doc.body.scrollHeight);
          if(h>0) setNaturalH(h);
        }catch(e){/* not ready yet */}
      });
    });
  }
  useEffect(()=>{
    const el=boxRef.current;
    if(!el) return;
    const measure=()=>setContainerW(el.clientWidth);
    measure();
    const ro=typeof ResizeObserver!=='undefined' ? new ResizeObserver(measure) : null;
    if(ro) ro.observe(el);
    window.addEventListener('resize',measure);
    return ()=>{ if(ro) ro.disconnect(); window.removeEventListener('resize',measure); };
  },[]);
  function startResize(e){
    e.preventDefault();
    const startY=e.touches?e.touches[0].clientY:e.clientY;
    const startH=boxH;
    dragRef.current={startY,startH};
    const onMove=ev=>{
      const y=ev.touches?ev.touches[0].clientY:ev.clientY;
      const delta=y-dragRef.current.startY;
      setBoxH(Math.max(260,Math.min(1000,dragRef.current.startH+delta)));
    };
    const onUp=()=>{
      window.removeEventListener('mousemove',onMove);
      window.removeEventListener('mouseup',onUp);
      window.removeEventListener('touchmove',onMove);
      window.removeEventListener('touchend',onUp);
    };
    window.addEventListener('mousemove',onMove);
    window.addEventListener('mouseup',onUp);
    window.addEventListener('touchmove',onMove,{passive:false});
    window.addEventListener('touchend',onUp);
  }

  const MM_PX=3.7795;
  const trueWidthPx=widthMm*MM_PX;
  const rawScale=containerW>0 ? (containerW-24)/trueWidthPx : 1;
  const scale=Math.min(2.4,Math.max(0.3,rawScale));

  return(
    <div className="card" style={{position:'sticky',top:12,display:'flex',flexDirection:'column'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:11,flexWrap:'wrap',gap:8}}>
        <div className="stitle" style={{marginBottom:0}}>👁️ Live Preview</div>
        <button className="btn bp bsm" onClick={onTestPrint}>🖨️ Test Print</button>
      </div>
      {modeSwitcher}
      <div ref={boxRef} style={{background:'#d8d8d8',borderRadius:'12px 12px 0 0',padding:'22px 14px',display:'flex',justifyContent:'center',height:boxH,overflowY:'auto'}}>
        <div style={{width:trueWidthPx*scale,height:naturalH*scale,position:'relative',flexShrink:0,boxShadow:'0 8px 28px rgba(0,0,0,0.4)',borderRadius:8,overflow:'hidden'}}>
          <iframe
            ref={previewRef}
            title="print-preview"
            srcDoc={html}
            scrolling="no"
            onLoad={fitHeight}
            style={{
              width:trueWidthPx,height:naturalH,border:'none',background:'#fff',
              transform:`scale(${scale})`,transformOrigin:'top left',
              position:'absolute',top:0,left:0,
            }}
          />
        </div>
      </div>
      <div onMouseDown={startResize} onTouchStart={startResize}
        style={{height:16,background:'#c4c4c4',borderRadius:'0 0 12px 12px',cursor:'ns-resize',
          display:'flex',alignItems:'center',justifyContent:'center',userSelect:'none',touchAction:'none'}}>
        <div style={{width:36,height:4,borderRadius:2,background:'#8a8a8a'}}/>
      </div>
      <div style={{fontSize:10.5,color:'var(--t3)',textAlign:'center',marginTop:8}}>True-to-scale preview · drag the handle above to resize</div>
    </div>
  );
}

// ─── ReceiptSettingsPanel — top-level tab switcher (Receipt / Report) ───────
function ReceiptSettingsPanel(){
  const [subTab,setSubTab]=useState('receipt'); // 'receipt' | 'report'
  return(
    <div>
      <div style={{display:'flex',gap:6,marginBottom:14,background:'rgba(255,255,255,0.04)',borderRadius:11,padding:4,maxWidth:400}}>
        <div onClick={()=>setSubTab('receipt')}
          style={{flex:1,textAlign:'center',padding:'9px 12px',borderRadius:8,cursor:'pointer',fontSize:13,fontWeight:700,
            background:subTab==='receipt'?'var(--blue)':'transparent',color:subTab==='receipt'?'#fff':'var(--t2)',userSelect:'none',transition:'all .15s'}}>
          🧾 Receipt
        </div>
        <div onClick={()=>setSubTab('report')}
          style={{flex:1,textAlign:'center',padding:'9px 12px',borderRadius:8,cursor:'pointer',fontSize:13,fontWeight:700,
            background:subTab==='report'?'var(--blue)':'transparent',color:subTab==='report'?'#fff':'var(--t2)',userSelect:'none',transition:'all .15s'}}>
          📋 Report
        </div>
      </div>
      {subTab==='receipt' ? <ReceiptTab/> : <ReportTab/>}
    </div>
  );
}

// ─── ReceiptTab ───────────────────────────────────────────────────────────
function ReceiptTab(){
  const [settings,setSettingsState]=useState(getReceiptSettings);
  const sampleRepair={
    id:1042, customerName:"Ahmad Hassan", phone:"07701234567",
    device:"iPhone 13 Pro", types:["Screen Replacement"], imei:"356938035643809",
    status:"Done", paid:false, price:"45000", deposit:"10000",
    partsUsed:[{name:"OLED Screen",price:35000,cost:22000,qty:1},{name:"Adhesive Kit",price:5000,cost:1500,qty:1}],
    notes:"Customer reported cracked screen after drop.",
    warrantyUntil:new Date(Date.now()+30*864e5).toISOString(),
    createdAt:new Date().toISOString(),
  };
  const sampleFmt=v=>{
    const cur=SDB.get('currency')||'USD';
    const n=parseFloat(v)||0;
    return cur==='IQD'?`${n.toLocaleString()} IQD`:`$${n.toLocaleString()}`;
  };
  function update(k,v){
    const next={...settings,[k]:v};
    setSettingsState(next);
    saveReceiptSettings(next);
  }
  function updateTranslation(lang,key,value){
    const nextTranslations={...settings.translations,[lang]:{...settings.translations[lang],[key]:value}};
    const next={...settings,translations:nextTranslations};
    setSettingsState(next);
    saveReceiptSettings(next);
  }
  function resetTranslations(lang){
    const nextTranslations={...settings.translations,[lang]:{}};
    const next={...settings,translations:nextTranslations};
    setSettingsState(next);
    saveReceiptSettings(next);
    toast('↩️','Reset',`${lang==='ar'?'Arabic':'English'} labels reset to default`);
  }

  const preset=getReceiptPreset(settings.paper);
  const ACCENT_PRESETS=['#0A84FF','#30D158','#FF9F0A','#BF5AF2','#FF453A','#5AC8FA','#1a1a1a'];
  const TRANSLATION_KEYS=[
    ['receiptLabel','Receipt'],['date','Date'],['status','Status'],['customer','Customer (section)'],
    ['name','Name'],['phone','Phone'],['device','Device (section)'],['model','Model'],['service','Service'],
    ['imei','IMEI/SN'],['partsLabor','Parts & Labor'],['subtotal','Subtotal'],['depositPaid','Deposit Paid'],
    ['paidInFull','Paid in Full'],['balanceDue','Balance Due'],['warrantyUntil','Warranty until'],['notes','Notes'],
  ];
  const activeLang=settings.receiptLang||'en';
  const activeDict=getReceiptI18n(activeLang,settings);
  const previewHtml=generateReceiptHTML(sampleRepair,sampleFmt);

  return(
    <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(320px,1fr))',gap:13,alignItems:'start'}}>
      <div style={{display:'flex',flexDirection:'column',gap:10}}>
        <CollapsibleCard title="Paper Size" icon="📄" defaultOpen={true}>
          <div style={{display:'flex',flexDirection:'column',gap:7}}>
            {RECEIPT_PRESETS.map(p=>(
              <div key={p.id} onClick={()=>update('paper',p.id)}
                style={{display:'flex',alignItems:'center',gap:10,padding:'10px 12px',
                  background:settings.paper===p.id?'rgba(10,132,255,0.09)':'rgba(255,255,255,0.03)',
                  border:`1px solid ${settings.paper===p.id?'rgba(10,132,255,0.3)':'var(--glb)'}`,
                  borderRadius:10,cursor:'pointer',userSelect:'none'}}>
                <span style={{fontSize:18}}>{p.isReceipt?'🧾':'📃'}</span>
                <div style={{flex:1}}>
                  <div style={{fontSize:12.5,fontWeight:600,color:settings.paper===p.id?'var(--blue)':'var(--tx)'}}>{p.label}</div>
                  <div style={{fontSize:10.5,color:'var(--t3)'}}>{p.widthMm}mm width</div>
                </div>
                {settings.paper===p.id&&<span style={{color:'var(--blue)',fontSize:16}}>✓</span>}
              </div>
            ))}
          </div>
        </CollapsibleCard>

        <CollapsibleCard title="Style" icon="🎨" defaultOpen={false}>
          <div style={{marginBottom:12}}>
            <label className="fl" style={{marginBottom:7,display:'block'}}>Accent color</label>
            <div style={{display:'flex',gap:7,flexWrap:'wrap',alignItems:'center'}}>
              {ACCENT_PRESETS.map(c=>(
                <div key={c} onClick={()=>update('accentColor',c)}
                  style={{width:26,height:26,borderRadius:'50%',background:c,cursor:'pointer',
                    border:settings.accentColor===c?'2.5px solid #fff':'2px solid transparent',
                    boxShadow:settings.accentColor===c?`0 0 0 2px ${c}`:'0 0 0 1px rgba(255,255,255,0.15)'}}/>
              ))}
              <input type="color" value={settings.accentColor} onChange={e=>update('accentColor',e.target.value)}
                style={{width:30,height:26,padding:0,border:'1px solid var(--glb)',borderRadius:6,background:'none',cursor:'pointer'}}/>
            </div>
          </div>
          <div className="fg" style={{marginBottom:10}}>
            <label className="fl">Font style</label>
            <select className="inp" value={settings.fontFamily} onChange={e=>update('fontFamily',e.target.value)}>
              <option value="system">System (clean, modern)</option>
              <option value="serif">Serif (classic, formal)</option>
              <option value="mono">Monospace (typewriter)</option>
            </select>
          </div>
          <div className="fg">
            <label className="fl">Header layout</label>
            <select className="inp" value={settings.headerStyle} onChange={e=>update('headerStyle',e.target.value)}>
              <option value="banner">Banner (colored background)</option>
              <option value="centered">Centered (minimal, with underline)</option>
            </select>
          </div>
        </CollapsibleCard>

        <CollapsibleCard title="Language" icon="🌐" defaultOpen={false}>
          <div className="fg" style={{marginBottom:10}}>
            <label className="fl">Receipt language</label>
            <select className="inp" value={settings.receiptLang} onChange={e=>update('receiptLang',e.target.value)}>
              <option value="en">English</option>
              <option value="ar">العربية (Arabic)</option>
            </select>
          </div>
          <div style={{fontSize:11,color:'var(--t3)',marginBottom:10}}>
            Edit any label below — saved automatically and used instead of the default {activeLang==='ar'?'Arabic':'English'} text.
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:7,maxHeight:280,overflowY:'auto',paddingRight:4}}>
            {TRANSLATION_KEYS.map(([key,hint])=>(
              <div key={key} className="fg" style={{marginBottom:0}}>
                <label className="fl" style={{fontSize:10}}>{hint}</label>
                <input className="inp" style={{fontSize:12.5,direction:activeLang==='ar'?'rtl':'ltr'}}
                  value={activeDict[key]}
                  onChange={e=>updateTranslation(activeLang,key,e.target.value)}/>
              </div>
            ))}
          </div>
          <button className="btn bg2 bsm" style={{marginTop:10,width:'100%',justifyContent:'center'}} onClick={()=>resetTranslations(activeLang)}>
            ↩ Reset {activeLang==='ar'?'Arabic':'English'} labels to default
          </button>
        </CollapsibleCard>

        <CollapsibleCard title="Content" icon="🧾" defaultOpen={false}>
          <div style={{display:'flex',flexDirection:'column',gap:8}}>
            {[
              ['showLogo','Show shop logo'],
              ['showAddress','Show address'],
              ['showPhone','Show phone number'],
              ['showEmail','Show email'],
              ['showWebsite','Show website'],
              ['showDeposit','Show deposit line'],
              ['showWarranty','Show warranty badge'],
              ['showNotes','Show notes'],
            ].map(([key,label])=>(
              <div key={key} onClick={()=>update(key,!settings[key])}
                style={{display:'flex',alignItems:'center',gap:9,padding:'7px 2px',cursor:'pointer',userSelect:'none'}}>
                <div className="tog" style={{pointerEvents:'none'}}>
                  <input type="checkbox" checked={!!settings[key]} readOnly tabIndex={-1}/>
                  <span className="ts"/>
                </div>
                <span style={{fontSize:12.5}}>{label}</span>
              </div>
            ))}
          </div>
          <div className="fg" style={{marginTop:10}}>
            <label className="fl">Footer message</label>
            <input className="inp" value={settings.footerText} onChange={e=>update('footerText',e.target.value)} placeholder="Thank you for your business!"/>
          </div>
        </CollapsibleCard>

        <div style={{fontSize:11,color:'var(--t3)',padding:'0 2px'}}>
          💡 Shop name, logo, address, phone, email and website are pulled from the <strong>Shop &amp; Identity</strong> tab. Edit them there.
        </div>
      </div>

      <PrintPreviewPanel html={previewHtml} widthMm={preset.widthMm} onTestPrint={()=>printReceipt(sampleRepair,sampleFmt)}/>
    </div>
  );
}

// ─── ReportTab ────────────────────────────────────────────────────────────
function ReportTab(){
  const [reportSettings,setReportSettingsState]=useState(getReportSettings);
  const sampleFmt=v=>{
    const cur=SDB.get('currency')||'USD';
    const n=parseFloat(v)||0;
    return cur==='IQD'?`${n.toLocaleString()} IQD`:`$${n.toLocaleString()}`;
  };

  function updateCol(key,val){
    const next={...reportSettings,columns:{...reportSettings.columns,[key]:val}};
    setReportSettingsState(next); saveReportSettings(next);
  }
  function updateSetting(k,v){
    const next={...reportSettings,[k]:v};
    setReportSettingsState(next); saveReportSettings(next);
  }
  function updateHeader(k,v){
    const next={...reportSettings,header:{...reportSettings.header,[k]:v}};
    setReportSettingsState(next); saveReportSettings(next);
  }
  function updateSummaryCard(key,val){
    const next={...reportSettings,summaryCards:{...reportSettings.summaryCards,[key]:val}};
    setReportSettingsState(next); saveReportSettings(next);
  }
  function updateTranslation(lang,key,value){
    const nextTranslations={...reportSettings.translations,[lang]:{...reportSettings.translations[lang],[key]:value}};
    const next={...reportSettings,translations:nextTranslations};
    setReportSettingsState(next); saveReportSettings(next);
  }
  function resetTranslations(lang){
    const nextTranslations={...reportSettings.translations,[lang]:{}};
    const next={...reportSettings,translations:nextTranslations};
    setReportSettingsState(next); saveReportSettings(next);
    toast('↩️','Reset',`${lang==='ar'?'Arabic':'English'} report labels reset`);
  }
  function updateTypeTranslation(typeName,value){
    const nextMap={...(reportSettings.typeTranslations.ar||{}),[typeName]:value};
    const next={...reportSettings,typeTranslations:{...reportSettings.typeTranslations,ar:nextMap}};
    setReportSettingsState(next); saveReportSettings(next);
  }

  const REPORT_COLS=[
    ['id','# ID'],['customer','Customer Name'],['device','Device'],['type','Repair Type'],
    ['status','Status'],['price','Price'],['cost','Parts Cost'],['profit','Profit'],
    ['paid','Paid Status'],['paidDate','Payment Date'],['date','Received Date'],
  ];
  const SUMMARY_CARD_DEFS=[
    ['totalJobs','Total Jobs'],['paidJobs','Paid Jobs'],['unpaidJobs','Unpaid Jobs'],
    ['revenue','Revenue (paid)'],['partsCost','Parts Cost'],['netProfit','Net Profit'],
    ['pendingProfit','Pending Profit'],['losses','Losses'],['lossCount','Loss Jobs (count)'],
    ['deposits','Deposits Held'],['outstanding','Outstanding'],['avgValue','Average Repair Value'],
    ['completionRate','Completion Rate'],
  ];
  const REPORT_TRANSLATION_KEYS=[
    ['reportTitle','Report title'],['repairsWord','"repairs" word'],['generatedWord','"Generated" word'],
    ['colId','Column: #'],['colCustomer','Column: Customer'],['colDevice','Column: Device'],['colType','Column: Type'],
    ['colStatus','Column: Status'],['colPrice','Column: Price'],['colCost','Column: Cost'],['colProfit','Column: Profit'],
    ['colPaid','Column: Paid'],['colPaidDate','Column: Payment Date'],['colDate','Column: Received Date'],
    ['statusPaid','Paid label'],['statusUnpaid','Unpaid label'],
    ['sumTotalJobs','Card: Total Jobs'],['sumPaidJobs','Card: Paid Jobs'],['sumUnpaidJobs','Card: Unpaid Jobs'],
    ['sumRevenue','Card: Revenue'],['sumPartsCost','Card: Parts Cost'],['sumNetProfit','Card: Net Profit'],
    ['sumPendingProfit','Card: Pending Profit'],['sumLosses','Card: Losses'],['sumLossCount','Card: Loss Jobs'],
    ['sumDeposits','Card: Deposits'],['sumOutstanding','Card: Outstanding'],['sumAvgValue','Card: Avg. Value'],
    ['sumCompletionRate','Card: Completion Rate'],
    ['statusPending','Status: Pending'],['statusInProgress','Status: In Progress'],['statusDone','Status: Done'],
    ['statusDelivered','Status: Delivered'],['statusCancelled','Status: Cancelled'],['statusAwaitingCustomer','Status: Awaiting Customer'],
  ];

  const reportLang=reportSettings.lang||'en';
  const reportDict=getReportI18n(reportLang,reportSettings);
  const allRepairTypes=getRepairTypes().map(t=>t.name);

  const reportAllCols=[
    {key:'id',label:reportDict.colId},{key:'customer',label:reportDict.colCustomer},{key:'device',label:reportDict.colDevice},
    {key:'type',label:reportDict.colType},{key:'status',label:reportDict.colStatus},{key:'price',label:reportDict.colPrice,align:'right'},
    {key:'cost',label:reportDict.colCost,align:'right'},{key:'profit',label:reportDict.colProfit,align:'right'},
    {key:'paid',label:reportDict.colPaid},{key:'paidDate',label:reportDict.colPaidDate},{key:'date',label:reportDict.colDate},
  ];
  const reportColumns=reportAllCols.filter(c=>reportSettings.columns[c.key]!==false);

  // Sample rows — type name & status run through the SAME translation
  // functions used by the real print, so the preview always matches.
  const sampleRepairsRaw=[
    {id:1042,customer:'Ahmad Hassan',device:'iPhone 13 Pro',type:'Screen Replacement',status:'Done',price:45000,cost:22000,paidState:true},
    {id:1041,customer:'Sara Ali',device:'Samsung S22',type:'Battery Replacement',status:'Delivered',price:20000,cost:8000,paidState:false},
    {id:1040,customer:'No name',device:'iPhone 12',type:'Charging Port Fix',status:'Done',price:15000,cost:4000,paidState:true},
    {id:1039,customer:'Mohammed Karim',device:'iPad Air',type:'Screen Replacement',status:'In Progress',price:60000,cost:38000,paidState:null},
  ];
  const sampleReportRows=sampleRepairsRaw.map(r=>({
    id:r.id, customer:r.customer, device:r.device,
    type:translateRepairType(r.type,reportLang,reportSettings),
    status:translateStatus(r.status,reportLang,reportDict),
    price:sampleFmt(r.price), cost:sampleFmt(r.cost), profit:sampleFmt(r.price-r.cost),
    paid:r.paidState===null?reportDict.statusNA:(r.paidState?reportDict.statusPaid:reportDict.statusUnpaid),
    paidDate:r.paidState===true?new Date().toLocaleDateString(reportLang==='ar'?'ar-IQ':'en-US'):reportDict.statusNA,
    date:new Date(Date.now()-3*864e5).toLocaleDateString(reportLang==='ar'?'ar-IQ':'en-US'),
  }));
  const paidCount=sampleRepairsRaw.filter(r=>r.paidState===true).length;
  const unpaidCount=sampleRepairsRaw.filter(r=>r.paidState===false).length;
  const sampleRevenue=sampleRepairsRaw.filter(r=>r.paidState===true).reduce((s,r)=>s+r.price,0);
  const sampleCost=sampleRepairsRaw.filter(r=>r.paidState===true).reduce((s,r)=>s+r.cost,0);
  const sampleSummary=buildReportSummary({
    totalJobs:String(sampleRepairsRaw.length), paidJobs:String(paidCount), unpaidJobs:String(unpaidCount),
    revenue:sampleFmt(sampleRevenue), partsCost:sampleFmt(sampleCost),
    netProfit:sampleFmt(sampleRevenue-sampleCost), netProfitColor:'#0A63C2',
    pendingProfit:sampleFmt(22000), losses:sampleFmt(0), lossCount:'0',
    deposits:sampleFmt(10000), outstanding:sampleFmt(15000),
    avgValue:sampleFmt(paidCount?sampleRevenue/paidCount:0), completionRate:'50%',
  },reportLang,reportSettings);

  const previewHtml=generateReportHTML({
    title:`${reportDict.reportTitle} — Sample`,
    subtitle:`${sampleRepairsRaw.length} ${reportDict.repairsWord} · Preview`,
    columns:reportColumns,
    rows:sampleReportRows,
    summary:sampleSummary,
    lang:reportLang,
    headerConfig:reportSettings.header,
  });

  return(
    <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(320px,1fr))',gap:13,alignItems:'start'}}>
      <div style={{display:'flex',flexDirection:'column',gap:10}}>
        <CollapsibleCard title="Table Columns" icon="📋" defaultOpen={true}>
          <div style={{fontSize:11,color:'var(--t3)',marginBottom:10}}>Choose what appears in the printed table — e.g. hide customer names if you'd rather keep those private.</div>
          <div style={{display:'flex',flexDirection:'column',gap:8}}>
            {REPORT_COLS.map(([key,label])=>(
              <div key={key} onClick={()=>updateCol(key,reportSettings.columns[key]===false)}
                style={{display:'flex',alignItems:'center',gap:9,padding:'7px 2px',cursor:'pointer',userSelect:'none'}}>
                <div className="tog" style={{pointerEvents:'none'}}>
                  <input type="checkbox" checked={reportSettings.columns[key]!==false} readOnly tabIndex={-1}/>
                  <span className="ts"/>
                </div>
                <span style={{fontSize:12.5}}>{label}</span>
              </div>
            ))}
          </div>
        </CollapsibleCard>

        <CollapsibleCard title="Summary Cards" icon="🗂️" defaultOpen={true}>
          <div style={{fontSize:11,color:'var(--t3)',marginBottom:10}}>Pick exactly which stat cards appear above the table. Fully optional — turn off anything you don't need.</div>
          <div style={{display:'flex',flexDirection:'column',gap:8}}>
            {SUMMARY_CARD_DEFS.map(([key,label])=>(
              <div key={key} onClick={()=>updateSummaryCard(key,!reportSettings.summaryCards[key])}
                style={{display:'flex',alignItems:'center',gap:9,padding:'7px 2px',cursor:'pointer',userSelect:'none'}}>
                <div className="tog" style={{pointerEvents:'none'}}>
                  <input type="checkbox" checked={!!reportSettings.summaryCards[key]} readOnly tabIndex={-1}/>
                  <span className="ts"/>
                </div>
                <span style={{fontSize:12.5}}>{label}</span>
              </div>
            ))}
          </div>
        </CollapsibleCard>

        <CollapsibleCard title="Header" icon="🏷️" defaultOpen={false}>
          <div style={{fontSize:11,color:'var(--t3)',marginBottom:10}}>Control the shop info block on the printed report — what's included and where it sits on the page.</div>
          <div className="fg" style={{marginBottom:10}}>
            <label className="fl">Position</label>
            <select className="inp" value={reportSettings.header.position} onChange={e=>updateHeader('position',e.target.value)}>
              <option value="top">Top of page</option>
              <option value="bottom">Bottom of page</option>
            </select>
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:8}}>
            {[
              ['showLogo','Show shop logo'],
              ['showName','Show shop name'],
              ['showAddress','Show address'],
              ['showPhone','Show phone number'],
              ['showEmail','Show email'],
            ].map(([key,label])=>(
              <div key={key} onClick={()=>updateHeader(key,!reportSettings.header[key])}
                style={{display:'flex',alignItems:'center',gap:9,padding:'7px 2px',cursor:'pointer',userSelect:'none'}}>
                <div className="tog" style={{pointerEvents:'none'}}>
                  <input type="checkbox" checked={!!reportSettings.header[key]} readOnly tabIndex={-1}/>
                  <span className="ts"/>
                </div>
                <span style={{fontSize:12.5}}>{label}</span>
              </div>
            ))}
          </div>
        </CollapsibleCard>

        <CollapsibleCard title="Language" icon="🌐" defaultOpen={false}>
          <div className="fg" style={{marginBottom:10}}>
            <label className="fl">Report language</label>
            <select className="inp" value={reportSettings.lang} onChange={e=>updateSetting('lang',e.target.value)}>
              <option value="en">English</option>
              <option value="ar">العربية (Arabic)</option>
            </select>
          </div>
          <div style={{fontSize:11,color:'var(--t3)',marginBottom:10}}>
            Column headers, summary card labels and status words — fully editable below.
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:7,maxHeight:280,overflowY:'auto',paddingRight:4}}>
            {REPORT_TRANSLATION_KEYS.map(([key,hint])=>(
              <div key={key} className="fg" style={{marginBottom:0}}>
                <label className="fl" style={{fontSize:10}}>{hint}</label>
                <input className="inp" style={{fontSize:12.5,direction:reportLang==='ar'?'rtl':'ltr'}}
                  value={reportDict[key]}
                  onChange={e=>updateTranslation(reportLang,key,e.target.value)}/>
              </div>
            ))}
          </div>
          <button className="btn bg2 bsm" style={{marginTop:10,width:'100%',justifyContent:'center'}} onClick={()=>resetTranslations(reportLang)}>
            ↩ Reset {reportLang==='ar'?'Arabic':'English'} report labels to default
          </button>
        </CollapsibleCard>

        <CollapsibleCard title="Repair Type Translations" icon="🔧" defaultOpen={false}>
          <div style={{fontSize:11,color:'var(--t3)',marginBottom:10}}>
            Common repair types are pre-translated to Arabic automatically. Add or override any type below — used in the report table when Arabic is selected.
          </div>
          {allRepairTypes.length===0
            ? <div style={{fontSize:12,color:'var(--t3)',textAlign:'center',padding:'10px 0'}}>No repair types found</div>
            : <div style={{display:'flex',flexDirection:'column',gap:7,maxHeight:280,overflowY:'auto',paddingRight:4}}>
                {allRepairTypes.map(tp=>(
                  <div key={tp} className="fg" style={{marginBottom:0}}>
                    <label className="fl" style={{fontSize:10}}>{tp}</label>
                    <input className="inp" style={{fontSize:12.5,direction:'rtl'}}
                      value={reportSettings.typeTranslations.ar[tp]??DEFAULT_TYPE_TRANSLATIONS_AR[tp]??''}
                      onChange={e=>updateTypeTranslation(tp,e.target.value)}/>
                  </div>
                ))}
              </div>
          }
        </CollapsibleCard>

        <div style={{fontSize:11,color:'var(--t3)',padding:'0 2px'}}>
          💡 Shop name, logo, address, phone, email and website are pulled from the <strong>Shop &amp; Identity</strong> tab. Edit them there.
        </div>
      </div>

      <PrintPreviewPanel html={previewHtml} widthMm={210} onTestPrint={()=>printReport({
        title:`${reportDict.reportTitle} — Sample`,
        subtitle:`${sampleRepairsRaw.length} ${reportDict.repairsWord} · Preview`,
        columns:reportColumns, rows:sampleReportRows, summary:sampleSummary,
        lang:reportLang, headerConfig:reportSettings.header,
      })}/>
    </div>
  );
}

function SettingsPage({t,techs,saveTechs,lang,onLangChange,currency,onCurrencyChange,onRtlChange,onRestore,rtlLayout,assets,brands,saveAssetsFn,saveBrandsFn,currentUser,setCurrentUser,readOnly,appearance,updateAppearance,param}){
  const isAdmin = currentUser?.role==='admin';
  // Which tab is visible
  const allTabs = SETTINGS_SECTIONS.filter(s=>canSeeSettingsSection(currentUser,s.id));
  const [activeTab,setActiveTab] = useState(()=>{
    // Support deep-link via param: nav("settings","data") or navSub({tab:"data"})
    if(param){
      const requested = typeof param==='object' ? param.tab : param;
      const found = allTabs.find(t=>t.id===requested);
      if(found) return found.id;
    }
    return allTabs[0]?.id||'shop';
  });
  // If param changes (e.g. nav shortcut fires while already on settings page), update tab
  useEffect(()=>{
    if(!param) return;
    const requested = typeof param==='object' ? param.tab : param;
    const found = allTabs.find(t=>t.id===requested);
    if(found) setActiveTab(found.id);
  },[param]);

  const [token,setToken]=useState(SDB.get("tg_token")||"");
  const [waAuto,setWaAuto]=useState(SDB.get("wa_auto")===true);
  const [shopName,setShopName]=useState(SDB.get("shop_name")||"RepairOS");
  const [shopLogo,setShopLogo]=useState(SDB.get("shop_logo")||"");
  const [appVersion,setAppVersion]=useState(SDB.get("app_version")||"v7");
  const [splitPct,setSplitPct]=useState(SDB.get("split_pct")||50);
  // New shop fields
  const [shopPhone,setShopPhone]=useState(SDB.get("shop_phone")||"");
  const [countryCode,setCountryCode]=useState(SDB.get("country_code")||"");
  const [shopEmail,setShopEmail]=useState(SDB.get("shop_email")||"");
  const [shopAddress,setShopAddress]=useState(SDB.get("shop_address")||"");
  const [shopTagline,setShopTagline]=useState(SDB.get("shop_tagline")||"");
  const [shopHours,setShopHours]=useState(SDB.get("shop_hours")||"");
  const [shopWebsite,setShopWebsite]=useState(SDB.get("shop_website")||"");
  const [receiptFooter,setReceiptFooter]=useState(SDB.get("receipt_footer")||"");
  const [receiptShowLogo,setReceiptShowLogo]=useState(SDB.get("receipt_show_logo")!==false);
  const [receiptShowAddress,setReceiptShowAddress]=useState(SDB.get("receipt_show_address")!==false);
  // Repair types editor
  const [repairTypesList,setRepairTypesList]=useState(()=>getRepairTypes());
  const [rtInput,setRtInput]=useState("");const [rtIcon,setRtIcon]=useState("🔧");
  const [rtEdit,setRtEdit]=useState(null); // index being edited
  // Warranty options editor
  const [warrantyList,setWarrantyList]=useState(()=>getWarrantyOptions());
  const [wLabel,setWLabel]=useState("");const [wValue,setWValue]=useState("");
  const [techModal,setTechModal]=useState(null);
  const [catModal,setCatModal]=useState(null);
  const [brandsOpen,setBrandsOpen]=useState(false);
  const fileRef=useRef();
  const [templates,setTemplates]=useState({
    done:SDB.get("msg_done")||`✅ Hi {name}! Your <b>{device}</b> is ready! 🎉\nThank you for choosing <b>{shop}</b>!`,
    done_wa:SDB.get("msg_done_wa")||`✅ Hi {name}! Your *{device}* is ready! 🎉\nThank you for choosing *{shop}*!`,
    repair_delivered:SDB.get("msg_repair_delivered")||`📦 <b>Device Collected</b>\nCustomer: {name}\nDevice: {device}\nJob: #{id}`,
    new_repair:SDB.get("msg_new_repair")||`🔧 <b>New Repair</b>\nCustomer: {name}\nDevice: {device}\nType: {type}\nJob: #{id}\nPriority: {priority}`,
    warranty_expiring:SDB.get("msg_warranty_expiring")||`🛡️ <b>Warranty Expiring</b>\nCustomer: {name}\nDevice: {device}\nExpires: {date}`,
    low_stock:SDB.get("msg_low_stock")||`⚠️ <b>Low Stock Alert</b>\n{part} ({brand})\nOnly <b>{qty}</b> units left!\nShop: {shop}`,
    withdrawal:SDB.get("msg_withdrawal")||`💸 <b>Withdrawal: {amount}</b>\nNote: {note}`,
  });
  function saveTpl(key,val){const upd={...templates,[key]:val};setTemplates(upd);SDB.set(`msg_${key}`,val);}
  function saveAll(){
    SDB.set("tg_token",token);SDB.set("wa_auto",waAuto);
    SDB.set("shop_name",shopName);SDB.set("shop_logo",shopLogo);SDB.set("app_version",appVersion);SDB.set("split_pct",parseInt(splitPct)||50);
    SDB.set("shop_phone",shopPhone);SDB.set("shop_email",shopEmail);SDB.set("shop_address",shopAddress);SDB.set("country_code",countryCode);
    SDB.set("shop_tagline",shopTagline);SDB.set("shop_hours",shopHours);SDB.set("shop_website",shopWebsite);
    SDB.set("receipt_footer",receiptFooter);SDB.set("receipt_show_logo",receiptShowLogo);SDB.set("receipt_show_address",receiptShowAddress);
    SDB.set("repair_types",repairTypesList);SDB.set("warranty_options",warrantyList);
    Object.entries(templates).forEach(([k,v])=>SDB.set(`msg_${k}`,v));
    toast("✅",t.saved,"All settings updated");
  }
  async function testTg(tech){if(!token||!tech.telegramId){toast("⚠️",t.missing,"Token and Telegram ID required");return;}const ok=await sendTelegram(token,tech.telegramId,`🤖 Test from ${shopName}!\n\nTelegram notifications working ✅\n\nTechnician: ${tech.name}`);toast(ok?"✅":"❌",ok?t.testSent:t.failed,ok?`Message sent to ${tech.name}`:t.checkToken);}
  function toggleCat(tech,catId){const cats=tech.notifCats||[];const updated=cats.includes(catId)?cats.filter(c=>c!==catId):[...cats,catId];const ut=techs.map(tp=>tp.id===tech.id?{...tp,notifCats:updated}:tp);saveTechs(ut);if(catModal?.id===tech.id)setCatModal(ut.find(tp=>tp.id===tech.id));}
  function saveTech(data){if(techModal==="add")saveTechs([...techs,{...data,id:SDB.nextId(),notifCats:[]}]);else saveTechs(techs.map(tp=>tp.id===techModal.id?{...tp,...data}:tp));setTechModal(null);toast("👤",t.saved,"");}

  function handleExport(){
    const data={repairs:SDB.get("repairs"),parts:SDB.get("parts"),customers:SDB.get("customers"),withdrawals:SDB.get("withdrawals"),technicians:SDB.get("technicians"),customPartsCatalog:SDB.get("customPartsCatalog"),settings:{shop_name:SDB.get("shop_name"),split_pct:SDB.get("split_pct"),language:SDB.get("language"),currency:SDB.get("currency"),tg_token:SDB.get("tg_token"),wa_auto:SDB.get("wa_auto"),msg_done:SDB.get("msg_done"),msg_done_wa:SDB.get("msg_done_wa"),msg_new_repair:SDB.get("msg_new_repair"),msg_repair_delivered:SDB.get("msg_repair_delivered"),msg_warranty_expiring:SDB.get("msg_warranty_expiring"),msg_low_stock:SDB.get("msg_low_stock"),msg_withdrawal:SDB.get("msg_withdrawal")},next_id:SDB.get("next_id"),exportedAt:new Date().toISOString()};
    const blob=new Blob([JSON.stringify(data,null,2)],{type:"application/json"});
    const a=document.createElement("a");a.href=URL.createObjectURL(blob);a.download=`repairosbackup_${new Date().toISOString().slice(0,10)}.json`;a.click();
    toast("💾","Backup","Downloaded");
  }
  function handleRestoreFile(e){
    const file=e.target.files?.[0];if(!file)return;
    const reader=new FileReader();
    reader.onload=ev=>{
      try{
        const data=JSON.parse(ev.target.result);
        if(!data.repairs&&!data.customers&&!data.parts){toast("❌",t.invalidBackup,"");return;}
        if(!window.confirm(t.restoreConfirm))return;
        if(data.repairs)SDB.set("repairs",data.repairs);
        if(data.parts)SDB.set("parts",data.parts);
        if(data.customers)SDB.set("customers",data.customers);
        if(data.withdrawals)SDB.set("withdrawals",data.withdrawals);
        if(data.technicians)SDB.set("technicians",data.technicians);
        if(data.customPartsCatalog)SDB.set("customPartsCatalog",data.customPartsCatalog);
        if(data.next_id)SDB.set("next_id",data.next_id);
        if(data.settings){Object.entries(data.settings).forEach(([k,v])=>{if(v!==null&&v!==undefined)SDB.set(k,v);});}
        onRestore();
        toast("✅",t.backupRestored,"All data restored successfully");
      }catch{toast("❌",t.invalidBackup,"Could not parse backup file");}
    };
    reader.readAsText(file);
    e.target.value="";
  }

  // ── Settings access control editor (admin only) ──────────────────────────────
  const [settingsAccess,setSettingsAccessState]=useState(()=>{
    const saved=SDB.get('settings_access')||{};
    const result={};
    Object.keys(DEFAULT_SETTINGS_ACCESS).forEach(role=>{
      result[role]={...DEFAULT_SETTINGS_ACCESS[role],...(saved[role]||{})};
    });
    return result;
  });
  function toggleSettingsSection(role,sectionId){
    if(role==='admin') return; // admin always has all
    setSettingsAccessState(prev=>{
      const next={...prev,[role]:{...prev[role],[sectionId]:!prev[role][sectionId]}};
      SDB.set('settings_access',next);
      return next;
    });
  }

  const tab = canSeeSettingsSection(currentUser,activeTab) ? activeTab : (allTabs[0]?.id||'shop');
  useViewScroll("settings:"+tab);

  return(
    <div className="page">
      <div className="ph">
        <div><div className="pt">{t.settings}</div></div>
        <button className="btn bp" onClick={saveAll}>{t.saveAll}</button>
      </div>

      {/* Tab bar */}
      <div style={{display:'flex',gap:4,flexWrap:'wrap',marginBottom:16,padding:'4px',background:'rgba(255,255,255,0.03)',borderRadius:12,border:'1px solid var(--glb)'}}>
        {allTabs.map(s=>(
          <button key={s.id} onClick={()=>setActiveTab(s.id)}
            style={{display:'flex',alignItems:'center',gap:5,padding:'7px 12px',borderRadius:8,border:'none',cursor:'pointer',fontSize:12,fontWeight:tab===s.id?700:500,
              background:tab===s.id?'var(--blue)':'transparent',
              color:tab===s.id?'#fff':'var(--t2)',transition:'all .15s'}}>
            <span>{s.icon}</span><span className="nv-label">{s.label}</span>
          </button>
        ))}
      </div>

      {/* ── General / Shop ── */}
      {tab==='shop'&&(
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(320px,1fr))',gap:13,alignItems:'start'}}>

          {/* Left column: identity + contact + hours */}
          <div style={{display:'flex',flexDirection:'column',gap:13}}>
            <div className="card">
              <div className="stitle">🏪 Shop Identity</div>
              <div style={{display:'flex',gap:14,alignItems:'flex-start',marginBottom:13}}>
                <div style={{display:'flex',flexDirection:'column',gap:5,alignItems:'center',flexShrink:0}}>
                  <div style={{width:72,height:72,borderRadius:16,background:'rgba(255,255,255,0.05)',border:'2px dashed rgba(10,132,255,0.3)',display:'flex',alignItems:'center',justifyContent:'center',overflow:'hidden'}}>
                    {shopLogo?<img src={shopLogo} alt="" style={{width:'100%',height:'100%',objectFit:'contain'}}/>:<span style={{fontSize:30}}>🏪</span>}
                  </div>
                  <div style={{display:'flex',gap:4}}>
                    <label style={{fontSize:10,padding:'3px 7px',background:'rgba(10,132,255,0.1)',border:'1px solid rgba(10,132,255,0.2)',borderRadius:5,color:'var(--blue)',cursor:'pointer',fontWeight:600}}>
                      📷 Logo<input type="file" accept="image/*" style={{display:'none'}} onChange={e=>{const f=e.target.files?.[0];if(!f)return;const r=new FileReader();r.onload=ev=>setShopLogo(ev.target.result);r.readAsDataURL(f);e.target.value='';}}/>
                    </label>
                    {shopLogo&&<button type="button" onClick={()=>setShopLogo('')} style={{fontSize:10,padding:'3px 7px',background:'rgba(255,69,58,0.08)',border:'1px solid rgba(255,69,58,0.18)',borderRadius:5,color:'var(--red)',cursor:'pointer'}}>✕</button>}
                  </div>
                </div>
                <div style={{flex:1,display:'flex',flexDirection:'column',gap:9}}>
                  <div className="fg"><label className="fl">{t.shopName}</label><input className="inp" value={shopName} onChange={e=>setShopName(e.target.value)} placeholder="My Repair Shop"/></div>
                  <div className="fg"><label className="fl">Tagline / Slogan</label><input className="inp" value={shopTagline} onChange={e=>setShopTagline(e.target.value)} placeholder="Fast. Reliable. Trusted."/></div>
                </div>
              </div>
              <div style={{display:'flex',flexDirection:'column',gap:9}}>
                <div className="fg2">
                  <div className="fg"><label className="fl">📞 Phone</label><input className="inp" value={shopPhone} onChange={e=>setShopPhone(e.target.value)} placeholder="+964 770 000 0000"/></div>
                  <div className="fg"><label className="fl">🌍 Country Code <span style={{fontSize:11,color:"var(--t3)",fontWeight:400}}>(for WhatsApp, e.g. 964 for Iraq)</span></label><input className="inp" value={countryCode} onChange={e=>setCountryCode(e.target.value.replace(/\D/g,""))} placeholder="964" maxLength={4}/></div>
                  <div className="fg"><label className="fl">✉️ Email</label><input className="inp" type="email" value={shopEmail} onChange={e=>setShopEmail(e.target.value)} placeholder="shop@example.com"/></div>
                </div>
                <div className="fg"><label className="fl">🌐 Website</label><input className="inp" value={shopWebsite} onChange={e=>setShopWebsite(e.target.value)} placeholder="https://yourshop.com"/></div>
                <div className="fg"><label className="fl">📍 Address</label><textarea className="inp" rows={2} value={shopAddress} onChange={e=>setShopAddress(e.target.value)} placeholder="Street, City, Country" style={{resize:'vertical'}}/></div>
                <div className="fg"><label className="fl">🕐 Working Hours</label><input className="inp" value={shopHours} onChange={e=>setShopHours(e.target.value)} placeholder="Sat–Thu 9 AM – 7 PM"/></div>
              </div>
            </div>

            {/* Profit split */}
            <div className="card">
              <div className="stitle">💰 Profit Split</div>
              <div style={{display:'flex',flexDirection:'column',gap:10}}>
                <div className="fg"><label className="fl">{t.splitPct}</label>
                  <div style={{display:'flex',alignItems:'center',gap:10}}>
                    <input className="inp" type="number" min="1" max="99" value={splitPct} onChange={e=>setSplitPct(e.target.value)} style={{width:80}}/>
                    <span style={{fontSize:12,color:'var(--t3)'}}>{t.yourCut}: <strong style={{color:'var(--blue)'}}>{splitPct}%</strong> · {t.storeCut}: <strong style={{color:'var(--green)'}}>{100-parseInt(splitPct)||50}%</strong></span>
                  </div>
                </div>
                <div style={{display:'flex',gap:0,borderRadius:8,overflow:'hidden',height:10}}>
                  <div style={{flex:parseInt(splitPct)||50,background:'var(--blue)',transition:'flex .3s'}}/>
                  <div style={{flex:100-(parseInt(splitPct)||50),background:'var(--green)',transition:'flex .3s'}}/>
                </div>
                <div style={{fontSize:11,color:'var(--t3)'}}>Used to split repair revenue between you and the store. "Mine only" repairs always go 100% to you.</div>
              </div>
            </div>
          </div>

          {/* Right column: repair types + warranty + app meta + receipt */}
          <div style={{display:'flex',flexDirection:'column',gap:13}}>

            {/* Repair Types Editor */}
            <div className="card">
              <div className="stitle">🔧 Repair Types</div>
              <div style={{display:'flex',flexDirection:'column',gap:8}}>
                <div style={{display:'flex',flexWrap:'wrap',gap:5}}>
                  {repairTypesList.map((rt,i)=>(
                    <div key={rt.name+i} style={{display:'flex',alignItems:'center',gap:4,padding:'4px 9px',background:'rgba(255,255,255,0.05)',border:'1px solid var(--glb)',borderRadius:20,fontSize:12}}>
                      <span>{rt.icon}</span>
                      {rtEdit===i
                        ? <input autoFocus style={{background:'transparent',border:'none',color:'var(--tx)',fontSize:12,width:100,outline:'none'}} value={rt.name} onChange={e=>{const arr=[...repairTypesList];arr[i]={...arr[i],name:e.target.value};setRepairTypesList(arr);}}  onBlur={()=>setRtEdit(null)} onKeyDown={e=>{if(e.key==='Enter'||e.key==='Escape')setRtEdit(null);}}/>
                        : <span style={{cursor:'pointer'}} onClick={()=>setRtEdit(i)}>{rt.name}</span>
                      }
                      <button onClick={()=>setRepairTypesList(repairTypesList.filter((_,j)=>j!==i))} style={{background:'none',border:'none',color:'var(--t3)',cursor:'pointer',fontSize:13,lineHeight:1,padding:'0 2px'}}>×</button>
                    </div>
                  ))}
                </div>
                <div style={{display:'flex',gap:7,alignItems:'center',marginTop:4}}>
                  <input className="inp" value={rtIcon} onChange={e=>setRtIcon(e.target.value)} style={{width:44,textAlign:'center',fontSize:18,padding:'5px 8px'}} maxLength={2} placeholder="🔧"/>
                  <input className="inp" value={rtInput} onChange={e=>setRtInput(e.target.value)} placeholder="New repair type name…" onKeyDown={e=>{if(e.key==='Enter'&&rtInput.trim()){setRepairTypesList([...repairTypesList,{name:rtInput.trim(),icon:rtIcon||"🔧"}]);setRtInput("");setRtIcon("🔧");}}} style={{flex:1}}/>
                  <button className="btn bp bsm" onClick={()=>{if(!rtInput.trim())return;setRepairTypesList([...repairTypesList,{name:rtInput.trim(),icon:rtIcon||"🔧"}]);setRtInput("");setRtIcon("🔧");}}>+ Add</button>
                </div>
                <div style={{fontSize:10,color:'var(--t3)'}}>Click a type name to rename it. Changes apply to new repairs. Existing repairs keep their old type.</div>
              </div>
            </div>

            {/* Quick Repair Presets Editor — extracted to proper component */}
            <PresetsEditor/>

            {/* Warranty Options Editor */}
            <div className="card">
              <div className="stitle">🛡️ Warranty Options</div>
              <div style={{display:'flex',flexDirection:'column',gap:8}}>
                <div style={{display:'flex',flexWrap:'wrap',gap:5}}>
                  {warrantyList.map((w,i)=>(
                    <div key={w.value+i} style={{display:'flex',alignItems:'center',gap:4,padding:'4px 9px',background:'rgba(255,255,255,0.05)',border:'1px solid var(--glb)',borderRadius:20,fontSize:12}}>
                      <span style={{color:'var(--green)'}}>🛡️</span>
                      <span>{w.label}</span>
                      <button onClick={()=>setWarrantyList(warrantyList.filter((_,j)=>j!==i))} style={{background:'none',border:'none',color:'var(--t3)',cursor:'pointer',fontSize:13,lineHeight:1,padding:'0 2px'}}>×</button>
                    </div>
                  ))}
                </div>
                <div style={{display:'flex',gap:7,alignItems:'center',marginTop:4}}>
                  <input className="inp" value={wLabel} onChange={e=>setWLabel(e.target.value)} placeholder="Label, e.g. 18 months" style={{flex:2}}/>
                  <input className="inp" type="number" value={wValue} onChange={e=>setWValue(e.target.value)} placeholder="Months" style={{width:80}}/>
                  <button className="btn bp bsm" onClick={()=>{if(!wLabel.trim()||!wValue)return;setWarrantyList([...warrantyList,{label:wLabel.trim(),value:String(parseFloat(wValue)||0)}]);setWLabel("");setWValue("");}}>+ Add</button>
                </div>
                <div style={{fontSize:10,color:'var(--t3)'}}>Value is in months (0.25 = 1 week, 0.5 = 2 weeks, 12 = 1 year).</div>
              </div>
            </div>

            {/* Receipt settings */}
            <div className="card">
              <div className="stitle">🧾 Receipt Settings</div>
              <div style={{display:'flex',flexDirection:'column',gap:10}}>
                <div style={{display:'flex',flexDirection:'column',gap:7}}>
                  <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer'}}>
                    <div className="tog" style={{transform:'scale(0.85)',transformOrigin:'left'}}><input type="checkbox" checked={receiptShowLogo} onChange={e=>setReceiptShowLogo(e.target.checked)}/><span className="ts"/></div>
                    <span style={{fontSize:12.5}}>Show logo on receipts</span>
                  </label>
                  <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer'}}>
                    <div className="tog" style={{transform:'scale(0.85)',transformOrigin:'left'}}><input type="checkbox" checked={receiptShowAddress} onChange={e=>setReceiptShowAddress(e.target.checked)}/><span className="ts"/></div>
                    <span style={{fontSize:12.5}}>Show address on receipts</span>
                  </label>
                </div>
                <div className="fg"><label className="fl">Receipt footer text</label><textarea className="inp" rows={2} value={receiptFooter} onChange={e=>setReceiptFooter(e.target.value)} placeholder="Thank you for your business! Warranty valid from date of collection." style={{resize:'vertical',fontSize:12}}/></div>
              </div>
            </div>

            {/* App meta (admin only) */}
            {isAdmin&&(
              <div className="card">
                <div className="stitle">⚙️ App Configuration</div>
                <div style={{display:'flex',flexDirection:'column',gap:9}}>
                  <div className="fg"><label className="fl">App Version Label</label><input className="inp" value={appVersion} onChange={e=>setAppVersion(e.target.value)} placeholder="v7" style={{fontFamily:'monospace'}}/><div style={{fontSize:10,color:'var(--t3)',marginTop:3}}>Displayed in sidebar footer and login screen.</div></div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── Appearance ── */}
      {tab==='appearance'&&(
        <div style={{display:'flex',flexDirection:'column',gap:13}}>
          <div className="card">
            <div className="stitle">🌐 Language &amp; Region</div>
            <div style={{display:'flex',flexDirection:'column',gap:11}}>
              <div className="fg2">
                <div className="fg"><label className="fl">{t.language}</label>
                  <select className="inp" value={lang} onChange={e=>onLangChange(e.target.value)}>
                    <option value="en">🇬🇧 English</option>
                    <option value="ar">🇮🇶 العربية</option>
                  </select>
                </div>
                <div className="fg"><label className="fl">{t.currency}</label>
                  <select className="inp" value={currency} onChange={e=>onCurrencyChange(e.target.value)}>
                    <option value="USD">🇺🇸 USD</option>
                    <option value="IQD">🇮🇶 IQD</option>
                    <option value="EUR">🇪🇺 EUR</option>
                    <option value="GBP">🇬🇧 GBP</option>
                    <option value="SAR">🇸🇦 SAR</option>
                  </select>
                </div>
              </div>
              <div style={{display:'flex',alignItems:'center',gap:10}}>
                <label className="tog"><input type="checkbox" checked={rtlLayout} onChange={e=>onRtlChange(e.target.checked)}/><span className="ts"/></label>
                <div><div style={{fontSize:12.5,fontWeight:500}}>{t.rtlLayout}</div><div style={{fontSize:10.5,color:'var(--t3)'}}>Text aligns right, layout stays LTR</div></div>
              </div>
            </div>
          </div>
          <AppearanceCard appearance={appearance} updateAppearance={updateAppearance} currentUser={currentUser} t={t}/>
          {/* Biometric lock — extracted into proper component to avoid hooks-in-IIFE error */}
          <BioLockToggle/>
        </div>
      )}

      {/* ── Printing & Receipts ── */}
      {tab==='printing'&&(<ReceiptSettingsPanel/>)}

      {/* ── Telegram & Alerts ── */}
      {tab==='telegram'&&(
        <div style={{display:'flex',flexDirection:'column',gap:13}}>
          <div className="card">
            <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:13}}><TgIcon s={18}/><div className="stitle" style={{marginBottom:0}}>{t.telegram}</div></div>
            <div style={{background:'rgba(41,182,246,0.07)',border:'1px solid rgba(41,182,246,0.17)',borderRadius:9,padding:'10px 13px',marginBottom:12,fontSize:11.5,color:'var(--t3)',lineHeight:1.8}}>
              Message <strong style={{color:'var(--teal)'}}>@BotFather</strong> → /newbot → get token. Technicians must message your bot first.
            </div>
            <div className="fg"><label className="fl">Bot API Token</label><input className="inp" type="password" value={token} onChange={e=>setToken(e.target.value)} placeholder="123456789:ABCDefGhijk..."/></div>
            <div style={{display:'flex',alignItems:'center',gap:10,marginTop:11}}>
              <label className="tog"><input type="checkbox" checked={waAuto} onChange={e=>setWaAuto(e.target.checked)}/><span className="ts"/></label>
              <div><div style={{fontSize:12.5,fontWeight:500}}>{t.waAuto}</div></div>
            </div>
          </div>
          <div className="card">
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:13}}>
              <div className="stitle" style={{marginBottom:0}}>👥 {t.technicians}</div>
              <button className="btn bp bsm" onClick={()=>setTechModal('add')}><I n="plus" s={12} c="#fff"/> {t.addTech}</button>
            </div>
            {techs.length===0
              ? <div style={{color:'var(--t3)',fontSize:13}}>No technicians yet. Add yourself to receive Telegram notifications.</div>
              : <div style={{display:'flex',flexDirection:'column',gap:9}}>{techs.map(tech=>(
                  <div key={tech.id} className="tech-card">
                    <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:10}}>
                      <div style={{width:36,height:36,borderRadius:10,background:'rgba(10,132,255,0.15)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16,fontWeight:700,color:'var(--blue)',flexShrink:0,overflow:'hidden'}}>{tech.photoUrl?<img src={tech.photoUrl} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/>:tech.name?.[0]?.toUpperCase()||'T'}</div>
                      <div style={{flex:1}}>
                        <div style={{fontWeight:600,fontSize:13}}>{tech.name}</div>
                        <div style={{fontSize:11,color:'var(--t3)',marginTop:1,display:'flex',gap:8,alignItems:'center'}}>
                          {tech.role&&<span>{tech.role}</span>}
                          {tech.telegramId&&<span style={{display:'flex',alignItems:'center',gap:3}}><TgIcon s={11}/>{tech.telegramId}</span>}
                        </div>
                      </div>
                      <div style={{display:'flex',gap:6}}>
                        <button className="btn bg2 bsm" onClick={()=>setCatModal(tech)} title="Notification categories">🔔</button>
                        <button className="btn bg2 bsm" onClick={()=>testTg(tech)}><I n="send" s={11}/></button>
                        <button className="btn bg2 bsm" onClick={()=>setTechModal(tech)}><I n="edit" s={11}/></button>
                        <button className="btn bd bsm" onClick={()=>{saveTechs(techs.filter(tp=>tp.id!==tech.id));toast('🗑️',t.removed,tech.name);}}><I n="trash" s={11}/></button>
                      </div>
                    </div>
                    <div style={{display:'flex',gap:5,flexWrap:'wrap'}}>
                      {(tech.notifCats||[]).length===0
                        ? <span style={{fontSize:11,color:'var(--t3)'}}>No notifications — click 🔔 to configure</span>
                        : (tech.notifCats||[]).map(catId=>{const cat=NOTIF_CATS.find(c=>c.id===catId);return cat?(<span key={catId} style={{fontSize:10.5,background:'rgba(10,132,255,0.12)',color:'var(--blue)',border:'1px solid rgba(10,132,255,0.2)',padding:'2px 8px',borderRadius:10,fontWeight:600}}>{cat.icon} {lang==='ar'?cat.labelAr:cat.label}</span>):null;})
                      }
                    </div>
                  </div>
                ))}</div>
            }
          </div>
        </div>
      )}

      {/* ── Message Templates ── */}
      {tab==='templates'&&(
        <TemplateEditor templates={templates} saveTpl={saveTpl} saveAll={saveAll}/>
      )}

      {/* ── Technicians tab removed — moved into Telegram ── */}
      {tab==='technicians'&&null}

      {/* ── Assets & Brands ── */}
      {tab==='assets'&&(
        <div style={{display:'flex',flexDirection:'column',gap:13}}>
          <AssetsCard assets={assets} saveAssets={saveAssetsFn}/>
          {/* Collapsible Brands */}
          <div className="card">
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',cursor:'pointer',userSelect:'none'}} onClick={()=>setBrandsOpen(v=>!v)}>
              <div className="stitle" style={{marginBottom:0}}>🏷️ Brand Icons</div>
              <div style={{display:'flex',alignItems:'center',gap:8}}>
                <span style={{fontSize:11,color:'var(--t3)'}}>{brandsOpen?'Collapse':'Expand to edit'}</span>
                <span style={{color:'var(--t3)',fontSize:16,transition:'transform .2s',display:'inline-block',transform:brandsOpen?'rotate(180deg)':'rotate(0deg)'}}>▾</span>
              </div>
            </div>
            {!brandsOpen&&(
              <div style={{marginTop:10,display:'flex',flexWrap:'wrap',gap:7}}>
                {getActiveBrands().slice(0,8).map(b=>(
                  <div key={b.name} style={{display:'flex',alignItems:'center',gap:5,padding:'4px 10px',background:'rgba(255,255,255,0.04)',border:'1px solid var(--glb)',borderRadius:20}}>
                    <span style={{fontSize:14}}>{getBrandDisplay(b.name,b.logoUrl,16)}</span>
                    <span style={{fontSize:11,color:'var(--t2)'}}>{b.name}</span>
                  </div>
                ))}
                {getActiveBrands().length>8&&<span style={{fontSize:11,color:'var(--t3)',alignSelf:'center'}}>+{getActiveBrands().length-8} more</span>}
              </div>
            )}
            {brandsOpen&&<div style={{marginTop:14}}><BrandsCard brands={brands} saveBrands={saveBrandsFn} embedded/></div>}
          </div>
        </div>
      )}

      {/* ── Data & Databases (merged) ── */}
      {tab==='data'&&(
        <div style={{display:'flex',flexDirection:'column',gap:13}}>
          <div className="card">
            <div className="stitle">💾 {t.dataSection}</div>
            <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
              <button className="btn bg2" onClick={handleExport}><I n="send" s={13}/> {t.exportBackup}</button>
              <button className="btn bgreen" onClick={()=>fileRef.current?.click()}><I n="upload" s={13}/> {t.restoreBackup}</button>
              <input ref={fileRef} type="file" accept=".json" style={{display:'none'}} onChange={handleRestoreFile}/>
              {isAdmin&&<button className="btn bd" onClick={()=>{if(window.confirm('Delete ALL data?')){['repairs','customers','notifications','withdrawals','customPartsCatalog'].forEach(k=>SDB.set(k,[]));SDB.set('parts',INITIAL_PARTS);toast('🗑️','Cleared','Reset done');onRestore();}}}>🗑️ {t.clearData}</button>}
            </div>
            <div style={{marginTop:10,fontSize:11.5,color:'var(--t3)'}}>Restore from a previously exported .json backup file. All current data will be replaced.</div>
          </div>
          <div className="card">
            <div className="stitle">🖥️ Server &amp; Databases</div>
            <div style={{fontSize:11.5,color:'var(--t3)',marginBottom:12,lineHeight:1.7}}>
              Connect to a local <code style={{color:'var(--blue)'}}>server.js</code> instance to sync databases across all devices on your network.
            </div>
            <ServerSection t={t} onDbSwitch={async()=>{if(ServerDB.isActive())await ServerDB.reload();onRestore();}}/>
          </div>
        </div>
      )}

      {/* ── database tab redirects to data ── */}
      {tab==='database'&&null}

      {/* ── User Management ── */}
      {tab==='users'&&isAdmin&&(
        <div style={{display:'flex',flexDirection:'column',gap:13}}>
          <UserManager currentUser={currentUser} setCurrentUser={setCurrentUser} t={t}/>

          {/* Settings Access Control */}
          <div className="card">
            <div className="stitle">🔐 Settings Access per Role</div>
            <div style={{fontSize:11.5,color:'var(--t3)',marginBottom:14,lineHeight:1.7}}>
              Control which settings sections each role can see when they open the Settings page.
              Admin always has full access.
            </div>
            <div style={{overflowX:'auto'}}>
              <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
                <thead>
                  <tr>
                    <th style={{textAlign:'left',padding:'7px 10px',color:'var(--t3)',fontWeight:600,borderBottom:'1px solid var(--glb)',whiteSpace:'nowrap'}}>Section</th>
                    {Object.keys(DEFAULT_SETTINGS_ACCESS).filter(r=>r!=='admin').map(role=>(
                      <th key={role} style={{padding:'7px 8px',color:'var(--t2)',fontWeight:600,borderBottom:'1px solid var(--glb)',textAlign:'center',whiteSpace:'nowrap',fontSize:11}}>
                        {ROLES[role]?.label||role}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {SETTINGS_SECTIONS.filter(s=>s.id!=='users').map((sec,i)=>(
                    <tr key={sec.id} style={{background:i%2===0?'rgba(255,255,255,0.02)':'transparent'}}>
                      <td style={{padding:'8px 10px',borderBottom:'1px solid rgba(255,255,255,0.04)'}}>
                        <div style={{fontWeight:500}}>{sec.icon} {sec.label}</div>
                        <div style={{fontSize:10,color:'var(--t3)',marginTop:1}}>{sec.desc}</div>
                      </td>
                      {Object.keys(DEFAULT_SETTINGS_ACCESS).filter(r=>r!=='admin').map(role=>{
                        const allowed = settingsAccess[role]?.[sec.id]||false;
                        return(
                          <td key={role} style={{padding:'8px',borderBottom:'1px solid rgba(255,255,255,0.04)',textAlign:'center'}}>
                            <button onClick={()=>toggleSettingsSection(role,sec.id)}
                              style={{width:28,height:28,borderRadius:7,border:`1.5px solid ${allowed?'var(--green)':'var(--glb)'}`,background:allowed?'rgba(48,209,88,0.15)':'transparent',cursor:'pointer',display:'inline-flex',alignItems:'center',justifyContent:'center',transition:'all .15s'}}>
                              {allowed?<span style={{color:'var(--green)',fontSize:14,fontWeight:700}}>✓</span>:<span style={{color:'var(--t3)',fontSize:14}}>–</span>}
                            </button>
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{marginTop:10,padding:'8px 12px',background:'rgba(10,132,255,0.06)',border:'1px solid rgba(10,132,255,0.15)',borderRadius:8,fontSize:11,color:'var(--t3)'}}>
              💡 Changes take effect immediately. Users must reload the page to see updated access.
            </div>
          </div>
        </div>
      )}

      {techModal&&(<TechModal tech={techModal==='add'?null:techModal} onClose={()=>setTechModal(null)} onSave={saveTech} t={t}/>)}
      {catModal&&(
        <div className="mo">
          <div className="md" style={{maxWidth:440}} onClick={e=>e.stopPropagation()}>
            <div className="mh"><div className="mt2">🔔 Notifications for {catModal.name}</div><span style={{cursor:'pointer'}} onClick={()=>setCatModal(null)}><I n="close" s={15} c="var(--t3)"/></span></div>
            <div style={{fontSize:12,color:'var(--t3)',marginBottom:14}}>Select events that trigger a Telegram message:</div>
            <div style={{display:'flex',flexDirection:'column'}}>
              {NOTIF_CATS.map(cat=>{
                const enabled=(catModal.notifCats||[]).includes(cat.id);
                return(<div key={cat.id} className="cat-check" onClick={()=>toggleCat(catModal,cat.id)}>
                  <div className={`cb ${enabled?'on':''}`}>{enabled&&<I n="check" s={11} c="#fff"/>}</div>
                  <div style={{flex:1}}><div style={{fontSize:13,fontWeight:500}}>{cat.icon} {lang==='ar'?cat.labelAr:cat.label}</div></div>
                  <div style={{fontSize:11.5,color:enabled?'var(--green)':'var(--t3)',fontWeight:600}}>{enabled?'ON':'OFF'}</div>
                </div>);
              })}
            </div>
            <div className="ma"><button className="btn bp" onClick={()=>setCatModal(null)}>{t.done}</button></div>
          </div>
        </div>
      )}
    </div>
  );
}

function TechModal({tech,onClose,onSave,t}){
  const[f,setF]=useState(tech||{name:"",role:"Technician",telegramId:"",photoUrl:""});
  const s=(k,v)=>setF(x=>({...x,[k]:v}));
  return(
    <div className="mo">
      <div className="md" style={{maxWidth:420}} onClick={e=>e.stopPropagation()}>
        <div className="mh"><div className="mt2">{tech?t.edit:t.add} Technician</div><span style={{cursor:"pointer"}} onClick={onClose}><I n="close" s={15} c="var(--t3)"/></span></div>
        <div style={{display:"flex",flexDirection:"column",gap:11}}>
          <div style={{display:"flex",alignItems:"flex-start",gap:14}}>
            <PhotoPicker value={f.photoUrl||""} onChange={v=>s("photoUrl",v)} size={52}/>
            <div style={{flex:1,display:"flex",flexDirection:"column",gap:10}}>
              <div className="fg"><label className="fl">{t.name}</label><input className="inp" value={f.name} onChange={e=>s("name",e.target.value)}/></div>
              <div className="fg"><label className="fl">Role</label><input className="inp" value={f.role} onChange={e=>s("role",e.target.value)} placeholder="Owner / Technician"/></div>
              <div className="fg"><label className="fl">Telegram ID</label><div style={{display:"flex",gap:8,alignItems:"center"}}><TgIcon s={15}/><input className="inp" value={f.telegramId} onChange={e=>s("telegramId",e.target.value)} placeholder="@yourusername or numeric chat ID"/></div></div>
            </div>
          </div>
          <div style={{fontSize:11.5,color:"var(--t3)",background:"rgba(255,255,255,0.04)",borderRadius:9,padding:"9px 12px"}}>After saving, click 🔔 to configure notification categories.</div>
        </div>
        <div className="ma"><button className="btn bg2" onClick={onClose}>{t.cancel}</button><button className="btn bp" onClick={()=>{if(!f.name)return;onSave(f);}}>{t.save}</button></div>
      </div>
    </div>
  );
}